
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2041"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2041"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("j4DCz", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $de2d1ffc55a31aad$export$ffb0004e005737fa, (v) => $de2d1ffc55a31aad$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $de2d1ffc55a31aad$export$34b9dba7ce09269b, (v) => $de2d1ffc55a31aad$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $de2d1ffc55a31aad$export$25062201e9e25d76, (v) => $de2d1ffc55a31aad$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $de2d1ffc55a31aad$export$ffb0004e005737fa;
var $de2d1ffc55a31aad$export$34b9dba7ce09269b;
var $de2d1ffc55a31aad$export$25062201e9e25d76;
"use strict";
var $de2d1ffc55a31aad$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $de2d1ffc55a31aad$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $de2d1ffc55a31aad$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $de2d1ffc55a31aad$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$de2d1ffc55a31aad$export$ffb0004e005737fa = $de2d1ffc55a31aad$var$REACT_FRAGMENT_TYPE;
$de2d1ffc55a31aad$export$34b9dba7ce09269b = $de2d1ffc55a31aad$var$jsxProd;
$de2d1ffc55a31aad$export$25062201e9e25d76 = $de2d1ffc55a31aad$var$jsxProd;

});

parcelRegister("2Ypn1", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $22a4dd66bc9aa8d5$export$9c16c1426311996d, (v) => $22a4dd66bc9aa8d5$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $22a4dd66bc9aa8d5$export$dca3b0875bd9a954, (v) => $22a4dd66bc9aa8d5$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $22a4dd66bc9aa8d5$export$16fa2f45be04daa8, (v) => $22a4dd66bc9aa8d5$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $22a4dd66bc9aa8d5$export$ffb0004e005737fa, (v) => $22a4dd66bc9aa8d5$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $22a4dd66bc9aa8d5$export$e2c29f18771995cb, (v) => $22a4dd66bc9aa8d5$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $22a4dd66bc9aa8d5$export$221d75b3f55bb0bd, (v) => $22a4dd66bc9aa8d5$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $22a4dd66bc9aa8d5$export$5f8d39834fd61797, (v) => $22a4dd66bc9aa8d5$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $22a4dd66bc9aa8d5$export$74bf444e3cd11ea5, (v) => $22a4dd66bc9aa8d5$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $22a4dd66bc9aa8d5$export$1ced07cd6b1985ce, (v) => $22a4dd66bc9aa8d5$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $22a4dd66bc9aa8d5$export$abd8e32b826d7ea7, (v) => $22a4dd66bc9aa8d5$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $22a4dd66bc9aa8d5$export$69a3209f1a06c04d, (v) => $22a4dd66bc9aa8d5$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $22a4dd66bc9aa8d5$export$8c538325882c7eec, (v) => $22a4dd66bc9aa8d5$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $22a4dd66bc9aa8d5$export$e530037191fcd5d7, (v) => $22a4dd66bc9aa8d5$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $22a4dd66bc9aa8d5$export$fd42f52fd3ae1109, (v) => $22a4dd66bc9aa8d5$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $22a4dd66bc9aa8d5$export$c8a8987d4410bf2d, (v) => $22a4dd66bc9aa8d5$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $22a4dd66bc9aa8d5$export$7d1e3a5e95ceca43, (v) => $22a4dd66bc9aa8d5$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $22a4dd66bc9aa8d5$export$257a8862b851cb5b, (v) => $22a4dd66bc9aa8d5$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $22a4dd66bc9aa8d5$export$a8257692ac88316c, (v) => $22a4dd66bc9aa8d5$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $22a4dd66bc9aa8d5$export$488013bae63b21da, (v) => $22a4dd66bc9aa8d5$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $22a4dd66bc9aa8d5$export$7c73462e0d25e514, (v) => $22a4dd66bc9aa8d5$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $22a4dd66bc9aa8d5$export$7568632d0d33d16d, (v) => $22a4dd66bc9aa8d5$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $22a4dd66bc9aa8d5$export$f93f40ac0ca7e3a8, (v) => $22a4dd66bc9aa8d5$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $22a4dd66bc9aa8d5$export$1f96ae73734a86cc, (v) => $22a4dd66bc9aa8d5$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $22a4dd66bc9aa8d5$export$9a47ced3238df325, (v) => $22a4dd66bc9aa8d5$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $22a4dd66bc9aa8d5$export$35808ee640e87ca7, (v) => $22a4dd66bc9aa8d5$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $22a4dd66bc9aa8d5$export$fae74005e78b1a27, (v) => $22a4dd66bc9aa8d5$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $22a4dd66bc9aa8d5$export$dc8fbce3eb94dc1e, (v) => $22a4dd66bc9aa8d5$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $22a4dd66bc9aa8d5$export$6a7bc4e911dc01cf, (v) => $22a4dd66bc9aa8d5$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $22a4dd66bc9aa8d5$export$6d9c69b0de29b591, (v) => $22a4dd66bc9aa8d5$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $22a4dd66bc9aa8d5$export$7f54fc3180508a52, (v) => $22a4dd66bc9aa8d5$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $22a4dd66bc9aa8d5$export$f680877a34711e37, (v) => $22a4dd66bc9aa8d5$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $22a4dd66bc9aa8d5$export$d5a552a76deda3c2, (v) => $22a4dd66bc9aa8d5$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $22a4dd66bc9aa8d5$export$aaabe4eda9ed9969, (v) => $22a4dd66bc9aa8d5$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $22a4dd66bc9aa8d5$export$e5c5a5f917a5871c, (v) => $22a4dd66bc9aa8d5$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $22a4dd66bc9aa8d5$export$1538c33de8887b59, (v) => $22a4dd66bc9aa8d5$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $22a4dd66bc9aa8d5$export$fca7f784ae7a249a, (v) => $22a4dd66bc9aa8d5$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $22a4dd66bc9aa8d5$export$13e3392192263954, (v) => $22a4dd66bc9aa8d5$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $22a4dd66bc9aa8d5$export$b8f5890fc79d6aca, (v) => $22a4dd66bc9aa8d5$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $22a4dd66bc9aa8d5$export$60241385465d0a34, (v) => $22a4dd66bc9aa8d5$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $22a4dd66bc9aa8d5$export$306c0aa65ff9ec16, (v) => $22a4dd66bc9aa8d5$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $22a4dd66bc9aa8d5$export$7b286972b8d8ccbf, (v) => $22a4dd66bc9aa8d5$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $22a4dd66bc9aa8d5$export$83d89fbfd8236492, (v) => $22a4dd66bc9aa8d5$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $22a4dd66bc9aa8d5$export$9c16c1426311996d;
var $22a4dd66bc9aa8d5$export$dca3b0875bd9a954;
var $22a4dd66bc9aa8d5$export$16fa2f45be04daa8;
var $22a4dd66bc9aa8d5$export$ffb0004e005737fa;
var $22a4dd66bc9aa8d5$export$e2c29f18771995cb;
var $22a4dd66bc9aa8d5$export$221d75b3f55bb0bd;
var $22a4dd66bc9aa8d5$export$5f8d39834fd61797;
var $22a4dd66bc9aa8d5$export$74bf444e3cd11ea5;
var $22a4dd66bc9aa8d5$export$1ced07cd6b1985ce;
var $22a4dd66bc9aa8d5$export$abd8e32b826d7ea7;
var $22a4dd66bc9aa8d5$export$69a3209f1a06c04d;
var $22a4dd66bc9aa8d5$export$8c538325882c7eec;
var $22a4dd66bc9aa8d5$export$e530037191fcd5d7;
var $22a4dd66bc9aa8d5$export$fd42f52fd3ae1109;
var $22a4dd66bc9aa8d5$export$c8a8987d4410bf2d;
var $22a4dd66bc9aa8d5$export$7d1e3a5e95ceca43;
var $22a4dd66bc9aa8d5$export$257a8862b851cb5b;
var $22a4dd66bc9aa8d5$export$a8257692ac88316c;
var $22a4dd66bc9aa8d5$export$488013bae63b21da;
var $22a4dd66bc9aa8d5$export$7c73462e0d25e514;
var $22a4dd66bc9aa8d5$export$7568632d0d33d16d;
var $22a4dd66bc9aa8d5$export$f93f40ac0ca7e3a8;
var $22a4dd66bc9aa8d5$export$1f96ae73734a86cc;
var $22a4dd66bc9aa8d5$export$9a47ced3238df325;
var $22a4dd66bc9aa8d5$export$35808ee640e87ca7;
var $22a4dd66bc9aa8d5$export$fae74005e78b1a27;
var $22a4dd66bc9aa8d5$export$dc8fbce3eb94dc1e;
var $22a4dd66bc9aa8d5$export$6a7bc4e911dc01cf;
var $22a4dd66bc9aa8d5$export$6d9c69b0de29b591;
var $22a4dd66bc9aa8d5$export$7f54fc3180508a52;
var $22a4dd66bc9aa8d5$export$f680877a34711e37;
var $22a4dd66bc9aa8d5$export$d5a552a76deda3c2;
var $22a4dd66bc9aa8d5$export$aaabe4eda9ed9969;
var $22a4dd66bc9aa8d5$export$e5c5a5f917a5871c;
var $22a4dd66bc9aa8d5$export$1538c33de8887b59;
var $22a4dd66bc9aa8d5$export$fca7f784ae7a249a;
var $22a4dd66bc9aa8d5$export$13e3392192263954;
var $22a4dd66bc9aa8d5$export$b8f5890fc79d6aca;
var $22a4dd66bc9aa8d5$export$60241385465d0a34;
var $22a4dd66bc9aa8d5$export$306c0aa65ff9ec16;
var $22a4dd66bc9aa8d5$export$7b286972b8d8ccbf;
var $22a4dd66bc9aa8d5$export$83d89fbfd8236492;
"use strict";
var $22a4dd66bc9aa8d5$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $22a4dd66bc9aa8d5$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $22a4dd66bc9aa8d5$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $22a4dd66bc9aa8d5$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $22a4dd66bc9aa8d5$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $22a4dd66bc9aa8d5$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $22a4dd66bc9aa8d5$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $22a4dd66bc9aa8d5$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $22a4dd66bc9aa8d5$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $22a4dd66bc9aa8d5$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $22a4dd66bc9aa8d5$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $22a4dd66bc9aa8d5$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $22a4dd66bc9aa8d5$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $22a4dd66bc9aa8d5$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $22a4dd66bc9aa8d5$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$22a4dd66bc9aa8d5$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $22a4dd66bc9aa8d5$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $22a4dd66bc9aa8d5$var$assign = Object.assign, $22a4dd66bc9aa8d5$var$emptyObject = {};
function $22a4dd66bc9aa8d5$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $22a4dd66bc9aa8d5$var$emptyObject;
    this.updater = updater || $22a4dd66bc9aa8d5$var$ReactNoopUpdateQueue;
}
$22a4dd66bc9aa8d5$var$Component.prototype.isReactComponent = {};
$22a4dd66bc9aa8d5$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$22a4dd66bc9aa8d5$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $22a4dd66bc9aa8d5$var$ComponentDummy() {}
$22a4dd66bc9aa8d5$var$ComponentDummy.prototype = $22a4dd66bc9aa8d5$var$Component.prototype;
function $22a4dd66bc9aa8d5$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $22a4dd66bc9aa8d5$var$emptyObject;
    this.updater = updater || $22a4dd66bc9aa8d5$var$ReactNoopUpdateQueue;
}
var $22a4dd66bc9aa8d5$var$pureComponentPrototype = $22a4dd66bc9aa8d5$var$PureComponent.prototype = new $22a4dd66bc9aa8d5$var$ComponentDummy();
$22a4dd66bc9aa8d5$var$pureComponentPrototype.constructor = $22a4dd66bc9aa8d5$var$PureComponent;
$22a4dd66bc9aa8d5$var$assign($22a4dd66bc9aa8d5$var$pureComponentPrototype, $22a4dd66bc9aa8d5$var$Component.prototype);
$22a4dd66bc9aa8d5$var$pureComponentPrototype.isPureReactComponent = !0;
var $22a4dd66bc9aa8d5$var$isArrayImpl = Array.isArray;
function $22a4dd66bc9aa8d5$var$noop() {}
var $22a4dd66bc9aa8d5$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $22a4dd66bc9aa8d5$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $22a4dd66bc9aa8d5$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $22a4dd66bc9aa8d5$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $22a4dd66bc9aa8d5$var$cloneAndReplaceKey(oldElement, newKey) {
    return $22a4dd66bc9aa8d5$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $22a4dd66bc9aa8d5$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $22a4dd66bc9aa8d5$var$REACT_ELEMENT_TYPE;
}
function $22a4dd66bc9aa8d5$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $22a4dd66bc9aa8d5$var$userProvidedKeyEscapeRegex = /\/+/g;
function $22a4dd66bc9aa8d5$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $22a4dd66bc9aa8d5$var$escape("" + element.key) : index.toString(36);
}
function $22a4dd66bc9aa8d5$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($22a4dd66bc9aa8d5$var$noop, $22a4dd66bc9aa8d5$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $22a4dd66bc9aa8d5$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $22a4dd66bc9aa8d5$var$REACT_ELEMENT_TYPE:
                case $22a4dd66bc9aa8d5$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $22a4dd66bc9aa8d5$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $22a4dd66bc9aa8d5$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $22a4dd66bc9aa8d5$var$getElementKey(children, 0) : nameSoFar, $22a4dd66bc9aa8d5$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($22a4dd66bc9aa8d5$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $22a4dd66bc9aa8d5$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($22a4dd66bc9aa8d5$var$isValidElement(callback) && (callback = $22a4dd66bc9aa8d5$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($22a4dd66bc9aa8d5$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($22a4dd66bc9aa8d5$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $22a4dd66bc9aa8d5$var$getElementKey(nameSoFar, i), invokeCallback += $22a4dd66bc9aa8d5$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $22a4dd66bc9aa8d5$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $22a4dd66bc9aa8d5$var$getElementKey(nameSoFar, i++), invokeCallback += $22a4dd66bc9aa8d5$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $22a4dd66bc9aa8d5$var$mapIntoArray($22a4dd66bc9aa8d5$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $22a4dd66bc9aa8d5$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $22a4dd66bc9aa8d5$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $22a4dd66bc9aa8d5$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $22a4dd66bc9aa8d5$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $22a4dd66bc9aa8d5$var$Children = {
    map: $22a4dd66bc9aa8d5$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $22a4dd66bc9aa8d5$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $22a4dd66bc9aa8d5$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $22a4dd66bc9aa8d5$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$22a4dd66bc9aa8d5$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$22a4dd66bc9aa8d5$export$9c16c1426311996d = $22a4dd66bc9aa8d5$var$REACT_ACTIVITY_TYPE;
$22a4dd66bc9aa8d5$export$dca3b0875bd9a954 = $22a4dd66bc9aa8d5$var$Children;
$22a4dd66bc9aa8d5$export$16fa2f45be04daa8 = $22a4dd66bc9aa8d5$var$Component;
$22a4dd66bc9aa8d5$export$ffb0004e005737fa = $22a4dd66bc9aa8d5$var$REACT_FRAGMENT_TYPE;
$22a4dd66bc9aa8d5$export$e2c29f18771995cb = $22a4dd66bc9aa8d5$var$REACT_PROFILER_TYPE;
$22a4dd66bc9aa8d5$export$221d75b3f55bb0bd = $22a4dd66bc9aa8d5$var$PureComponent;
$22a4dd66bc9aa8d5$export$5f8d39834fd61797 = $22a4dd66bc9aa8d5$var$REACT_STRICT_MODE_TYPE;
$22a4dd66bc9aa8d5$export$74bf444e3cd11ea5 = $22a4dd66bc9aa8d5$var$REACT_SUSPENSE_TYPE;
$22a4dd66bc9aa8d5$export$1ced07cd6b1985ce = $22a4dd66bc9aa8d5$var$ReactSharedInternals;
$22a4dd66bc9aa8d5$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $22a4dd66bc9aa8d5$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$22a4dd66bc9aa8d5$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$22a4dd66bc9aa8d5$export$8c538325882c7eec = function() {
    return null;
};
$22a4dd66bc9aa8d5$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $22a4dd66bc9aa8d5$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$22a4dd66bc9aa8d5$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $22a4dd66bc9aa8d5$var$ReactElement(element.type, key, props);
};
$22a4dd66bc9aa8d5$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $22a4dd66bc9aa8d5$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $22a4dd66bc9aa8d5$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$22a4dd66bc9aa8d5$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$22a4dd66bc9aa8d5$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $22a4dd66bc9aa8d5$var$ReactElement(type, key, props);
};
$22a4dd66bc9aa8d5$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$22a4dd66bc9aa8d5$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $22a4dd66bc9aa8d5$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$22a4dd66bc9aa8d5$export$a8257692ac88316c = $22a4dd66bc9aa8d5$var$isValidElement;
$22a4dd66bc9aa8d5$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $22a4dd66bc9aa8d5$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $22a4dd66bc9aa8d5$var$lazyInitializer
    };
};
$22a4dd66bc9aa8d5$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $22a4dd66bc9aa8d5$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$22a4dd66bc9aa8d5$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $22a4dd66bc9aa8d5$var$ReactSharedInternals.T, currentTransition = {};
    $22a4dd66bc9aa8d5$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $22a4dd66bc9aa8d5$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($22a4dd66bc9aa8d5$var$noop, $22a4dd66bc9aa8d5$var$reportGlobalError);
    } catch (error) {
        $22a4dd66bc9aa8d5$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $22a4dd66bc9aa8d5$var$ReactSharedInternals.T = prevTransition;
    }
};
$22a4dd66bc9aa8d5$export$f93f40ac0ca7e3a8 = function() {
    return $22a4dd66bc9aa8d5$var$ReactSharedInternals.H.useCacheRefresh();
};
$22a4dd66bc9aa8d5$export$1f96ae73734a86cc = function(usable) {
    return $22a4dd66bc9aa8d5$var$ReactSharedInternals.H.use(usable);
};
$22a4dd66bc9aa8d5$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $22a4dd66bc9aa8d5$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$22a4dd66bc9aa8d5$export$35808ee640e87ca7 = function(callback, deps) {
    return $22a4dd66bc9aa8d5$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$22a4dd66bc9aa8d5$export$fae74005e78b1a27 = function(Context) {
    return $22a4dd66bc9aa8d5$var$ReactSharedInternals.H.useContext(Context);
};
$22a4dd66bc9aa8d5$export$dc8fbce3eb94dc1e = function() {};
$22a4dd66bc9aa8d5$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $22a4dd66bc9aa8d5$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$22a4dd66bc9aa8d5$export$6d9c69b0de29b591 = function(create, deps) {
    return $22a4dd66bc9aa8d5$var$ReactSharedInternals.H.useEffect(create, deps);
};
$22a4dd66bc9aa8d5$export$7f54fc3180508a52 = function(callback) {
    return $22a4dd66bc9aa8d5$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$22a4dd66bc9aa8d5$export$f680877a34711e37 = function() {
    return $22a4dd66bc9aa8d5$var$ReactSharedInternals.H.useId();
};
$22a4dd66bc9aa8d5$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $22a4dd66bc9aa8d5$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$22a4dd66bc9aa8d5$export$aaabe4eda9ed9969 = function(create, deps) {
    return $22a4dd66bc9aa8d5$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$22a4dd66bc9aa8d5$export$e5c5a5f917a5871c = function(create, deps) {
    return $22a4dd66bc9aa8d5$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$22a4dd66bc9aa8d5$export$1538c33de8887b59 = function(create, deps) {
    return $22a4dd66bc9aa8d5$var$ReactSharedInternals.H.useMemo(create, deps);
};
$22a4dd66bc9aa8d5$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $22a4dd66bc9aa8d5$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$22a4dd66bc9aa8d5$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $22a4dd66bc9aa8d5$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$22a4dd66bc9aa8d5$export$b8f5890fc79d6aca = function(initialValue) {
    return $22a4dd66bc9aa8d5$var$ReactSharedInternals.H.useRef(initialValue);
};
$22a4dd66bc9aa8d5$export$60241385465d0a34 = function(initialState) {
    return $22a4dd66bc9aa8d5$var$ReactSharedInternals.H.useState(initialState);
};
$22a4dd66bc9aa8d5$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $22a4dd66bc9aa8d5$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$22a4dd66bc9aa8d5$export$7b286972b8d8ccbf = function() {
    return $22a4dd66bc9aa8d5$var$ReactSharedInternals.H.useTransition();
};
$22a4dd66bc9aa8d5$export$83d89fbfd8236492 = "19.2.6";

});

parcelRegister("7N7uP", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $5ac2ec94ade4afdf$export$882461b6382ed46c, (v) => $5ac2ec94ade4afdf$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $5ac2ec94ade4afdf$export$757ceba2d55c277e, (v) => $5ac2ec94ade4afdf$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $5ac2ec94ade4afdf$export$83d89fbfd8236492, (v) => $5ac2ec94ade4afdf$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $5ac2ec94ade4afdf$export$882461b6382ed46c;
var $5ac2ec94ade4afdf$export$757ceba2d55c277e;
var $5ac2ec94ade4afdf$export$83d89fbfd8236492;
"use strict";

var $bIbqH = parcelRequire("bIbqH");

var $5iwRF = parcelRequire("5iwRF");

var $epKkp = parcelRequire("epKkp");
function $5ac2ec94ade4afdf$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $5ac2ec94ade4afdf$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $5ac2ec94ade4afdf$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $5ac2ec94ade4afdf$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $5ac2ec94ade4afdf$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $5ac2ec94ade4afdf$var$assertIsMounted(fiber) {
    if ($5ac2ec94ade4afdf$var$getNearestMountedFiber(fiber) !== fiber) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(188));
}
function $5ac2ec94ade4afdf$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $5ac2ec94ade4afdf$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $5ac2ec94ade4afdf$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $5ac2ec94ade4afdf$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $5ac2ec94ade4afdf$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $5ac2ec94ade4afdf$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $5ac2ec94ade4afdf$var$assign = Object.assign, $5ac2ec94ade4afdf$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $5ac2ec94ade4afdf$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $5ac2ec94ade4afdf$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $5ac2ec94ade4afdf$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $5ac2ec94ade4afdf$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $5ac2ec94ade4afdf$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $5ac2ec94ade4afdf$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $5ac2ec94ade4afdf$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $5ac2ec94ade4afdf$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $5ac2ec94ade4afdf$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $5ac2ec94ade4afdf$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $5ac2ec94ade4afdf$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $5ac2ec94ade4afdf$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $5ac2ec94ade4afdf$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $5ac2ec94ade4afdf$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $5ac2ec94ade4afdf$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $5ac2ec94ade4afdf$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $5ac2ec94ade4afdf$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$5ac2ec94ade4afdf$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $5ac2ec94ade4afdf$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $5ac2ec94ade4afdf$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $5ac2ec94ade4afdf$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $5ac2ec94ade4afdf$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $5ac2ec94ade4afdf$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $5ac2ec94ade4afdf$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $5ac2ec94ade4afdf$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $5ac2ec94ade4afdf$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $5ac2ec94ade4afdf$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $5ac2ec94ade4afdf$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $5ac2ec94ade4afdf$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $5ac2ec94ade4afdf$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $5ac2ec94ade4afdf$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $5ac2ec94ade4afdf$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $5ac2ec94ade4afdf$var$getComponentNameFromType(type.type) || "Memo";
        case $5ac2ec94ade4afdf$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $5ac2ec94ade4afdf$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $5ac2ec94ade4afdf$var$isArrayImpl = Array.isArray, $5ac2ec94ade4afdf$var$ReactSharedInternals = $5iwRF.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $5ac2ec94ade4afdf$var$ReactDOMSharedInternals = $epKkp.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $5ac2ec94ade4afdf$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $5ac2ec94ade4afdf$var$valueStack = [], $5ac2ec94ade4afdf$var$index = -1;
function $5ac2ec94ade4afdf$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $5ac2ec94ade4afdf$var$pop(cursor) {
    0 > $5ac2ec94ade4afdf$var$index || (cursor.current = $5ac2ec94ade4afdf$var$valueStack[$5ac2ec94ade4afdf$var$index], $5ac2ec94ade4afdf$var$valueStack[$5ac2ec94ade4afdf$var$index] = null, $5ac2ec94ade4afdf$var$index--);
}
function $5ac2ec94ade4afdf$var$push(cursor, value) {
    $5ac2ec94ade4afdf$var$index++;
    $5ac2ec94ade4afdf$var$valueStack[$5ac2ec94ade4afdf$var$index] = cursor.current;
    cursor.current = value;
}
var $5ac2ec94ade4afdf$var$contextStackCursor = $5ac2ec94ade4afdf$var$createCursor(null), $5ac2ec94ade4afdf$var$contextFiberStackCursor = $5ac2ec94ade4afdf$var$createCursor(null), $5ac2ec94ade4afdf$var$rootInstanceStackCursor = $5ac2ec94ade4afdf$var$createCursor(null), $5ac2ec94ade4afdf$var$hostTransitionProviderCursor = $5ac2ec94ade4afdf$var$createCursor(null);
function $5ac2ec94ade4afdf$var$pushHostContainer(fiber, nextRootInstance) {
    $5ac2ec94ade4afdf$var$push($5ac2ec94ade4afdf$var$rootInstanceStackCursor, nextRootInstance);
    $5ac2ec94ade4afdf$var$push($5ac2ec94ade4afdf$var$contextFiberStackCursor, fiber);
    $5ac2ec94ade4afdf$var$push($5ac2ec94ade4afdf$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $5ac2ec94ade4afdf$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $5ac2ec94ade4afdf$var$getOwnHostContext(nextRootInstance), fiber = $5ac2ec94ade4afdf$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $5ac2ec94ade4afdf$var$pop($5ac2ec94ade4afdf$var$contextStackCursor);
    $5ac2ec94ade4afdf$var$push($5ac2ec94ade4afdf$var$contextStackCursor, fiber);
}
function $5ac2ec94ade4afdf$var$popHostContainer() {
    $5ac2ec94ade4afdf$var$pop($5ac2ec94ade4afdf$var$contextStackCursor);
    $5ac2ec94ade4afdf$var$pop($5ac2ec94ade4afdf$var$contextFiberStackCursor);
    $5ac2ec94ade4afdf$var$pop($5ac2ec94ade4afdf$var$rootInstanceStackCursor);
}
function $5ac2ec94ade4afdf$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $5ac2ec94ade4afdf$var$push($5ac2ec94ade4afdf$var$hostTransitionProviderCursor, fiber);
    var context = $5ac2ec94ade4afdf$var$contextStackCursor.current;
    var JSCompiler_inline_result = $5ac2ec94ade4afdf$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($5ac2ec94ade4afdf$var$push($5ac2ec94ade4afdf$var$contextFiberStackCursor, fiber), $5ac2ec94ade4afdf$var$push($5ac2ec94ade4afdf$var$contextStackCursor, JSCompiler_inline_result));
}
function $5ac2ec94ade4afdf$var$popHostContext(fiber) {
    $5ac2ec94ade4afdf$var$contextFiberStackCursor.current === fiber && ($5ac2ec94ade4afdf$var$pop($5ac2ec94ade4afdf$var$contextStackCursor), $5ac2ec94ade4afdf$var$pop($5ac2ec94ade4afdf$var$contextFiberStackCursor));
    $5ac2ec94ade4afdf$var$hostTransitionProviderCursor.current === fiber && ($5ac2ec94ade4afdf$var$pop($5ac2ec94ade4afdf$var$hostTransitionProviderCursor), $5ac2ec94ade4afdf$var$HostTransitionContext._currentValue = $5ac2ec94ade4afdf$var$sharedNotPendingObject);
}
var $5ac2ec94ade4afdf$var$prefix, $5ac2ec94ade4afdf$var$suffix;
function $5ac2ec94ade4afdf$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $5ac2ec94ade4afdf$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $5ac2ec94ade4afdf$var$prefix = match && match[1] || "";
        $5ac2ec94ade4afdf$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $5ac2ec94ade4afdf$var$prefix + name + $5ac2ec94ade4afdf$var$suffix;
}
var $5ac2ec94ade4afdf$var$reentry = !1;
function $5ac2ec94ade4afdf$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $5ac2ec94ade4afdf$var$reentry) return "";
    $5ac2ec94ade4afdf$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $5ac2ec94ade4afdf$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $5ac2ec94ade4afdf$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $5ac2ec94ade4afdf$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $5ac2ec94ade4afdf$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $5ac2ec94ade4afdf$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $5ac2ec94ade4afdf$var$describeBuiltInComponentFrame("Suspense Fallback") : $5ac2ec94ade4afdf$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $5ac2ec94ade4afdf$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $5ac2ec94ade4afdf$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $5ac2ec94ade4afdf$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $5ac2ec94ade4afdf$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $5ac2ec94ade4afdf$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $5ac2ec94ade4afdf$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $5ac2ec94ade4afdf$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $5ac2ec94ade4afdf$var$hasOwnProperty = Object.prototype.hasOwnProperty, $5ac2ec94ade4afdf$var$scheduleCallback$3 = $bIbqH.unstable_scheduleCallback, $5ac2ec94ade4afdf$var$cancelCallback$1 = $bIbqH.unstable_cancelCallback, $5ac2ec94ade4afdf$var$shouldYield = $bIbqH.unstable_shouldYield, $5ac2ec94ade4afdf$var$requestPaint = $bIbqH.unstable_requestPaint, $5ac2ec94ade4afdf$var$now = $bIbqH.unstable_now, $5ac2ec94ade4afdf$var$getCurrentPriorityLevel = $bIbqH.unstable_getCurrentPriorityLevel, $5ac2ec94ade4afdf$var$ImmediatePriority = $bIbqH.unstable_ImmediatePriority, $5ac2ec94ade4afdf$var$UserBlockingPriority = $bIbqH.unstable_UserBlockingPriority, $5ac2ec94ade4afdf$var$NormalPriority$1 = $bIbqH.unstable_NormalPriority, $5ac2ec94ade4afdf$var$LowPriority = $bIbqH.unstable_LowPriority, $5ac2ec94ade4afdf$var$IdlePriority = $bIbqH.unstable_IdlePriority, $5ac2ec94ade4afdf$var$log$1 = $bIbqH.log, $5ac2ec94ade4afdf$var$unstable_setDisableYieldValue = $bIbqH.unstable_setDisableYieldValue, $5ac2ec94ade4afdf$var$rendererID = null, $5ac2ec94ade4afdf$var$injectedHook = null;
function $5ac2ec94ade4afdf$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $5ac2ec94ade4afdf$var$log$1 && $5ac2ec94ade4afdf$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($5ac2ec94ade4afdf$var$injectedHook && "function" === typeof $5ac2ec94ade4afdf$var$injectedHook.setStrictMode) try {
        $5ac2ec94ade4afdf$var$injectedHook.setStrictMode($5ac2ec94ade4afdf$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $5ac2ec94ade4afdf$var$clz32 = Math.clz32 ? Math.clz32 : $5ac2ec94ade4afdf$var$clz32Fallback, $5ac2ec94ade4afdf$var$log = Math.log, $5ac2ec94ade4afdf$var$LN2 = Math.LN2;
function $5ac2ec94ade4afdf$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($5ac2ec94ade4afdf$var$log(x) / $5ac2ec94ade4afdf$var$LN2 | 0) | 0;
}
var $5ac2ec94ade4afdf$var$nextTransitionUpdateLane = 256, $5ac2ec94ade4afdf$var$nextTransitionDeferredLane = 262144, $5ac2ec94ade4afdf$var$nextRetryLane = 4194304;
function $5ac2ec94ade4afdf$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $5ac2ec94ade4afdf$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $5ac2ec94ade4afdf$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $5ac2ec94ade4afdf$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $5ac2ec94ade4afdf$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $5ac2ec94ade4afdf$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $5ac2ec94ade4afdf$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $5ac2ec94ade4afdf$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $5ac2ec94ade4afdf$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $5ac2ec94ade4afdf$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $5ac2ec94ade4afdf$var$claimNextRetryLane() {
    var lane = $5ac2ec94ade4afdf$var$nextRetryLane;
    $5ac2ec94ade4afdf$var$nextRetryLane <<= 1;
    0 === ($5ac2ec94ade4afdf$var$nextRetryLane & 62914560) && ($5ac2ec94ade4afdf$var$nextRetryLane = 4194304);
    return lane;
}
function $5ac2ec94ade4afdf$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $5ac2ec94ade4afdf$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $5ac2ec94ade4afdf$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $5ac2ec94ade4afdf$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $5ac2ec94ade4afdf$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $5ac2ec94ade4afdf$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $5ac2ec94ade4afdf$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $5ac2ec94ade4afdf$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $5ac2ec94ade4afdf$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $5ac2ec94ade4afdf$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $5ac2ec94ade4afdf$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $5ac2ec94ade4afdf$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $5ac2ec94ade4afdf$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $5ac2ec94ade4afdf$var$resolveUpdatePriority() {
    var updatePriority = $5ac2ec94ade4afdf$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $5ac2ec94ade4afdf$var$getEventPriority(updatePriority.type);
}
function $5ac2ec94ade4afdf$var$runWithPriority(priority, fn) {
    var previousPriority = $5ac2ec94ade4afdf$var$ReactDOMSharedInternals.p;
    try {
        return $5ac2ec94ade4afdf$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $5ac2ec94ade4afdf$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $5ac2ec94ade4afdf$var$randomKey = Math.random().toString(36).slice(2), $5ac2ec94ade4afdf$var$internalInstanceKey = "__reactFiber$" + $5ac2ec94ade4afdf$var$randomKey, $5ac2ec94ade4afdf$var$internalPropsKey = "__reactProps$" + $5ac2ec94ade4afdf$var$randomKey, $5ac2ec94ade4afdf$var$internalContainerInstanceKey = "__reactContainer$" + $5ac2ec94ade4afdf$var$randomKey, $5ac2ec94ade4afdf$var$internalEventHandlersKey = "__reactEvents$" + $5ac2ec94ade4afdf$var$randomKey, $5ac2ec94ade4afdf$var$internalEventHandlerListenersKey = "__reactListeners$" + $5ac2ec94ade4afdf$var$randomKey, $5ac2ec94ade4afdf$var$internalEventHandlesSetKey = "__reactHandles$" + $5ac2ec94ade4afdf$var$randomKey, $5ac2ec94ade4afdf$var$internalRootNodeResourcesKey = "__reactResources$" + $5ac2ec94ade4afdf$var$randomKey, $5ac2ec94ade4afdf$var$internalHoistableMarker = "__reactMarker$" + $5ac2ec94ade4afdf$var$randomKey;
function $5ac2ec94ade4afdf$var$detachDeletedInstance(node) {
    delete node[$5ac2ec94ade4afdf$var$internalInstanceKey];
    delete node[$5ac2ec94ade4afdf$var$internalPropsKey];
    delete node[$5ac2ec94ade4afdf$var$internalEventHandlersKey];
    delete node[$5ac2ec94ade4afdf$var$internalEventHandlerListenersKey];
    delete node[$5ac2ec94ade4afdf$var$internalEventHandlesSetKey];
}
function $5ac2ec94ade4afdf$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$5ac2ec94ade4afdf$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$5ac2ec94ade4afdf$var$internalContainerInstanceKey] || parentNode[$5ac2ec94ade4afdf$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $5ac2ec94ade4afdf$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$5ac2ec94ade4afdf$var$internalInstanceKey]) return parentNode;
                targetNode = $5ac2ec94ade4afdf$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $5ac2ec94ade4afdf$var$getInstanceFromNode(node) {
    if (node = node[$5ac2ec94ade4afdf$var$internalInstanceKey] || node[$5ac2ec94ade4afdf$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $5ac2ec94ade4afdf$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(33));
}
function $5ac2ec94ade4afdf$var$getResourcesFromRoot(root) {
    var resources = root[$5ac2ec94ade4afdf$var$internalRootNodeResourcesKey];
    resources || (resources = root[$5ac2ec94ade4afdf$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $5ac2ec94ade4afdf$var$markNodeAsHoistable(node) {
    node[$5ac2ec94ade4afdf$var$internalHoistableMarker] = !0;
}
var $5ac2ec94ade4afdf$var$allNativeEvents = new Set(), $5ac2ec94ade4afdf$var$registrationNameDependencies = {};
function $5ac2ec94ade4afdf$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $5ac2ec94ade4afdf$var$registerDirectEvent(registrationName, dependencies);
    $5ac2ec94ade4afdf$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $5ac2ec94ade4afdf$var$registerDirectEvent(registrationName, dependencies) {
    $5ac2ec94ade4afdf$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$5ac2ec94ade4afdf$var$allNativeEvents.add(dependencies[registrationName]);
}
var $5ac2ec94ade4afdf$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $5ac2ec94ade4afdf$var$illegalAttributeNameCache = {}, $5ac2ec94ade4afdf$var$validatedAttributeNameCache = {};
function $5ac2ec94ade4afdf$var$isAttributeNameSafe(attributeName) {
    if ($5ac2ec94ade4afdf$var$hasOwnProperty.call($5ac2ec94ade4afdf$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($5ac2ec94ade4afdf$var$hasOwnProperty.call($5ac2ec94ade4afdf$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($5ac2ec94ade4afdf$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $5ac2ec94ade4afdf$var$validatedAttributeNameCache[attributeName] = !0;
    $5ac2ec94ade4afdf$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $5ac2ec94ade4afdf$var$setValueForAttribute(node, name, value) {
    if ($5ac2ec94ade4afdf$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $5ac2ec94ade4afdf$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $5ac2ec94ade4afdf$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $5ac2ec94ade4afdf$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $5ac2ec94ade4afdf$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $5ac2ec94ade4afdf$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $5ac2ec94ade4afdf$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $5ac2ec94ade4afdf$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $5ac2ec94ade4afdf$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $5ac2ec94ade4afdf$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $5ac2ec94ade4afdf$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $5ac2ec94ade4afdf$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $5ac2ec94ade4afdf$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $5ac2ec94ade4afdf$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($5ac2ec94ade4afdf$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $5ac2ec94ade4afdf$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $5ac2ec94ade4afdf$var$getToStringValue(value);
        } else element.value !== "" + $5ac2ec94ade4afdf$var$getToStringValue(value) && (element.value = "" + $5ac2ec94ade4afdf$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $5ac2ec94ade4afdf$var$setDefaultValue(element, type, $5ac2ec94ade4afdf$var$getToStringValue(value)) : null != defaultValue ? $5ac2ec94ade4afdf$var$setDefaultValue(element, type, $5ac2ec94ade4afdf$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $5ac2ec94ade4afdf$var$getToStringValue(name) : element.removeAttribute("name");
}
function $5ac2ec94ade4afdf$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $5ac2ec94ade4afdf$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $5ac2ec94ade4afdf$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $5ac2ec94ade4afdf$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $5ac2ec94ade4afdf$var$track(element);
}
function $5ac2ec94ade4afdf$var$setDefaultValue(node, type, value) {
    "number" === type && $5ac2ec94ade4afdf$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $5ac2ec94ade4afdf$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $5ac2ec94ade4afdf$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $5ac2ec94ade4afdf$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $5ac2ec94ade4afdf$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $5ac2ec94ade4afdf$var$getToStringValue(defaultValue) : "";
}
function $5ac2ec94ade4afdf$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(92));
            if ($5ac2ec94ade4afdf$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $5ac2ec94ade4afdf$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $5ac2ec94ade4afdf$var$track(element);
}
function $5ac2ec94ade4afdf$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $5ac2ec94ade4afdf$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $5ac2ec94ade4afdf$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $5ac2ec94ade4afdf$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $5ac2ec94ade4afdf$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $5ac2ec94ade4afdf$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $5ac2ec94ade4afdf$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $5ac2ec94ade4afdf$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $5ac2ec94ade4afdf$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $5ac2ec94ade4afdf$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $5ac2ec94ade4afdf$var$sanitizeURL(url) {
    return $5ac2ec94ade4afdf$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $5ac2ec94ade4afdf$var$noop$1() {}
var $5ac2ec94ade4afdf$var$currentReplayingEvent = null;
function $5ac2ec94ade4afdf$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $5ac2ec94ade4afdf$var$restoreTarget = null, $5ac2ec94ade4afdf$var$restoreQueue = null;
function $5ac2ec94ade4afdf$var$restoreStateOfTarget(target) {
    var internalInstance = $5ac2ec94ade4afdf$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$5ac2ec94ade4afdf$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $5ac2ec94ade4afdf$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $5ac2ec94ade4afdf$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$5ac2ec94ade4afdf$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(90));
                            $5ac2ec94ade4afdf$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $5ac2ec94ade4afdf$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $5ac2ec94ade4afdf$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $5ac2ec94ade4afdf$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $5ac2ec94ade4afdf$var$isInsideEventHandler = !1;
function $5ac2ec94ade4afdf$var$batchedUpdates$1(fn, a, b) {
    if ($5ac2ec94ade4afdf$var$isInsideEventHandler) return fn(a, b);
    $5ac2ec94ade4afdf$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($5ac2ec94ade4afdf$var$isInsideEventHandler = !1, null !== $5ac2ec94ade4afdf$var$restoreTarget || null !== $5ac2ec94ade4afdf$var$restoreQueue) {
            if ($5ac2ec94ade4afdf$var$flushSyncWork$1(), $5ac2ec94ade4afdf$var$restoreTarget && (a = $5ac2ec94ade4afdf$var$restoreTarget, fn = $5ac2ec94ade4afdf$var$restoreQueue, $5ac2ec94ade4afdf$var$restoreQueue = $5ac2ec94ade4afdf$var$restoreTarget = null, $5ac2ec94ade4afdf$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$5ac2ec94ade4afdf$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $5ac2ec94ade4afdf$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$5ac2ec94ade4afdf$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $5ac2ec94ade4afdf$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $5ac2ec94ade4afdf$var$passiveBrowserEventsSupported = !1;
if ($5ac2ec94ade4afdf$var$canUseDOM) try {
    var $5ac2ec94ade4afdf$var$options = {};
    Object.defineProperty($5ac2ec94ade4afdf$var$options, "passive", {
        get: function() {
            $5ac2ec94ade4afdf$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $5ac2ec94ade4afdf$var$options, $5ac2ec94ade4afdf$var$options);
    window.removeEventListener("test", $5ac2ec94ade4afdf$var$options, $5ac2ec94ade4afdf$var$options);
} catch (e) {
    $5ac2ec94ade4afdf$var$passiveBrowserEventsSupported = !1;
}
var $5ac2ec94ade4afdf$var$root = null, $5ac2ec94ade4afdf$var$startText = null, $5ac2ec94ade4afdf$var$fallbackText = null;
function $5ac2ec94ade4afdf$var$getData() {
    if ($5ac2ec94ade4afdf$var$fallbackText) return $5ac2ec94ade4afdf$var$fallbackText;
    var start, startValue = $5ac2ec94ade4afdf$var$startText, startLength = startValue.length, end, endValue = "value" in $5ac2ec94ade4afdf$var$root ? $5ac2ec94ade4afdf$var$root.value : $5ac2ec94ade4afdf$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $5ac2ec94ade4afdf$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $5ac2ec94ade4afdf$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $5ac2ec94ade4afdf$var$functionThatReturnsTrue() {
    return !0;
}
function $5ac2ec94ade4afdf$var$functionThatReturnsFalse() {
    return !1;
}
function $5ac2ec94ade4afdf$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $5ac2ec94ade4afdf$var$functionThatReturnsTrue : $5ac2ec94ade4afdf$var$functionThatReturnsFalse;
        this.isPropagationStopped = $5ac2ec94ade4afdf$var$functionThatReturnsFalse;
        return this;
    }
    $5ac2ec94ade4afdf$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $5ac2ec94ade4afdf$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $5ac2ec94ade4afdf$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $5ac2ec94ade4afdf$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $5ac2ec94ade4afdf$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $5ac2ec94ade4afdf$var$SyntheticEvent = $5ac2ec94ade4afdf$var$createSyntheticEvent($5ac2ec94ade4afdf$var$EventInterface), $5ac2ec94ade4afdf$var$UIEventInterface = $5ac2ec94ade4afdf$var$assign({}, $5ac2ec94ade4afdf$var$EventInterface, {
    view: 0,
    detail: 0
}), $5ac2ec94ade4afdf$var$SyntheticUIEvent = $5ac2ec94ade4afdf$var$createSyntheticEvent($5ac2ec94ade4afdf$var$UIEventInterface), $5ac2ec94ade4afdf$var$lastMovementX, $5ac2ec94ade4afdf$var$lastMovementY, $5ac2ec94ade4afdf$var$lastMouseEvent, $5ac2ec94ade4afdf$var$MouseEventInterface = $5ac2ec94ade4afdf$var$assign({}, $5ac2ec94ade4afdf$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $5ac2ec94ade4afdf$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $5ac2ec94ade4afdf$var$lastMouseEvent && ($5ac2ec94ade4afdf$var$lastMouseEvent && "mousemove" === event.type ? ($5ac2ec94ade4afdf$var$lastMovementX = event.screenX - $5ac2ec94ade4afdf$var$lastMouseEvent.screenX, $5ac2ec94ade4afdf$var$lastMovementY = event.screenY - $5ac2ec94ade4afdf$var$lastMouseEvent.screenY) : $5ac2ec94ade4afdf$var$lastMovementY = $5ac2ec94ade4afdf$var$lastMovementX = 0, $5ac2ec94ade4afdf$var$lastMouseEvent = event);
        return $5ac2ec94ade4afdf$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $5ac2ec94ade4afdf$var$lastMovementY;
    }
}), $5ac2ec94ade4afdf$var$SyntheticMouseEvent = $5ac2ec94ade4afdf$var$createSyntheticEvent($5ac2ec94ade4afdf$var$MouseEventInterface), $5ac2ec94ade4afdf$var$DragEventInterface = $5ac2ec94ade4afdf$var$assign({}, $5ac2ec94ade4afdf$var$MouseEventInterface, {
    dataTransfer: 0
}), $5ac2ec94ade4afdf$var$SyntheticDragEvent = $5ac2ec94ade4afdf$var$createSyntheticEvent($5ac2ec94ade4afdf$var$DragEventInterface), $5ac2ec94ade4afdf$var$FocusEventInterface = $5ac2ec94ade4afdf$var$assign({}, $5ac2ec94ade4afdf$var$UIEventInterface, {
    relatedTarget: 0
}), $5ac2ec94ade4afdf$var$SyntheticFocusEvent = $5ac2ec94ade4afdf$var$createSyntheticEvent($5ac2ec94ade4afdf$var$FocusEventInterface), $5ac2ec94ade4afdf$var$AnimationEventInterface = $5ac2ec94ade4afdf$var$assign({}, $5ac2ec94ade4afdf$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $5ac2ec94ade4afdf$var$SyntheticAnimationEvent = $5ac2ec94ade4afdf$var$createSyntheticEvent($5ac2ec94ade4afdf$var$AnimationEventInterface), $5ac2ec94ade4afdf$var$ClipboardEventInterface = $5ac2ec94ade4afdf$var$assign({}, $5ac2ec94ade4afdf$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $5ac2ec94ade4afdf$var$SyntheticClipboardEvent = $5ac2ec94ade4afdf$var$createSyntheticEvent($5ac2ec94ade4afdf$var$ClipboardEventInterface), $5ac2ec94ade4afdf$var$CompositionEventInterface = $5ac2ec94ade4afdf$var$assign({}, $5ac2ec94ade4afdf$var$EventInterface, {
    data: 0
}), $5ac2ec94ade4afdf$var$SyntheticCompositionEvent = $5ac2ec94ade4afdf$var$createSyntheticEvent($5ac2ec94ade4afdf$var$CompositionEventInterface), $5ac2ec94ade4afdf$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $5ac2ec94ade4afdf$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $5ac2ec94ade4afdf$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $5ac2ec94ade4afdf$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $5ac2ec94ade4afdf$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $5ac2ec94ade4afdf$var$getEventModifierState() {
    return $5ac2ec94ade4afdf$var$modifierStateGetter;
}
var $5ac2ec94ade4afdf$var$KeyboardEventInterface = $5ac2ec94ade4afdf$var$assign({}, $5ac2ec94ade4afdf$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $5ac2ec94ade4afdf$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $5ac2ec94ade4afdf$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $5ac2ec94ade4afdf$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $5ac2ec94ade4afdf$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $5ac2ec94ade4afdf$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $5ac2ec94ade4afdf$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $5ac2ec94ade4afdf$var$SyntheticKeyboardEvent = $5ac2ec94ade4afdf$var$createSyntheticEvent($5ac2ec94ade4afdf$var$KeyboardEventInterface), $5ac2ec94ade4afdf$var$PointerEventInterface = $5ac2ec94ade4afdf$var$assign({}, $5ac2ec94ade4afdf$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $5ac2ec94ade4afdf$var$SyntheticPointerEvent = $5ac2ec94ade4afdf$var$createSyntheticEvent($5ac2ec94ade4afdf$var$PointerEventInterface), $5ac2ec94ade4afdf$var$TouchEventInterface = $5ac2ec94ade4afdf$var$assign({}, $5ac2ec94ade4afdf$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $5ac2ec94ade4afdf$var$getEventModifierState
}), $5ac2ec94ade4afdf$var$SyntheticTouchEvent = $5ac2ec94ade4afdf$var$createSyntheticEvent($5ac2ec94ade4afdf$var$TouchEventInterface), $5ac2ec94ade4afdf$var$TransitionEventInterface = $5ac2ec94ade4afdf$var$assign({}, $5ac2ec94ade4afdf$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $5ac2ec94ade4afdf$var$SyntheticTransitionEvent = $5ac2ec94ade4afdf$var$createSyntheticEvent($5ac2ec94ade4afdf$var$TransitionEventInterface), $5ac2ec94ade4afdf$var$WheelEventInterface = $5ac2ec94ade4afdf$var$assign({}, $5ac2ec94ade4afdf$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $5ac2ec94ade4afdf$var$SyntheticWheelEvent = $5ac2ec94ade4afdf$var$createSyntheticEvent($5ac2ec94ade4afdf$var$WheelEventInterface), $5ac2ec94ade4afdf$var$ToggleEventInterface = $5ac2ec94ade4afdf$var$assign({}, $5ac2ec94ade4afdf$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $5ac2ec94ade4afdf$var$SyntheticToggleEvent = $5ac2ec94ade4afdf$var$createSyntheticEvent($5ac2ec94ade4afdf$var$ToggleEventInterface), $5ac2ec94ade4afdf$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $5ac2ec94ade4afdf$var$canUseCompositionEvent = $5ac2ec94ade4afdf$var$canUseDOM && "CompositionEvent" in window, $5ac2ec94ade4afdf$var$documentMode = null;
$5ac2ec94ade4afdf$var$canUseDOM && "documentMode" in document && ($5ac2ec94ade4afdf$var$documentMode = document.documentMode);
var $5ac2ec94ade4afdf$var$canUseTextInputEvent = $5ac2ec94ade4afdf$var$canUseDOM && "TextEvent" in window && !$5ac2ec94ade4afdf$var$documentMode, $5ac2ec94ade4afdf$var$useFallbackCompositionData = $5ac2ec94ade4afdf$var$canUseDOM && (!$5ac2ec94ade4afdf$var$canUseCompositionEvent || $5ac2ec94ade4afdf$var$documentMode && 8 < $5ac2ec94ade4afdf$var$documentMode && 11 >= $5ac2ec94ade4afdf$var$documentMode), $5ac2ec94ade4afdf$var$SPACEBAR_CHAR = String.fromCharCode(32), $5ac2ec94ade4afdf$var$hasSpaceKeypress = !1;
function $5ac2ec94ade4afdf$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $5ac2ec94ade4afdf$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $5ac2ec94ade4afdf$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $5ac2ec94ade4afdf$var$isComposing = !1;
function $5ac2ec94ade4afdf$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $5ac2ec94ade4afdf$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $5ac2ec94ade4afdf$var$hasSpaceKeypress = !0;
            return $5ac2ec94ade4afdf$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $5ac2ec94ade4afdf$var$SPACEBAR_CHAR && $5ac2ec94ade4afdf$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $5ac2ec94ade4afdf$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($5ac2ec94ade4afdf$var$isComposing) return "compositionend" === domEventName || !$5ac2ec94ade4afdf$var$canUseCompositionEvent && $5ac2ec94ade4afdf$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $5ac2ec94ade4afdf$var$getData(), $5ac2ec94ade4afdf$var$fallbackText = $5ac2ec94ade4afdf$var$startText = $5ac2ec94ade4afdf$var$root = null, $5ac2ec94ade4afdf$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $5ac2ec94ade4afdf$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $5ac2ec94ade4afdf$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $5ac2ec94ade4afdf$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$5ac2ec94ade4afdf$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $5ac2ec94ade4afdf$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $5ac2ec94ade4afdf$var$restoreTarget ? $5ac2ec94ade4afdf$var$restoreQueue ? $5ac2ec94ade4afdf$var$restoreQueue.push(target) : $5ac2ec94ade4afdf$var$restoreQueue = [
        target
    ] : $5ac2ec94ade4afdf$var$restoreTarget = target;
    inst = $5ac2ec94ade4afdf$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $5ac2ec94ade4afdf$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $5ac2ec94ade4afdf$var$activeElement$1 = null, $5ac2ec94ade4afdf$var$activeElementInst$1 = null;
function $5ac2ec94ade4afdf$var$runEventInBatch(dispatchQueue) {
    $5ac2ec94ade4afdf$var$processDispatchQueue(dispatchQueue, 0);
}
function $5ac2ec94ade4afdf$var$getInstIfValueChanged(targetInst) {
    var targetNode = $5ac2ec94ade4afdf$var$getNodeFromInstance(targetInst);
    if ($5ac2ec94ade4afdf$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $5ac2ec94ade4afdf$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $5ac2ec94ade4afdf$var$isInputEventSupported = !1;
if ($5ac2ec94ade4afdf$var$canUseDOM) {
    var $5ac2ec94ade4afdf$var$JSCompiler_inline_result$jscomp$286;
    if ($5ac2ec94ade4afdf$var$canUseDOM) {
        var $5ac2ec94ade4afdf$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$5ac2ec94ade4afdf$var$isSupported$jscomp$inline_427) {
            var $5ac2ec94ade4afdf$var$element$jscomp$inline_428 = document.createElement("div");
            $5ac2ec94ade4afdf$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $5ac2ec94ade4afdf$var$isSupported$jscomp$inline_427 = "function" === typeof $5ac2ec94ade4afdf$var$element$jscomp$inline_428.oninput;
        }
        $5ac2ec94ade4afdf$var$JSCompiler_inline_result$jscomp$286 = $5ac2ec94ade4afdf$var$isSupported$jscomp$inline_427;
    } else $5ac2ec94ade4afdf$var$JSCompiler_inline_result$jscomp$286 = !1;
    $5ac2ec94ade4afdf$var$isInputEventSupported = $5ac2ec94ade4afdf$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $5ac2ec94ade4afdf$var$stopWatchingForValueChange() {
    $5ac2ec94ade4afdf$var$activeElement$1 && ($5ac2ec94ade4afdf$var$activeElement$1.detachEvent("onpropertychange", $5ac2ec94ade4afdf$var$handlePropertyChange), $5ac2ec94ade4afdf$var$activeElementInst$1 = $5ac2ec94ade4afdf$var$activeElement$1 = null);
}
function $5ac2ec94ade4afdf$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $5ac2ec94ade4afdf$var$getInstIfValueChanged($5ac2ec94ade4afdf$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $5ac2ec94ade4afdf$var$createAndAccumulateChangeEvent(dispatchQueue, $5ac2ec94ade4afdf$var$activeElementInst$1, nativeEvent, $5ac2ec94ade4afdf$var$getEventTarget(nativeEvent));
        $5ac2ec94ade4afdf$var$batchedUpdates$1($5ac2ec94ade4afdf$var$runEventInBatch, dispatchQueue);
    }
}
function $5ac2ec94ade4afdf$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($5ac2ec94ade4afdf$var$stopWatchingForValueChange(), $5ac2ec94ade4afdf$var$activeElement$1 = target, $5ac2ec94ade4afdf$var$activeElementInst$1 = targetInst, $5ac2ec94ade4afdf$var$activeElement$1.attachEvent("onpropertychange", $5ac2ec94ade4afdf$var$handlePropertyChange)) : "focusout" === domEventName && $5ac2ec94ade4afdf$var$stopWatchingForValueChange();
}
function $5ac2ec94ade4afdf$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $5ac2ec94ade4afdf$var$getInstIfValueChanged($5ac2ec94ade4afdf$var$activeElementInst$1);
}
function $5ac2ec94ade4afdf$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $5ac2ec94ade4afdf$var$getInstIfValueChanged(targetInst);
}
function $5ac2ec94ade4afdf$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $5ac2ec94ade4afdf$var$getInstIfValueChanged(targetInst);
}
function $5ac2ec94ade4afdf$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $5ac2ec94ade4afdf$var$objectIs = "function" === typeof Object.is ? Object.is : $5ac2ec94ade4afdf$var$is;
function $5ac2ec94ade4afdf$var$shallowEqual(objA, objB) {
    if ($5ac2ec94ade4afdf$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$5ac2ec94ade4afdf$var$hasOwnProperty.call(objB, currentKey) || !$5ac2ec94ade4afdf$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $5ac2ec94ade4afdf$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $5ac2ec94ade4afdf$var$getNodeForCharacterOffset(root, offset) {
    var node = $5ac2ec94ade4afdf$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $5ac2ec94ade4afdf$var$getLeafNode(node);
    }
}
function $5ac2ec94ade4afdf$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $5ac2ec94ade4afdf$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $5ac2ec94ade4afdf$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $5ac2ec94ade4afdf$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $5ac2ec94ade4afdf$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $5ac2ec94ade4afdf$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $5ac2ec94ade4afdf$var$skipSelectionChangeEvent = $5ac2ec94ade4afdf$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $5ac2ec94ade4afdf$var$activeElement = null, $5ac2ec94ade4afdf$var$activeElementInst = null, $5ac2ec94ade4afdf$var$lastSelection = null, $5ac2ec94ade4afdf$var$mouseDown = !1;
function $5ac2ec94ade4afdf$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $5ac2ec94ade4afdf$var$mouseDown || null == $5ac2ec94ade4afdf$var$activeElement || $5ac2ec94ade4afdf$var$activeElement !== $5ac2ec94ade4afdf$var$getActiveElement(doc) || (doc = $5ac2ec94ade4afdf$var$activeElement, "selectionStart" in doc && $5ac2ec94ade4afdf$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $5ac2ec94ade4afdf$var$lastSelection && $5ac2ec94ade4afdf$var$shallowEqual($5ac2ec94ade4afdf$var$lastSelection, doc) || ($5ac2ec94ade4afdf$var$lastSelection = doc, doc = $5ac2ec94ade4afdf$var$accumulateTwoPhaseListeners($5ac2ec94ade4afdf$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $5ac2ec94ade4afdf$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $5ac2ec94ade4afdf$var$activeElement)));
}
function $5ac2ec94ade4afdf$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $5ac2ec94ade4afdf$var$vendorPrefixes = {
    animationend: $5ac2ec94ade4afdf$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $5ac2ec94ade4afdf$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $5ac2ec94ade4afdf$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $5ac2ec94ade4afdf$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $5ac2ec94ade4afdf$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $5ac2ec94ade4afdf$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $5ac2ec94ade4afdf$var$makePrefixMap("Transition", "TransitionEnd")
}, $5ac2ec94ade4afdf$var$prefixedEventNames = {}, $5ac2ec94ade4afdf$var$style = {};
$5ac2ec94ade4afdf$var$canUseDOM && ($5ac2ec94ade4afdf$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $5ac2ec94ade4afdf$var$vendorPrefixes.animationend.animation, delete $5ac2ec94ade4afdf$var$vendorPrefixes.animationiteration.animation, delete $5ac2ec94ade4afdf$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $5ac2ec94ade4afdf$var$vendorPrefixes.transitionend.transition);
function $5ac2ec94ade4afdf$var$getVendorPrefixedEventName(eventName) {
    if ($5ac2ec94ade4afdf$var$prefixedEventNames[eventName]) return $5ac2ec94ade4afdf$var$prefixedEventNames[eventName];
    if (!$5ac2ec94ade4afdf$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $5ac2ec94ade4afdf$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $5ac2ec94ade4afdf$var$style) return $5ac2ec94ade4afdf$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $5ac2ec94ade4afdf$var$ANIMATION_END = $5ac2ec94ade4afdf$var$getVendorPrefixedEventName("animationend"), $5ac2ec94ade4afdf$var$ANIMATION_ITERATION = $5ac2ec94ade4afdf$var$getVendorPrefixedEventName("animationiteration"), $5ac2ec94ade4afdf$var$ANIMATION_START = $5ac2ec94ade4afdf$var$getVendorPrefixedEventName("animationstart"), $5ac2ec94ade4afdf$var$TRANSITION_RUN = $5ac2ec94ade4afdf$var$getVendorPrefixedEventName("transitionrun"), $5ac2ec94ade4afdf$var$TRANSITION_START = $5ac2ec94ade4afdf$var$getVendorPrefixedEventName("transitionstart"), $5ac2ec94ade4afdf$var$TRANSITION_CANCEL = $5ac2ec94ade4afdf$var$getVendorPrefixedEventName("transitioncancel"), $5ac2ec94ade4afdf$var$TRANSITION_END = $5ac2ec94ade4afdf$var$getVendorPrefixedEventName("transitionend"), $5ac2ec94ade4afdf$var$topLevelEventsToReactNames = new Map(), $5ac2ec94ade4afdf$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$5ac2ec94ade4afdf$var$simpleEventPluginEvents.push("scrollEnd");
function $5ac2ec94ade4afdf$var$registerSimpleEvent(domEventName, reactName) {
    $5ac2ec94ade4afdf$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $5ac2ec94ade4afdf$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $5ac2ec94ade4afdf$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $5ac2ec94ade4afdf$var$concurrentQueues = [], $5ac2ec94ade4afdf$var$concurrentQueuesIndex = 0, $5ac2ec94ade4afdf$var$concurrentlyUpdatedLanes = 0;
function $5ac2ec94ade4afdf$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $5ac2ec94ade4afdf$var$concurrentQueuesIndex, i = $5ac2ec94ade4afdf$var$concurrentlyUpdatedLanes = $5ac2ec94ade4afdf$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $5ac2ec94ade4afdf$var$concurrentQueues[i];
        $5ac2ec94ade4afdf$var$concurrentQueues[i++] = null;
        var queue = $5ac2ec94ade4afdf$var$concurrentQueues[i];
        $5ac2ec94ade4afdf$var$concurrentQueues[i++] = null;
        var update = $5ac2ec94ade4afdf$var$concurrentQueues[i];
        $5ac2ec94ade4afdf$var$concurrentQueues[i++] = null;
        var lane = $5ac2ec94ade4afdf$var$concurrentQueues[i];
        $5ac2ec94ade4afdf$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $5ac2ec94ade4afdf$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $5ac2ec94ade4afdf$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $5ac2ec94ade4afdf$var$concurrentQueues[$5ac2ec94ade4afdf$var$concurrentQueuesIndex++] = fiber;
    $5ac2ec94ade4afdf$var$concurrentQueues[$5ac2ec94ade4afdf$var$concurrentQueuesIndex++] = queue;
    $5ac2ec94ade4afdf$var$concurrentQueues[$5ac2ec94ade4afdf$var$concurrentQueuesIndex++] = update;
    $5ac2ec94ade4afdf$var$concurrentQueues[$5ac2ec94ade4afdf$var$concurrentQueuesIndex++] = lane;
    $5ac2ec94ade4afdf$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $5ac2ec94ade4afdf$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $5ac2ec94ade4afdf$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $5ac2ec94ade4afdf$var$getRootForUpdatedFiber(fiber);
}
function $5ac2ec94ade4afdf$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $5ac2ec94ade4afdf$var$enqueueUpdate$1(fiber, null, null, lane);
    return $5ac2ec94ade4afdf$var$getRootForUpdatedFiber(fiber);
}
function $5ac2ec94ade4afdf$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $5ac2ec94ade4afdf$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $5ac2ec94ade4afdf$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $5ac2ec94ade4afdf$var$nestedUpdateCount) throw $5ac2ec94ade4afdf$var$nestedUpdateCount = 0, $5ac2ec94ade4afdf$var$rootWithNestedUpdates = null, Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $5ac2ec94ade4afdf$var$emptyContextObject = {};
function $5ac2ec94ade4afdf$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $5ac2ec94ade4afdf$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $5ac2ec94ade4afdf$var$FiberNode(tag, pendingProps, key, mode);
}
function $5ac2ec94ade4afdf$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $5ac2ec94ade4afdf$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $5ac2ec94ade4afdf$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $5ac2ec94ade4afdf$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $5ac2ec94ade4afdf$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $5ac2ec94ade4afdf$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $5ac2ec94ade4afdf$var$isHostHoistableType(type, pendingProps, $5ac2ec94ade4afdf$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $5ac2ec94ade4afdf$var$REACT_ACTIVITY_TYPE:
            return type = $5ac2ec94ade4afdf$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $5ac2ec94ade4afdf$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $5ac2ec94ade4afdf$var$REACT_FRAGMENT_TYPE:
            return $5ac2ec94ade4afdf$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $5ac2ec94ade4afdf$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $5ac2ec94ade4afdf$var$REACT_PROFILER_TYPE:
            return type = $5ac2ec94ade4afdf$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $5ac2ec94ade4afdf$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $5ac2ec94ade4afdf$var$REACT_SUSPENSE_TYPE:
            return type = $5ac2ec94ade4afdf$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $5ac2ec94ade4afdf$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $5ac2ec94ade4afdf$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $5ac2ec94ade4afdf$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $5ac2ec94ade4afdf$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $5ac2ec94ade4afdf$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $5ac2ec94ade4afdf$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $5ac2ec94ade4afdf$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $5ac2ec94ade4afdf$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $5ac2ec94ade4afdf$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $5ac2ec94ade4afdf$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $5ac2ec94ade4afdf$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $5ac2ec94ade4afdf$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $5ac2ec94ade4afdf$var$createFiberFromText(content, mode, lanes) {
    content = $5ac2ec94ade4afdf$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $5ac2ec94ade4afdf$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $5ac2ec94ade4afdf$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $5ac2ec94ade4afdf$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $5ac2ec94ade4afdf$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $5ac2ec94ade4afdf$var$CapturedStacks = new WeakMap();
function $5ac2ec94ade4afdf$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $5ac2ec94ade4afdf$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $5ac2ec94ade4afdf$var$getStackByFiberInDevAndProd(source)
        };
        $5ac2ec94ade4afdf$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $5ac2ec94ade4afdf$var$getStackByFiberInDevAndProd(source)
    };
}
var $5ac2ec94ade4afdf$var$forkStack = [], $5ac2ec94ade4afdf$var$forkStackIndex = 0, $5ac2ec94ade4afdf$var$treeForkProvider = null, $5ac2ec94ade4afdf$var$treeForkCount = 0, $5ac2ec94ade4afdf$var$idStack = [], $5ac2ec94ade4afdf$var$idStackIndex = 0, $5ac2ec94ade4afdf$var$treeContextProvider = null, $5ac2ec94ade4afdf$var$treeContextId = 1, $5ac2ec94ade4afdf$var$treeContextOverflow = "";
function $5ac2ec94ade4afdf$var$pushTreeFork(workInProgress, totalChildren) {
    $5ac2ec94ade4afdf$var$forkStack[$5ac2ec94ade4afdf$var$forkStackIndex++] = $5ac2ec94ade4afdf$var$treeForkCount;
    $5ac2ec94ade4afdf$var$forkStack[$5ac2ec94ade4afdf$var$forkStackIndex++] = $5ac2ec94ade4afdf$var$treeForkProvider;
    $5ac2ec94ade4afdf$var$treeForkProvider = workInProgress;
    $5ac2ec94ade4afdf$var$treeForkCount = totalChildren;
}
function $5ac2ec94ade4afdf$var$pushTreeId(workInProgress, totalChildren, index) {
    $5ac2ec94ade4afdf$var$idStack[$5ac2ec94ade4afdf$var$idStackIndex++] = $5ac2ec94ade4afdf$var$treeContextId;
    $5ac2ec94ade4afdf$var$idStack[$5ac2ec94ade4afdf$var$idStackIndex++] = $5ac2ec94ade4afdf$var$treeContextOverflow;
    $5ac2ec94ade4afdf$var$idStack[$5ac2ec94ade4afdf$var$idStackIndex++] = $5ac2ec94ade4afdf$var$treeContextProvider;
    $5ac2ec94ade4afdf$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $5ac2ec94ade4afdf$var$treeContextId;
    workInProgress = $5ac2ec94ade4afdf$var$treeContextOverflow;
    var baseLength = 32 - $5ac2ec94ade4afdf$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $5ac2ec94ade4afdf$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $5ac2ec94ade4afdf$var$treeContextId = 1 << 32 - $5ac2ec94ade4afdf$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $5ac2ec94ade4afdf$var$treeContextOverflow = length + workInProgress;
    } else $5ac2ec94ade4afdf$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $5ac2ec94ade4afdf$var$treeContextOverflow = workInProgress;
}
function $5ac2ec94ade4afdf$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($5ac2ec94ade4afdf$var$pushTreeFork(workInProgress, 1), $5ac2ec94ade4afdf$var$pushTreeId(workInProgress, 1, 0));
}
function $5ac2ec94ade4afdf$var$popTreeContext(workInProgress) {
    for(; workInProgress === $5ac2ec94ade4afdf$var$treeForkProvider;)$5ac2ec94ade4afdf$var$treeForkProvider = $5ac2ec94ade4afdf$var$forkStack[--$5ac2ec94ade4afdf$var$forkStackIndex], $5ac2ec94ade4afdf$var$forkStack[$5ac2ec94ade4afdf$var$forkStackIndex] = null, $5ac2ec94ade4afdf$var$treeForkCount = $5ac2ec94ade4afdf$var$forkStack[--$5ac2ec94ade4afdf$var$forkStackIndex], $5ac2ec94ade4afdf$var$forkStack[$5ac2ec94ade4afdf$var$forkStackIndex] = null;
    for(; workInProgress === $5ac2ec94ade4afdf$var$treeContextProvider;)$5ac2ec94ade4afdf$var$treeContextProvider = $5ac2ec94ade4afdf$var$idStack[--$5ac2ec94ade4afdf$var$idStackIndex], $5ac2ec94ade4afdf$var$idStack[$5ac2ec94ade4afdf$var$idStackIndex] = null, $5ac2ec94ade4afdf$var$treeContextOverflow = $5ac2ec94ade4afdf$var$idStack[--$5ac2ec94ade4afdf$var$idStackIndex], $5ac2ec94ade4afdf$var$idStack[$5ac2ec94ade4afdf$var$idStackIndex] = null, $5ac2ec94ade4afdf$var$treeContextId = $5ac2ec94ade4afdf$var$idStack[--$5ac2ec94ade4afdf$var$idStackIndex], $5ac2ec94ade4afdf$var$idStack[$5ac2ec94ade4afdf$var$idStackIndex] = null;
}
function $5ac2ec94ade4afdf$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $5ac2ec94ade4afdf$var$idStack[$5ac2ec94ade4afdf$var$idStackIndex++] = $5ac2ec94ade4afdf$var$treeContextId;
    $5ac2ec94ade4afdf$var$idStack[$5ac2ec94ade4afdf$var$idStackIndex++] = $5ac2ec94ade4afdf$var$treeContextOverflow;
    $5ac2ec94ade4afdf$var$idStack[$5ac2ec94ade4afdf$var$idStackIndex++] = $5ac2ec94ade4afdf$var$treeContextProvider;
    $5ac2ec94ade4afdf$var$treeContextId = suspendedContext.id;
    $5ac2ec94ade4afdf$var$treeContextOverflow = suspendedContext.overflow;
    $5ac2ec94ade4afdf$var$treeContextProvider = workInProgress;
}
var $5ac2ec94ade4afdf$var$hydrationParentFiber = null, $5ac2ec94ade4afdf$var$nextHydratableInstance = null, $5ac2ec94ade4afdf$var$isHydrating = !1, $5ac2ec94ade4afdf$var$hydrationErrors = null, $5ac2ec94ade4afdf$var$rootOrSingletonContext = !1, $5ac2ec94ade4afdf$var$HydrationMismatchException = Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(519));
function $5ac2ec94ade4afdf$var$throwOnHydrationMismatch(fiber) {
    var error = Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $5ac2ec94ade4afdf$var$queueHydrationError($5ac2ec94ade4afdf$var$createCapturedValueAtFiber(error, fiber));
    throw $5ac2ec94ade4afdf$var$HydrationMismatchException;
}
function $5ac2ec94ade4afdf$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$5ac2ec94ade4afdf$var$internalInstanceKey] = fiber;
    instance[$5ac2ec94ade4afdf$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $5ac2ec94ade4afdf$var$listenToNonDelegatedEvent("cancel", instance);
            $5ac2ec94ade4afdf$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $5ac2ec94ade4afdf$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $5ac2ec94ade4afdf$var$mediaEventTypes.length; type++)$5ac2ec94ade4afdf$var$listenToNonDelegatedEvent($5ac2ec94ade4afdf$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $5ac2ec94ade4afdf$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $5ac2ec94ade4afdf$var$listenToNonDelegatedEvent("error", instance);
            $5ac2ec94ade4afdf$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $5ac2ec94ade4afdf$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $5ac2ec94ade4afdf$var$listenToNonDelegatedEvent("invalid", instance);
            $5ac2ec94ade4afdf$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $5ac2ec94ade4afdf$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $5ac2ec94ade4afdf$var$listenToNonDelegatedEvent("invalid", instance), $5ac2ec94ade4afdf$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $5ac2ec94ade4afdf$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($5ac2ec94ade4afdf$var$listenToNonDelegatedEvent("beforetoggle", instance), $5ac2ec94ade4afdf$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $5ac2ec94ade4afdf$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $5ac2ec94ade4afdf$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $5ac2ec94ade4afdf$var$noop$1), instance = !0) : instance = !1;
    instance || $5ac2ec94ade4afdf$var$throwOnHydrationMismatch(fiber, !0);
}
function $5ac2ec94ade4afdf$var$popToNextHostParent(fiber) {
    for($5ac2ec94ade4afdf$var$hydrationParentFiber = fiber.return; $5ac2ec94ade4afdf$var$hydrationParentFiber;)switch($5ac2ec94ade4afdf$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $5ac2ec94ade4afdf$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $5ac2ec94ade4afdf$var$rootOrSingletonContext = !0;
            return;
        default:
            $5ac2ec94ade4afdf$var$hydrationParentFiber = $5ac2ec94ade4afdf$var$hydrationParentFiber.return;
    }
}
function $5ac2ec94ade4afdf$var$popHydrationState(fiber) {
    if (fiber !== $5ac2ec94ade4afdf$var$hydrationParentFiber) return !1;
    if (!$5ac2ec94ade4afdf$var$isHydrating) return $5ac2ec94ade4afdf$var$popToNextHostParent(fiber), $5ac2ec94ade4afdf$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $5ac2ec94ade4afdf$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $5ac2ec94ade4afdf$var$nextHydratableInstance && $5ac2ec94ade4afdf$var$throwOnHydrationMismatch(fiber);
    $5ac2ec94ade4afdf$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(317));
        $5ac2ec94ade4afdf$var$nextHydratableInstance = $5ac2ec94ade4afdf$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(317));
        $5ac2ec94ade4afdf$var$nextHydratableInstance = $5ac2ec94ade4afdf$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $5ac2ec94ade4afdf$var$nextHydratableInstance, $5ac2ec94ade4afdf$var$isSingletonScope(fiber.type) ? (fiber = $5ac2ec94ade4afdf$var$previousHydratableOnEnteringScopedSingleton, $5ac2ec94ade4afdf$var$previousHydratableOnEnteringScopedSingleton = null, $5ac2ec94ade4afdf$var$nextHydratableInstance = fiber) : $5ac2ec94ade4afdf$var$nextHydratableInstance = tag) : $5ac2ec94ade4afdf$var$nextHydratableInstance = $5ac2ec94ade4afdf$var$hydrationParentFiber ? $5ac2ec94ade4afdf$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $5ac2ec94ade4afdf$var$resetHydrationState() {
    $5ac2ec94ade4afdf$var$nextHydratableInstance = $5ac2ec94ade4afdf$var$hydrationParentFiber = null;
    $5ac2ec94ade4afdf$var$isHydrating = !1;
}
function $5ac2ec94ade4afdf$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $5ac2ec94ade4afdf$var$hydrationErrors;
    null !== queuedErrors && (null === $5ac2ec94ade4afdf$var$workInProgressRootRecoverableErrors ? $5ac2ec94ade4afdf$var$workInProgressRootRecoverableErrors = queuedErrors : $5ac2ec94ade4afdf$var$workInProgressRootRecoverableErrors.push.apply($5ac2ec94ade4afdf$var$workInProgressRootRecoverableErrors, queuedErrors), $5ac2ec94ade4afdf$var$hydrationErrors = null);
    return queuedErrors;
}
function $5ac2ec94ade4afdf$var$queueHydrationError(error) {
    null === $5ac2ec94ade4afdf$var$hydrationErrors ? $5ac2ec94ade4afdf$var$hydrationErrors = [
        error
    ] : $5ac2ec94ade4afdf$var$hydrationErrors.push(error);
}
var $5ac2ec94ade4afdf$var$valueCursor = $5ac2ec94ade4afdf$var$createCursor(null), $5ac2ec94ade4afdf$var$currentlyRenderingFiber$1 = null, $5ac2ec94ade4afdf$var$lastContextDependency = null;
function $5ac2ec94ade4afdf$var$pushProvider(providerFiber, context, nextValue) {
    $5ac2ec94ade4afdf$var$push($5ac2ec94ade4afdf$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $5ac2ec94ade4afdf$var$popProvider(context) {
    context._currentValue = $5ac2ec94ade4afdf$var$valueCursor.current;
    $5ac2ec94ade4afdf$var$pop($5ac2ec94ade4afdf$var$valueCursor);
}
function $5ac2ec94ade4afdf$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $5ac2ec94ade4afdf$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $5ac2ec94ade4afdf$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $5ac2ec94ade4afdf$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $5ac2ec94ade4afdf$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $5ac2ec94ade4afdf$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $5ac2ec94ade4afdf$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($5ac2ec94ade4afdf$var$HostTransitionContext) : current = [
                $5ac2ec94ade4afdf$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $5ac2ec94ade4afdf$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $5ac2ec94ade4afdf$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$5ac2ec94ade4afdf$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $5ac2ec94ade4afdf$var$prepareToReadContext(workInProgress) {
    $5ac2ec94ade4afdf$var$currentlyRenderingFiber$1 = workInProgress;
    $5ac2ec94ade4afdf$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $5ac2ec94ade4afdf$var$readContext(context) {
    return $5ac2ec94ade4afdf$var$readContextForConsumer($5ac2ec94ade4afdf$var$currentlyRenderingFiber$1, context);
}
function $5ac2ec94ade4afdf$var$readContextDuringReconciliation(consumer, context) {
    null === $5ac2ec94ade4afdf$var$currentlyRenderingFiber$1 && $5ac2ec94ade4afdf$var$prepareToReadContext(consumer);
    return $5ac2ec94ade4afdf$var$readContextForConsumer(consumer, context);
}
function $5ac2ec94ade4afdf$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $5ac2ec94ade4afdf$var$lastContextDependency) {
        if (null === consumer) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(308));
        $5ac2ec94ade4afdf$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $5ac2ec94ade4afdf$var$lastContextDependency = $5ac2ec94ade4afdf$var$lastContextDependency.next = context;
    return value;
}
var $5ac2ec94ade4afdf$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $5ac2ec94ade4afdf$var$scheduleCallback$2 = $bIbqH.unstable_scheduleCallback, $5ac2ec94ade4afdf$var$NormalPriority = $bIbqH.unstable_NormalPriority, $5ac2ec94ade4afdf$var$CacheContext = {
    $$typeof: $5ac2ec94ade4afdf$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $5ac2ec94ade4afdf$var$createCache() {
    return {
        controller: new $5ac2ec94ade4afdf$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $5ac2ec94ade4afdf$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $5ac2ec94ade4afdf$var$scheduleCallback$2($5ac2ec94ade4afdf$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $5ac2ec94ade4afdf$var$currentEntangledListeners = null, $5ac2ec94ade4afdf$var$currentEntangledPendingCount = 0, $5ac2ec94ade4afdf$var$currentEntangledLane = 0, $5ac2ec94ade4afdf$var$currentEntangledActionThenable = null;
function $5ac2ec94ade4afdf$var$entangleAsyncAction(transition, thenable) {
    if (null === $5ac2ec94ade4afdf$var$currentEntangledListeners) {
        var entangledListeners = $5ac2ec94ade4afdf$var$currentEntangledListeners = [];
        $5ac2ec94ade4afdf$var$currentEntangledPendingCount = 0;
        $5ac2ec94ade4afdf$var$currentEntangledLane = $5ac2ec94ade4afdf$var$requestTransitionLane();
        $5ac2ec94ade4afdf$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $5ac2ec94ade4afdf$var$currentEntangledPendingCount++;
    thenable.then($5ac2ec94ade4afdf$var$pingEngtangledActionScope, $5ac2ec94ade4afdf$var$pingEngtangledActionScope);
    return thenable;
}
function $5ac2ec94ade4afdf$var$pingEngtangledActionScope() {
    if (0 === --$5ac2ec94ade4afdf$var$currentEntangledPendingCount && null !== $5ac2ec94ade4afdf$var$currentEntangledListeners) {
        null !== $5ac2ec94ade4afdf$var$currentEntangledActionThenable && ($5ac2ec94ade4afdf$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $5ac2ec94ade4afdf$var$currentEntangledListeners;
        $5ac2ec94ade4afdf$var$currentEntangledListeners = null;
        $5ac2ec94ade4afdf$var$currentEntangledLane = 0;
        $5ac2ec94ade4afdf$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $5ac2ec94ade4afdf$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $5ac2ec94ade4afdf$var$prevOnStartTransitionFinish = $5ac2ec94ade4afdf$var$ReactSharedInternals.S;
$5ac2ec94ade4afdf$var$ReactSharedInternals.S = function(transition, returnValue) {
    $5ac2ec94ade4afdf$var$globalMostRecentTransitionTime = $5ac2ec94ade4afdf$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $5ac2ec94ade4afdf$var$entangleAsyncAction(transition, returnValue);
    null !== $5ac2ec94ade4afdf$var$prevOnStartTransitionFinish && $5ac2ec94ade4afdf$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $5ac2ec94ade4afdf$var$resumedCache = $5ac2ec94ade4afdf$var$createCursor(null);
function $5ac2ec94ade4afdf$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $5ac2ec94ade4afdf$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $5ac2ec94ade4afdf$var$workInProgressRoot.pooledCache;
}
function $5ac2ec94ade4afdf$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $5ac2ec94ade4afdf$var$push($5ac2ec94ade4afdf$var$resumedCache, $5ac2ec94ade4afdf$var$resumedCache.current) : $5ac2ec94ade4afdf$var$push($5ac2ec94ade4afdf$var$resumedCache, prevCachePool.pool);
}
function $5ac2ec94ade4afdf$var$getSuspendedCache() {
    var cacheFromPool = $5ac2ec94ade4afdf$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $5ac2ec94ade4afdf$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $5ac2ec94ade4afdf$var$SuspenseException = Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(460)), $5ac2ec94ade4afdf$var$SuspenseyCommitException = Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(474)), $5ac2ec94ade4afdf$var$SuspenseActionException = Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(542)), $5ac2ec94ade4afdf$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $5ac2ec94ade4afdf$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $5ac2ec94ade4afdf$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($5ac2ec94ade4afdf$var$noop$1, $5ac2ec94ade4afdf$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $5ac2ec94ade4afdf$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($5ac2ec94ade4afdf$var$noop$1, $5ac2ec94ade4afdf$var$noop$1);
            else {
                thenableState = $5ac2ec94ade4afdf$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $5ac2ec94ade4afdf$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $5ac2ec94ade4afdf$var$suspendedThenable = thenable;
            throw $5ac2ec94ade4afdf$var$SuspenseException;
    }
}
function $5ac2ec94ade4afdf$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $5ac2ec94ade4afdf$var$suspendedThenable = x, $5ac2ec94ade4afdf$var$SuspenseException;
        throw x;
    }
}
var $5ac2ec94ade4afdf$var$suspendedThenable = null;
function $5ac2ec94ade4afdf$var$getSuspendedThenable() {
    if (null === $5ac2ec94ade4afdf$var$suspendedThenable) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(459));
    var thenable = $5ac2ec94ade4afdf$var$suspendedThenable;
    $5ac2ec94ade4afdf$var$suspendedThenable = null;
    return thenable;
}
function $5ac2ec94ade4afdf$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $5ac2ec94ade4afdf$var$SuspenseException || rejectedReason === $5ac2ec94ade4afdf$var$SuspenseActionException) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(483));
}
var $5ac2ec94ade4afdf$var$thenableState$1 = null, $5ac2ec94ade4afdf$var$thenableIndexCounter$1 = 0;
function $5ac2ec94ade4afdf$var$unwrapThenable(thenable) {
    var index = $5ac2ec94ade4afdf$var$thenableIndexCounter$1;
    $5ac2ec94ade4afdf$var$thenableIndexCounter$1 += 1;
    null === $5ac2ec94ade4afdf$var$thenableState$1 && ($5ac2ec94ade4afdf$var$thenableState$1 = []);
    return $5ac2ec94ade4afdf$var$trackUsedThenable($5ac2ec94ade4afdf$var$thenableState$1, thenable, index);
}
function $5ac2ec94ade4afdf$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $5ac2ec94ade4afdf$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $5ac2ec94ade4afdf$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $5ac2ec94ade4afdf$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $5ac2ec94ade4afdf$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $5ac2ec94ade4afdf$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $5ac2ec94ade4afdf$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $5ac2ec94ade4afdf$var$REACT_LAZY_TYPE && $5ac2ec94ade4afdf$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $5ac2ec94ade4afdf$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $5ac2ec94ade4afdf$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $5ac2ec94ade4afdf$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $5ac2ec94ade4afdf$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $5ac2ec94ade4afdf$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $5ac2ec94ade4afdf$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $5ac2ec94ade4afdf$var$REACT_ELEMENT_TYPE:
                    return lanes = $5ac2ec94ade4afdf$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $5ac2ec94ade4afdf$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $5ac2ec94ade4afdf$var$REACT_PORTAL_TYPE:
                    return newChild = $5ac2ec94ade4afdf$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $5ac2ec94ade4afdf$var$REACT_LAZY_TYPE:
                    return newChild = $5ac2ec94ade4afdf$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($5ac2ec94ade4afdf$var$isArrayImpl(newChild) || $5ac2ec94ade4afdf$var$getIteratorFn(newChild)) return newChild = $5ac2ec94ade4afdf$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $5ac2ec94ade4afdf$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $5ac2ec94ade4afdf$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $5ac2ec94ade4afdf$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $5ac2ec94ade4afdf$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $5ac2ec94ade4afdf$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $5ac2ec94ade4afdf$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $5ac2ec94ade4afdf$var$REACT_LAZY_TYPE:
                    return newChild = $5ac2ec94ade4afdf$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($5ac2ec94ade4afdf$var$isArrayImpl(newChild) || $5ac2ec94ade4afdf$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $5ac2ec94ade4afdf$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $5ac2ec94ade4afdf$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $5ac2ec94ade4afdf$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $5ac2ec94ade4afdf$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $5ac2ec94ade4afdf$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $5ac2ec94ade4afdf$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $5ac2ec94ade4afdf$var$REACT_LAZY_TYPE:
                    return newChild = $5ac2ec94ade4afdf$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($5ac2ec94ade4afdf$var$isArrayImpl(newChild) || $5ac2ec94ade4afdf$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $5ac2ec94ade4afdf$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $5ac2ec94ade4afdf$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $5ac2ec94ade4afdf$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $5ac2ec94ade4afdf$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $5ac2ec94ade4afdf$var$isHydrating && $5ac2ec94ade4afdf$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $5ac2ec94ade4afdf$var$isHydrating && $5ac2ec94ade4afdf$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $5ac2ec94ade4afdf$var$isHydrating && $5ac2ec94ade4afdf$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $5ac2ec94ade4afdf$var$isHydrating && $5ac2ec94ade4afdf$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $5ac2ec94ade4afdf$var$isHydrating && $5ac2ec94ade4afdf$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $5ac2ec94ade4afdf$var$isHydrating && $5ac2ec94ade4afdf$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $5ac2ec94ade4afdf$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $5ac2ec94ade4afdf$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $5ac2ec94ade4afdf$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $5ac2ec94ade4afdf$var$REACT_LAZY_TYPE && $5ac2ec94ade4afdf$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $5ac2ec94ade4afdf$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $5ac2ec94ade4afdf$var$REACT_FRAGMENT_TYPE ? (lanes = $5ac2ec94ade4afdf$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $5ac2ec94ade4afdf$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $5ac2ec94ade4afdf$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $5ac2ec94ade4afdf$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $5ac2ec94ade4afdf$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $5ac2ec94ade4afdf$var$REACT_LAZY_TYPE:
                    return newChild = $5ac2ec94ade4afdf$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($5ac2ec94ade4afdf$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($5ac2ec94ade4afdf$var$getIteratorFn(newChild)) {
                key = $5ac2ec94ade4afdf$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $5ac2ec94ade4afdf$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $5ac2ec94ade4afdf$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $5ac2ec94ade4afdf$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $5ac2ec94ade4afdf$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $5ac2ec94ade4afdf$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $5ac2ec94ade4afdf$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $5ac2ec94ade4afdf$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $5ac2ec94ade4afdf$var$SuspenseException || x === $5ac2ec94ade4afdf$var$SuspenseActionException) throw x;
            var fiber = $5ac2ec94ade4afdf$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $5ac2ec94ade4afdf$var$reconcileChildFibers = $5ac2ec94ade4afdf$var$createChildReconciler(!0), $5ac2ec94ade4afdf$var$mountChildFibers = $5ac2ec94ade4afdf$var$createChildReconciler(!1), $5ac2ec94ade4afdf$var$hasForceUpdate = !1;
function $5ac2ec94ade4afdf$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $5ac2ec94ade4afdf$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $5ac2ec94ade4afdf$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $5ac2ec94ade4afdf$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($5ac2ec94ade4afdf$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $5ac2ec94ade4afdf$var$getRootForUpdatedFiber(fiber);
        $5ac2ec94ade4afdf$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $5ac2ec94ade4afdf$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $5ac2ec94ade4afdf$var$getRootForUpdatedFiber(fiber);
}
function $5ac2ec94ade4afdf$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $5ac2ec94ade4afdf$var$markRootEntangled(root, lane);
    }
}
function $5ac2ec94ade4afdf$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $5ac2ec94ade4afdf$var$didReadFromEntangledAsyncAction = !1;
function $5ac2ec94ade4afdf$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($5ac2ec94ade4afdf$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $5ac2ec94ade4afdf$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $5ac2ec94ade4afdf$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $5ac2ec94ade4afdf$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $5ac2ec94ade4afdf$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($5ac2ec94ade4afdf$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $5ac2ec94ade4afdf$var$currentEntangledLane && ($5ac2ec94ade4afdf$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $5ac2ec94ade4afdf$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $5ac2ec94ade4afdf$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $5ac2ec94ade4afdf$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $5ac2ec94ade4afdf$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $5ac2ec94ade4afdf$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$5ac2ec94ade4afdf$var$callCallback(callbacks[updateQueue], context);
}
var $5ac2ec94ade4afdf$var$currentTreeHiddenStackCursor = $5ac2ec94ade4afdf$var$createCursor(null), $5ac2ec94ade4afdf$var$prevEntangledRenderLanesCursor = $5ac2ec94ade4afdf$var$createCursor(0);
function $5ac2ec94ade4afdf$var$pushHiddenContext(fiber, context) {
    fiber = $5ac2ec94ade4afdf$var$entangledRenderLanes;
    $5ac2ec94ade4afdf$var$push($5ac2ec94ade4afdf$var$prevEntangledRenderLanesCursor, fiber);
    $5ac2ec94ade4afdf$var$push($5ac2ec94ade4afdf$var$currentTreeHiddenStackCursor, context);
    $5ac2ec94ade4afdf$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $5ac2ec94ade4afdf$var$reuseHiddenContextOnStack() {
    $5ac2ec94ade4afdf$var$push($5ac2ec94ade4afdf$var$prevEntangledRenderLanesCursor, $5ac2ec94ade4afdf$var$entangledRenderLanes);
    $5ac2ec94ade4afdf$var$push($5ac2ec94ade4afdf$var$currentTreeHiddenStackCursor, $5ac2ec94ade4afdf$var$currentTreeHiddenStackCursor.current);
}
function $5ac2ec94ade4afdf$var$popHiddenContext() {
    $5ac2ec94ade4afdf$var$entangledRenderLanes = $5ac2ec94ade4afdf$var$prevEntangledRenderLanesCursor.current;
    $5ac2ec94ade4afdf$var$pop($5ac2ec94ade4afdf$var$currentTreeHiddenStackCursor);
    $5ac2ec94ade4afdf$var$pop($5ac2ec94ade4afdf$var$prevEntangledRenderLanesCursor);
}
var $5ac2ec94ade4afdf$var$suspenseHandlerStackCursor = $5ac2ec94ade4afdf$var$createCursor(null), $5ac2ec94ade4afdf$var$shellBoundary = null;
function $5ac2ec94ade4afdf$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $5ac2ec94ade4afdf$var$push($5ac2ec94ade4afdf$var$suspenseStackCursor, $5ac2ec94ade4afdf$var$suspenseStackCursor.current & 1);
    $5ac2ec94ade4afdf$var$push($5ac2ec94ade4afdf$var$suspenseHandlerStackCursor, handler);
    null === $5ac2ec94ade4afdf$var$shellBoundary && (null === current || null !== $5ac2ec94ade4afdf$var$currentTreeHiddenStackCursor.current ? $5ac2ec94ade4afdf$var$shellBoundary = handler : null !== current.memoizedState && ($5ac2ec94ade4afdf$var$shellBoundary = handler));
}
function $5ac2ec94ade4afdf$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $5ac2ec94ade4afdf$var$push($5ac2ec94ade4afdf$var$suspenseStackCursor, $5ac2ec94ade4afdf$var$suspenseStackCursor.current);
    $5ac2ec94ade4afdf$var$push($5ac2ec94ade4afdf$var$suspenseHandlerStackCursor, fiber);
    null === $5ac2ec94ade4afdf$var$shellBoundary && ($5ac2ec94ade4afdf$var$shellBoundary = fiber);
}
function $5ac2ec94ade4afdf$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($5ac2ec94ade4afdf$var$push($5ac2ec94ade4afdf$var$suspenseStackCursor, $5ac2ec94ade4afdf$var$suspenseStackCursor.current), $5ac2ec94ade4afdf$var$push($5ac2ec94ade4afdf$var$suspenseHandlerStackCursor, fiber), null === $5ac2ec94ade4afdf$var$shellBoundary && ($5ac2ec94ade4afdf$var$shellBoundary = fiber)) : $5ac2ec94ade4afdf$var$reuseSuspenseHandlerOnStack(fiber);
}
function $5ac2ec94ade4afdf$var$reuseSuspenseHandlerOnStack() {
    $5ac2ec94ade4afdf$var$push($5ac2ec94ade4afdf$var$suspenseStackCursor, $5ac2ec94ade4afdf$var$suspenseStackCursor.current);
    $5ac2ec94ade4afdf$var$push($5ac2ec94ade4afdf$var$suspenseHandlerStackCursor, $5ac2ec94ade4afdf$var$suspenseHandlerStackCursor.current);
}
function $5ac2ec94ade4afdf$var$popSuspenseHandler(fiber) {
    $5ac2ec94ade4afdf$var$pop($5ac2ec94ade4afdf$var$suspenseHandlerStackCursor);
    $5ac2ec94ade4afdf$var$shellBoundary === fiber && ($5ac2ec94ade4afdf$var$shellBoundary = null);
    $5ac2ec94ade4afdf$var$pop($5ac2ec94ade4afdf$var$suspenseStackCursor);
}
var $5ac2ec94ade4afdf$var$suspenseStackCursor = $5ac2ec94ade4afdf$var$createCursor(0);
function $5ac2ec94ade4afdf$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $5ac2ec94ade4afdf$var$isSuspenseInstancePending(state) || $5ac2ec94ade4afdf$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $5ac2ec94ade4afdf$var$renderLanes = 0, $5ac2ec94ade4afdf$var$currentlyRenderingFiber = null, $5ac2ec94ade4afdf$var$currentHook = null, $5ac2ec94ade4afdf$var$workInProgressHook = null, $5ac2ec94ade4afdf$var$didScheduleRenderPhaseUpdate = !1, $5ac2ec94ade4afdf$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $5ac2ec94ade4afdf$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $5ac2ec94ade4afdf$var$localIdCounter = 0, $5ac2ec94ade4afdf$var$thenableIndexCounter = 0, $5ac2ec94ade4afdf$var$thenableState = null, $5ac2ec94ade4afdf$var$globalClientIdCounter = 0;
function $5ac2ec94ade4afdf$var$throwInvalidHookError() {
    throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(321));
}
function $5ac2ec94ade4afdf$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$5ac2ec94ade4afdf$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $5ac2ec94ade4afdf$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $5ac2ec94ade4afdf$var$renderLanes = nextRenderLanes;
    $5ac2ec94ade4afdf$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $5ac2ec94ade4afdf$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $5ac2ec94ade4afdf$var$HooksDispatcherOnMount : $5ac2ec94ade4afdf$var$HooksDispatcherOnUpdate;
    $5ac2ec94ade4afdf$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $5ac2ec94ade4afdf$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $5ac2ec94ade4afdf$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $5ac2ec94ade4afdf$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $5ac2ec94ade4afdf$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $5ac2ec94ade4afdf$var$finishRenderingHooks(current) {
    $5ac2ec94ade4afdf$var$ReactSharedInternals.H = $5ac2ec94ade4afdf$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $5ac2ec94ade4afdf$var$currentHook && null !== $5ac2ec94ade4afdf$var$currentHook.next;
    $5ac2ec94ade4afdf$var$renderLanes = 0;
    $5ac2ec94ade4afdf$var$workInProgressHook = $5ac2ec94ade4afdf$var$currentHook = $5ac2ec94ade4afdf$var$currentlyRenderingFiber = null;
    $5ac2ec94ade4afdf$var$didScheduleRenderPhaseUpdate = !1;
    $5ac2ec94ade4afdf$var$thenableIndexCounter = 0;
    $5ac2ec94ade4afdf$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(300));
    null === current || $5ac2ec94ade4afdf$var$didReceiveUpdate || (current = current.dependencies, null !== current && $5ac2ec94ade4afdf$var$checkIfContextChanged(current) && ($5ac2ec94ade4afdf$var$didReceiveUpdate = !0));
}
function $5ac2ec94ade4afdf$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $5ac2ec94ade4afdf$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $5ac2ec94ade4afdf$var$didScheduleRenderPhaseUpdateDuringThisPass && ($5ac2ec94ade4afdf$var$thenableState = null);
        $5ac2ec94ade4afdf$var$thenableIndexCounter = 0;
        $5ac2ec94ade4afdf$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $5ac2ec94ade4afdf$var$workInProgressHook = $5ac2ec94ade4afdf$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $5ac2ec94ade4afdf$var$ReactSharedInternals.H = $5ac2ec94ade4afdf$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($5ac2ec94ade4afdf$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $5ac2ec94ade4afdf$var$TransitionAwareHostComponent() {
    var dispatcher = $5ac2ec94ade4afdf$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $5ac2ec94ade4afdf$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $5ac2ec94ade4afdf$var$currentHook ? $5ac2ec94ade4afdf$var$currentHook.memoizedState : null) !== dispatcher && ($5ac2ec94ade4afdf$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $5ac2ec94ade4afdf$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $5ac2ec94ade4afdf$var$localIdCounter;
    $5ac2ec94ade4afdf$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $5ac2ec94ade4afdf$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $5ac2ec94ade4afdf$var$resetHooksOnUnwind(workInProgress) {
    if ($5ac2ec94ade4afdf$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $5ac2ec94ade4afdf$var$didScheduleRenderPhaseUpdate = !1;
    }
    $5ac2ec94ade4afdf$var$renderLanes = 0;
    $5ac2ec94ade4afdf$var$workInProgressHook = $5ac2ec94ade4afdf$var$currentHook = $5ac2ec94ade4afdf$var$currentlyRenderingFiber = null;
    $5ac2ec94ade4afdf$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $5ac2ec94ade4afdf$var$thenableIndexCounter = $5ac2ec94ade4afdf$var$localIdCounter = 0;
    $5ac2ec94ade4afdf$var$thenableState = null;
}
function $5ac2ec94ade4afdf$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $5ac2ec94ade4afdf$var$workInProgressHook ? $5ac2ec94ade4afdf$var$currentlyRenderingFiber.memoizedState = $5ac2ec94ade4afdf$var$workInProgressHook = hook : $5ac2ec94ade4afdf$var$workInProgressHook = $5ac2ec94ade4afdf$var$workInProgressHook.next = hook;
    return $5ac2ec94ade4afdf$var$workInProgressHook;
}
function $5ac2ec94ade4afdf$var$updateWorkInProgressHook() {
    if (null === $5ac2ec94ade4afdf$var$currentHook) {
        var nextCurrentHook = $5ac2ec94ade4afdf$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $5ac2ec94ade4afdf$var$currentHook.next;
    var nextWorkInProgressHook = null === $5ac2ec94ade4afdf$var$workInProgressHook ? $5ac2ec94ade4afdf$var$currentlyRenderingFiber.memoizedState : $5ac2ec94ade4afdf$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $5ac2ec94ade4afdf$var$workInProgressHook = nextWorkInProgressHook, $5ac2ec94ade4afdf$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $5ac2ec94ade4afdf$var$currentlyRenderingFiber.alternate) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(467));
            throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(310));
        }
        $5ac2ec94ade4afdf$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $5ac2ec94ade4afdf$var$currentHook.memoizedState,
            baseState: $5ac2ec94ade4afdf$var$currentHook.baseState,
            baseQueue: $5ac2ec94ade4afdf$var$currentHook.baseQueue,
            queue: $5ac2ec94ade4afdf$var$currentHook.queue,
            next: null
        };
        null === $5ac2ec94ade4afdf$var$workInProgressHook ? $5ac2ec94ade4afdf$var$currentlyRenderingFiber.memoizedState = $5ac2ec94ade4afdf$var$workInProgressHook = nextCurrentHook : $5ac2ec94ade4afdf$var$workInProgressHook = $5ac2ec94ade4afdf$var$workInProgressHook.next = nextCurrentHook;
    }
    return $5ac2ec94ade4afdf$var$workInProgressHook;
}
function $5ac2ec94ade4afdf$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $5ac2ec94ade4afdf$var$useThenable(thenable) {
    var index = $5ac2ec94ade4afdf$var$thenableIndexCounter;
    $5ac2ec94ade4afdf$var$thenableIndexCounter += 1;
    null === $5ac2ec94ade4afdf$var$thenableState && ($5ac2ec94ade4afdf$var$thenableState = []);
    thenable = $5ac2ec94ade4afdf$var$trackUsedThenable($5ac2ec94ade4afdf$var$thenableState, thenable, index);
    index = $5ac2ec94ade4afdf$var$currentlyRenderingFiber;
    null === (null === $5ac2ec94ade4afdf$var$workInProgressHook ? index.memoizedState : $5ac2ec94ade4afdf$var$workInProgressHook.next) && (index = index.alternate, $5ac2ec94ade4afdf$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $5ac2ec94ade4afdf$var$HooksDispatcherOnMount : $5ac2ec94ade4afdf$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $5ac2ec94ade4afdf$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $5ac2ec94ade4afdf$var$useThenable(usable);
        if (usable.$$typeof === $5ac2ec94ade4afdf$var$REACT_CONTEXT_TYPE) return $5ac2ec94ade4afdf$var$readContext(usable);
    }
    throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(438, String(usable)));
}
function $5ac2ec94ade4afdf$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $5ac2ec94ade4afdf$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $5ac2ec94ade4afdf$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $5ac2ec94ade4afdf$var$createFunctionComponentUpdateQueue(), $5ac2ec94ade4afdf$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $5ac2ec94ade4afdf$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $5ac2ec94ade4afdf$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $5ac2ec94ade4afdf$var$updateReducer(reducer) {
    var hook = $5ac2ec94ade4afdf$var$updateWorkInProgressHook();
    return $5ac2ec94ade4afdf$var$updateReducerImpl(hook, $5ac2ec94ade4afdf$var$currentHook, reducer);
}
function $5ac2ec94ade4afdf$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($5ac2ec94ade4afdf$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($5ac2ec94ade4afdf$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $5ac2ec94ade4afdf$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($5ac2ec94ade4afdf$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $5ac2ec94ade4afdf$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $5ac2ec94ade4afdf$var$currentlyRenderingFiber.lanes |= revertLane, $5ac2ec94ade4afdf$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $5ac2ec94ade4afdf$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $5ac2ec94ade4afdf$var$currentlyRenderingFiber.lanes |= updateLane, $5ac2ec94ade4afdf$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$5ac2ec94ade4afdf$var$objectIs(pendingQueue, hook.memoizedState) && ($5ac2ec94ade4afdf$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $5ac2ec94ade4afdf$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $5ac2ec94ade4afdf$var$rerenderReducer(reducer) {
    var hook = $5ac2ec94ade4afdf$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $5ac2ec94ade4afdf$var$objectIs(newState, hook.memoizedState) || ($5ac2ec94ade4afdf$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $5ac2ec94ade4afdf$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $5ac2ec94ade4afdf$var$currentlyRenderingFiber, hook = $5ac2ec94ade4afdf$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $5ac2ec94ade4afdf$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$5ac2ec94ade4afdf$var$objectIs(($5ac2ec94ade4afdf$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $5ac2ec94ade4afdf$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $5ac2ec94ade4afdf$var$updateEffect($5ac2ec94ade4afdf$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $5ac2ec94ade4afdf$var$workInProgressHook && $5ac2ec94ade4afdf$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $5ac2ec94ade4afdf$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $5ac2ec94ade4afdf$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $5ac2ec94ade4afdf$var$workInProgressRoot) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($5ac2ec94ade4afdf$var$renderLanes & 127) || $5ac2ec94ade4afdf$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $5ac2ec94ade4afdf$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $5ac2ec94ade4afdf$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $5ac2ec94ade4afdf$var$createFunctionComponentUpdateQueue(), $5ac2ec94ade4afdf$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $5ac2ec94ade4afdf$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $5ac2ec94ade4afdf$var$checkIfSnapshotChanged(inst) && $5ac2ec94ade4afdf$var$forceStoreRerender(fiber);
}
function $5ac2ec94ade4afdf$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $5ac2ec94ade4afdf$var$checkIfSnapshotChanged(inst) && $5ac2ec94ade4afdf$var$forceStoreRerender(fiber);
    });
}
function $5ac2ec94ade4afdf$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$5ac2ec94ade4afdf$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $5ac2ec94ade4afdf$var$forceStoreRerender(fiber) {
    var root = $5ac2ec94ade4afdf$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $5ac2ec94ade4afdf$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $5ac2ec94ade4afdf$var$mountStateImpl(initialState) {
    var hook = $5ac2ec94ade4afdf$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($5ac2ec94ade4afdf$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $5ac2ec94ade4afdf$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $5ac2ec94ade4afdf$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $5ac2ec94ade4afdf$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $5ac2ec94ade4afdf$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $5ac2ec94ade4afdf$var$updateReducerImpl(hook, $5ac2ec94ade4afdf$var$currentHook, "function" === typeof reducer ? reducer : $5ac2ec94ade4afdf$var$basicStateReducer);
}
function $5ac2ec94ade4afdf$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($5ac2ec94ade4afdf$var$isRenderPhaseUpdate(fiber)) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $5ac2ec94ade4afdf$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $5ac2ec94ade4afdf$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $5ac2ec94ade4afdf$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $5ac2ec94ade4afdf$var$ReactSharedInternals.T, currentTransition = {};
        $5ac2ec94ade4afdf$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $5ac2ec94ade4afdf$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $5ac2ec94ade4afdf$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $5ac2ec94ade4afdf$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $5ac2ec94ade4afdf$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $5ac2ec94ade4afdf$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $5ac2ec94ade4afdf$var$onActionError(actionQueue, node, error$66);
    }
}
function $5ac2ec94ade4afdf$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $5ac2ec94ade4afdf$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $5ac2ec94ade4afdf$var$onActionError(actionQueue, node, error);
    }) : $5ac2ec94ade4afdf$var$onActionSuccess(actionQueue, node, returnValue);
}
function $5ac2ec94ade4afdf$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $5ac2ec94ade4afdf$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $5ac2ec94ade4afdf$var$runActionStateAction(actionQueue, nextState)));
}
function $5ac2ec94ade4afdf$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $5ac2ec94ade4afdf$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $5ac2ec94ade4afdf$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $5ac2ec94ade4afdf$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $5ac2ec94ade4afdf$var$mountActionState(action, initialStateProp) {
    if ($5ac2ec94ade4afdf$var$isHydrating) {
        var ssrFormState = $5ac2ec94ade4afdf$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $5ac2ec94ade4afdf$var$currentlyRenderingFiber;
                if ($5ac2ec94ade4afdf$var$isHydrating) {
                    if ($5ac2ec94ade4afdf$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $5ac2ec94ade4afdf$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $5ac2ec94ade4afdf$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $5ac2ec94ade4afdf$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $5ac2ec94ade4afdf$var$nextHydratableInstance = $5ac2ec94ade4afdf$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $5ac2ec94ade4afdf$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $5ac2ec94ade4afdf$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $5ac2ec94ade4afdf$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $5ac2ec94ade4afdf$var$dispatchSetState.bind(null, $5ac2ec94ade4afdf$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $5ac2ec94ade4afdf$var$mountStateImpl(!1);
    inRootOrSingleton = $5ac2ec94ade4afdf$var$dispatchOptimisticSetState.bind(null, $5ac2ec94ade4afdf$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $5ac2ec94ade4afdf$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $5ac2ec94ade4afdf$var$dispatchActionState.bind(null, $5ac2ec94ade4afdf$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $5ac2ec94ade4afdf$var$updateActionState(action) {
    var stateHook = $5ac2ec94ade4afdf$var$updateWorkInProgressHook();
    return $5ac2ec94ade4afdf$var$updateActionStateImpl(stateHook, $5ac2ec94ade4afdf$var$currentHook, action);
}
function $5ac2ec94ade4afdf$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $5ac2ec94ade4afdf$var$updateReducerImpl(stateHook, currentStateHook, $5ac2ec94ade4afdf$var$actionStateReducer)[0];
    stateHook = $5ac2ec94ade4afdf$var$updateReducer($5ac2ec94ade4afdf$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $5ac2ec94ade4afdf$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $5ac2ec94ade4afdf$var$SuspenseException) throw $5ac2ec94ade4afdf$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $5ac2ec94ade4afdf$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($5ac2ec94ade4afdf$var$currentlyRenderingFiber.flags |= 2048, $5ac2ec94ade4afdf$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $5ac2ec94ade4afdf$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $5ac2ec94ade4afdf$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $5ac2ec94ade4afdf$var$rerenderActionState(action) {
    var stateHook = $5ac2ec94ade4afdf$var$updateWorkInProgressHook(), currentStateHook = $5ac2ec94ade4afdf$var$currentHook;
    if (null !== currentStateHook) return $5ac2ec94ade4afdf$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $5ac2ec94ade4afdf$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $5ac2ec94ade4afdf$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $5ac2ec94ade4afdf$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $5ac2ec94ade4afdf$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $5ac2ec94ade4afdf$var$createFunctionComponentUpdateQueue(), $5ac2ec94ade4afdf$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $5ac2ec94ade4afdf$var$updateRef() {
    return $5ac2ec94ade4afdf$var$updateWorkInProgressHook().memoizedState;
}
function $5ac2ec94ade4afdf$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $5ac2ec94ade4afdf$var$mountWorkInProgressHook();
    $5ac2ec94ade4afdf$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $5ac2ec94ade4afdf$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $5ac2ec94ade4afdf$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $5ac2ec94ade4afdf$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $5ac2ec94ade4afdf$var$currentHook && null !== deps && $5ac2ec94ade4afdf$var$areHookInputsEqual(deps, $5ac2ec94ade4afdf$var$currentHook.memoizedState.deps) ? hook.memoizedState = $5ac2ec94ade4afdf$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($5ac2ec94ade4afdf$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $5ac2ec94ade4afdf$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $5ac2ec94ade4afdf$var$mountEffect(create, deps) {
    $5ac2ec94ade4afdf$var$mountEffectImpl(8390656, 8, create, deps);
}
function $5ac2ec94ade4afdf$var$updateEffect(create, deps) {
    $5ac2ec94ade4afdf$var$updateEffectImpl(2048, 8, create, deps);
}
function $5ac2ec94ade4afdf$var$useEffectEventImpl(payload) {
    $5ac2ec94ade4afdf$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $5ac2ec94ade4afdf$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $5ac2ec94ade4afdf$var$createFunctionComponentUpdateQueue(), $5ac2ec94ade4afdf$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $5ac2ec94ade4afdf$var$updateEvent(callback) {
    var ref = $5ac2ec94ade4afdf$var$updateWorkInProgressHook().memoizedState;
    $5ac2ec94ade4afdf$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($5ac2ec94ade4afdf$var$executionContext & 2)) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $5ac2ec94ade4afdf$var$updateInsertionEffect(create, deps) {
    return $5ac2ec94ade4afdf$var$updateEffectImpl(4, 2, create, deps);
}
function $5ac2ec94ade4afdf$var$updateLayoutEffect(create, deps) {
    return $5ac2ec94ade4afdf$var$updateEffectImpl(4, 4, create, deps);
}
function $5ac2ec94ade4afdf$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $5ac2ec94ade4afdf$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $5ac2ec94ade4afdf$var$updateEffectImpl(4, 4, $5ac2ec94ade4afdf$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $5ac2ec94ade4afdf$var$mountDebugValue() {}
function $5ac2ec94ade4afdf$var$updateCallback(callback, deps) {
    var hook = $5ac2ec94ade4afdf$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $5ac2ec94ade4afdf$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $5ac2ec94ade4afdf$var$updateMemo(nextCreate, deps) {
    var hook = $5ac2ec94ade4afdf$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $5ac2ec94ade4afdf$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($5ac2ec94ade4afdf$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $5ac2ec94ade4afdf$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $5ac2ec94ade4afdf$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $5ac2ec94ade4afdf$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($5ac2ec94ade4afdf$var$renderLanes & 1073741824) && 0 === ($5ac2ec94ade4afdf$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $5ac2ec94ade4afdf$var$requestDeferredLane();
    $5ac2ec94ade4afdf$var$currentlyRenderingFiber.lanes |= hook;
    $5ac2ec94ade4afdf$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $5ac2ec94ade4afdf$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($5ac2ec94ade4afdf$var$objectIs(value, prevValue)) return value;
    if (null !== $5ac2ec94ade4afdf$var$currentTreeHiddenStackCursor.current) return hook = $5ac2ec94ade4afdf$var$mountDeferredValueImpl(hook, value, initialValue), $5ac2ec94ade4afdf$var$objectIs(hook, prevValue) || ($5ac2ec94ade4afdf$var$didReceiveUpdate = !0), hook;
    if (0 === ($5ac2ec94ade4afdf$var$renderLanes & 42) || 0 !== ($5ac2ec94ade4afdf$var$renderLanes & 1073741824) && 0 === ($5ac2ec94ade4afdf$var$workInProgressRootRenderLanes & 261930)) return $5ac2ec94ade4afdf$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $5ac2ec94ade4afdf$var$requestDeferredLane();
    $5ac2ec94ade4afdf$var$currentlyRenderingFiber.lanes |= hook;
    $5ac2ec94ade4afdf$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $5ac2ec94ade4afdf$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $5ac2ec94ade4afdf$var$ReactDOMSharedInternals.p;
    $5ac2ec94ade4afdf$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $5ac2ec94ade4afdf$var$ReactSharedInternals.T, currentTransition = {};
    $5ac2ec94ade4afdf$var$ReactSharedInternals.T = currentTransition;
    $5ac2ec94ade4afdf$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $5ac2ec94ade4afdf$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $5ac2ec94ade4afdf$var$chainThenableValue(returnValue, finishedState);
            $5ac2ec94ade4afdf$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $5ac2ec94ade4afdf$var$requestUpdateLane(fiber));
        } else $5ac2ec94ade4afdf$var$dispatchSetStateInternal(fiber, queue, finishedState, $5ac2ec94ade4afdf$var$requestUpdateLane(fiber));
    } catch (error) {
        $5ac2ec94ade4afdf$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $5ac2ec94ade4afdf$var$requestUpdateLane());
    } finally{
        $5ac2ec94ade4afdf$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $5ac2ec94ade4afdf$var$ReactSharedInternals.T = prevTransition;
    }
}
function $5ac2ec94ade4afdf$var$noop() {}
function $5ac2ec94ade4afdf$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(476));
    var queue = $5ac2ec94ade4afdf$var$ensureFormComponentIsStateful(formFiber).queue;
    $5ac2ec94ade4afdf$var$startTransition(formFiber, queue, pendingState, $5ac2ec94ade4afdf$var$sharedNotPendingObject, null === action ? $5ac2ec94ade4afdf$var$noop : function() {
        $5ac2ec94ade4afdf$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $5ac2ec94ade4afdf$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $5ac2ec94ade4afdf$var$sharedNotPendingObject,
        baseState: $5ac2ec94ade4afdf$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $5ac2ec94ade4afdf$var$basicStateReducer,
            lastRenderedState: $5ac2ec94ade4afdf$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $5ac2ec94ade4afdf$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $5ac2ec94ade4afdf$var$requestFormReset$1(formFiber) {
    var stateHook = $5ac2ec94ade4afdf$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $5ac2ec94ade4afdf$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $5ac2ec94ade4afdf$var$requestUpdateLane());
}
function $5ac2ec94ade4afdf$var$useHostTransitionStatus() {
    return $5ac2ec94ade4afdf$var$readContext($5ac2ec94ade4afdf$var$HostTransitionContext);
}
function $5ac2ec94ade4afdf$var$updateId() {
    return $5ac2ec94ade4afdf$var$updateWorkInProgressHook().memoizedState;
}
function $5ac2ec94ade4afdf$var$updateRefresh() {
    return $5ac2ec94ade4afdf$var$updateWorkInProgressHook().memoizedState;
}
function $5ac2ec94ade4afdf$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $5ac2ec94ade4afdf$var$requestUpdateLane();
                fiber = $5ac2ec94ade4afdf$var$createUpdate(lane);
                var root$69 = $5ac2ec94ade4afdf$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($5ac2ec94ade4afdf$var$scheduleUpdateOnFiber(root$69, provider, lane), $5ac2ec94ade4afdf$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $5ac2ec94ade4afdf$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $5ac2ec94ade4afdf$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $5ac2ec94ade4afdf$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $5ac2ec94ade4afdf$var$isRenderPhaseUpdate(fiber) ? $5ac2ec94ade4afdf$var$enqueueRenderPhaseUpdate(queue, action) : (action = $5ac2ec94ade4afdf$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($5ac2ec94ade4afdf$var$scheduleUpdateOnFiber(action, fiber, lane), $5ac2ec94ade4afdf$var$entangleTransitionUpdate(action, queue, lane)));
}
function $5ac2ec94ade4afdf$var$dispatchSetState(fiber, queue, action) {
    var lane = $5ac2ec94ade4afdf$var$requestUpdateLane();
    $5ac2ec94ade4afdf$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $5ac2ec94ade4afdf$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($5ac2ec94ade4afdf$var$isRenderPhaseUpdate(fiber)) $5ac2ec94ade4afdf$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($5ac2ec94ade4afdf$var$objectIs(eagerState, currentState)) return $5ac2ec94ade4afdf$var$enqueueUpdate$1(fiber, queue, update, 0), null === $5ac2ec94ade4afdf$var$workInProgressRoot && $5ac2ec94ade4afdf$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $5ac2ec94ade4afdf$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $5ac2ec94ade4afdf$var$scheduleUpdateOnFiber(action, fiber, lane), $5ac2ec94ade4afdf$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $5ac2ec94ade4afdf$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $5ac2ec94ade4afdf$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($5ac2ec94ade4afdf$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $5ac2ec94ade4afdf$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $5ac2ec94ade4afdf$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $5ac2ec94ade4afdf$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $5ac2ec94ade4afdf$var$currentlyRenderingFiber || null !== alternate && alternate === $5ac2ec94ade4afdf$var$currentlyRenderingFiber;
}
function $5ac2ec94ade4afdf$var$enqueueRenderPhaseUpdate(queue, update) {
    $5ac2ec94ade4afdf$var$didScheduleRenderPhaseUpdateDuringThisPass = $5ac2ec94ade4afdf$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $5ac2ec94ade4afdf$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $5ac2ec94ade4afdf$var$markRootEntangled(root, lane);
    }
}
var $5ac2ec94ade4afdf$var$ContextOnlyDispatcher = {
    readContext: $5ac2ec94ade4afdf$var$readContext,
    use: $5ac2ec94ade4afdf$var$use,
    useCallback: $5ac2ec94ade4afdf$var$throwInvalidHookError,
    useContext: $5ac2ec94ade4afdf$var$throwInvalidHookError,
    useEffect: $5ac2ec94ade4afdf$var$throwInvalidHookError,
    useImperativeHandle: $5ac2ec94ade4afdf$var$throwInvalidHookError,
    useLayoutEffect: $5ac2ec94ade4afdf$var$throwInvalidHookError,
    useInsertionEffect: $5ac2ec94ade4afdf$var$throwInvalidHookError,
    useMemo: $5ac2ec94ade4afdf$var$throwInvalidHookError,
    useReducer: $5ac2ec94ade4afdf$var$throwInvalidHookError,
    useRef: $5ac2ec94ade4afdf$var$throwInvalidHookError,
    useState: $5ac2ec94ade4afdf$var$throwInvalidHookError,
    useDebugValue: $5ac2ec94ade4afdf$var$throwInvalidHookError,
    useDeferredValue: $5ac2ec94ade4afdf$var$throwInvalidHookError,
    useTransition: $5ac2ec94ade4afdf$var$throwInvalidHookError,
    useSyncExternalStore: $5ac2ec94ade4afdf$var$throwInvalidHookError,
    useId: $5ac2ec94ade4afdf$var$throwInvalidHookError,
    useHostTransitionStatus: $5ac2ec94ade4afdf$var$throwInvalidHookError,
    useFormState: $5ac2ec94ade4afdf$var$throwInvalidHookError,
    useActionState: $5ac2ec94ade4afdf$var$throwInvalidHookError,
    useOptimistic: $5ac2ec94ade4afdf$var$throwInvalidHookError,
    useMemoCache: $5ac2ec94ade4afdf$var$throwInvalidHookError,
    useCacheRefresh: $5ac2ec94ade4afdf$var$throwInvalidHookError
};
$5ac2ec94ade4afdf$var$ContextOnlyDispatcher.useEffectEvent = $5ac2ec94ade4afdf$var$throwInvalidHookError;
var $5ac2ec94ade4afdf$var$HooksDispatcherOnMount = {
    readContext: $5ac2ec94ade4afdf$var$readContext,
    use: $5ac2ec94ade4afdf$var$use,
    useCallback: function(callback, deps) {
        $5ac2ec94ade4afdf$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $5ac2ec94ade4afdf$var$readContext,
    useEffect: $5ac2ec94ade4afdf$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $5ac2ec94ade4afdf$var$mountEffectImpl(4194308, 4, $5ac2ec94ade4afdf$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $5ac2ec94ade4afdf$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $5ac2ec94ade4afdf$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $5ac2ec94ade4afdf$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($5ac2ec94ade4afdf$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $5ac2ec94ade4afdf$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $5ac2ec94ade4afdf$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $5ac2ec94ade4afdf$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($5ac2ec94ade4afdf$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $5ac2ec94ade4afdf$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $5ac2ec94ade4afdf$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $5ac2ec94ade4afdf$var$dispatchReducerAction.bind(null, $5ac2ec94ade4afdf$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $5ac2ec94ade4afdf$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $5ac2ec94ade4afdf$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $5ac2ec94ade4afdf$var$dispatchSetState.bind(null, $5ac2ec94ade4afdf$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $5ac2ec94ade4afdf$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $5ac2ec94ade4afdf$var$mountWorkInProgressHook();
        return $5ac2ec94ade4afdf$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $5ac2ec94ade4afdf$var$mountStateImpl(!1);
        stateHook = $5ac2ec94ade4afdf$var$startTransition.bind(null, $5ac2ec94ade4afdf$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $5ac2ec94ade4afdf$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $5ac2ec94ade4afdf$var$currentlyRenderingFiber, hook = $5ac2ec94ade4afdf$var$mountWorkInProgressHook();
        if ($5ac2ec94ade4afdf$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $5ac2ec94ade4afdf$var$workInProgressRoot) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(349));
            0 !== ($5ac2ec94ade4afdf$var$workInProgressRootRenderLanes & 127) || $5ac2ec94ade4afdf$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $5ac2ec94ade4afdf$var$mountEffect($5ac2ec94ade4afdf$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $5ac2ec94ade4afdf$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $5ac2ec94ade4afdf$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $5ac2ec94ade4afdf$var$mountWorkInProgressHook(), identifierPrefix = $5ac2ec94ade4afdf$var$workInProgressRoot.identifierPrefix;
        if ($5ac2ec94ade4afdf$var$isHydrating) {
            var JSCompiler_inline_result = $5ac2ec94ade4afdf$var$treeContextOverflow;
            var idWithLeadingBit = $5ac2ec94ade4afdf$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $5ac2ec94ade4afdf$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $5ac2ec94ade4afdf$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $5ac2ec94ade4afdf$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $5ac2ec94ade4afdf$var$useHostTransitionStatus,
    useFormState: $5ac2ec94ade4afdf$var$mountActionState,
    useActionState: $5ac2ec94ade4afdf$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $5ac2ec94ade4afdf$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $5ac2ec94ade4afdf$var$dispatchOptimisticSetState.bind(null, $5ac2ec94ade4afdf$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $5ac2ec94ade4afdf$var$useMemoCache,
    useCacheRefresh: function() {
        return $5ac2ec94ade4afdf$var$mountWorkInProgressHook().memoizedState = $5ac2ec94ade4afdf$var$refreshCache.bind(null, $5ac2ec94ade4afdf$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $5ac2ec94ade4afdf$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($5ac2ec94ade4afdf$var$executionContext & 2)) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $5ac2ec94ade4afdf$var$HooksDispatcherOnUpdate = {
    readContext: $5ac2ec94ade4afdf$var$readContext,
    use: $5ac2ec94ade4afdf$var$use,
    useCallback: $5ac2ec94ade4afdf$var$updateCallback,
    useContext: $5ac2ec94ade4afdf$var$readContext,
    useEffect: $5ac2ec94ade4afdf$var$updateEffect,
    useImperativeHandle: $5ac2ec94ade4afdf$var$updateImperativeHandle,
    useInsertionEffect: $5ac2ec94ade4afdf$var$updateInsertionEffect,
    useLayoutEffect: $5ac2ec94ade4afdf$var$updateLayoutEffect,
    useMemo: $5ac2ec94ade4afdf$var$updateMemo,
    useReducer: $5ac2ec94ade4afdf$var$updateReducer,
    useRef: $5ac2ec94ade4afdf$var$updateRef,
    useState: function() {
        return $5ac2ec94ade4afdf$var$updateReducer($5ac2ec94ade4afdf$var$basicStateReducer);
    },
    useDebugValue: $5ac2ec94ade4afdf$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $5ac2ec94ade4afdf$var$updateWorkInProgressHook();
        return $5ac2ec94ade4afdf$var$updateDeferredValueImpl(hook, $5ac2ec94ade4afdf$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $5ac2ec94ade4afdf$var$updateReducer($5ac2ec94ade4afdf$var$basicStateReducer)[0], start = $5ac2ec94ade4afdf$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $5ac2ec94ade4afdf$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $5ac2ec94ade4afdf$var$updateSyncExternalStore,
    useId: $5ac2ec94ade4afdf$var$updateId,
    useHostTransitionStatus: $5ac2ec94ade4afdf$var$useHostTransitionStatus,
    useFormState: $5ac2ec94ade4afdf$var$updateActionState,
    useActionState: $5ac2ec94ade4afdf$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $5ac2ec94ade4afdf$var$updateWorkInProgressHook();
        return $5ac2ec94ade4afdf$var$updateOptimisticImpl(hook, $5ac2ec94ade4afdf$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $5ac2ec94ade4afdf$var$useMemoCache,
    useCacheRefresh: $5ac2ec94ade4afdf$var$updateRefresh
};
$5ac2ec94ade4afdf$var$HooksDispatcherOnUpdate.useEffectEvent = $5ac2ec94ade4afdf$var$updateEvent;
var $5ac2ec94ade4afdf$var$HooksDispatcherOnRerender = {
    readContext: $5ac2ec94ade4afdf$var$readContext,
    use: $5ac2ec94ade4afdf$var$use,
    useCallback: $5ac2ec94ade4afdf$var$updateCallback,
    useContext: $5ac2ec94ade4afdf$var$readContext,
    useEffect: $5ac2ec94ade4afdf$var$updateEffect,
    useImperativeHandle: $5ac2ec94ade4afdf$var$updateImperativeHandle,
    useInsertionEffect: $5ac2ec94ade4afdf$var$updateInsertionEffect,
    useLayoutEffect: $5ac2ec94ade4afdf$var$updateLayoutEffect,
    useMemo: $5ac2ec94ade4afdf$var$updateMemo,
    useReducer: $5ac2ec94ade4afdf$var$rerenderReducer,
    useRef: $5ac2ec94ade4afdf$var$updateRef,
    useState: function() {
        return $5ac2ec94ade4afdf$var$rerenderReducer($5ac2ec94ade4afdf$var$basicStateReducer);
    },
    useDebugValue: $5ac2ec94ade4afdf$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $5ac2ec94ade4afdf$var$updateWorkInProgressHook();
        return null === $5ac2ec94ade4afdf$var$currentHook ? $5ac2ec94ade4afdf$var$mountDeferredValueImpl(hook, value, initialValue) : $5ac2ec94ade4afdf$var$updateDeferredValueImpl(hook, $5ac2ec94ade4afdf$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $5ac2ec94ade4afdf$var$rerenderReducer($5ac2ec94ade4afdf$var$basicStateReducer)[0], start = $5ac2ec94ade4afdf$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $5ac2ec94ade4afdf$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $5ac2ec94ade4afdf$var$updateSyncExternalStore,
    useId: $5ac2ec94ade4afdf$var$updateId,
    useHostTransitionStatus: $5ac2ec94ade4afdf$var$useHostTransitionStatus,
    useFormState: $5ac2ec94ade4afdf$var$rerenderActionState,
    useActionState: $5ac2ec94ade4afdf$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $5ac2ec94ade4afdf$var$updateWorkInProgressHook();
        if (null !== $5ac2ec94ade4afdf$var$currentHook) return $5ac2ec94ade4afdf$var$updateOptimisticImpl(hook, $5ac2ec94ade4afdf$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $5ac2ec94ade4afdf$var$useMemoCache,
    useCacheRefresh: $5ac2ec94ade4afdf$var$updateRefresh
};
$5ac2ec94ade4afdf$var$HooksDispatcherOnRerender.useEffectEvent = $5ac2ec94ade4afdf$var$updateEvent;
function $5ac2ec94ade4afdf$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $5ac2ec94ade4afdf$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $5ac2ec94ade4afdf$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $5ac2ec94ade4afdf$var$requestUpdateLane(), update = $5ac2ec94ade4afdf$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $5ac2ec94ade4afdf$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($5ac2ec94ade4afdf$var$scheduleUpdateOnFiber(payload, inst, lane), $5ac2ec94ade4afdf$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $5ac2ec94ade4afdf$var$requestUpdateLane(), update = $5ac2ec94ade4afdf$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $5ac2ec94ade4afdf$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($5ac2ec94ade4afdf$var$scheduleUpdateOnFiber(payload, inst, lane), $5ac2ec94ade4afdf$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $5ac2ec94ade4afdf$var$requestUpdateLane(), update = $5ac2ec94ade4afdf$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $5ac2ec94ade4afdf$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($5ac2ec94ade4afdf$var$scheduleUpdateOnFiber(callback, inst, lane), $5ac2ec94ade4afdf$var$entangleTransitions(callback, inst, lane));
    }
};
function $5ac2ec94ade4afdf$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$5ac2ec94ade4afdf$var$shallowEqual(oldProps, newProps) || !$5ac2ec94ade4afdf$var$shallowEqual(oldState, newState) : !0;
}
function $5ac2ec94ade4afdf$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $5ac2ec94ade4afdf$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $5ac2ec94ade4afdf$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $5ac2ec94ade4afdf$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $5ac2ec94ade4afdf$var$defaultOnUncaughtError(error) {
    $5ac2ec94ade4afdf$var$reportGlobalError(error);
}
function $5ac2ec94ade4afdf$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $5ac2ec94ade4afdf$var$defaultOnRecoverableError(error) {
    $5ac2ec94ade4afdf$var$reportGlobalError(error);
}
function $5ac2ec94ade4afdf$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $5ac2ec94ade4afdf$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $5ac2ec94ade4afdf$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $5ac2ec94ade4afdf$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $5ac2ec94ade4afdf$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $5ac2ec94ade4afdf$var$createClassErrorUpdate(lane) {
    lane = $5ac2ec94ade4afdf$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $5ac2ec94ade4afdf$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $5ac2ec94ade4afdf$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $5ac2ec94ade4afdf$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $5ac2ec94ade4afdf$var$legacyErrorBoundariesThatAlreadyFailed ? $5ac2ec94ade4afdf$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $5ac2ec94ade4afdf$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $5ac2ec94ade4afdf$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $5ac2ec94ade4afdf$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $5ac2ec94ade4afdf$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $5ac2ec94ade4afdf$var$shellBoundary ? $5ac2ec94ade4afdf$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $5ac2ec94ade4afdf$var$workInProgressRootExitStatus && ($5ac2ec94ade4afdf$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $5ac2ec94ade4afdf$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $5ac2ec94ade4afdf$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $5ac2ec94ade4afdf$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $5ac2ec94ade4afdf$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $5ac2ec94ade4afdf$var$attachPingListener(root, value, rootRenderLanes);
        $5ac2ec94ade4afdf$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($5ac2ec94ade4afdf$var$isHydrating) return returnFiber = $5ac2ec94ade4afdf$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $5ac2ec94ade4afdf$var$HydrationMismatchException && (root = Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(422), {
        cause: value
    }), $5ac2ec94ade4afdf$var$queueHydrationError($5ac2ec94ade4afdf$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $5ac2ec94ade4afdf$var$HydrationMismatchException && (returnFiber = Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(423), {
        cause: value
    }), $5ac2ec94ade4afdf$var$queueHydrationError($5ac2ec94ade4afdf$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $5ac2ec94ade4afdf$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $5ac2ec94ade4afdf$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $5ac2ec94ade4afdf$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $5ac2ec94ade4afdf$var$workInProgressRootExitStatus && ($5ac2ec94ade4afdf$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $5ac2ec94ade4afdf$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $5ac2ec94ade4afdf$var$workInProgressRootConcurrentErrors ? $5ac2ec94ade4afdf$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $5ac2ec94ade4afdf$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $5ac2ec94ade4afdf$var$workInProgressRootExitStatus && ($5ac2ec94ade4afdf$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $5ac2ec94ade4afdf$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $5ac2ec94ade4afdf$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $5ac2ec94ade4afdf$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $5ac2ec94ade4afdf$var$legacyErrorBoundariesThatAlreadyFailed || !$5ac2ec94ade4afdf$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $5ac2ec94ade4afdf$var$createClassErrorUpdate(rootRenderLanes), $5ac2ec94ade4afdf$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $5ac2ec94ade4afdf$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $5ac2ec94ade4afdf$var$SelectiveHydrationException = Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(461)), $5ac2ec94ade4afdf$var$didReceiveUpdate = !1;
function $5ac2ec94ade4afdf$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $5ac2ec94ade4afdf$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $5ac2ec94ade4afdf$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $5ac2ec94ade4afdf$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $5ac2ec94ade4afdf$var$prepareToReadContext(workInProgress);
    nextProps = $5ac2ec94ade4afdf$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $5ac2ec94ade4afdf$var$checkDidRenderIdHook();
    if (null !== current && !$5ac2ec94ade4afdf$var$didReceiveUpdate) return $5ac2ec94ade4afdf$var$bailoutHooks(current, workInProgress, renderLanes), $5ac2ec94ade4afdf$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $5ac2ec94ade4afdf$var$isHydrating && key && $5ac2ec94ade4afdf$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $5ac2ec94ade4afdf$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $5ac2ec94ade4afdf$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$5ac2ec94ade4afdf$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $5ac2ec94ade4afdf$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $5ac2ec94ade4afdf$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$5ac2ec94ade4afdf$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $5ac2ec94ade4afdf$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $5ac2ec94ade4afdf$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $5ac2ec94ade4afdf$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $5ac2ec94ade4afdf$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($5ac2ec94ade4afdf$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($5ac2ec94ade4afdf$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $5ac2ec94ade4afdf$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($5ac2ec94ade4afdf$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $5ac2ec94ade4afdf$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $5ac2ec94ade4afdf$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $5ac2ec94ade4afdf$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $5ac2ec94ade4afdf$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $5ac2ec94ade4afdf$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $5ac2ec94ade4afdf$var$pushHiddenContext(workInProgress, prevState) : $5ac2ec94ade4afdf$var$reuseHiddenContextOnStack(), $5ac2ec94ade4afdf$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $5ac2ec94ade4afdf$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($5ac2ec94ade4afdf$var$pushTransition(workInProgress, prevState.cachePool), $5ac2ec94ade4afdf$var$pushHiddenContext(workInProgress, prevState), $5ac2ec94ade4afdf$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $5ac2ec94ade4afdf$var$pushTransition(workInProgress, null), $5ac2ec94ade4afdf$var$reuseHiddenContextOnStack(), $5ac2ec94ade4afdf$var$reuseSuspenseHandlerOnStack(workInProgress));
    $5ac2ec94ade4afdf$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $5ac2ec94ade4afdf$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $5ac2ec94ade4afdf$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $5ac2ec94ade4afdf$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $5ac2ec94ade4afdf$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $5ac2ec94ade4afdf$var$pushTransition(workInProgress, null);
    $5ac2ec94ade4afdf$var$reuseHiddenContextOnStack();
    $5ac2ec94ade4afdf$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $5ac2ec94ade4afdf$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $5ac2ec94ade4afdf$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $5ac2ec94ade4afdf$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $5ac2ec94ade4afdf$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $5ac2ec94ade4afdf$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $5ac2ec94ade4afdf$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $5ac2ec94ade4afdf$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $5ac2ec94ade4afdf$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($5ac2ec94ade4afdf$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $5ac2ec94ade4afdf$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $5ac2ec94ade4afdf$var$bailoutOffscreenComponent(null, current);
            $5ac2ec94ade4afdf$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $5ac2ec94ade4afdf$var$nextHydratableInstance) ? (current = $5ac2ec94ade4afdf$var$canHydrateHydrationBoundary(current, $5ac2ec94ade4afdf$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $5ac2ec94ade4afdf$var$treeContextProvider ? {
                    id: $5ac2ec94ade4afdf$var$treeContextId,
                    overflow: $5ac2ec94ade4afdf$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $5ac2ec94ade4afdf$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $5ac2ec94ade4afdf$var$hydrationParentFiber = workInProgress, $5ac2ec94ade4afdf$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $5ac2ec94ade4afdf$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $5ac2ec94ade4afdf$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $5ac2ec94ade4afdf$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $5ac2ec94ade4afdf$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(558));
        } else if ($5ac2ec94ade4afdf$var$didReceiveUpdate || $5ac2ec94ade4afdf$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $5ac2ec94ade4afdf$var$didReceiveUpdate || didSuspend) {
            nextProps = $5ac2ec94ade4afdf$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $5ac2ec94ade4afdf$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $5ac2ec94ade4afdf$var$enqueueConcurrentRenderForLane(current, dehydrated), $5ac2ec94ade4afdf$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $5ac2ec94ade4afdf$var$SelectiveHydrationException;
            $5ac2ec94ade4afdf$var$renderDidSuspendDelayIfPossible();
            workInProgress = $5ac2ec94ade4afdf$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $5ac2ec94ade4afdf$var$nextHydratableInstance = $5ac2ec94ade4afdf$var$getNextHydratable(dehydrated.nextSibling), $5ac2ec94ade4afdf$var$hydrationParentFiber = workInProgress, $5ac2ec94ade4afdf$var$isHydrating = !0, $5ac2ec94ade4afdf$var$hydrationErrors = null, $5ac2ec94ade4afdf$var$rootOrSingletonContext = !1, null !== current && $5ac2ec94ade4afdf$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $5ac2ec94ade4afdf$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $5ac2ec94ade4afdf$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $5ac2ec94ade4afdf$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $5ac2ec94ade4afdf$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $5ac2ec94ade4afdf$var$prepareToReadContext(workInProgress);
    Component = $5ac2ec94ade4afdf$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $5ac2ec94ade4afdf$var$checkDidRenderIdHook();
    if (null !== current && !$5ac2ec94ade4afdf$var$didReceiveUpdate) return $5ac2ec94ade4afdf$var$bailoutHooks(current, workInProgress, renderLanes), $5ac2ec94ade4afdf$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $5ac2ec94ade4afdf$var$isHydrating && nextProps && $5ac2ec94ade4afdf$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $5ac2ec94ade4afdf$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $5ac2ec94ade4afdf$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $5ac2ec94ade4afdf$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $5ac2ec94ade4afdf$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $5ac2ec94ade4afdf$var$finishRenderingHooks(current);
    Component = $5ac2ec94ade4afdf$var$checkDidRenderIdHook();
    if (null !== current && !$5ac2ec94ade4afdf$var$didReceiveUpdate) return $5ac2ec94ade4afdf$var$bailoutHooks(current, workInProgress, renderLanes), $5ac2ec94ade4afdf$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $5ac2ec94ade4afdf$var$isHydrating && Component && $5ac2ec94ade4afdf$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $5ac2ec94ade4afdf$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $5ac2ec94ade4afdf$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $5ac2ec94ade4afdf$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $5ac2ec94ade4afdf$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $5ac2ec94ade4afdf$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $5ac2ec94ade4afdf$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $5ac2ec94ade4afdf$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $5ac2ec94ade4afdf$var$readContext(contextType) : $5ac2ec94ade4afdf$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($5ac2ec94ade4afdf$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $5ac2ec94ade4afdf$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $5ac2ec94ade4afdf$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $5ac2ec94ade4afdf$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $5ac2ec94ade4afdf$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $5ac2ec94ade4afdf$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $5ac2ec94ade4afdf$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $5ac2ec94ade4afdf$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $5ac2ec94ade4afdf$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $5ac2ec94ade4afdf$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $5ac2ec94ade4afdf$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $5ac2ec94ade4afdf$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($5ac2ec94ade4afdf$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $5ac2ec94ade4afdf$var$hasForceUpdate || $5ac2ec94ade4afdf$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $5ac2ec94ade4afdf$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $5ac2ec94ade4afdf$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $5ac2ec94ade4afdf$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $5ac2ec94ade4afdf$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $5ac2ec94ade4afdf$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $5ac2ec94ade4afdf$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $5ac2ec94ade4afdf$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $5ac2ec94ade4afdf$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $5ac2ec94ade4afdf$var$hasForceUpdate || null !== current && null !== current.dependencies && $5ac2ec94ade4afdf$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($5ac2ec94ade4afdf$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $5ac2ec94ade4afdf$var$hasForceUpdate || $5ac2ec94ade4afdf$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $5ac2ec94ade4afdf$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $5ac2ec94ade4afdf$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $5ac2ec94ade4afdf$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $5ac2ec94ade4afdf$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $5ac2ec94ade4afdf$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $5ac2ec94ade4afdf$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $5ac2ec94ade4afdf$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $5ac2ec94ade4afdf$var$resetHydrationState();
    workInProgress.flags |= 256;
    $5ac2ec94ade4afdf$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $5ac2ec94ade4afdf$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $5ac2ec94ade4afdf$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $5ac2ec94ade4afdf$var$getSuspendedCache()
    };
}
function $5ac2ec94ade4afdf$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $5ac2ec94ade4afdf$var$workInProgressDeferredLane);
    return current;
}
function $5ac2ec94ade4afdf$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($5ac2ec94ade4afdf$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($5ac2ec94ade4afdf$var$isHydrating) {
            showFallback ? $5ac2ec94ade4afdf$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $5ac2ec94ade4afdf$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $5ac2ec94ade4afdf$var$nextHydratableInstance) ? (current = $5ac2ec94ade4afdf$var$canHydrateHydrationBoundary(current, $5ac2ec94ade4afdf$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $5ac2ec94ade4afdf$var$treeContextProvider ? {
                    id: $5ac2ec94ade4afdf$var$treeContextId,
                    overflow: $5ac2ec94ade4afdf$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $5ac2ec94ade4afdf$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $5ac2ec94ade4afdf$var$hydrationParentFiber = workInProgress, $5ac2ec94ade4afdf$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $5ac2ec94ade4afdf$var$throwOnHydrationMismatch(workInProgress);
            $5ac2ec94ade4afdf$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $5ac2ec94ade4afdf$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $5ac2ec94ade4afdf$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $5ac2ec94ade4afdf$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $5ac2ec94ade4afdf$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $5ac2ec94ade4afdf$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $5ac2ec94ade4afdf$var$SUSPENDED_MARKER, $5ac2ec94ade4afdf$var$bailoutOffscreenComponent(null, nextProps);
        $5ac2ec94ade4afdf$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $5ac2ec94ade4afdf$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($5ac2ec94ade4afdf$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $5ac2ec94ade4afdf$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($5ac2ec94ade4afdf$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($5ac2ec94ade4afdf$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $5ac2ec94ade4afdf$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $5ac2ec94ade4afdf$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $5ac2ec94ade4afdf$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $5ac2ec94ade4afdf$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $5ac2ec94ade4afdf$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $5ac2ec94ade4afdf$var$SUSPENDED_MARKER, workInProgress = $5ac2ec94ade4afdf$var$bailoutOffscreenComponent(null, nextProps));
        else if ($5ac2ec94ade4afdf$var$pushPrimaryTreeSuspenseHandler(workInProgress), $5ac2ec94ade4afdf$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $5ac2ec94ade4afdf$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $5ac2ec94ade4afdf$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($5ac2ec94ade4afdf$var$didReceiveUpdate || $5ac2ec94ade4afdf$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $5ac2ec94ade4afdf$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $5ac2ec94ade4afdf$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $5ac2ec94ade4afdf$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $5ac2ec94ade4afdf$var$enqueueConcurrentRenderForLane(current, nextProps), $5ac2ec94ade4afdf$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $5ac2ec94ade4afdf$var$SelectiveHydrationException;
            $5ac2ec94ade4afdf$var$isSuspenseInstancePending(nextPrimaryChildren) || $5ac2ec94ade4afdf$var$renderDidSuspendDelayIfPossible();
            workInProgress = $5ac2ec94ade4afdf$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $5ac2ec94ade4afdf$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $5ac2ec94ade4afdf$var$nextHydratableInstance = $5ac2ec94ade4afdf$var$getNextHydratable(nextPrimaryChildren.nextSibling), $5ac2ec94ade4afdf$var$hydrationParentFiber = workInProgress, $5ac2ec94ade4afdf$var$isHydrating = !0, $5ac2ec94ade4afdf$var$hydrationErrors = null, $5ac2ec94ade4afdf$var$rootOrSingletonContext = !1, null !== current && $5ac2ec94ade4afdf$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $5ac2ec94ade4afdf$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $5ac2ec94ade4afdf$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $5ac2ec94ade4afdf$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $5ac2ec94ade4afdf$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $5ac2ec94ade4afdf$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $5ac2ec94ade4afdf$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $5ac2ec94ade4afdf$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $5ac2ec94ade4afdf$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $5ac2ec94ade4afdf$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $5ac2ec94ade4afdf$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $5ac2ec94ade4afdf$var$SUSPENDED_MARKER, $5ac2ec94ade4afdf$var$bailoutOffscreenComponent(current.child, nextProps);
    $5ac2ec94ade4afdf$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $5ac2ec94ade4afdf$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $5ac2ec94ade4afdf$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $5ac2ec94ade4afdf$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $5ac2ec94ade4afdf$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $5ac2ec94ade4afdf$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $5ac2ec94ade4afdf$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $5ac2ec94ade4afdf$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $5ac2ec94ade4afdf$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $5ac2ec94ade4afdf$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $5ac2ec94ade4afdf$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $5ac2ec94ade4afdf$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $5ac2ec94ade4afdf$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $5ac2ec94ade4afdf$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $5ac2ec94ade4afdf$var$push($5ac2ec94ade4afdf$var$suspenseStackCursor, suspenseContext);
    $5ac2ec94ade4afdf$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $5ac2ec94ade4afdf$var$isHydrating ? $5ac2ec94ade4afdf$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $5ac2ec94ade4afdf$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $5ac2ec94ade4afdf$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $5ac2ec94ade4afdf$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $5ac2ec94ade4afdf$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $5ac2ec94ade4afdf$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $5ac2ec94ade4afdf$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $5ac2ec94ade4afdf$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $5ac2ec94ade4afdf$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $5ac2ec94ade4afdf$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($5ac2ec94ade4afdf$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $5ac2ec94ade4afdf$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $5ac2ec94ade4afdf$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $5ac2ec94ade4afdf$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $5ac2ec94ade4afdf$var$checkIfContextChanged(current) ? !0 : !1;
}
function $5ac2ec94ade4afdf$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $5ac2ec94ade4afdf$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $5ac2ec94ade4afdf$var$pushProvider(workInProgress, $5ac2ec94ade4afdf$var$CacheContext, current.memoizedState.cache);
            $5ac2ec94ade4afdf$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $5ac2ec94ade4afdf$var$pushHostContext(workInProgress);
            break;
        case 4:
            $5ac2ec94ade4afdf$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $5ac2ec94ade4afdf$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $5ac2ec94ade4afdf$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $5ac2ec94ade4afdf$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $5ac2ec94ade4afdf$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $5ac2ec94ade4afdf$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $5ac2ec94ade4afdf$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $5ac2ec94ade4afdf$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($5ac2ec94ade4afdf$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $5ac2ec94ade4afdf$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $5ac2ec94ade4afdf$var$push($5ac2ec94ade4afdf$var$suspenseStackCursor, $5ac2ec94ade4afdf$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $5ac2ec94ade4afdf$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $5ac2ec94ade4afdf$var$pushProvider(workInProgress, $5ac2ec94ade4afdf$var$CacheContext, current.memoizedState.cache);
    }
    return $5ac2ec94ade4afdf$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $5ac2ec94ade4afdf$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $5ac2ec94ade4afdf$var$didReceiveUpdate = !0;
        else {
            if (!$5ac2ec94ade4afdf$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $5ac2ec94ade4afdf$var$didReceiveUpdate = !1, $5ac2ec94ade4afdf$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $5ac2ec94ade4afdf$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $5ac2ec94ade4afdf$var$didReceiveUpdate = !1, $5ac2ec94ade4afdf$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $5ac2ec94ade4afdf$var$pushTreeId(workInProgress, $5ac2ec94ade4afdf$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $5ac2ec94ade4afdf$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $5ac2ec94ade4afdf$var$shouldConstruct(current) ? (props = $5ac2ec94ade4afdf$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $5ac2ec94ade4afdf$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $5ac2ec94ade4afdf$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $5ac2ec94ade4afdf$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $5ac2ec94ade4afdf$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $5ac2ec94ade4afdf$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $5ac2ec94ade4afdf$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $5ac2ec94ade4afdf$var$getComponentNameFromType(current) || current;
                    throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $5ac2ec94ade4afdf$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $5ac2ec94ade4afdf$var$resolveClassComponentProps(props, workInProgress.pendingProps), $5ac2ec94ade4afdf$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $5ac2ec94ade4afdf$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $5ac2ec94ade4afdf$var$cloneUpdateQueue(current, workInProgress);
                $5ac2ec94ade4afdf$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $5ac2ec94ade4afdf$var$pushProvider(workInProgress, $5ac2ec94ade4afdf$var$CacheContext, props);
                props !== prevState.cache && $5ac2ec94ade4afdf$var$propagateContextChanges(workInProgress, [
                    $5ac2ec94ade4afdf$var$CacheContext
                ], renderLanes, !0);
                $5ac2ec94ade4afdf$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $5ac2ec94ade4afdf$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $5ac2ec94ade4afdf$var$createCapturedValueAtFiber(Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(424)), workInProgress);
                        $5ac2ec94ade4afdf$var$queueHydrationError($$typeof);
                        workInProgress = $5ac2ec94ade4afdf$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $5ac2ec94ade4afdf$var$nextHydratableInstance = $5ac2ec94ade4afdf$var$getNextHydratable(current.firstChild);
                        $5ac2ec94ade4afdf$var$hydrationParentFiber = workInProgress;
                        $5ac2ec94ade4afdf$var$isHydrating = !0;
                        $5ac2ec94ade4afdf$var$hydrationErrors = null;
                        $5ac2ec94ade4afdf$var$rootOrSingletonContext = !0;
                        renderLanes = $5ac2ec94ade4afdf$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $5ac2ec94ade4afdf$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $5ac2ec94ade4afdf$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $5ac2ec94ade4afdf$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $5ac2ec94ade4afdf$var$markRef(current, workInProgress), null === current ? (renderLanes = $5ac2ec94ade4afdf$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $5ac2ec94ade4afdf$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $5ac2ec94ade4afdf$var$getOwnerDocumentFromRootContainer($5ac2ec94ade4afdf$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$5ac2ec94ade4afdf$var$internalInstanceKey] = workInProgress, props[$5ac2ec94ade4afdf$var$internalPropsKey] = current, $5ac2ec94ade4afdf$var$setInitialProperties(props, renderLanes, current), $5ac2ec94ade4afdf$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $5ac2ec94ade4afdf$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $5ac2ec94ade4afdf$var$pushHostContext(workInProgress), null === current && $5ac2ec94ade4afdf$var$isHydrating && (props = workInProgress.stateNode = $5ac2ec94ade4afdf$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $5ac2ec94ade4afdf$var$rootInstanceStackCursor.current), $5ac2ec94ade4afdf$var$hydrationParentFiber = workInProgress, $5ac2ec94ade4afdf$var$rootOrSingletonContext = !0, $$typeof = $5ac2ec94ade4afdf$var$nextHydratableInstance, $5ac2ec94ade4afdf$var$isSingletonScope(workInProgress.type) ? ($5ac2ec94ade4afdf$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $5ac2ec94ade4afdf$var$nextHydratableInstance = $5ac2ec94ade4afdf$var$getNextHydratable(props.firstChild)) : $5ac2ec94ade4afdf$var$nextHydratableInstance = $$typeof), $5ac2ec94ade4afdf$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $5ac2ec94ade4afdf$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $5ac2ec94ade4afdf$var$isHydrating) {
                if ($$typeof = props = $5ac2ec94ade4afdf$var$nextHydratableInstance) props = $5ac2ec94ade4afdf$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $5ac2ec94ade4afdf$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $5ac2ec94ade4afdf$var$hydrationParentFiber = workInProgress, $5ac2ec94ade4afdf$var$nextHydratableInstance = $5ac2ec94ade4afdf$var$getNextHydratable(props.firstChild), $5ac2ec94ade4afdf$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $5ac2ec94ade4afdf$var$throwOnHydrationMismatch(workInProgress);
            }
            $5ac2ec94ade4afdf$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $5ac2ec94ade4afdf$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $5ac2ec94ade4afdf$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $5ac2ec94ade4afdf$var$renderWithHooks(current, workInProgress, $5ac2ec94ade4afdf$var$TransitionAwareHostComponent, null, null, renderLanes), $5ac2ec94ade4afdf$var$HostTransitionContext._currentValue = $$typeof);
            $5ac2ec94ade4afdf$var$markRef(current, workInProgress);
            $5ac2ec94ade4afdf$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $5ac2ec94ade4afdf$var$isHydrating) {
                if (current = renderLanes = $5ac2ec94ade4afdf$var$nextHydratableInstance) renderLanes = $5ac2ec94ade4afdf$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $5ac2ec94ade4afdf$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $5ac2ec94ade4afdf$var$hydrationParentFiber = workInProgress, $5ac2ec94ade4afdf$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $5ac2ec94ade4afdf$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $5ac2ec94ade4afdf$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $5ac2ec94ade4afdf$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $5ac2ec94ade4afdf$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $5ac2ec94ade4afdf$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $5ac2ec94ade4afdf$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $5ac2ec94ade4afdf$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $5ac2ec94ade4afdf$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $5ac2ec94ade4afdf$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $5ac2ec94ade4afdf$var$pushProvider(workInProgress, workInProgress.type, props.value), $5ac2ec94ade4afdf$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $5ac2ec94ade4afdf$var$prepareToReadContext(workInProgress), $$typeof = $5ac2ec94ade4afdf$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $5ac2ec94ade4afdf$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $5ac2ec94ade4afdf$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $5ac2ec94ade4afdf$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $5ac2ec94ade4afdf$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $5ac2ec94ade4afdf$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $5ac2ec94ade4afdf$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $5ac2ec94ade4afdf$var$prepareToReadContext(workInProgress), props = $5ac2ec94ade4afdf$var$readContext($5ac2ec94ade4afdf$var$CacheContext), null === current ? ($$typeof = $5ac2ec94ade4afdf$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $5ac2ec94ade4afdf$var$workInProgressRoot, prevState = $5ac2ec94ade4afdf$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $5ac2ec94ade4afdf$var$initializeUpdateQueue(workInProgress), $5ac2ec94ade4afdf$var$pushProvider(workInProgress, $5ac2ec94ade4afdf$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($5ac2ec94ade4afdf$var$cloneUpdateQueue(current, workInProgress), $5ac2ec94ade4afdf$var$processUpdateQueue(workInProgress, null, null, renderLanes), $5ac2ec94ade4afdf$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $5ac2ec94ade4afdf$var$pushProvider(workInProgress, $5ac2ec94ade4afdf$var$CacheContext, props)) : (props = prevState.cache, $5ac2ec94ade4afdf$var$pushProvider(workInProgress, $5ac2ec94ade4afdf$var$CacheContext, props), props !== $$typeof.cache && $5ac2ec94ade4afdf$var$propagateContextChanges(workInProgress, [
                $5ac2ec94ade4afdf$var$CacheContext
            ], renderLanes, !0))), $5ac2ec94ade4afdf$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $5ac2ec94ade4afdf$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $5ac2ec94ade4afdf$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($5ac2ec94ade4afdf$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $5ac2ec94ade4afdf$var$suspendedThenable = $5ac2ec94ade4afdf$var$noopSuspenseyCommitThenable, $5ac2ec94ade4afdf$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $5ac2ec94ade4afdf$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$5ac2ec94ade4afdf$var$preloadResource(resource)) {
        if ($5ac2ec94ade4afdf$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $5ac2ec94ade4afdf$var$suspendedThenable = $5ac2ec94ade4afdf$var$noopSuspenseyCommitThenable, $5ac2ec94ade4afdf$var$SuspenseyCommitException;
    }
}
function $5ac2ec94ade4afdf$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $5ac2ec94ade4afdf$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $5ac2ec94ade4afdf$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $5ac2ec94ade4afdf$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$5ac2ec94ade4afdf$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $5ac2ec94ade4afdf$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $5ac2ec94ade4afdf$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $5ac2ec94ade4afdf$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $5ac2ec94ade4afdf$var$bubbleProperties(workInProgress), null;
        case 1:
            return $5ac2ec94ade4afdf$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $5ac2ec94ade4afdf$var$popProvider($5ac2ec94ade4afdf$var$CacheContext);
            $5ac2ec94ade4afdf$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $5ac2ec94ade4afdf$var$popHydrationState(workInProgress) ? $5ac2ec94ade4afdf$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $5ac2ec94ade4afdf$var$upgradeHydrationErrorsToRecoverable());
            $5ac2ec94ade4afdf$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($5ac2ec94ade4afdf$var$markUpdate(workInProgress), null !== nextResource ? ($5ac2ec94ade4afdf$var$bubbleProperties(workInProgress), $5ac2ec94ade4afdf$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($5ac2ec94ade4afdf$var$bubbleProperties(workInProgress), $5ac2ec94ade4afdf$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($5ac2ec94ade4afdf$var$markUpdate(workInProgress), $5ac2ec94ade4afdf$var$bubbleProperties(workInProgress), $5ac2ec94ade4afdf$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($5ac2ec94ade4afdf$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $5ac2ec94ade4afdf$var$markUpdate(workInProgress), $5ac2ec94ade4afdf$var$bubbleProperties(workInProgress), $5ac2ec94ade4afdf$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $5ac2ec94ade4afdf$var$popHostContext(workInProgress);
            renderLanes = $5ac2ec94ade4afdf$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $5ac2ec94ade4afdf$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(166));
                    $5ac2ec94ade4afdf$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $5ac2ec94ade4afdf$var$contextStackCursor.current;
                $5ac2ec94ade4afdf$var$popHydrationState(workInProgress) ? $5ac2ec94ade4afdf$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $5ac2ec94ade4afdf$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $5ac2ec94ade4afdf$var$markUpdate(workInProgress));
            }
            $5ac2ec94ade4afdf$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $5ac2ec94ade4afdf$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $5ac2ec94ade4afdf$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(166));
                    $5ac2ec94ade4afdf$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $5ac2ec94ade4afdf$var$contextStackCursor.current;
                if ($5ac2ec94ade4afdf$var$popHydrationState(workInProgress)) $5ac2ec94ade4afdf$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $5ac2ec94ade4afdf$var$getOwnerDocumentFromRootContainer($5ac2ec94ade4afdf$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$5ac2ec94ade4afdf$var$internalInstanceKey] = workInProgress;
                    nextResource[$5ac2ec94ade4afdf$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($5ac2ec94ade4afdf$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $5ac2ec94ade4afdf$var$markUpdate(workInProgress);
                }
            }
            $5ac2ec94ade4afdf$var$bubbleProperties(workInProgress);
            $5ac2ec94ade4afdf$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $5ac2ec94ade4afdf$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(166));
                current = $5ac2ec94ade4afdf$var$rootInstanceStackCursor.current;
                if ($5ac2ec94ade4afdf$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $5ac2ec94ade4afdf$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$5ac2ec94ade4afdf$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $5ac2ec94ade4afdf$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $5ac2ec94ade4afdf$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $5ac2ec94ade4afdf$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$5ac2ec94ade4afdf$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $5ac2ec94ade4afdf$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $5ac2ec94ade4afdf$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(557));
                        current[$5ac2ec94ade4afdf$var$internalInstanceKey] = workInProgress;
                    } else $5ac2ec94ade4afdf$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $5ac2ec94ade4afdf$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $5ac2ec94ade4afdf$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $5ac2ec94ade4afdf$var$popSuspenseHandler(workInProgress), workInProgress;
                    $5ac2ec94ade4afdf$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(558));
            }
            $5ac2ec94ade4afdf$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $5ac2ec94ade4afdf$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(317));
                        type[$5ac2ec94ade4afdf$var$internalInstanceKey] = workInProgress;
                    } else $5ac2ec94ade4afdf$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $5ac2ec94ade4afdf$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $5ac2ec94ade4afdf$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $5ac2ec94ade4afdf$var$popSuspenseHandler(workInProgress), workInProgress;
                    $5ac2ec94ade4afdf$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $5ac2ec94ade4afdf$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $5ac2ec94ade4afdf$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $5ac2ec94ade4afdf$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $5ac2ec94ade4afdf$var$popHostContainer(), null === current && $5ac2ec94ade4afdf$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $5ac2ec94ade4afdf$var$bubbleProperties(workInProgress), null;
        case 10:
            return $5ac2ec94ade4afdf$var$popProvider(workInProgress.type), $5ac2ec94ade4afdf$var$bubbleProperties(workInProgress), null;
        case 19:
            $5ac2ec94ade4afdf$var$pop($5ac2ec94ade4afdf$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $5ac2ec94ade4afdf$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $5ac2ec94ade4afdf$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $5ac2ec94ade4afdf$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $5ac2ec94ade4afdf$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $5ac2ec94ade4afdf$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $5ac2ec94ade4afdf$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$5ac2ec94ade4afdf$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $5ac2ec94ade4afdf$var$push($5ac2ec94ade4afdf$var$suspenseStackCursor, $5ac2ec94ade4afdf$var$suspenseStackCursor.current & 1 | 2);
                            $5ac2ec94ade4afdf$var$isHydrating && $5ac2ec94ade4afdf$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $5ac2ec94ade4afdf$var$now() > $5ac2ec94ade4afdf$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $5ac2ec94ade4afdf$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $5ac2ec94ade4afdf$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $5ac2ec94ade4afdf$var$scheduleRetryEffect(workInProgress, current), $5ac2ec94ade4afdf$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$5ac2ec94ade4afdf$var$isHydrating) return $5ac2ec94ade4afdf$var$bubbleProperties(workInProgress), null;
                    } else 2 * $5ac2ec94ade4afdf$var$now() - newProps.renderingStartTime > $5ac2ec94ade4afdf$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $5ac2ec94ade4afdf$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $5ac2ec94ade4afdf$var$now(), current.sibling = null, renderLanes = $5ac2ec94ade4afdf$var$suspenseStackCursor.current, $5ac2ec94ade4afdf$var$push($5ac2ec94ade4afdf$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $5ac2ec94ade4afdf$var$isHydrating && $5ac2ec94ade4afdf$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $5ac2ec94ade4afdf$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $5ac2ec94ade4afdf$var$popSuspenseHandler(workInProgress), $5ac2ec94ade4afdf$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($5ac2ec94ade4afdf$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $5ac2ec94ade4afdf$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $5ac2ec94ade4afdf$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $5ac2ec94ade4afdf$var$pop($5ac2ec94ade4afdf$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $5ac2ec94ade4afdf$var$popProvider($5ac2ec94ade4afdf$var$CacheContext), $5ac2ec94ade4afdf$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $5ac2ec94ade4afdf$var$unwindWork(current, workInProgress) {
    $5ac2ec94ade4afdf$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $5ac2ec94ade4afdf$var$popProvider($5ac2ec94ade4afdf$var$CacheContext), $5ac2ec94ade4afdf$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $5ac2ec94ade4afdf$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $5ac2ec94ade4afdf$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(340));
                $5ac2ec94ade4afdf$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $5ac2ec94ade4afdf$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(340));
                $5ac2ec94ade4afdf$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $5ac2ec94ade4afdf$var$pop($5ac2ec94ade4afdf$var$suspenseStackCursor), null;
        case 4:
            return $5ac2ec94ade4afdf$var$popHostContainer(), null;
        case 10:
            return $5ac2ec94ade4afdf$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $5ac2ec94ade4afdf$var$popSuspenseHandler(workInProgress), $5ac2ec94ade4afdf$var$popHiddenContext(), null !== current && $5ac2ec94ade4afdf$var$pop($5ac2ec94ade4afdf$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $5ac2ec94ade4afdf$var$popProvider($5ac2ec94ade4afdf$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $5ac2ec94ade4afdf$var$unwindInterruptedWork(current, interruptedWork) {
    $5ac2ec94ade4afdf$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $5ac2ec94ade4afdf$var$popProvider($5ac2ec94ade4afdf$var$CacheContext);
            $5ac2ec94ade4afdf$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $5ac2ec94ade4afdf$var$popHostContext(interruptedWork);
            break;
        case 4:
            $5ac2ec94ade4afdf$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $5ac2ec94ade4afdf$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $5ac2ec94ade4afdf$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $5ac2ec94ade4afdf$var$pop($5ac2ec94ade4afdf$var$suspenseStackCursor);
            break;
        case 10:
            $5ac2ec94ade4afdf$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $5ac2ec94ade4afdf$var$popSuspenseHandler(interruptedWork);
            $5ac2ec94ade4afdf$var$popHiddenContext();
            null !== current && $5ac2ec94ade4afdf$var$pop($5ac2ec94ade4afdf$var$resumedCache);
            break;
        case 24:
            $5ac2ec94ade4afdf$var$popProvider($5ac2ec94ade4afdf$var$CacheContext);
    }
}
function $5ac2ec94ade4afdf$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $5ac2ec94ade4afdf$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $5ac2ec94ade4afdf$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $5ac2ec94ade4afdf$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $5ac2ec94ade4afdf$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $5ac2ec94ade4afdf$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $5ac2ec94ade4afdf$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $5ac2ec94ade4afdf$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $5ac2ec94ade4afdf$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $5ac2ec94ade4afdf$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $5ac2ec94ade4afdf$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $5ac2ec94ade4afdf$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $5ac2ec94ade4afdf$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $5ac2ec94ade4afdf$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $5ac2ec94ade4afdf$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $5ac2ec94ade4afdf$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $5ac2ec94ade4afdf$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $5ac2ec94ade4afdf$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $5ac2ec94ade4afdf$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $5ac2ec94ade4afdf$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$5ac2ec94ade4afdf$var$internalPropsKey] = newProps;
    } catch (error) {
        $5ac2ec94ade4afdf$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $5ac2ec94ade4afdf$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $5ac2ec94ade4afdf$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $5ac2ec94ade4afdf$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $5ac2ec94ade4afdf$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $5ac2ec94ade4afdf$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $5ac2ec94ade4afdf$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $5ac2ec94ade4afdf$var$noop$1));
    else if (4 !== tag && (27 === tag && $5ac2ec94ade4afdf$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($5ac2ec94ade4afdf$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$5ac2ec94ade4afdf$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $5ac2ec94ade4afdf$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $5ac2ec94ade4afdf$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($5ac2ec94ade4afdf$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$5ac2ec94ade4afdf$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $5ac2ec94ade4afdf$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $5ac2ec94ade4afdf$var$setInitialProperties(singleton, type, props);
        singleton[$5ac2ec94ade4afdf$var$internalInstanceKey] = finishedWork;
        singleton[$5ac2ec94ade4afdf$var$internalPropsKey] = props;
    } catch (error) {
        $5ac2ec94ade4afdf$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $5ac2ec94ade4afdf$var$offscreenSubtreeIsHidden = !1, $5ac2ec94ade4afdf$var$offscreenSubtreeWasHidden = !1, $5ac2ec94ade4afdf$var$needsFormReset = !1, $5ac2ec94ade4afdf$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $5ac2ec94ade4afdf$var$nextEffect = null;
function $5ac2ec94ade4afdf$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $5ac2ec94ade4afdf$var$eventsEnabled = $5ac2ec94ade4afdf$var$_enabled;
    root = $5ac2ec94ade4afdf$var$getActiveElementDeep(root);
    if ($5ac2ec94ade4afdf$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $5ac2ec94ade4afdf$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $5ac2ec94ade4afdf$var$_enabled = !1;
    for($5ac2ec94ade4afdf$var$nextEffect = firstChild; null !== $5ac2ec94ade4afdf$var$nextEffect;)if (firstChild = $5ac2ec94ade4afdf$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $5ac2ec94ade4afdf$var$nextEffect = root;
    else for(; null !== $5ac2ec94ade4afdf$var$nextEffect;){
        firstChild = $5ac2ec94ade4afdf$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $5ac2ec94ade4afdf$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $5ac2ec94ade4afdf$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $5ac2ec94ade4afdf$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $5ac2ec94ade4afdf$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $5ac2ec94ade4afdf$var$nextEffect = root;
            break;
        }
        $5ac2ec94ade4afdf$var$nextEffect = firstChild.return;
    }
}
function $5ac2ec94ade4afdf$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $5ac2ec94ade4afdf$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $5ac2ec94ade4afdf$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $5ac2ec94ade4afdf$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $5ac2ec94ade4afdf$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $5ac2ec94ade4afdf$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $5ac2ec94ade4afdf$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $5ac2ec94ade4afdf$var$commitClassCallbacks(finishedWork);
            flags & 512 && $5ac2ec94ade4afdf$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $5ac2ec94ade4afdf$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $5ac2ec94ade4afdf$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $5ac2ec94ade4afdf$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $5ac2ec94ade4afdf$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $5ac2ec94ade4afdf$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $5ac2ec94ade4afdf$var$commitHostMount(finishedWork);
            flags & 512 && $5ac2ec94ade4afdf$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $5ac2ec94ade4afdf$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $5ac2ec94ade4afdf$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $5ac2ec94ade4afdf$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $5ac2ec94ade4afdf$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $5ac2ec94ade4afdf$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $5ac2ec94ade4afdf$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $5ac2ec94ade4afdf$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $5ac2ec94ade4afdf$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $5ac2ec94ade4afdf$var$offscreenSubtreeWasHidden;
                prevProps = $5ac2ec94ade4afdf$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $5ac2ec94ade4afdf$var$offscreenSubtreeWasHidden;
                $5ac2ec94ade4afdf$var$offscreenSubtreeIsHidden = flags;
                ($5ac2ec94ade4afdf$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $5ac2ec94ade4afdf$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $5ac2ec94ade4afdf$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $5ac2ec94ade4afdf$var$offscreenSubtreeIsHidden = prevProps;
                $5ac2ec94ade4afdf$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $5ac2ec94ade4afdf$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $5ac2ec94ade4afdf$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $5ac2ec94ade4afdf$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $5ac2ec94ade4afdf$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $5ac2ec94ade4afdf$var$hostParent = null, $5ac2ec94ade4afdf$var$hostParentIsContainer = !1;
function $5ac2ec94ade4afdf$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$5ac2ec94ade4afdf$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $5ac2ec94ade4afdf$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($5ac2ec94ade4afdf$var$injectedHook && "function" === typeof $5ac2ec94ade4afdf$var$injectedHook.onCommitFiberUnmount) try {
        $5ac2ec94ade4afdf$var$injectedHook.onCommitFiberUnmount($5ac2ec94ade4afdf$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $5ac2ec94ade4afdf$var$offscreenSubtreeWasHidden || $5ac2ec94ade4afdf$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $5ac2ec94ade4afdf$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $5ac2ec94ade4afdf$var$offscreenSubtreeWasHidden || $5ac2ec94ade4afdf$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $5ac2ec94ade4afdf$var$hostParent, prevHostParentIsContainer = $5ac2ec94ade4afdf$var$hostParentIsContainer;
            $5ac2ec94ade4afdf$var$isSingletonScope(deletedFiber.type) && ($5ac2ec94ade4afdf$var$hostParent = deletedFiber.stateNode, $5ac2ec94ade4afdf$var$hostParentIsContainer = !1);
            $5ac2ec94ade4afdf$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $5ac2ec94ade4afdf$var$releaseSingletonInstance(deletedFiber.stateNode);
            $5ac2ec94ade4afdf$var$hostParent = prevHostParent;
            $5ac2ec94ade4afdf$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $5ac2ec94ade4afdf$var$offscreenSubtreeWasHidden || $5ac2ec94ade4afdf$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $5ac2ec94ade4afdf$var$hostParent;
            prevHostParentIsContainer = $5ac2ec94ade4afdf$var$hostParentIsContainer;
            $5ac2ec94ade4afdf$var$hostParent = null;
            $5ac2ec94ade4afdf$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $5ac2ec94ade4afdf$var$hostParent = prevHostParent;
            $5ac2ec94ade4afdf$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $5ac2ec94ade4afdf$var$hostParent) {
                if ($5ac2ec94ade4afdf$var$hostParentIsContainer) try {
                    (9 === $5ac2ec94ade4afdf$var$hostParent.nodeType ? $5ac2ec94ade4afdf$var$hostParent.body : "HTML" === $5ac2ec94ade4afdf$var$hostParent.nodeName ? $5ac2ec94ade4afdf$var$hostParent.ownerDocument.body : $5ac2ec94ade4afdf$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $5ac2ec94ade4afdf$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $5ac2ec94ade4afdf$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $5ac2ec94ade4afdf$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $5ac2ec94ade4afdf$var$hostParent && ($5ac2ec94ade4afdf$var$hostParentIsContainer ? (finishedRoot = $5ac2ec94ade4afdf$var$hostParent, $5ac2ec94ade4afdf$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $5ac2ec94ade4afdf$var$retryIfBlockedOn(finishedRoot)) : $5ac2ec94ade4afdf$var$clearHydrationBoundary($5ac2ec94ade4afdf$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $5ac2ec94ade4afdf$var$hostParent;
            prevHostParentIsContainer = $5ac2ec94ade4afdf$var$hostParentIsContainer;
            $5ac2ec94ade4afdf$var$hostParent = deletedFiber.stateNode.containerInfo;
            $5ac2ec94ade4afdf$var$hostParentIsContainer = !0;
            $5ac2ec94ade4afdf$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $5ac2ec94ade4afdf$var$hostParent = prevHostParent;
            $5ac2ec94ade4afdf$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $5ac2ec94ade4afdf$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $5ac2ec94ade4afdf$var$offscreenSubtreeWasHidden || $5ac2ec94ade4afdf$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $5ac2ec94ade4afdf$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $5ac2ec94ade4afdf$var$offscreenSubtreeWasHidden || ($5ac2ec94ade4afdf$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $5ac2ec94ade4afdf$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $5ac2ec94ade4afdf$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $5ac2ec94ade4afdf$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $5ac2ec94ade4afdf$var$offscreenSubtreeWasHidden = (prevHostParent = $5ac2ec94ade4afdf$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $5ac2ec94ade4afdf$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $5ac2ec94ade4afdf$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $5ac2ec94ade4afdf$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $5ac2ec94ade4afdf$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $5ac2ec94ade4afdf$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $5ac2ec94ade4afdf$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $5ac2ec94ade4afdf$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $5ac2ec94ade4afdf$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $5ac2ec94ade4afdf$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $5ac2ec94ade4afdf$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $5ac2ec94ade4afdf$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $5ac2ec94ade4afdf$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $5ac2ec94ade4afdf$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $5ac2ec94ade4afdf$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $5ac2ec94ade4afdf$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $5ac2ec94ade4afdf$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($5ac2ec94ade4afdf$var$isSingletonScope(parent.type)) {
                        $5ac2ec94ade4afdf$var$hostParent = parent.stateNode;
                        $5ac2ec94ade4afdf$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $5ac2ec94ade4afdf$var$hostParent = parent.stateNode;
                    $5ac2ec94ade4afdf$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $5ac2ec94ade4afdf$var$hostParent = parent.stateNode.containerInfo;
                    $5ac2ec94ade4afdf$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $5ac2ec94ade4afdf$var$hostParent) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(160));
        $5ac2ec94ade4afdf$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $5ac2ec94ade4afdf$var$hostParent = null;
        $5ac2ec94ade4afdf$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$5ac2ec94ade4afdf$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $5ac2ec94ade4afdf$var$currentHoistableRoot = null;
function $5ac2ec94ade4afdf$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $5ac2ec94ade4afdf$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $5ac2ec94ade4afdf$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($5ac2ec94ade4afdf$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $5ac2ec94ade4afdf$var$commitHookEffectListMount(3, finishedWork), $5ac2ec94ade4afdf$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $5ac2ec94ade4afdf$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $5ac2ec94ade4afdf$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($5ac2ec94ade4afdf$var$offscreenSubtreeWasHidden || null === current || $5ac2ec94ade4afdf$var$safelyDetachRef(current, current.return));
            flags & 64 && $5ac2ec94ade4afdf$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $5ac2ec94ade4afdf$var$currentHoistableRoot;
            $5ac2ec94ade4afdf$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $5ac2ec94ade4afdf$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($5ac2ec94ade4afdf$var$offscreenSubtreeWasHidden || null === current || $5ac2ec94ade4afdf$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$5ac2ec94ade4afdf$var$internalHoistableMarker] || currentResource[$5ac2ec94ade4afdf$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $5ac2ec94ade4afdf$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$5ac2ec94ade4afdf$var$internalInstanceKey] = finishedWork;
                                        $5ac2ec94ade4afdf$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $5ac2ec94ade4afdf$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $5ac2ec94ade4afdf$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $5ac2ec94ade4afdf$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $5ac2ec94ade4afdf$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$5ac2ec94ade4afdf$var$internalInstanceKey] = finishedWork;
                                $5ac2ec94ade4afdf$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $5ac2ec94ade4afdf$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $5ac2ec94ade4afdf$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $5ac2ec94ade4afdf$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $5ac2ec94ade4afdf$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $5ac2ec94ade4afdf$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $5ac2ec94ade4afdf$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $5ac2ec94ade4afdf$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($5ac2ec94ade4afdf$var$offscreenSubtreeWasHidden || null === current || $5ac2ec94ade4afdf$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $5ac2ec94ade4afdf$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $5ac2ec94ade4afdf$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $5ac2ec94ade4afdf$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($5ac2ec94ade4afdf$var$offscreenSubtreeWasHidden || null === current || $5ac2ec94ade4afdf$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $5ac2ec94ade4afdf$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $5ac2ec94ade4afdf$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $5ac2ec94ade4afdf$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($5ac2ec94ade4afdf$var$needsFormReset = !0);
            break;
        case 6:
            $5ac2ec94ade4afdf$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $5ac2ec94ade4afdf$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $5ac2ec94ade4afdf$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $5ac2ec94ade4afdf$var$tagCaches = null;
            hoistableRoot = $5ac2ec94ade4afdf$var$currentHoistableRoot;
            $5ac2ec94ade4afdf$var$currentHoistableRoot = $5ac2ec94ade4afdf$var$getHoistableRoot(root.containerInfo);
            $5ac2ec94ade4afdf$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $5ac2ec94ade4afdf$var$currentHoistableRoot = hoistableRoot;
            $5ac2ec94ade4afdf$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $5ac2ec94ade4afdf$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $5ac2ec94ade4afdf$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $5ac2ec94ade4afdf$var$needsFormReset && ($5ac2ec94ade4afdf$var$needsFormReset = !1, $5ac2ec94ade4afdf$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $5ac2ec94ade4afdf$var$currentHoistableRoot;
            $5ac2ec94ade4afdf$var$currentHoistableRoot = $5ac2ec94ade4afdf$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $5ac2ec94ade4afdf$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $5ac2ec94ade4afdf$var$commitReconciliationEffects(finishedWork);
            $5ac2ec94ade4afdf$var$currentHoistableRoot = flags;
            break;
        case 12:
            $5ac2ec94ade4afdf$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $5ac2ec94ade4afdf$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $5ac2ec94ade4afdf$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $5ac2ec94ade4afdf$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $5ac2ec94ade4afdf$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $5ac2ec94ade4afdf$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $5ac2ec94ade4afdf$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($5ac2ec94ade4afdf$var$globalMostRecentFallbackTime = $5ac2ec94ade4afdf$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $5ac2ec94ade4afdf$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $5ac2ec94ade4afdf$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $5ac2ec94ade4afdf$var$offscreenSubtreeWasHidden;
            $5ac2ec94ade4afdf$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $5ac2ec94ade4afdf$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $5ac2ec94ade4afdf$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $5ac2ec94ade4afdf$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $5ac2ec94ade4afdf$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $5ac2ec94ade4afdf$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $5ac2ec94ade4afdf$var$offscreenSubtreeIsHidden || $5ac2ec94ade4afdf$var$offscreenSubtreeWasHidden || $5ac2ec94ade4afdf$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $5ac2ec94ade4afdf$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $5ac2ec94ade4afdf$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $5ac2ec94ade4afdf$var$hideOrUnhideDehydratedBoundary(instance, !0) : $5ac2ec94ade4afdf$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $5ac2ec94ade4afdf$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $5ac2ec94ade4afdf$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $5ac2ec94ade4afdf$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $5ac2ec94ade4afdf$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $5ac2ec94ade4afdf$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $5ac2ec94ade4afdf$var$recursivelyTraverseMutationEffects(root, finishedWork), $5ac2ec94ade4afdf$var$commitReconciliationEffects(finishedWork);
    }
}
function $5ac2ec94ade4afdf$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($5ac2ec94ade4afdf$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $5ac2ec94ade4afdf$var$getHostSibling(finishedWork);
                    $5ac2ec94ade4afdf$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($5ac2ec94ade4afdf$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $5ac2ec94ade4afdf$var$getHostSibling(finishedWork);
                    $5ac2ec94ade4afdf$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $5ac2ec94ade4afdf$var$getHostSibling(finishedWork);
                    $5ac2ec94ade4afdf$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $5ac2ec94ade4afdf$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $5ac2ec94ade4afdf$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $5ac2ec94ade4afdf$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $5ac2ec94ade4afdf$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$5ac2ec94ade4afdf$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $5ac2ec94ade4afdf$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $5ac2ec94ade4afdf$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $5ac2ec94ade4afdf$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $5ac2ec94ade4afdf$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $5ac2ec94ade4afdf$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $5ac2ec94ade4afdf$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $5ac2ec94ade4afdf$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $5ac2ec94ade4afdf$var$safelyDetachRef(finishedWork, finishedWork.return);
                $5ac2ec94ade4afdf$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $5ac2ec94ade4afdf$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $5ac2ec94ade4afdf$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $5ac2ec94ade4afdf$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $5ac2ec94ade4afdf$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $5ac2ec94ade4afdf$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $5ac2ec94ade4afdf$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $5ac2ec94ade4afdf$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $5ac2ec94ade4afdf$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$5ac2ec94ade4afdf$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $5ac2ec94ade4afdf$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $5ac2ec94ade4afdf$var$commitClassCallbacks(finishedWork);
                $5ac2ec94ade4afdf$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $5ac2ec94ade4afdf$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $5ac2ec94ade4afdf$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $5ac2ec94ade4afdf$var$commitHostMount(finishedWork);
                $5ac2ec94ade4afdf$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $5ac2ec94ade4afdf$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $5ac2ec94ade4afdf$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $5ac2ec94ade4afdf$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $5ac2ec94ade4afdf$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $5ac2ec94ade4afdf$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $5ac2ec94ade4afdf$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $5ac2ec94ade4afdf$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $5ac2ec94ade4afdf$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $5ac2ec94ade4afdf$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $5ac2ec94ade4afdf$var$releaseCache(previousCache));
}
function $5ac2ec94ade4afdf$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $5ac2ec94ade4afdf$var$releaseCache(current));
}
function $5ac2ec94ade4afdf$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$5ac2ec94ade4afdf$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $5ac2ec94ade4afdf$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $5ac2ec94ade4afdf$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $5ac2ec94ade4afdf$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $5ac2ec94ade4afdf$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $5ac2ec94ade4afdf$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $5ac2ec94ade4afdf$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $5ac2ec94ade4afdf$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $5ac2ec94ade4afdf$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $5ac2ec94ade4afdf$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $5ac2ec94ade4afdf$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $5ac2ec94ade4afdf$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $5ac2ec94ade4afdf$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $5ac2ec94ade4afdf$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $5ac2ec94ade4afdf$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $5ac2ec94ade4afdf$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $5ac2ec94ade4afdf$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $5ac2ec94ade4afdf$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $5ac2ec94ade4afdf$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $5ac2ec94ade4afdf$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $5ac2ec94ade4afdf$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $5ac2ec94ade4afdf$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $5ac2ec94ade4afdf$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $5ac2ec94ade4afdf$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $5ac2ec94ade4afdf$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $5ac2ec94ade4afdf$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $5ac2ec94ade4afdf$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $5ac2ec94ade4afdf$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $5ac2ec94ade4afdf$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $5ac2ec94ade4afdf$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $5ac2ec94ade4afdf$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $5ac2ec94ade4afdf$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $5ac2ec94ade4afdf$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $5ac2ec94ade4afdf$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $5ac2ec94ade4afdf$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $5ac2ec94ade4afdf$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $5ac2ec94ade4afdf$var$suspenseyCommitFlag = 8192;
function $5ac2ec94ade4afdf$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $5ac2ec94ade4afdf$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$5ac2ec94ade4afdf$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $5ac2ec94ade4afdf$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $5ac2ec94ade4afdf$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $5ac2ec94ade4afdf$var$suspenseyCommitFlag && null !== fiber.memoizedState && $5ac2ec94ade4afdf$var$suspendResource(suspendedState, $5ac2ec94ade4afdf$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $5ac2ec94ade4afdf$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $5ac2ec94ade4afdf$var$currentHoistableRoot;
            $5ac2ec94ade4afdf$var$currentHoistableRoot = $5ac2ec94ade4afdf$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $5ac2ec94ade4afdf$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $5ac2ec94ade4afdf$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $5ac2ec94ade4afdf$var$suspenseyCommitFlag, $5ac2ec94ade4afdf$var$suspenseyCommitFlag = 16777216, $5ac2ec94ade4afdf$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $5ac2ec94ade4afdf$var$suspenseyCommitFlag = previousHoistableRoot) : $5ac2ec94ade4afdf$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $5ac2ec94ade4afdf$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $5ac2ec94ade4afdf$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $5ac2ec94ade4afdf$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $5ac2ec94ade4afdf$var$nextEffect = childToDelete;
            $5ac2ec94ade4afdf$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $5ac2ec94ade4afdf$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$5ac2ec94ade4afdf$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $5ac2ec94ade4afdf$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $5ac2ec94ade4afdf$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $5ac2ec94ade4afdf$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $5ac2ec94ade4afdf$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $5ac2ec94ade4afdf$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $5ac2ec94ade4afdf$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $5ac2ec94ade4afdf$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $5ac2ec94ade4afdf$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $5ac2ec94ade4afdf$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $5ac2ec94ade4afdf$var$nextEffect = childToDelete;
            $5ac2ec94ade4afdf$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $5ac2ec94ade4afdf$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $5ac2ec94ade4afdf$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $5ac2ec94ade4afdf$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $5ac2ec94ade4afdf$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $5ac2ec94ade4afdf$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $5ac2ec94ade4afdf$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $5ac2ec94ade4afdf$var$nextEffect;){
        var fiber = $5ac2ec94ade4afdf$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $5ac2ec94ade4afdf$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $5ac2ec94ade4afdf$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $5ac2ec94ade4afdf$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $5ac2ec94ade4afdf$var$nextEffect;){
            cache = $5ac2ec94ade4afdf$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $5ac2ec94ade4afdf$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $5ac2ec94ade4afdf$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $5ac2ec94ade4afdf$var$nextEffect = sibling;
                break a;
            }
            $5ac2ec94ade4afdf$var$nextEffect = returnFiber;
        }
    }
}
var $5ac2ec94ade4afdf$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $5ac2ec94ade4afdf$var$readContext($5ac2ec94ade4afdf$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $5ac2ec94ade4afdf$var$readContext($5ac2ec94ade4afdf$var$CacheContext).controller.signal;
    }
}, $5ac2ec94ade4afdf$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $5ac2ec94ade4afdf$var$executionContext = 0, $5ac2ec94ade4afdf$var$workInProgressRoot = null, $5ac2ec94ade4afdf$var$workInProgress = null, $5ac2ec94ade4afdf$var$workInProgressRootRenderLanes = 0, $5ac2ec94ade4afdf$var$workInProgressSuspendedReason = 0, $5ac2ec94ade4afdf$var$workInProgressThrownValue = null, $5ac2ec94ade4afdf$var$workInProgressRootDidSkipSuspendedSiblings = !1, $5ac2ec94ade4afdf$var$workInProgressRootIsPrerendering = !1, $5ac2ec94ade4afdf$var$workInProgressRootDidAttachPingListener = !1, $5ac2ec94ade4afdf$var$entangledRenderLanes = 0, $5ac2ec94ade4afdf$var$workInProgressRootExitStatus = 0, $5ac2ec94ade4afdf$var$workInProgressRootSkippedLanes = 0, $5ac2ec94ade4afdf$var$workInProgressRootInterleavedUpdatedLanes = 0, $5ac2ec94ade4afdf$var$workInProgressRootPingedLanes = 0, $5ac2ec94ade4afdf$var$workInProgressDeferredLane = 0, $5ac2ec94ade4afdf$var$workInProgressSuspendedRetryLanes = 0, $5ac2ec94ade4afdf$var$workInProgressRootConcurrentErrors = null, $5ac2ec94ade4afdf$var$workInProgressRootRecoverableErrors = null, $5ac2ec94ade4afdf$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $5ac2ec94ade4afdf$var$globalMostRecentFallbackTime = 0, $5ac2ec94ade4afdf$var$globalMostRecentTransitionTime = 0, $5ac2ec94ade4afdf$var$workInProgressRootRenderTargetTime = Infinity, $5ac2ec94ade4afdf$var$workInProgressTransitions = null, $5ac2ec94ade4afdf$var$legacyErrorBoundariesThatAlreadyFailed = null, $5ac2ec94ade4afdf$var$pendingEffectsStatus = 0, $5ac2ec94ade4afdf$var$pendingEffectsRoot = null, $5ac2ec94ade4afdf$var$pendingFinishedWork = null, $5ac2ec94ade4afdf$var$pendingEffectsLanes = 0, $5ac2ec94ade4afdf$var$pendingEffectsRemainingLanes = 0, $5ac2ec94ade4afdf$var$pendingPassiveTransitions = null, $5ac2ec94ade4afdf$var$pendingRecoverableErrors = null, $5ac2ec94ade4afdf$var$nestedUpdateCount = 0, $5ac2ec94ade4afdf$var$rootWithNestedUpdates = null;
function $5ac2ec94ade4afdf$var$requestUpdateLane() {
    return 0 !== ($5ac2ec94ade4afdf$var$executionContext & 2) && 0 !== $5ac2ec94ade4afdf$var$workInProgressRootRenderLanes ? $5ac2ec94ade4afdf$var$workInProgressRootRenderLanes & -$5ac2ec94ade4afdf$var$workInProgressRootRenderLanes : null !== $5ac2ec94ade4afdf$var$ReactSharedInternals.T ? $5ac2ec94ade4afdf$var$requestTransitionLane() : $5ac2ec94ade4afdf$var$resolveUpdatePriority();
}
function $5ac2ec94ade4afdf$var$requestDeferredLane() {
    if (0 === $5ac2ec94ade4afdf$var$workInProgressDeferredLane) {
        if (0 === ($5ac2ec94ade4afdf$var$workInProgressRootRenderLanes & 536870912) || $5ac2ec94ade4afdf$var$isHydrating) {
            var lane = $5ac2ec94ade4afdf$var$nextTransitionDeferredLane;
            $5ac2ec94ade4afdf$var$nextTransitionDeferredLane <<= 1;
            0 === ($5ac2ec94ade4afdf$var$nextTransitionDeferredLane & 3932160) && ($5ac2ec94ade4afdf$var$nextTransitionDeferredLane = 262144);
            $5ac2ec94ade4afdf$var$workInProgressDeferredLane = lane;
        } else $5ac2ec94ade4afdf$var$workInProgressDeferredLane = 536870912;
    }
    lane = $5ac2ec94ade4afdf$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $5ac2ec94ade4afdf$var$workInProgressDeferredLane;
}
function $5ac2ec94ade4afdf$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $5ac2ec94ade4afdf$var$workInProgressRoot && (2 === $5ac2ec94ade4afdf$var$workInProgressSuspendedReason || 9 === $5ac2ec94ade4afdf$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $5ac2ec94ade4afdf$var$prepareFreshStack(root, 0), $5ac2ec94ade4afdf$var$markRootSuspended(root, $5ac2ec94ade4afdf$var$workInProgressRootRenderLanes, $5ac2ec94ade4afdf$var$workInProgressDeferredLane, !1);
    $5ac2ec94ade4afdf$var$markRootUpdated$1(root, lane);
    if (0 === ($5ac2ec94ade4afdf$var$executionContext & 2) || root !== $5ac2ec94ade4afdf$var$workInProgressRoot) root === $5ac2ec94ade4afdf$var$workInProgressRoot && (0 === ($5ac2ec94ade4afdf$var$executionContext & 2) && ($5ac2ec94ade4afdf$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $5ac2ec94ade4afdf$var$workInProgressRootExitStatus && $5ac2ec94ade4afdf$var$markRootSuspended(root, $5ac2ec94ade4afdf$var$workInProgressRootRenderLanes, $5ac2ec94ade4afdf$var$workInProgressDeferredLane, !1)), $5ac2ec94ade4afdf$var$ensureRootIsScheduled(root);
}
function $5ac2ec94ade4afdf$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($5ac2ec94ade4afdf$var$executionContext & 6)) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $5ac2ec94ade4afdf$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $5ac2ec94ade4afdf$var$renderRootConcurrent(root$jscomp$0, lanes) : $5ac2ec94ade4afdf$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $5ac2ec94ade4afdf$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $5ac2ec94ade4afdf$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$5ac2ec94ade4afdf$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $5ac2ec94ade4afdf$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $5ac2ec94ade4afdf$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($5ac2ec94ade4afdf$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $5ac2ec94ade4afdf$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($5ac2ec94ade4afdf$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $5ac2ec94ade4afdf$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $5ac2ec94ade4afdf$var$workInProgressRootRecoverableErrors;
                            $5ac2ec94ade4afdf$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $5ac2ec94ade4afdf$var$workInProgressRootRecoverableErrors ? $5ac2ec94ade4afdf$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $5ac2ec94ade4afdf$var$workInProgressRootRecoverableErrors.push.apply($5ac2ec94ade4afdf$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $5ac2ec94ade4afdf$var$prepareFreshStack(root$jscomp$0, 0);
                $5ac2ec94ade4afdf$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $5ac2ec94ade4afdf$var$markRootSuspended(shouldTimeSlice, lanes, $5ac2ec94ade4afdf$var$workInProgressDeferredLane, !$5ac2ec94ade4afdf$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $5ac2ec94ade4afdf$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $5ac2ec94ade4afdf$var$globalMostRecentFallbackTime + 300 - $5ac2ec94ade4afdf$var$now(), 10 < exitStatus)) {
                    $5ac2ec94ade4afdf$var$markRootSuspended(shouldTimeSlice, lanes, $5ac2ec94ade4afdf$var$workInProgressDeferredLane, !$5ac2ec94ade4afdf$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $5ac2ec94ade4afdf$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $5ac2ec94ade4afdf$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $5ac2ec94ade4afdf$var$scheduleTimeout($5ac2ec94ade4afdf$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $5ac2ec94ade4afdf$var$workInProgressRootRecoverableErrors, $5ac2ec94ade4afdf$var$workInProgressTransitions, $5ac2ec94ade4afdf$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $5ac2ec94ade4afdf$var$workInProgressDeferredLane, $5ac2ec94ade4afdf$var$workInProgressRootInterleavedUpdatedLanes, $5ac2ec94ade4afdf$var$workInProgressSuspendedRetryLanes, $5ac2ec94ade4afdf$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $5ac2ec94ade4afdf$var$commitRootWhenReady(shouldTimeSlice, forceSync, $5ac2ec94ade4afdf$var$workInProgressRootRecoverableErrors, $5ac2ec94ade4afdf$var$workInProgressTransitions, $5ac2ec94ade4afdf$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $5ac2ec94ade4afdf$var$workInProgressDeferredLane, $5ac2ec94ade4afdf$var$workInProgressRootInterleavedUpdatedLanes, $5ac2ec94ade4afdf$var$workInProgressSuspendedRetryLanes, $5ac2ec94ade4afdf$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $5ac2ec94ade4afdf$var$ensureRootIsScheduled(root$jscomp$0);
}
function $5ac2ec94ade4afdf$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $5ac2ec94ade4afdf$var$noop$1
        };
        $5ac2ec94ade4afdf$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $5ac2ec94ade4afdf$var$globalMostRecentFallbackTime - $5ac2ec94ade4afdf$var$now() : (lanes & 4194048) === lanes ? $5ac2ec94ade4afdf$var$globalMostRecentTransitionTime - $5ac2ec94ade4afdf$var$now() : 0;
        timeoutOffset = $5ac2ec94ade4afdf$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $5ac2ec94ade4afdf$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($5ac2ec94ade4afdf$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $5ac2ec94ade4afdf$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $5ac2ec94ade4afdf$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $5ac2ec94ade4afdf$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$5ac2ec94ade4afdf$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $5ac2ec94ade4afdf$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$5ac2ec94ade4afdf$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$5ac2ec94ade4afdf$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $5ac2ec94ade4afdf$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $5ac2ec94ade4afdf$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $5ac2ec94ade4afdf$var$flushSyncWork$1() {
    return 0 === ($5ac2ec94ade4afdf$var$executionContext & 6) ? ($5ac2ec94ade4afdf$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $5ac2ec94ade4afdf$var$resetWorkInProgressStack() {
    if (null !== $5ac2ec94ade4afdf$var$workInProgress) {
        if (0 === $5ac2ec94ade4afdf$var$workInProgressSuspendedReason) var interruptedWork = $5ac2ec94ade4afdf$var$workInProgress.return;
        else interruptedWork = $5ac2ec94ade4afdf$var$workInProgress, $5ac2ec94ade4afdf$var$lastContextDependency = $5ac2ec94ade4afdf$var$currentlyRenderingFiber$1 = null, $5ac2ec94ade4afdf$var$resetHooksOnUnwind(interruptedWork), $5ac2ec94ade4afdf$var$thenableState$1 = null, $5ac2ec94ade4afdf$var$thenableIndexCounter$1 = 0, interruptedWork = $5ac2ec94ade4afdf$var$workInProgress;
        for(; null !== interruptedWork;)$5ac2ec94ade4afdf$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $5ac2ec94ade4afdf$var$workInProgress = null;
    }
}
function $5ac2ec94ade4afdf$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $5ac2ec94ade4afdf$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $5ac2ec94ade4afdf$var$pendingEffectsLanes = 0;
    $5ac2ec94ade4afdf$var$resetWorkInProgressStack();
    $5ac2ec94ade4afdf$var$workInProgressRoot = root;
    $5ac2ec94ade4afdf$var$workInProgress = timeoutHandle = $5ac2ec94ade4afdf$var$createWorkInProgress(root.current, null);
    $5ac2ec94ade4afdf$var$workInProgressRootRenderLanes = lanes;
    $5ac2ec94ade4afdf$var$workInProgressSuspendedReason = 0;
    $5ac2ec94ade4afdf$var$workInProgressThrownValue = null;
    $5ac2ec94ade4afdf$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $5ac2ec94ade4afdf$var$workInProgressRootIsPrerendering = $5ac2ec94ade4afdf$var$checkIfRootIsPrerendering(root, lanes);
    $5ac2ec94ade4afdf$var$workInProgressRootDidAttachPingListener = !1;
    $5ac2ec94ade4afdf$var$workInProgressSuspendedRetryLanes = $5ac2ec94ade4afdf$var$workInProgressDeferredLane = $5ac2ec94ade4afdf$var$workInProgressRootPingedLanes = $5ac2ec94ade4afdf$var$workInProgressRootInterleavedUpdatedLanes = $5ac2ec94ade4afdf$var$workInProgressRootSkippedLanes = $5ac2ec94ade4afdf$var$workInProgressRootExitStatus = 0;
    $5ac2ec94ade4afdf$var$workInProgressRootRecoverableErrors = $5ac2ec94ade4afdf$var$workInProgressRootConcurrentErrors = null;
    $5ac2ec94ade4afdf$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $5ac2ec94ade4afdf$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $5ac2ec94ade4afdf$var$entangledRenderLanes = lanes;
    $5ac2ec94ade4afdf$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $5ac2ec94ade4afdf$var$handleThrow(root, thrownValue) {
    $5ac2ec94ade4afdf$var$currentlyRenderingFiber = null;
    $5ac2ec94ade4afdf$var$ReactSharedInternals.H = $5ac2ec94ade4afdf$var$ContextOnlyDispatcher;
    thrownValue === $5ac2ec94ade4afdf$var$SuspenseException || thrownValue === $5ac2ec94ade4afdf$var$SuspenseActionException ? (thrownValue = $5ac2ec94ade4afdf$var$getSuspendedThenable(), $5ac2ec94ade4afdf$var$workInProgressSuspendedReason = 3) : thrownValue === $5ac2ec94ade4afdf$var$SuspenseyCommitException ? (thrownValue = $5ac2ec94ade4afdf$var$getSuspendedThenable(), $5ac2ec94ade4afdf$var$workInProgressSuspendedReason = 4) : $5ac2ec94ade4afdf$var$workInProgressSuspendedReason = thrownValue === $5ac2ec94ade4afdf$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $5ac2ec94ade4afdf$var$workInProgressThrownValue = thrownValue;
    null === $5ac2ec94ade4afdf$var$workInProgress && ($5ac2ec94ade4afdf$var$workInProgressRootExitStatus = 1, $5ac2ec94ade4afdf$var$logUncaughtError(root, $5ac2ec94ade4afdf$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $5ac2ec94ade4afdf$var$shouldRemainOnPreviousScreen() {
    var handler = $5ac2ec94ade4afdf$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($5ac2ec94ade4afdf$var$workInProgressRootRenderLanes & 4194048) === $5ac2ec94ade4afdf$var$workInProgressRootRenderLanes ? null === $5ac2ec94ade4afdf$var$shellBoundary ? !0 : !1 : ($5ac2ec94ade4afdf$var$workInProgressRootRenderLanes & 62914560) === $5ac2ec94ade4afdf$var$workInProgressRootRenderLanes || 0 !== ($5ac2ec94ade4afdf$var$workInProgressRootRenderLanes & 536870912) ? handler === $5ac2ec94ade4afdf$var$shellBoundary : !1;
}
function $5ac2ec94ade4afdf$var$pushDispatcher() {
    var prevDispatcher = $5ac2ec94ade4afdf$var$ReactSharedInternals.H;
    $5ac2ec94ade4afdf$var$ReactSharedInternals.H = $5ac2ec94ade4afdf$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $5ac2ec94ade4afdf$var$ContextOnlyDispatcher : prevDispatcher;
}
function $5ac2ec94ade4afdf$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $5ac2ec94ade4afdf$var$ReactSharedInternals.A;
    $5ac2ec94ade4afdf$var$ReactSharedInternals.A = $5ac2ec94ade4afdf$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $5ac2ec94ade4afdf$var$renderDidSuspendDelayIfPossible() {
    $5ac2ec94ade4afdf$var$workInProgressRootExitStatus = 4;
    $5ac2ec94ade4afdf$var$workInProgressRootDidSkipSuspendedSiblings || ($5ac2ec94ade4afdf$var$workInProgressRootRenderLanes & 4194048) !== $5ac2ec94ade4afdf$var$workInProgressRootRenderLanes && null !== $5ac2ec94ade4afdf$var$suspenseHandlerStackCursor.current || ($5ac2ec94ade4afdf$var$workInProgressRootIsPrerendering = !0);
    0 === ($5ac2ec94ade4afdf$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($5ac2ec94ade4afdf$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $5ac2ec94ade4afdf$var$workInProgressRoot || $5ac2ec94ade4afdf$var$markRootSuspended($5ac2ec94ade4afdf$var$workInProgressRoot, $5ac2ec94ade4afdf$var$workInProgressRootRenderLanes, $5ac2ec94ade4afdf$var$workInProgressDeferredLane, !1);
}
function $5ac2ec94ade4afdf$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $5ac2ec94ade4afdf$var$executionContext;
    $5ac2ec94ade4afdf$var$executionContext |= 2;
    var prevDispatcher = $5ac2ec94ade4afdf$var$pushDispatcher(), prevAsyncDispatcher = $5ac2ec94ade4afdf$var$pushAsyncDispatcher();
    if ($5ac2ec94ade4afdf$var$workInProgressRoot !== root || $5ac2ec94ade4afdf$var$workInProgressRootRenderLanes !== lanes) $5ac2ec94ade4afdf$var$workInProgressTransitions = null, $5ac2ec94ade4afdf$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $5ac2ec94ade4afdf$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $5ac2ec94ade4afdf$var$workInProgressSuspendedReason && null !== $5ac2ec94ade4afdf$var$workInProgress) {
            var unitOfWork = $5ac2ec94ade4afdf$var$workInProgress, thrownValue = $5ac2ec94ade4afdf$var$workInProgressThrownValue;
            switch($5ac2ec94ade4afdf$var$workInProgressSuspendedReason){
                case 8:
                    $5ac2ec94ade4afdf$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $5ac2ec94ade4afdf$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $5ac2ec94ade4afdf$var$workInProgressSuspendedReason;
                    $5ac2ec94ade4afdf$var$workInProgressSuspendedReason = 0;
                    $5ac2ec94ade4afdf$var$workInProgressThrownValue = null;
                    $5ac2ec94ade4afdf$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $5ac2ec94ade4afdf$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $5ac2ec94ade4afdf$var$workInProgressSuspendedReason, $5ac2ec94ade4afdf$var$workInProgressSuspendedReason = 0, $5ac2ec94ade4afdf$var$workInProgressThrownValue = null, $5ac2ec94ade4afdf$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $5ac2ec94ade4afdf$var$workLoopSync();
        exitStatus = $5ac2ec94ade4afdf$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $5ac2ec94ade4afdf$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $5ac2ec94ade4afdf$var$lastContextDependency = $5ac2ec94ade4afdf$var$currentlyRenderingFiber$1 = null;
    $5ac2ec94ade4afdf$var$executionContext = prevExecutionContext;
    $5ac2ec94ade4afdf$var$ReactSharedInternals.H = prevDispatcher;
    $5ac2ec94ade4afdf$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $5ac2ec94ade4afdf$var$workInProgress && ($5ac2ec94ade4afdf$var$workInProgressRoot = null, $5ac2ec94ade4afdf$var$workInProgressRootRenderLanes = 0, $5ac2ec94ade4afdf$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $5ac2ec94ade4afdf$var$workLoopSync() {
    for(; null !== $5ac2ec94ade4afdf$var$workInProgress;)$5ac2ec94ade4afdf$var$performUnitOfWork($5ac2ec94ade4afdf$var$workInProgress);
}
function $5ac2ec94ade4afdf$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $5ac2ec94ade4afdf$var$executionContext;
    $5ac2ec94ade4afdf$var$executionContext |= 2;
    var prevDispatcher = $5ac2ec94ade4afdf$var$pushDispatcher(), prevAsyncDispatcher = $5ac2ec94ade4afdf$var$pushAsyncDispatcher();
    $5ac2ec94ade4afdf$var$workInProgressRoot !== root || $5ac2ec94ade4afdf$var$workInProgressRootRenderLanes !== lanes ? ($5ac2ec94ade4afdf$var$workInProgressTransitions = null, $5ac2ec94ade4afdf$var$workInProgressRootRenderTargetTime = $5ac2ec94ade4afdf$var$now() + 500, $5ac2ec94ade4afdf$var$prepareFreshStack(root, lanes)) : $5ac2ec94ade4afdf$var$workInProgressRootIsPrerendering = $5ac2ec94ade4afdf$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $5ac2ec94ade4afdf$var$workInProgressSuspendedReason && null !== $5ac2ec94ade4afdf$var$workInProgress) {
            lanes = $5ac2ec94ade4afdf$var$workInProgress;
            var thrownValue = $5ac2ec94ade4afdf$var$workInProgressThrownValue;
            b: switch($5ac2ec94ade4afdf$var$workInProgressSuspendedReason){
                case 1:
                    $5ac2ec94ade4afdf$var$workInProgressSuspendedReason = 0;
                    $5ac2ec94ade4afdf$var$workInProgressThrownValue = null;
                    $5ac2ec94ade4afdf$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($5ac2ec94ade4afdf$var$isThenableResolved(thrownValue)) {
                        $5ac2ec94ade4afdf$var$workInProgressSuspendedReason = 0;
                        $5ac2ec94ade4afdf$var$workInProgressThrownValue = null;
                        $5ac2ec94ade4afdf$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $5ac2ec94ade4afdf$var$workInProgressSuspendedReason && 9 !== $5ac2ec94ade4afdf$var$workInProgressSuspendedReason || $5ac2ec94ade4afdf$var$workInProgressRoot !== root || ($5ac2ec94ade4afdf$var$workInProgressSuspendedReason = 7);
                        $5ac2ec94ade4afdf$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $5ac2ec94ade4afdf$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $5ac2ec94ade4afdf$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $5ac2ec94ade4afdf$var$isThenableResolved(thrownValue) ? ($5ac2ec94ade4afdf$var$workInProgressSuspendedReason = 0, $5ac2ec94ade4afdf$var$workInProgressThrownValue = null, $5ac2ec94ade4afdf$var$replaySuspendedUnitOfWork(lanes)) : ($5ac2ec94ade4afdf$var$workInProgressSuspendedReason = 0, $5ac2ec94ade4afdf$var$workInProgressThrownValue = null, $5ac2ec94ade4afdf$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($5ac2ec94ade4afdf$var$workInProgress.tag){
                        case 26:
                            resource = $5ac2ec94ade4afdf$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $5ac2ec94ade4afdf$var$workInProgress;
                            if (resource ? $5ac2ec94ade4afdf$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $5ac2ec94ade4afdf$var$workInProgressSuspendedReason = 0;
                                $5ac2ec94ade4afdf$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $5ac2ec94ade4afdf$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($5ac2ec94ade4afdf$var$workInProgress = returnFiber, $5ac2ec94ade4afdf$var$completeUnitOfWork(returnFiber)) : $5ac2ec94ade4afdf$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $5ac2ec94ade4afdf$var$workInProgressSuspendedReason = 0;
                    $5ac2ec94ade4afdf$var$workInProgressThrownValue = null;
                    $5ac2ec94ade4afdf$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $5ac2ec94ade4afdf$var$workInProgressSuspendedReason = 0;
                    $5ac2ec94ade4afdf$var$workInProgressThrownValue = null;
                    $5ac2ec94ade4afdf$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $5ac2ec94ade4afdf$var$resetWorkInProgressStack();
                    $5ac2ec94ade4afdf$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(462));
            }
        }
        $5ac2ec94ade4afdf$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $5ac2ec94ade4afdf$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $5ac2ec94ade4afdf$var$lastContextDependency = $5ac2ec94ade4afdf$var$currentlyRenderingFiber$1 = null;
    $5ac2ec94ade4afdf$var$ReactSharedInternals.H = prevDispatcher;
    $5ac2ec94ade4afdf$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $5ac2ec94ade4afdf$var$executionContext = prevExecutionContext;
    if (null !== $5ac2ec94ade4afdf$var$workInProgress) return 0;
    $5ac2ec94ade4afdf$var$workInProgressRoot = null;
    $5ac2ec94ade4afdf$var$workInProgressRootRenderLanes = 0;
    $5ac2ec94ade4afdf$var$finishQueueingConcurrentUpdates();
    return $5ac2ec94ade4afdf$var$workInProgressRootExitStatus;
}
function $5ac2ec94ade4afdf$var$workLoopConcurrentByScheduler() {
    for(; null !== $5ac2ec94ade4afdf$var$workInProgress && !$5ac2ec94ade4afdf$var$shouldYield();)$5ac2ec94ade4afdf$var$performUnitOfWork($5ac2ec94ade4afdf$var$workInProgress);
}
function $5ac2ec94ade4afdf$var$performUnitOfWork(unitOfWork) {
    var next = $5ac2ec94ade4afdf$var$beginWork(unitOfWork.alternate, unitOfWork, $5ac2ec94ade4afdf$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $5ac2ec94ade4afdf$var$completeUnitOfWork(unitOfWork) : $5ac2ec94ade4afdf$var$workInProgress = next;
}
function $5ac2ec94ade4afdf$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $5ac2ec94ade4afdf$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $5ac2ec94ade4afdf$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $5ac2ec94ade4afdf$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $5ac2ec94ade4afdf$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $5ac2ec94ade4afdf$var$resetHooksOnUnwind(next);
        default:
            $5ac2ec94ade4afdf$var$unwindInterruptedWork(current, next), next = $5ac2ec94ade4afdf$var$workInProgress = $5ac2ec94ade4afdf$var$resetWorkInProgress(next, $5ac2ec94ade4afdf$var$entangledRenderLanes), next = $5ac2ec94ade4afdf$var$beginWork(current, next, $5ac2ec94ade4afdf$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $5ac2ec94ade4afdf$var$completeUnitOfWork(unitOfWork) : $5ac2ec94ade4afdf$var$workInProgress = next;
}
function $5ac2ec94ade4afdf$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $5ac2ec94ade4afdf$var$lastContextDependency = $5ac2ec94ade4afdf$var$currentlyRenderingFiber$1 = null;
    $5ac2ec94ade4afdf$var$resetHooksOnUnwind(unitOfWork);
    $5ac2ec94ade4afdf$var$thenableState$1 = null;
    $5ac2ec94ade4afdf$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($5ac2ec94ade4afdf$var$throwException(root, returnFiber, unitOfWork, thrownValue, $5ac2ec94ade4afdf$var$workInProgressRootRenderLanes)) {
            $5ac2ec94ade4afdf$var$workInProgressRootExitStatus = 1;
            $5ac2ec94ade4afdf$var$logUncaughtError(root, $5ac2ec94ade4afdf$var$createCapturedValueAtFiber(thrownValue, root.current));
            $5ac2ec94ade4afdf$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $5ac2ec94ade4afdf$var$workInProgress = returnFiber, error;
        $5ac2ec94ade4afdf$var$workInProgressRootExitStatus = 1;
        $5ac2ec94ade4afdf$var$logUncaughtError(root, $5ac2ec94ade4afdf$var$createCapturedValueAtFiber(thrownValue, root.current));
        $5ac2ec94ade4afdf$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($5ac2ec94ade4afdf$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($5ac2ec94ade4afdf$var$workInProgressRootIsPrerendering || 0 !== ($5ac2ec94ade4afdf$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($5ac2ec94ade4afdf$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $5ac2ec94ade4afdf$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $5ac2ec94ade4afdf$var$unwindUnitOfWork(unitOfWork, root);
    } else $5ac2ec94ade4afdf$var$completeUnitOfWork(unitOfWork);
}
function $5ac2ec94ade4afdf$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $5ac2ec94ade4afdf$var$unwindUnitOfWork(completedWork, $5ac2ec94ade4afdf$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $5ac2ec94ade4afdf$var$completeWork(completedWork.alternate, completedWork, $5ac2ec94ade4afdf$var$entangledRenderLanes);
        if (null !== next) {
            $5ac2ec94ade4afdf$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $5ac2ec94ade4afdf$var$workInProgress = completedWork;
            return;
        }
        $5ac2ec94ade4afdf$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $5ac2ec94ade4afdf$var$workInProgressRootExitStatus && ($5ac2ec94ade4afdf$var$workInProgressRootExitStatus = 5);
}
function $5ac2ec94ade4afdf$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $5ac2ec94ade4afdf$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $5ac2ec94ade4afdf$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $5ac2ec94ade4afdf$var$workInProgress = unitOfWork;
            return;
        }
        $5ac2ec94ade4afdf$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $5ac2ec94ade4afdf$var$workInProgressRootExitStatus = 6;
    $5ac2ec94ade4afdf$var$workInProgress = null;
}
function $5ac2ec94ade4afdf$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $5ac2ec94ade4afdf$var$flushPendingEffects();
    while (0 !== $5ac2ec94ade4afdf$var$pendingEffectsStatus);
    if (0 !== ($5ac2ec94ade4afdf$var$executionContext & 6)) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $5ac2ec94ade4afdf$var$concurrentlyUpdatedLanes;
        $5ac2ec94ade4afdf$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $5ac2ec94ade4afdf$var$workInProgressRoot && ($5ac2ec94ade4afdf$var$workInProgress = $5ac2ec94ade4afdf$var$workInProgressRoot = null, $5ac2ec94ade4afdf$var$workInProgressRootRenderLanes = 0);
        $5ac2ec94ade4afdf$var$pendingFinishedWork = finishedWork;
        $5ac2ec94ade4afdf$var$pendingEffectsRoot = root;
        $5ac2ec94ade4afdf$var$pendingEffectsLanes = lanes;
        $5ac2ec94ade4afdf$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $5ac2ec94ade4afdf$var$pendingPassiveTransitions = transitions;
        $5ac2ec94ade4afdf$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $5ac2ec94ade4afdf$var$scheduleCallback$1($5ac2ec94ade4afdf$var$NormalPriority$1, function() {
            $5ac2ec94ade4afdf$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $5ac2ec94ade4afdf$var$ReactSharedInternals.T;
            $5ac2ec94ade4afdf$var$ReactSharedInternals.T = null;
            transitions = $5ac2ec94ade4afdf$var$ReactDOMSharedInternals.p;
            $5ac2ec94ade4afdf$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $5ac2ec94ade4afdf$var$executionContext;
            $5ac2ec94ade4afdf$var$executionContext |= 4;
            try {
                $5ac2ec94ade4afdf$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $5ac2ec94ade4afdf$var$executionContext = spawnedLane, $5ac2ec94ade4afdf$var$ReactDOMSharedInternals.p = transitions, $5ac2ec94ade4afdf$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $5ac2ec94ade4afdf$var$pendingEffectsStatus = 1;
        $5ac2ec94ade4afdf$var$flushMutationEffects();
        $5ac2ec94ade4afdf$var$flushLayoutEffects();
        $5ac2ec94ade4afdf$var$flushSpawnedWork();
    }
}
function $5ac2ec94ade4afdf$var$flushMutationEffects() {
    if (1 === $5ac2ec94ade4afdf$var$pendingEffectsStatus) {
        $5ac2ec94ade4afdf$var$pendingEffectsStatus = 0;
        var root = $5ac2ec94ade4afdf$var$pendingEffectsRoot, finishedWork = $5ac2ec94ade4afdf$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $5ac2ec94ade4afdf$var$ReactSharedInternals.T;
            $5ac2ec94ade4afdf$var$ReactSharedInternals.T = null;
            var previousPriority = $5ac2ec94ade4afdf$var$ReactDOMSharedInternals.p;
            $5ac2ec94ade4afdf$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $5ac2ec94ade4afdf$var$executionContext;
            $5ac2ec94ade4afdf$var$executionContext |= 4;
            try {
                $5ac2ec94ade4afdf$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $5ac2ec94ade4afdf$var$selectionInformation, curFocusedElem = $5ac2ec94ade4afdf$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $5ac2ec94ade4afdf$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $5ac2ec94ade4afdf$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $5ac2ec94ade4afdf$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $5ac2ec94ade4afdf$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $5ac2ec94ade4afdf$var$_enabled = !!$5ac2ec94ade4afdf$var$eventsEnabled;
                $5ac2ec94ade4afdf$var$selectionInformation = $5ac2ec94ade4afdf$var$eventsEnabled = null;
            } finally{
                $5ac2ec94ade4afdf$var$executionContext = prevExecutionContext, $5ac2ec94ade4afdf$var$ReactDOMSharedInternals.p = previousPriority, $5ac2ec94ade4afdf$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $5ac2ec94ade4afdf$var$pendingEffectsStatus = 2;
    }
}
function $5ac2ec94ade4afdf$var$flushLayoutEffects() {
    if (2 === $5ac2ec94ade4afdf$var$pendingEffectsStatus) {
        $5ac2ec94ade4afdf$var$pendingEffectsStatus = 0;
        var root = $5ac2ec94ade4afdf$var$pendingEffectsRoot, finishedWork = $5ac2ec94ade4afdf$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $5ac2ec94ade4afdf$var$ReactSharedInternals.T;
            $5ac2ec94ade4afdf$var$ReactSharedInternals.T = null;
            var previousPriority = $5ac2ec94ade4afdf$var$ReactDOMSharedInternals.p;
            $5ac2ec94ade4afdf$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $5ac2ec94ade4afdf$var$executionContext;
            $5ac2ec94ade4afdf$var$executionContext |= 4;
            try {
                $5ac2ec94ade4afdf$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $5ac2ec94ade4afdf$var$executionContext = prevExecutionContext, $5ac2ec94ade4afdf$var$ReactDOMSharedInternals.p = previousPriority, $5ac2ec94ade4afdf$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $5ac2ec94ade4afdf$var$pendingEffectsStatus = 3;
    }
}
function $5ac2ec94ade4afdf$var$flushSpawnedWork() {
    if (4 === $5ac2ec94ade4afdf$var$pendingEffectsStatus || 3 === $5ac2ec94ade4afdf$var$pendingEffectsStatus) {
        $5ac2ec94ade4afdf$var$pendingEffectsStatus = 0;
        $5ac2ec94ade4afdf$var$requestPaint();
        var root = $5ac2ec94ade4afdf$var$pendingEffectsRoot, finishedWork = $5ac2ec94ade4afdf$var$pendingFinishedWork, lanes = $5ac2ec94ade4afdf$var$pendingEffectsLanes, recoverableErrors = $5ac2ec94ade4afdf$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $5ac2ec94ade4afdf$var$pendingEffectsStatus = 5 : ($5ac2ec94ade4afdf$var$pendingEffectsStatus = 0, $5ac2ec94ade4afdf$var$pendingFinishedWork = $5ac2ec94ade4afdf$var$pendingEffectsRoot = null, $5ac2ec94ade4afdf$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($5ac2ec94ade4afdf$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $5ac2ec94ade4afdf$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($5ac2ec94ade4afdf$var$injectedHook && "function" === typeof $5ac2ec94ade4afdf$var$injectedHook.onCommitFiberRoot) try {
            $5ac2ec94ade4afdf$var$injectedHook.onCommitFiberRoot($5ac2ec94ade4afdf$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $5ac2ec94ade4afdf$var$ReactSharedInternals.T;
            remainingLanes = $5ac2ec94ade4afdf$var$ReactDOMSharedInternals.p;
            $5ac2ec94ade4afdf$var$ReactDOMSharedInternals.p = 2;
            $5ac2ec94ade4afdf$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $5ac2ec94ade4afdf$var$ReactSharedInternals.T = finishedWork, $5ac2ec94ade4afdf$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($5ac2ec94ade4afdf$var$pendingEffectsLanes & 3) && $5ac2ec94ade4afdf$var$flushPendingEffects();
        $5ac2ec94ade4afdf$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $5ac2ec94ade4afdf$var$rootWithNestedUpdates ? $5ac2ec94ade4afdf$var$nestedUpdateCount++ : ($5ac2ec94ade4afdf$var$nestedUpdateCount = 0, $5ac2ec94ade4afdf$var$rootWithNestedUpdates = root) : $5ac2ec94ade4afdf$var$nestedUpdateCount = 0;
        $5ac2ec94ade4afdf$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $5ac2ec94ade4afdf$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $5ac2ec94ade4afdf$var$releaseCache(remainingLanes)));
}
function $5ac2ec94ade4afdf$var$flushPendingEffects() {
    $5ac2ec94ade4afdf$var$flushMutationEffects();
    $5ac2ec94ade4afdf$var$flushLayoutEffects();
    $5ac2ec94ade4afdf$var$flushSpawnedWork();
    return $5ac2ec94ade4afdf$var$flushPassiveEffects();
}
function $5ac2ec94ade4afdf$var$flushPassiveEffects() {
    if (5 !== $5ac2ec94ade4afdf$var$pendingEffectsStatus) return !1;
    var root = $5ac2ec94ade4afdf$var$pendingEffectsRoot, remainingLanes = $5ac2ec94ade4afdf$var$pendingEffectsRemainingLanes;
    $5ac2ec94ade4afdf$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $5ac2ec94ade4afdf$var$lanesToEventPriority($5ac2ec94ade4afdf$var$pendingEffectsLanes), prevTransition = $5ac2ec94ade4afdf$var$ReactSharedInternals.T, previousPriority = $5ac2ec94ade4afdf$var$ReactDOMSharedInternals.p;
    try {
        $5ac2ec94ade4afdf$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $5ac2ec94ade4afdf$var$ReactSharedInternals.T = null;
        renderPriority = $5ac2ec94ade4afdf$var$pendingPassiveTransitions;
        $5ac2ec94ade4afdf$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $5ac2ec94ade4afdf$var$pendingEffectsRoot, lanes = $5ac2ec94ade4afdf$var$pendingEffectsLanes;
        $5ac2ec94ade4afdf$var$pendingEffectsStatus = 0;
        $5ac2ec94ade4afdf$var$pendingFinishedWork = $5ac2ec94ade4afdf$var$pendingEffectsRoot = null;
        $5ac2ec94ade4afdf$var$pendingEffectsLanes = 0;
        if (0 !== ($5ac2ec94ade4afdf$var$executionContext & 6)) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(331));
        var prevExecutionContext = $5ac2ec94ade4afdf$var$executionContext;
        $5ac2ec94ade4afdf$var$executionContext |= 4;
        $5ac2ec94ade4afdf$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $5ac2ec94ade4afdf$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $5ac2ec94ade4afdf$var$executionContext = prevExecutionContext;
        $5ac2ec94ade4afdf$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($5ac2ec94ade4afdf$var$injectedHook && "function" === typeof $5ac2ec94ade4afdf$var$injectedHook.onPostCommitFiberRoot) try {
            $5ac2ec94ade4afdf$var$injectedHook.onPostCommitFiberRoot($5ac2ec94ade4afdf$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $5ac2ec94ade4afdf$var$ReactDOMSharedInternals.p = previousPriority, $5ac2ec94ade4afdf$var$ReactSharedInternals.T = prevTransition, $5ac2ec94ade4afdf$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $5ac2ec94ade4afdf$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $5ac2ec94ade4afdf$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $5ac2ec94ade4afdf$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $5ac2ec94ade4afdf$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($5ac2ec94ade4afdf$var$markRootUpdated$1(rootFiber, 2), $5ac2ec94ade4afdf$var$ensureRootIsScheduled(rootFiber));
}
function $5ac2ec94ade4afdf$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $5ac2ec94ade4afdf$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $5ac2ec94ade4afdf$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $5ac2ec94ade4afdf$var$legacyErrorBoundariesThatAlreadyFailed || !$5ac2ec94ade4afdf$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $5ac2ec94ade4afdf$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $5ac2ec94ade4afdf$var$createClassErrorUpdate(2);
                instance = $5ac2ec94ade4afdf$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($5ac2ec94ade4afdf$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $5ac2ec94ade4afdf$var$markRootUpdated$1(instance, 2), $5ac2ec94ade4afdf$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $5ac2ec94ade4afdf$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $5ac2ec94ade4afdf$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($5ac2ec94ade4afdf$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $5ac2ec94ade4afdf$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $5ac2ec94ade4afdf$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $5ac2ec94ade4afdf$var$workInProgressRoot === root && ($5ac2ec94ade4afdf$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $5ac2ec94ade4afdf$var$workInProgressRootExitStatus || 3 === $5ac2ec94ade4afdf$var$workInProgressRootExitStatus && ($5ac2ec94ade4afdf$var$workInProgressRootRenderLanes & 62914560) === $5ac2ec94ade4afdf$var$workInProgressRootRenderLanes && 300 > $5ac2ec94ade4afdf$var$now() - $5ac2ec94ade4afdf$var$globalMostRecentFallbackTime ? 0 === ($5ac2ec94ade4afdf$var$executionContext & 2) && $5ac2ec94ade4afdf$var$prepareFreshStack(root, 0) : $5ac2ec94ade4afdf$var$workInProgressRootPingedLanes |= pingedLanes, $5ac2ec94ade4afdf$var$workInProgressSuspendedRetryLanes === $5ac2ec94ade4afdf$var$workInProgressRootRenderLanes && ($5ac2ec94ade4afdf$var$workInProgressSuspendedRetryLanes = 0));
    $5ac2ec94ade4afdf$var$ensureRootIsScheduled(root);
}
function $5ac2ec94ade4afdf$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $5ac2ec94ade4afdf$var$claimNextRetryLane());
    boundaryFiber = $5ac2ec94ade4afdf$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($5ac2ec94ade4afdf$var$markRootUpdated$1(boundaryFiber, retryLane), $5ac2ec94ade4afdf$var$ensureRootIsScheduled(boundaryFiber));
}
function $5ac2ec94ade4afdf$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $5ac2ec94ade4afdf$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $5ac2ec94ade4afdf$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $5ac2ec94ade4afdf$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $5ac2ec94ade4afdf$var$scheduleCallback$1(priorityLevel, callback) {
    return $5ac2ec94ade4afdf$var$scheduleCallback$3(priorityLevel, callback);
}
var $5ac2ec94ade4afdf$var$firstScheduledRoot = null, $5ac2ec94ade4afdf$var$lastScheduledRoot = null, $5ac2ec94ade4afdf$var$didScheduleMicrotask = !1, $5ac2ec94ade4afdf$var$mightHavePendingSyncWork = !1, $5ac2ec94ade4afdf$var$isFlushingWork = !1, $5ac2ec94ade4afdf$var$currentEventTransitionLane = 0;
function $5ac2ec94ade4afdf$var$ensureRootIsScheduled(root) {
    root !== $5ac2ec94ade4afdf$var$lastScheduledRoot && null === root.next && (null === $5ac2ec94ade4afdf$var$lastScheduledRoot ? $5ac2ec94ade4afdf$var$firstScheduledRoot = $5ac2ec94ade4afdf$var$lastScheduledRoot = root : $5ac2ec94ade4afdf$var$lastScheduledRoot = $5ac2ec94ade4afdf$var$lastScheduledRoot.next = root);
    $5ac2ec94ade4afdf$var$mightHavePendingSyncWork = !0;
    $5ac2ec94ade4afdf$var$didScheduleMicrotask || ($5ac2ec94ade4afdf$var$didScheduleMicrotask = !0, $5ac2ec94ade4afdf$var$scheduleImmediateRootScheduleTask());
}
function $5ac2ec94ade4afdf$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$5ac2ec94ade4afdf$var$isFlushingWork && $5ac2ec94ade4afdf$var$mightHavePendingSyncWork) {
        $5ac2ec94ade4afdf$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $5ac2ec94ade4afdf$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $5ac2ec94ade4afdf$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $5ac2ec94ade4afdf$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $5ac2ec94ade4afdf$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $5ac2ec94ade4afdf$var$getNextLanes(root$170, root$170 === $5ac2ec94ade4afdf$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $5ac2ec94ade4afdf$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $5ac2ec94ade4afdf$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $5ac2ec94ade4afdf$var$isFlushingWork = !1;
    }
}
function $5ac2ec94ade4afdf$var$processRootScheduleInImmediateTask() {
    $5ac2ec94ade4afdf$var$processRootScheduleInMicrotask();
}
function $5ac2ec94ade4afdf$var$processRootScheduleInMicrotask() {
    $5ac2ec94ade4afdf$var$mightHavePendingSyncWork = $5ac2ec94ade4afdf$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $5ac2ec94ade4afdf$var$currentEventTransitionLane && $5ac2ec94ade4afdf$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $5ac2ec94ade4afdf$var$currentEventTransitionLane);
    for(var currentTime = $5ac2ec94ade4afdf$var$now(), prev = null, root = $5ac2ec94ade4afdf$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $5ac2ec94ade4afdf$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $5ac2ec94ade4afdf$var$firstScheduledRoot = next : prev.next = next, null === next && ($5ac2ec94ade4afdf$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $5ac2ec94ade4afdf$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $5ac2ec94ade4afdf$var$pendingEffectsStatus && 5 !== $5ac2ec94ade4afdf$var$pendingEffectsStatus || $5ac2ec94ade4afdf$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $5ac2ec94ade4afdf$var$currentEventTransitionLane && ($5ac2ec94ade4afdf$var$currentEventTransitionLane = 0);
}
function $5ac2ec94ade4afdf$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $5ac2ec94ade4afdf$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $5ac2ec94ade4afdf$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $5ac2ec94ade4afdf$var$workInProgressRoot;
    suspendedLanes = $5ac2ec94ade4afdf$var$workInProgressRootRenderLanes;
    suspendedLanes = $5ac2ec94ade4afdf$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $5ac2ec94ade4afdf$var$workInProgressSuspendedReason || 9 === $5ac2ec94ade4afdf$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $5ac2ec94ade4afdf$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $5ac2ec94ade4afdf$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $5ac2ec94ade4afdf$var$cancelCallback$1(pingedLanes);
        switch($5ac2ec94ade4afdf$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $5ac2ec94ade4afdf$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $5ac2ec94ade4afdf$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $5ac2ec94ade4afdf$var$IdlePriority;
                break;
            default:
                suspendedLanes = $5ac2ec94ade4afdf$var$NormalPriority$1;
        }
        pingedLanes = $5ac2ec94ade4afdf$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $5ac2ec94ade4afdf$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $5ac2ec94ade4afdf$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $5ac2ec94ade4afdf$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $5ac2ec94ade4afdf$var$pendingEffectsStatus && 5 !== $5ac2ec94ade4afdf$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($5ac2ec94ade4afdf$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $5ac2ec94ade4afdf$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $5ac2ec94ade4afdf$var$getNextLanes(root, root === $5ac2ec94ade4afdf$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $5ac2ec94ade4afdf$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $5ac2ec94ade4afdf$var$scheduleTaskForRootDuringMicrotask(root, $5ac2ec94ade4afdf$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $5ac2ec94ade4afdf$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $5ac2ec94ade4afdf$var$performSyncWorkOnRoot(root, lanes) {
    if ($5ac2ec94ade4afdf$var$flushPendingEffects()) return null;
    $5ac2ec94ade4afdf$var$performWorkOnRoot(root, lanes, !0);
}
function $5ac2ec94ade4afdf$var$scheduleImmediateRootScheduleTask() {
    $5ac2ec94ade4afdf$var$scheduleMicrotask(function() {
        0 !== ($5ac2ec94ade4afdf$var$executionContext & 6) ? $5ac2ec94ade4afdf$var$scheduleCallback$3($5ac2ec94ade4afdf$var$ImmediatePriority, $5ac2ec94ade4afdf$var$processRootScheduleInImmediateTask) : $5ac2ec94ade4afdf$var$processRootScheduleInMicrotask();
    });
}
function $5ac2ec94ade4afdf$var$requestTransitionLane() {
    if (0 === $5ac2ec94ade4afdf$var$currentEventTransitionLane) {
        var actionScopeLane = $5ac2ec94ade4afdf$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $5ac2ec94ade4afdf$var$nextTransitionUpdateLane, $5ac2ec94ade4afdf$var$nextTransitionUpdateLane <<= 1, 0 === ($5ac2ec94ade4afdf$var$nextTransitionUpdateLane & 261888) && ($5ac2ec94ade4afdf$var$nextTransitionUpdateLane = 256));
        $5ac2ec94ade4afdf$var$currentEventTransitionLane = actionScopeLane;
    }
    return $5ac2ec94ade4afdf$var$currentEventTransitionLane;
}
function $5ac2ec94ade4afdf$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $5ac2ec94ade4afdf$var$sanitizeURL("" + actionProp);
}
function $5ac2ec94ade4afdf$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $5ac2ec94ade4afdf$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $5ac2ec94ade4afdf$var$coerceFormActionProp((nativeEventTarget[$5ac2ec94ade4afdf$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$5ac2ec94ade4afdf$var$internalPropsKey] || null) ? $5ac2ec94ade4afdf$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $5ac2ec94ade4afdf$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $5ac2ec94ade4afdf$var$currentEventTransitionLane) {
                                var formData = submitter ? $5ac2ec94ade4afdf$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $5ac2ec94ade4afdf$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $5ac2ec94ade4afdf$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $5ac2ec94ade4afdf$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $5ac2ec94ade4afdf$var$i$jscomp$inline_1577 = 0; $5ac2ec94ade4afdf$var$i$jscomp$inline_1577 < $5ac2ec94ade4afdf$var$simpleEventPluginEvents.length; $5ac2ec94ade4afdf$var$i$jscomp$inline_1577++){
    var $5ac2ec94ade4afdf$var$eventName$jscomp$inline_1578 = $5ac2ec94ade4afdf$var$simpleEventPluginEvents[$5ac2ec94ade4afdf$var$i$jscomp$inline_1577], $5ac2ec94ade4afdf$var$domEventName$jscomp$inline_1579 = $5ac2ec94ade4afdf$var$eventName$jscomp$inline_1578.toLowerCase(), $5ac2ec94ade4afdf$var$capitalizedEvent$jscomp$inline_1580 = $5ac2ec94ade4afdf$var$eventName$jscomp$inline_1578[0].toUpperCase() + $5ac2ec94ade4afdf$var$eventName$jscomp$inline_1578.slice(1);
    $5ac2ec94ade4afdf$var$registerSimpleEvent($5ac2ec94ade4afdf$var$domEventName$jscomp$inline_1579, "on" + $5ac2ec94ade4afdf$var$capitalizedEvent$jscomp$inline_1580);
}
$5ac2ec94ade4afdf$var$registerSimpleEvent($5ac2ec94ade4afdf$var$ANIMATION_END, "onAnimationEnd");
$5ac2ec94ade4afdf$var$registerSimpleEvent($5ac2ec94ade4afdf$var$ANIMATION_ITERATION, "onAnimationIteration");
$5ac2ec94ade4afdf$var$registerSimpleEvent($5ac2ec94ade4afdf$var$ANIMATION_START, "onAnimationStart");
$5ac2ec94ade4afdf$var$registerSimpleEvent("dblclick", "onDoubleClick");
$5ac2ec94ade4afdf$var$registerSimpleEvent("focusin", "onFocus");
$5ac2ec94ade4afdf$var$registerSimpleEvent("focusout", "onBlur");
$5ac2ec94ade4afdf$var$registerSimpleEvent($5ac2ec94ade4afdf$var$TRANSITION_RUN, "onTransitionRun");
$5ac2ec94ade4afdf$var$registerSimpleEvent($5ac2ec94ade4afdf$var$TRANSITION_START, "onTransitionStart");
$5ac2ec94ade4afdf$var$registerSimpleEvent($5ac2ec94ade4afdf$var$TRANSITION_CANCEL, "onTransitionCancel");
$5ac2ec94ade4afdf$var$registerSimpleEvent($5ac2ec94ade4afdf$var$TRANSITION_END, "onTransitionEnd");
$5ac2ec94ade4afdf$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$5ac2ec94ade4afdf$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$5ac2ec94ade4afdf$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$5ac2ec94ade4afdf$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$5ac2ec94ade4afdf$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$5ac2ec94ade4afdf$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$5ac2ec94ade4afdf$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$5ac2ec94ade4afdf$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$5ac2ec94ade4afdf$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$5ac2ec94ade4afdf$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $5ac2ec94ade4afdf$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $5ac2ec94ade4afdf$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($5ac2ec94ade4afdf$var$mediaEventTypes));
function $5ac2ec94ade4afdf$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $5ac2ec94ade4afdf$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $5ac2ec94ade4afdf$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $5ac2ec94ade4afdf$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$5ac2ec94ade4afdf$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$5ac2ec94ade4afdf$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($5ac2ec94ade4afdf$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $5ac2ec94ade4afdf$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $5ac2ec94ade4afdf$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $5ac2ec94ade4afdf$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $5ac2ec94ade4afdf$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$5ac2ec94ade4afdf$var$listeningMarker]) {
        rootContainerElement[$5ac2ec94ade4afdf$var$listeningMarker] = !0;
        $5ac2ec94ade4afdf$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($5ac2ec94ade4afdf$var$nonDelegatedEvents.has(domEventName) || $5ac2ec94ade4afdf$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $5ac2ec94ade4afdf$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$5ac2ec94ade4afdf$var$listeningMarker] || (ownerDocument[$5ac2ec94ade4afdf$var$listeningMarker] = !0, $5ac2ec94ade4afdf$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $5ac2ec94ade4afdf$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($5ac2ec94ade4afdf$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $5ac2ec94ade4afdf$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $5ac2ec94ade4afdf$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $5ac2ec94ade4afdf$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$5ac2ec94ade4afdf$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $5ac2ec94ade4afdf$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $5ac2ec94ade4afdf$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $5ac2ec94ade4afdf$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $5ac2ec94ade4afdf$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $5ac2ec94ade4afdf$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $5ac2ec94ade4afdf$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $5ac2ec94ade4afdf$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $5ac2ec94ade4afdf$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $5ac2ec94ade4afdf$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $5ac2ec94ade4afdf$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $5ac2ec94ade4afdf$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $5ac2ec94ade4afdf$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $5ac2ec94ade4afdf$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $5ac2ec94ade4afdf$var$SyntheticTouchEvent;
                        break;
                    case $5ac2ec94ade4afdf$var$ANIMATION_END:
                    case $5ac2ec94ade4afdf$var$ANIMATION_ITERATION:
                    case $5ac2ec94ade4afdf$var$ANIMATION_START:
                        SyntheticEventCtor = $5ac2ec94ade4afdf$var$SyntheticAnimationEvent;
                        break;
                    case $5ac2ec94ade4afdf$var$TRANSITION_END:
                        SyntheticEventCtor = $5ac2ec94ade4afdf$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $5ac2ec94ade4afdf$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $5ac2ec94ade4afdf$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $5ac2ec94ade4afdf$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $5ac2ec94ade4afdf$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $5ac2ec94ade4afdf$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $5ac2ec94ade4afdf$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($5ac2ec94ade4afdf$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $5ac2ec94ade4afdf$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($5ac2ec94ade4afdf$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$5ac2ec94ade4afdf$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $5ac2ec94ade4afdf$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $5ac2ec94ade4afdf$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $5ac2ec94ade4afdf$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $5ac2ec94ade4afdf$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $5ac2ec94ade4afdf$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $5ac2ec94ade4afdf$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $5ac2ec94ade4afdf$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $5ac2ec94ade4afdf$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $5ac2ec94ade4afdf$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $5ac2ec94ade4afdf$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $5ac2ec94ade4afdf$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $5ac2ec94ade4afdf$var$getTargetInstForChangeEvent;
                else if ($5ac2ec94ade4afdf$var$isTextInputElement(reactName)) {
                    if ($5ac2ec94ade4afdf$var$isInputEventSupported) getTargetInstFunc = $5ac2ec94ade4afdf$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $5ac2ec94ade4afdf$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $5ac2ec94ade4afdf$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $5ac2ec94ade4afdf$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $5ac2ec94ade4afdf$var$getTargetInstForChangeEvent) : getTargetInstFunc = $5ac2ec94ade4afdf$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $5ac2ec94ade4afdf$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $5ac2ec94ade4afdf$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $5ac2ec94ade4afdf$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($5ac2ec94ade4afdf$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $5ac2ec94ade4afdf$var$activeElement = handleEventFunc, $5ac2ec94ade4afdf$var$activeElementInst = targetInst, $5ac2ec94ade4afdf$var$lastSelection = null;
                    break;
                case "focusout":
                    $5ac2ec94ade4afdf$var$lastSelection = $5ac2ec94ade4afdf$var$activeElementInst = $5ac2ec94ade4afdf$var$activeElement = null;
                    break;
                case "mousedown":
                    $5ac2ec94ade4afdf$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $5ac2ec94ade4afdf$var$mouseDown = !1;
                    $5ac2ec94ade4afdf$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($5ac2ec94ade4afdf$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $5ac2ec94ade4afdf$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($5ac2ec94ade4afdf$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $5ac2ec94ade4afdf$var$isComposing ? $5ac2ec94ade4afdf$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($5ac2ec94ade4afdf$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($5ac2ec94ade4afdf$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $5ac2ec94ade4afdf$var$isComposing && (fallbackData = $5ac2ec94ade4afdf$var$getData()) : ($5ac2ec94ade4afdf$var$root = nativeEventTarget, $5ac2ec94ade4afdf$var$startText = "value" in $5ac2ec94ade4afdf$var$root ? $5ac2ec94ade4afdf$var$root.value : $5ac2ec94ade4afdf$var$root.textContent, $5ac2ec94ade4afdf$var$isComposing = !0)), handleEventFunc = $5ac2ec94ade4afdf$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $5ac2ec94ade4afdf$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $5ac2ec94ade4afdf$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $5ac2ec94ade4afdf$var$canUseTextInputEvent ? $5ac2ec94ade4afdf$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $5ac2ec94ade4afdf$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $5ac2ec94ade4afdf$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $5ac2ec94ade4afdf$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $5ac2ec94ade4afdf$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $5ac2ec94ade4afdf$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $5ac2ec94ade4afdf$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $5ac2ec94ade4afdf$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $5ac2ec94ade4afdf$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($5ac2ec94ade4afdf$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $5ac2ec94ade4afdf$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($5ac2ec94ade4afdf$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $5ac2ec94ade4afdf$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $5ac2ec94ade4afdf$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $5ac2ec94ade4afdf$var$getListener(target, registrationName), null != stateNode && listeners.unshift($5ac2ec94ade4afdf$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $5ac2ec94ade4afdf$var$getListener(target, registrationName), null != stateNode && listeners.push($5ac2ec94ade4afdf$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $5ac2ec94ade4afdf$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $5ac2ec94ade4afdf$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $5ac2ec94ade4afdf$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($5ac2ec94ade4afdf$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($5ac2ec94ade4afdf$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $5ac2ec94ade4afdf$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $5ac2ec94ade4afdf$var$normalizeMarkupForTextOrAttribute(clientText);
    return $5ac2ec94ade4afdf$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $5ac2ec94ade4afdf$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $5ac2ec94ade4afdf$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $5ac2ec94ade4afdf$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $5ac2ec94ade4afdf$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $5ac2ec94ade4afdf$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $5ac2ec94ade4afdf$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $5ac2ec94ade4afdf$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $5ac2ec94ade4afdf$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $5ac2ec94ade4afdf$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $5ac2ec94ade4afdf$var$setProp(domElement, tag, "name", props.name, props, null), $5ac2ec94ade4afdf$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $5ac2ec94ade4afdf$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $5ac2ec94ade4afdf$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($5ac2ec94ade4afdf$var$setProp(domElement, tag, "encType", props.encType, props, null), $5ac2ec94ade4afdf$var$setProp(domElement, tag, "method", props.method, props, null), $5ac2ec94ade4afdf$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $5ac2ec94ade4afdf$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $5ac2ec94ade4afdf$var$noop$1);
            break;
        case "onScroll":
            null != value && $5ac2ec94ade4afdf$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $5ac2ec94ade4afdf$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $5ac2ec94ade4afdf$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $5ac2ec94ade4afdf$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $5ac2ec94ade4afdf$var$listenToNonDelegatedEvent("toggle", domElement);
            $5ac2ec94ade4afdf$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $5ac2ec94ade4afdf$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $5ac2ec94ade4afdf$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $5ac2ec94ade4afdf$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $5ac2ec94ade4afdf$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $5ac2ec94ade4afdf$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $5ac2ec94ade4afdf$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $5ac2ec94ade4afdf$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $5ac2ec94ade4afdf$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $5ac2ec94ade4afdf$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $5ac2ec94ade4afdf$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $5ac2ec94ade4afdf$var$aliases.get(key) || key, $5ac2ec94ade4afdf$var$setValueForAttribute(domElement, key, value);
    }
}
function $5ac2ec94ade4afdf$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $5ac2ec94ade4afdf$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $5ac2ec94ade4afdf$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $5ac2ec94ade4afdf$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $5ac2ec94ade4afdf$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $5ac2ec94ade4afdf$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $5ac2ec94ade4afdf$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$5ac2ec94ade4afdf$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$5ac2ec94ade4afdf$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $5ac2ec94ade4afdf$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $5ac2ec94ade4afdf$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $5ac2ec94ade4afdf$var$listenToNonDelegatedEvent("error", domElement);
            $5ac2ec94ade4afdf$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(137, tag));
                    default:
                        $5ac2ec94ade4afdf$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $5ac2ec94ade4afdf$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $5ac2ec94ade4afdf$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $5ac2ec94ade4afdf$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $5ac2ec94ade4afdf$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $5ac2ec94ade4afdf$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $5ac2ec94ade4afdf$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $5ac2ec94ade4afdf$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $5ac2ec94ade4afdf$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $5ac2ec94ade4afdf$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $5ac2ec94ade4afdf$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(91));
                    break;
                default:
                    $5ac2ec94ade4afdf$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $5ac2ec94ade4afdf$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $5ac2ec94ade4afdf$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $5ac2ec94ade4afdf$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $5ac2ec94ade4afdf$var$listenToNonDelegatedEvent("toggle", domElement);
            $5ac2ec94ade4afdf$var$listenToNonDelegatedEvent("cancel", domElement);
            $5ac2ec94ade4afdf$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $5ac2ec94ade4afdf$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $5ac2ec94ade4afdf$var$mediaEventTypes.length; hasSrc++)$5ac2ec94ade4afdf$var$listenToNonDelegatedEvent($5ac2ec94ade4afdf$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $5ac2ec94ade4afdf$var$listenToNonDelegatedEvent("error", domElement);
            $5ac2ec94ade4afdf$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $5ac2ec94ade4afdf$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $5ac2ec94ade4afdf$var$listenToNonDelegatedEvent("error", domElement), $5ac2ec94ade4afdf$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(137, tag));
                default:
                    $5ac2ec94ade4afdf$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($5ac2ec94ade4afdf$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $5ac2ec94ade4afdf$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $5ac2ec94ade4afdf$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $5ac2ec94ade4afdf$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $5ac2ec94ade4afdf$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $5ac2ec94ade4afdf$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $5ac2ec94ade4afdf$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $5ac2ec94ade4afdf$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $5ac2ec94ade4afdf$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $5ac2ec94ade4afdf$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $5ac2ec94ade4afdf$var$updateOptions(domElement, !!lastProps, tag, !0) : $5ac2ec94ade4afdf$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $5ac2ec94ade4afdf$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $5ac2ec94ade4afdf$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $5ac2ec94ade4afdf$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $5ac2ec94ade4afdf$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $5ac2ec94ade4afdf$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $5ac2ec94ade4afdf$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $5ac2ec94ade4afdf$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($5ac2ec94ade4afdf$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $5ac2ec94ade4afdf$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $5ac2ec94ade4afdf$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $5ac2ec94ade4afdf$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $5ac2ec94ade4afdf$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $5ac2ec94ade4afdf$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $5ac2ec94ade4afdf$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $5ac2ec94ade4afdf$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $5ac2ec94ade4afdf$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $5ac2ec94ade4afdf$var$eventsEnabled = null, $5ac2ec94ade4afdf$var$selectionInformation = null;
function $5ac2ec94ade4afdf$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $5ac2ec94ade4afdf$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $5ac2ec94ade4afdf$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $5ac2ec94ade4afdf$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $5ac2ec94ade4afdf$var$currentPopstateTransitionEvent = null;
function $5ac2ec94ade4afdf$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $5ac2ec94ade4afdf$var$currentPopstateTransitionEvent) return !1;
        $5ac2ec94ade4afdf$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $5ac2ec94ade4afdf$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $5ac2ec94ade4afdf$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $5ac2ec94ade4afdf$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $5ac2ec94ade4afdf$var$localPromise = "function" === typeof Promise ? Promise : void 0, $5ac2ec94ade4afdf$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $5ac2ec94ade4afdf$var$localPromise ? function(callback) {
    return $5ac2ec94ade4afdf$var$localPromise.resolve(null).then(callback).catch($5ac2ec94ade4afdf$var$handleErrorInNextTick);
} : $5ac2ec94ade4afdf$var$scheduleTimeout;
function $5ac2ec94ade4afdf$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $5ac2ec94ade4afdf$var$isSingletonScope(type) {
    return "head" === type;
}
function $5ac2ec94ade4afdf$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $5ac2ec94ade4afdf$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $5ac2ec94ade4afdf$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $5ac2ec94ade4afdf$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$5ac2ec94ade4afdf$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $5ac2ec94ade4afdf$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $5ac2ec94ade4afdf$var$retryIfBlockedOn(hydrationInstance);
}
function $5ac2ec94ade4afdf$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $5ac2ec94ade4afdf$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $5ac2ec94ade4afdf$var$clearContainerSparingly(node);
                $5ac2ec94ade4afdf$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $5ac2ec94ade4afdf$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$5ac2ec94ade4afdf$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $5ac2ec94ade4afdf$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $5ac2ec94ade4afdf$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $5ac2ec94ade4afdf$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $5ac2ec94ade4afdf$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $5ac2ec94ade4afdf$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $5ac2ec94ade4afdf$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $5ac2ec94ade4afdf$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $5ac2ec94ade4afdf$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $5ac2ec94ade4afdf$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $5ac2ec94ade4afdf$var$previousHydratableOnEnteringScopedSingleton = null;
function $5ac2ec94ade4afdf$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $5ac2ec94ade4afdf$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $5ac2ec94ade4afdf$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $5ac2ec94ade4afdf$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $5ac2ec94ade4afdf$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(451));
    }
}
function $5ac2ec94ade4afdf$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $5ac2ec94ade4afdf$var$detachDeletedInstance(instance);
}
var $5ac2ec94ade4afdf$var$preloadPropsMap = new Map(), $5ac2ec94ade4afdf$var$preconnectsSet = new Set();
function $5ac2ec94ade4afdf$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $5ac2ec94ade4afdf$var$previousDispatcher = $5ac2ec94ade4afdf$var$ReactDOMSharedInternals.d;
$5ac2ec94ade4afdf$var$ReactDOMSharedInternals.d = {
    f: $5ac2ec94ade4afdf$var$flushSyncWork,
    r: $5ac2ec94ade4afdf$var$requestFormReset,
    D: $5ac2ec94ade4afdf$var$prefetchDNS,
    C: $5ac2ec94ade4afdf$var$preconnect,
    L: $5ac2ec94ade4afdf$var$preload,
    m: $5ac2ec94ade4afdf$var$preloadModule,
    X: $5ac2ec94ade4afdf$var$preinitScript,
    S: $5ac2ec94ade4afdf$var$preinitStyle,
    M: $5ac2ec94ade4afdf$var$preinitModuleScript
};
function $5ac2ec94ade4afdf$var$flushSyncWork() {
    var previousWasRendering = $5ac2ec94ade4afdf$var$previousDispatcher.f(), wasRendering = $5ac2ec94ade4afdf$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $5ac2ec94ade4afdf$var$requestFormReset(form) {
    var formInst = $5ac2ec94ade4afdf$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $5ac2ec94ade4afdf$var$requestFormReset$1(formInst) : $5ac2ec94ade4afdf$var$previousDispatcher.r(form);
}
var $5ac2ec94ade4afdf$var$globalDocument = "undefined" === typeof document ? null : document;
function $5ac2ec94ade4afdf$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $5ac2ec94ade4afdf$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $5ac2ec94ade4afdf$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $5ac2ec94ade4afdf$var$preconnectsSet.has(limitedEscapedHref) || ($5ac2ec94ade4afdf$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $5ac2ec94ade4afdf$var$setInitialProperties(href, "link", rel), $5ac2ec94ade4afdf$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $5ac2ec94ade4afdf$var$prefetchDNS(href) {
    $5ac2ec94ade4afdf$var$previousDispatcher.D(href);
    $5ac2ec94ade4afdf$var$preconnectAs("dns-prefetch", href, null);
}
function $5ac2ec94ade4afdf$var$preconnect(href, crossOrigin) {
    $5ac2ec94ade4afdf$var$previousDispatcher.C(href, crossOrigin);
    $5ac2ec94ade4afdf$var$preconnectAs("preconnect", href, crossOrigin);
}
function $5ac2ec94ade4afdf$var$preload(href, as, options) {
    $5ac2ec94ade4afdf$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $5ac2ec94ade4afdf$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $5ac2ec94ade4afdf$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $5ac2ec94ade4afdf$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $5ac2ec94ade4afdf$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $5ac2ec94ade4afdf$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $5ac2ec94ade4afdf$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $5ac2ec94ade4afdf$var$getStyleKey(href);
                break;
            case "script":
                key = $5ac2ec94ade4afdf$var$getScriptKey(href);
        }
        $5ac2ec94ade4afdf$var$preloadPropsMap.has(key) || (href = $5ac2ec94ade4afdf$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $5ac2ec94ade4afdf$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($5ac2ec94ade4afdf$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($5ac2ec94ade4afdf$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $5ac2ec94ade4afdf$var$setInitialProperties(as, "link", href), $5ac2ec94ade4afdf$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $5ac2ec94ade4afdf$var$preloadModule(href, options) {
    $5ac2ec94ade4afdf$var$previousDispatcher.m(href, options);
    var ownerDocument = $5ac2ec94ade4afdf$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $5ac2ec94ade4afdf$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $5ac2ec94ade4afdf$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $5ac2ec94ade4afdf$var$getScriptKey(href);
        }
        if (!$5ac2ec94ade4afdf$var$preloadPropsMap.has(key) && (href = $5ac2ec94ade4afdf$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $5ac2ec94ade4afdf$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($5ac2ec94ade4afdf$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $5ac2ec94ade4afdf$var$setInitialProperties(as, "link", href);
            $5ac2ec94ade4afdf$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $5ac2ec94ade4afdf$var$preinitStyle(href, precedence, options) {
    $5ac2ec94ade4afdf$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $5ac2ec94ade4afdf$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $5ac2ec94ade4afdf$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $5ac2ec94ade4afdf$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($5ac2ec94ade4afdf$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $5ac2ec94ade4afdf$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $5ac2ec94ade4afdf$var$preloadPropsMap.get(key)) && $5ac2ec94ade4afdf$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $5ac2ec94ade4afdf$var$markNodeAsHoistable(link);
                $5ac2ec94ade4afdf$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $5ac2ec94ade4afdf$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $5ac2ec94ade4afdf$var$preinitScript(src, options) {
    $5ac2ec94ade4afdf$var$previousDispatcher.X(src, options);
    var ownerDocument = $5ac2ec94ade4afdf$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $5ac2ec94ade4afdf$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $5ac2ec94ade4afdf$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($5ac2ec94ade4afdf$var$getScriptSelectorFromKey(key)), resource || (src = $5ac2ec94ade4afdf$var$assign({
            src: src,
            async: !0
        }, options), (options = $5ac2ec94ade4afdf$var$preloadPropsMap.get(key)) && $5ac2ec94ade4afdf$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $5ac2ec94ade4afdf$var$markNodeAsHoistable(resource), $5ac2ec94ade4afdf$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $5ac2ec94ade4afdf$var$preinitModuleScript(src, options) {
    $5ac2ec94ade4afdf$var$previousDispatcher.M(src, options);
    var ownerDocument = $5ac2ec94ade4afdf$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $5ac2ec94ade4afdf$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $5ac2ec94ade4afdf$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($5ac2ec94ade4afdf$var$getScriptSelectorFromKey(key)), resource || (src = $5ac2ec94ade4afdf$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $5ac2ec94ade4afdf$var$preloadPropsMap.get(key)) && $5ac2ec94ade4afdf$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $5ac2ec94ade4afdf$var$markNodeAsHoistable(resource), $5ac2ec94ade4afdf$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $5ac2ec94ade4afdf$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $5ac2ec94ade4afdf$var$rootInstanceStackCursor.current) ? $5ac2ec94ade4afdf$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $5ac2ec94ade4afdf$var$getStyleKey(pendingProps.href), pendingProps = $5ac2ec94ade4afdf$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $5ac2ec94ade4afdf$var$getStyleKey(pendingProps.href);
                var styles$243 = $5ac2ec94ade4afdf$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($5ac2ec94ade4afdf$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $5ac2ec94ade4afdf$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $5ac2ec94ade4afdf$var$preloadPropsMap.set(type, pendingProps), styles$243 || $5ac2ec94ade4afdf$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $5ac2ec94ade4afdf$var$getScriptKey(pendingProps), pendingProps = $5ac2ec94ade4afdf$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(444, type));
    }
}
function $5ac2ec94ade4afdf$var$getStyleKey(href) {
    return 'href="' + $5ac2ec94ade4afdf$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $5ac2ec94ade4afdf$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $5ac2ec94ade4afdf$var$stylesheetPropsFromRawProps(rawProps) {
    return $5ac2ec94ade4afdf$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $5ac2ec94ade4afdf$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $5ac2ec94ade4afdf$var$setInitialProperties(key, "link", preloadProps), $5ac2ec94ade4afdf$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $5ac2ec94ade4afdf$var$getScriptKey(src) {
    return '[src="' + $5ac2ec94ade4afdf$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $5ac2ec94ade4afdf$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $5ac2ec94ade4afdf$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $5ac2ec94ade4afdf$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $5ac2ec94ade4afdf$var$markNodeAsHoistable(instance), instance;
            var styleProps = $5ac2ec94ade4afdf$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $5ac2ec94ade4afdf$var$markNodeAsHoistable(instance);
            $5ac2ec94ade4afdf$var$setInitialProperties(instance, "style", styleProps);
            $5ac2ec94ade4afdf$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $5ac2ec94ade4afdf$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($5ac2ec94ade4afdf$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $5ac2ec94ade4afdf$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $5ac2ec94ade4afdf$var$stylesheetPropsFromRawProps(props);
            (styleProps = $5ac2ec94ade4afdf$var$preloadPropsMap.get(styleProps)) && $5ac2ec94ade4afdf$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $5ac2ec94ade4afdf$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $5ac2ec94ade4afdf$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $5ac2ec94ade4afdf$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $5ac2ec94ade4afdf$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($5ac2ec94ade4afdf$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $5ac2ec94ade4afdf$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $5ac2ec94ade4afdf$var$preloadPropsMap.get(instance$249)) instance = $5ac2ec94ade4afdf$var$assign({}, props), $5ac2ec94ade4afdf$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $5ac2ec94ade4afdf$var$markNodeAsHoistable(styleProps);
            $5ac2ec94ade4afdf$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $5ac2ec94ade4afdf$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $5ac2ec94ade4afdf$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $5ac2ec94ade4afdf$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $5ac2ec94ade4afdf$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $5ac2ec94ade4afdf$var$tagCaches = null;
function $5ac2ec94ade4afdf$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $5ac2ec94ade4afdf$var$tagCaches) {
        var cache = new Map();
        var caches = $5ac2ec94ade4afdf$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $5ac2ec94ade4afdf$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$5ac2ec94ade4afdf$var$internalHoistableMarker] || node[$5ac2ec94ade4afdf$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $5ac2ec94ade4afdf$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $5ac2ec94ade4afdf$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $5ac2ec94ade4afdf$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $5ac2ec94ade4afdf$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $5ac2ec94ade4afdf$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($5ac2ec94ade4afdf$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $5ac2ec94ade4afdf$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $5ac2ec94ade4afdf$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $5ac2ec94ade4afdf$var$stylesheetPropsFromRawProps(props);
            (key = $5ac2ec94ade4afdf$var$preloadPropsMap.get(key)) && $5ac2ec94ade4afdf$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $5ac2ec94ade4afdf$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $5ac2ec94ade4afdf$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $5ac2ec94ade4afdf$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $5ac2ec94ade4afdf$var$estimatedBytesWithinLimit = 0;
function $5ac2ec94ade4afdf$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $5ac2ec94ade4afdf$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $5ac2ec94ade4afdf$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $5ac2ec94ade4afdf$var$estimatedBytesWithinLimit && ($5ac2ec94ade4afdf$var$estimatedBytesWithinLimit = 62500 * $5ac2ec94ade4afdf$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $5ac2ec94ade4afdf$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $5ac2ec94ade4afdf$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $5ac2ec94ade4afdf$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $5ac2ec94ade4afdf$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $5ac2ec94ade4afdf$var$precedencesByRoot = null;
function $5ac2ec94ade4afdf$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $5ac2ec94ade4afdf$var$precedencesByRoot = new Map(), resources.forEach($5ac2ec94ade4afdf$var$insertStylesheetIntoRoot, state), $5ac2ec94ade4afdf$var$precedencesByRoot = null, $5ac2ec94ade4afdf$var$onUnsuspend.call(state));
}
function $5ac2ec94ade4afdf$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $5ac2ec94ade4afdf$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $5ac2ec94ade4afdf$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $5ac2ec94ade4afdf$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $5ac2ec94ade4afdf$var$HostTransitionContext = {
    $$typeof: $5ac2ec94ade4afdf$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $5ac2ec94ade4afdf$var$sharedNotPendingObject,
    _currentValue2: $5ac2ec94ade4afdf$var$sharedNotPendingObject,
    _threadCount: 0
};
function $5ac2ec94ade4afdf$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $5ac2ec94ade4afdf$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $5ac2ec94ade4afdf$var$createLaneMap(0);
    this.hiddenUpdates = $5ac2ec94ade4afdf$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $5ac2ec94ade4afdf$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $5ac2ec94ade4afdf$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $5ac2ec94ade4afdf$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $5ac2ec94ade4afdf$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $5ac2ec94ade4afdf$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $5ac2ec94ade4afdf$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $5ac2ec94ade4afdf$var$emptyContextObject;
    parentComponent = $5ac2ec94ade4afdf$var$emptyContextObject;
    return parentComponent;
}
function $5ac2ec94ade4afdf$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $5ac2ec94ade4afdf$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $5ac2ec94ade4afdf$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $5ac2ec94ade4afdf$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($5ac2ec94ade4afdf$var$scheduleUpdateOnFiber(element, rootFiber, lane), $5ac2ec94ade4afdf$var$entangleTransitions(element, rootFiber, lane));
}
function $5ac2ec94ade4afdf$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $5ac2ec94ade4afdf$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $5ac2ec94ade4afdf$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $5ac2ec94ade4afdf$var$markRetryLaneImpl(fiber, retryLane);
}
function $5ac2ec94ade4afdf$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $5ac2ec94ade4afdf$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $5ac2ec94ade4afdf$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $5ac2ec94ade4afdf$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $5ac2ec94ade4afdf$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $5ac2ec94ade4afdf$var$requestUpdateLane();
        lane = $5ac2ec94ade4afdf$var$getBumpedLaneForHydrationByLane(lane);
        var root = $5ac2ec94ade4afdf$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $5ac2ec94ade4afdf$var$scheduleUpdateOnFiber(root, fiber, lane);
        $5ac2ec94ade4afdf$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $5ac2ec94ade4afdf$var$_enabled = !0;
function $5ac2ec94ade4afdf$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $5ac2ec94ade4afdf$var$ReactSharedInternals.T;
    $5ac2ec94ade4afdf$var$ReactSharedInternals.T = null;
    var previousPriority = $5ac2ec94ade4afdf$var$ReactDOMSharedInternals.p;
    try {
        $5ac2ec94ade4afdf$var$ReactDOMSharedInternals.p = 2, $5ac2ec94ade4afdf$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $5ac2ec94ade4afdf$var$ReactDOMSharedInternals.p = previousPriority, $5ac2ec94ade4afdf$var$ReactSharedInternals.T = prevTransition;
    }
}
function $5ac2ec94ade4afdf$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $5ac2ec94ade4afdf$var$ReactSharedInternals.T;
    $5ac2ec94ade4afdf$var$ReactSharedInternals.T = null;
    var previousPriority = $5ac2ec94ade4afdf$var$ReactDOMSharedInternals.p;
    try {
        $5ac2ec94ade4afdf$var$ReactDOMSharedInternals.p = 8, $5ac2ec94ade4afdf$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $5ac2ec94ade4afdf$var$ReactDOMSharedInternals.p = previousPriority, $5ac2ec94ade4afdf$var$ReactSharedInternals.T = prevTransition;
    }
}
function $5ac2ec94ade4afdf$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($5ac2ec94ade4afdf$var$_enabled) {
        var blockedOn = $5ac2ec94ade4afdf$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $5ac2ec94ade4afdf$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $5ac2ec94ade4afdf$var$return_targetInst, targetContainer), $5ac2ec94ade4afdf$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($5ac2ec94ade4afdf$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($5ac2ec94ade4afdf$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $5ac2ec94ade4afdf$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $5ac2ec94ade4afdf$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $5ac2ec94ade4afdf$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $5ac2ec94ade4afdf$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $5ac2ec94ade4afdf$var$ensureRootIsScheduled(fiber);
                                0 === ($5ac2ec94ade4afdf$var$executionContext & 6) && ($5ac2ec94ade4afdf$var$workInProgressRootRenderTargetTime = $5ac2ec94ade4afdf$var$now() + 500, $5ac2ec94ade4afdf$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $5ac2ec94ade4afdf$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $5ac2ec94ade4afdf$var$scheduleUpdateOnFiber(root, fiber, 2), $5ac2ec94ade4afdf$var$flushSyncWork$1(), $5ac2ec94ade4afdf$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $5ac2ec94ade4afdf$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $5ac2ec94ade4afdf$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $5ac2ec94ade4afdf$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $5ac2ec94ade4afdf$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $5ac2ec94ade4afdf$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $5ac2ec94ade4afdf$var$getEventTarget(nativeEvent);
    return $5ac2ec94ade4afdf$var$findInstanceBlockingTarget(nativeEvent);
}
var $5ac2ec94ade4afdf$var$return_targetInst = null;
function $5ac2ec94ade4afdf$var$findInstanceBlockingTarget(targetNode) {
    $5ac2ec94ade4afdf$var$return_targetInst = null;
    targetNode = $5ac2ec94ade4afdf$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $5ac2ec94ade4afdf$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $5ac2ec94ade4afdf$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $5ac2ec94ade4afdf$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $5ac2ec94ade4afdf$var$return_targetInst = targetNode;
    return null;
}
function $5ac2ec94ade4afdf$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($5ac2ec94ade4afdf$var$getCurrentPriorityLevel()){
                case $5ac2ec94ade4afdf$var$ImmediatePriority:
                    return 2;
                case $5ac2ec94ade4afdf$var$UserBlockingPriority:
                    return 8;
                case $5ac2ec94ade4afdf$var$NormalPriority$1:
                case $5ac2ec94ade4afdf$var$LowPriority:
                    return 32;
                case $5ac2ec94ade4afdf$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $5ac2ec94ade4afdf$var$hasScheduledReplayAttempt = !1, $5ac2ec94ade4afdf$var$queuedFocus = null, $5ac2ec94ade4afdf$var$queuedDrag = null, $5ac2ec94ade4afdf$var$queuedMouse = null, $5ac2ec94ade4afdf$var$queuedPointers = new Map(), $5ac2ec94ade4afdf$var$queuedPointerCaptures = new Map(), $5ac2ec94ade4afdf$var$queuedExplicitHydrationTargets = [], $5ac2ec94ade4afdf$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $5ac2ec94ade4afdf$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $5ac2ec94ade4afdf$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $5ac2ec94ade4afdf$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $5ac2ec94ade4afdf$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $5ac2ec94ade4afdf$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $5ac2ec94ade4afdf$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $5ac2ec94ade4afdf$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $5ac2ec94ade4afdf$var$getInstanceFromNode(blockedOn), null !== blockedOn && $5ac2ec94ade4afdf$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $5ac2ec94ade4afdf$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $5ac2ec94ade4afdf$var$queuedFocus = $5ac2ec94ade4afdf$var$accumulateOrCreateContinuousQueuedReplayableEvent($5ac2ec94ade4afdf$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $5ac2ec94ade4afdf$var$queuedDrag = $5ac2ec94ade4afdf$var$accumulateOrCreateContinuousQueuedReplayableEvent($5ac2ec94ade4afdf$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $5ac2ec94ade4afdf$var$queuedMouse = $5ac2ec94ade4afdf$var$accumulateOrCreateContinuousQueuedReplayableEvent($5ac2ec94ade4afdf$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $5ac2ec94ade4afdf$var$queuedPointers.set(pointerId, $5ac2ec94ade4afdf$var$accumulateOrCreateContinuousQueuedReplayableEvent($5ac2ec94ade4afdf$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $5ac2ec94ade4afdf$var$queuedPointerCaptures.set(pointerId, $5ac2ec94ade4afdf$var$accumulateOrCreateContinuousQueuedReplayableEvent($5ac2ec94ade4afdf$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $5ac2ec94ade4afdf$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $5ac2ec94ade4afdf$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $5ac2ec94ade4afdf$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $5ac2ec94ade4afdf$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $5ac2ec94ade4afdf$var$runWithPriority(queuedTarget.priority, function() {
                        $5ac2ec94ade4afdf$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $5ac2ec94ade4afdf$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $5ac2ec94ade4afdf$var$runWithPriority(queuedTarget.priority, function() {
                        $5ac2ec94ade4afdf$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $5ac2ec94ade4afdf$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $5ac2ec94ade4afdf$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $5ac2ec94ade4afdf$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $5ac2ec94ade4afdf$var$currentReplayingEvent = null;
        } else return targetContainers = $5ac2ec94ade4afdf$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $5ac2ec94ade4afdf$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $5ac2ec94ade4afdf$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $5ac2ec94ade4afdf$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $5ac2ec94ade4afdf$var$replayUnblockedEvents() {
    $5ac2ec94ade4afdf$var$hasScheduledReplayAttempt = !1;
    null !== $5ac2ec94ade4afdf$var$queuedFocus && $5ac2ec94ade4afdf$var$attemptReplayContinuousQueuedEvent($5ac2ec94ade4afdf$var$queuedFocus) && ($5ac2ec94ade4afdf$var$queuedFocus = null);
    null !== $5ac2ec94ade4afdf$var$queuedDrag && $5ac2ec94ade4afdf$var$attemptReplayContinuousQueuedEvent($5ac2ec94ade4afdf$var$queuedDrag) && ($5ac2ec94ade4afdf$var$queuedDrag = null);
    null !== $5ac2ec94ade4afdf$var$queuedMouse && $5ac2ec94ade4afdf$var$attemptReplayContinuousQueuedEvent($5ac2ec94ade4afdf$var$queuedMouse) && ($5ac2ec94ade4afdf$var$queuedMouse = null);
    $5ac2ec94ade4afdf$var$queuedPointers.forEach($5ac2ec94ade4afdf$var$attemptReplayContinuousQueuedEventInMap);
    $5ac2ec94ade4afdf$var$queuedPointerCaptures.forEach($5ac2ec94ade4afdf$var$attemptReplayContinuousQueuedEventInMap);
}
function $5ac2ec94ade4afdf$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $5ac2ec94ade4afdf$var$hasScheduledReplayAttempt || ($5ac2ec94ade4afdf$var$hasScheduledReplayAttempt = !0, $bIbqH.unstable_scheduleCallback($bIbqH.unstable_NormalPriority, $5ac2ec94ade4afdf$var$replayUnblockedEvents)));
}
var $5ac2ec94ade4afdf$var$lastScheduledReplayQueue = null;
function $5ac2ec94ade4afdf$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $5ac2ec94ade4afdf$var$lastScheduledReplayQueue !== formReplayingQueue && ($5ac2ec94ade4afdf$var$lastScheduledReplayQueue = formReplayingQueue, $bIbqH.unstable_scheduleCallback($bIbqH.unstable_NormalPriority, function() {
        $5ac2ec94ade4afdf$var$lastScheduledReplayQueue === formReplayingQueue && ($5ac2ec94ade4afdf$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $5ac2ec94ade4afdf$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $5ac2ec94ade4afdf$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $5ac2ec94ade4afdf$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $5ac2ec94ade4afdf$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $5ac2ec94ade4afdf$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $5ac2ec94ade4afdf$var$queuedFocus && $5ac2ec94ade4afdf$var$scheduleCallbackIfUnblocked($5ac2ec94ade4afdf$var$queuedFocus, unblocked);
    null !== $5ac2ec94ade4afdf$var$queuedDrag && $5ac2ec94ade4afdf$var$scheduleCallbackIfUnblocked($5ac2ec94ade4afdf$var$queuedDrag, unblocked);
    null !== $5ac2ec94ade4afdf$var$queuedMouse && $5ac2ec94ade4afdf$var$scheduleCallbackIfUnblocked($5ac2ec94ade4afdf$var$queuedMouse, unblocked);
    $5ac2ec94ade4afdf$var$queuedPointers.forEach(unblock);
    $5ac2ec94ade4afdf$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $5ac2ec94ade4afdf$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $5ac2ec94ade4afdf$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $5ac2ec94ade4afdf$var$queuedExplicitHydrationTargets.length && (i = $5ac2ec94ade4afdf$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$5ac2ec94ade4afdf$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $5ac2ec94ade4afdf$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$5ac2ec94ade4afdf$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $5ac2ec94ade4afdf$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$5ac2ec94ade4afdf$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $5ac2ec94ade4afdf$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $5ac2ec94ade4afdf$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $5ac2ec94ade4afdf$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $5ac2ec94ade4afdf$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$5ac2ec94ade4afdf$var$ReactDOMHydrationRoot.prototype.render = $5ac2ec94ade4afdf$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(409));
    var current = root.current, lane = $5ac2ec94ade4afdf$var$requestUpdateLane();
    $5ac2ec94ade4afdf$var$updateContainerImpl(current, lane, children, root, null, null);
};
$5ac2ec94ade4afdf$var$ReactDOMHydrationRoot.prototype.unmount = $5ac2ec94ade4afdf$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $5ac2ec94ade4afdf$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $5ac2ec94ade4afdf$var$flushSyncWork$1();
        container[$5ac2ec94ade4afdf$var$internalContainerInstanceKey] = null;
    }
};
function $5ac2ec94ade4afdf$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$5ac2ec94ade4afdf$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $5ac2ec94ade4afdf$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $5ac2ec94ade4afdf$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $5ac2ec94ade4afdf$var$queuedExplicitHydrationTargets[i].priority; i++);
        $5ac2ec94ade4afdf$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $5ac2ec94ade4afdf$var$attemptExplicitHydrationTarget(target);
    }
};
var $5ac2ec94ade4afdf$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $5iwRF.version;
if ("19.2.6" !== $5ac2ec94ade4afdf$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(527, $5ac2ec94ade4afdf$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.6"));
$5ac2ec94ade4afdf$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $5ac2ec94ade4afdf$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $5ac2ec94ade4afdf$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $5ac2ec94ade4afdf$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.6",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $5ac2ec94ade4afdf$var$ReactSharedInternals,
    reconcilerVersion: "19.2.6"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $5ac2ec94ade4afdf$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$5ac2ec94ade4afdf$var$hook$jscomp$inline_2348.isDisabled && $5ac2ec94ade4afdf$var$hook$jscomp$inline_2348.supportsFiber) try {
        $5ac2ec94ade4afdf$var$rendererID = $5ac2ec94ade4afdf$var$hook$jscomp$inline_2348.inject($5ac2ec94ade4afdf$var$internals$jscomp$inline_2347), $5ac2ec94ade4afdf$var$injectedHook = $5ac2ec94ade4afdf$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$5ac2ec94ade4afdf$export$882461b6382ed46c = function(container, options) {
    if (!$5ac2ec94ade4afdf$var$isValidContainer(container)) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $5ac2ec94ade4afdf$var$defaultOnUncaughtError, onCaughtError = $5ac2ec94ade4afdf$var$defaultOnCaughtError, onRecoverableError = $5ac2ec94ade4afdf$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $5ac2ec94ade4afdf$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $5ac2ec94ade4afdf$var$defaultOnDefaultTransitionIndicator);
    container[$5ac2ec94ade4afdf$var$internalContainerInstanceKey] = options.current;
    $5ac2ec94ade4afdf$var$listenToAllSupportedEvents(container);
    return new $5ac2ec94ade4afdf$var$ReactDOMRoot(options);
};
$5ac2ec94ade4afdf$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$5ac2ec94ade4afdf$var$isValidContainer(container)) throw Error($5ac2ec94ade4afdf$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $5ac2ec94ade4afdf$var$defaultOnUncaughtError, onCaughtError = $5ac2ec94ade4afdf$var$defaultOnCaughtError, onRecoverableError = $5ac2ec94ade4afdf$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $5ac2ec94ade4afdf$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $5ac2ec94ade4afdf$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $5ac2ec94ade4afdf$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $5ac2ec94ade4afdf$var$requestUpdateLane();
    isStrictMode = $5ac2ec94ade4afdf$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $5ac2ec94ade4afdf$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $5ac2ec94ade4afdf$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $5ac2ec94ade4afdf$var$markRootUpdated$1(initialChildren, options);
    $5ac2ec94ade4afdf$var$ensureRootIsScheduled(initialChildren);
    container[$5ac2ec94ade4afdf$var$internalContainerInstanceKey] = initialChildren.current;
    $5ac2ec94ade4afdf$var$listenToAllSupportedEvents(container);
    return new $5ac2ec94ade4afdf$var$ReactDOMHydrationRoot(initialChildren);
};
$5ac2ec94ade4afdf$export$83d89fbfd8236492 = "19.2.6";

});
parcelRegister("bIbqH", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hvKuw"));

});
parcelRegister("hvKuw", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $cbf9651fe4890f47$export$c4744153514ff05d, (v) => $cbf9651fe4890f47$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $cbf9651fe4890f47$export$3e506c1ccc9cc1a7, (v) => $cbf9651fe4890f47$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $cbf9651fe4890f47$export$e26fe2ed2fa76875, (v) => $cbf9651fe4890f47$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $cbf9651fe4890f47$export$502329bbf4b505b1, (v) => $cbf9651fe4890f47$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $cbf9651fe4890f47$export$6e3807111c4874c4, (v) => $cbf9651fe4890f47$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $cbf9651fe4890f47$export$c27134553091fb3a, (v) => $cbf9651fe4890f47$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $cbf9651fe4890f47$export$33ee1acdc04fd2a2, (v) => $cbf9651fe4890f47$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $cbf9651fe4890f47$export$b00a404bbd5edef2, (v) => $cbf9651fe4890f47$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $cbf9651fe4890f47$export$d66a1c1c77bd778b, (v) => $cbf9651fe4890f47$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $cbf9651fe4890f47$export$d3dfb8e4810cb555, (v) => $cbf9651fe4890f47$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $cbf9651fe4890f47$export$72fdf0e06517287b, (v) => $cbf9651fe4890f47$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $cbf9651fe4890f47$export$816d2913ae6b83b1, (v) => $cbf9651fe4890f47$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $cbf9651fe4890f47$export$61bcfe829111a1d0, (v) => $cbf9651fe4890f47$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $cbf9651fe4890f47$export$7ee8c9beb337bc3f, (v) => $cbf9651fe4890f47$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $cbf9651fe4890f47$export$b5836b71941fa3ed, (v) => $cbf9651fe4890f47$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $cbf9651fe4890f47$export$cf845f2c119da08a, (v) => $cbf9651fe4890f47$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $cbf9651fe4890f47$export$c4744153514ff05d;
var $cbf9651fe4890f47$export$3e506c1ccc9cc1a7;
var $cbf9651fe4890f47$export$e26fe2ed2fa76875;
var $cbf9651fe4890f47$export$502329bbf4b505b1;
var $cbf9651fe4890f47$export$6e3807111c4874c4;
var $cbf9651fe4890f47$export$c27134553091fb3a;
var $cbf9651fe4890f47$export$33ee1acdc04fd2a2;
var $cbf9651fe4890f47$export$b00a404bbd5edef2;
var $cbf9651fe4890f47$export$d66a1c1c77bd778b;
var $cbf9651fe4890f47$export$d3dfb8e4810cb555;
var $cbf9651fe4890f47$export$72fdf0e06517287b;
var $cbf9651fe4890f47$export$816d2913ae6b83b1;
var $cbf9651fe4890f47$export$61bcfe829111a1d0;
var $cbf9651fe4890f47$export$7ee8c9beb337bc3f;
var $cbf9651fe4890f47$export$b5836b71941fa3ed;
var $cbf9651fe4890f47$export$cf845f2c119da08a;
"use strict";
function $cbf9651fe4890f47$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $cbf9651fe4890f47$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $cbf9651fe4890f47$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $cbf9651fe4890f47$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $cbf9651fe4890f47$var$compare(left, last)) rightIndex < length && 0 > $cbf9651fe4890f47$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $cbf9651fe4890f47$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $cbf9651fe4890f47$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$cbf9651fe4890f47$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $cbf9651fe4890f47$var$localPerformance = performance;
    $cbf9651fe4890f47$export$c4744153514ff05d = function() {
        return $cbf9651fe4890f47$var$localPerformance.now();
    };
} else {
    var $cbf9651fe4890f47$var$localDate = Date, $cbf9651fe4890f47$var$initialTime = $cbf9651fe4890f47$var$localDate.now();
    $cbf9651fe4890f47$export$c4744153514ff05d = function() {
        return $cbf9651fe4890f47$var$localDate.now() - $cbf9651fe4890f47$var$initialTime;
    };
}
var $cbf9651fe4890f47$var$taskQueue = [], $cbf9651fe4890f47$var$timerQueue = [], $cbf9651fe4890f47$var$taskIdCounter = 1, $cbf9651fe4890f47$var$currentTask = null, $cbf9651fe4890f47$var$currentPriorityLevel = 3, $cbf9651fe4890f47$var$isPerformingWork = !1, $cbf9651fe4890f47$var$isHostCallbackScheduled = !1, $cbf9651fe4890f47$var$isHostTimeoutScheduled = !1, $cbf9651fe4890f47$var$needsPaint = !1, $cbf9651fe4890f47$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $cbf9651fe4890f47$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $cbf9651fe4890f47$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $cbf9651fe4890f47$var$advanceTimers(currentTime) {
    for(var timer = $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$timerQueue); null !== timer;){
        if (null === timer.callback) $cbf9651fe4890f47$var$pop($cbf9651fe4890f47$var$timerQueue);
        else if (timer.startTime <= currentTime) $cbf9651fe4890f47$var$pop($cbf9651fe4890f47$var$timerQueue), timer.sortIndex = timer.expirationTime, $cbf9651fe4890f47$var$push($cbf9651fe4890f47$var$taskQueue, timer);
        else break;
        timer = $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$timerQueue);
    }
}
function $cbf9651fe4890f47$var$handleTimeout(currentTime) {
    $cbf9651fe4890f47$var$isHostTimeoutScheduled = !1;
    $cbf9651fe4890f47$var$advanceTimers(currentTime);
    if (!$cbf9651fe4890f47$var$isHostCallbackScheduled) {
        if (null !== $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$taskQueue)) $cbf9651fe4890f47$var$isHostCallbackScheduled = !0, $cbf9651fe4890f47$var$isMessageLoopRunning || ($cbf9651fe4890f47$var$isMessageLoopRunning = !0, $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$timerQueue);
            null !== firstTimer && $cbf9651fe4890f47$var$requestHostTimeout($cbf9651fe4890f47$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $cbf9651fe4890f47$var$isMessageLoopRunning = !1, $cbf9651fe4890f47$var$taskTimeoutID = -1, $cbf9651fe4890f47$var$frameInterval = 5, $cbf9651fe4890f47$var$startTime = -1;
function $cbf9651fe4890f47$var$shouldYieldToHost() {
    return $cbf9651fe4890f47$var$needsPaint ? !0 : $cbf9651fe4890f47$export$c4744153514ff05d() - $cbf9651fe4890f47$var$startTime < $cbf9651fe4890f47$var$frameInterval ? !1 : !0;
}
function $cbf9651fe4890f47$var$performWorkUntilDeadline() {
    $cbf9651fe4890f47$var$needsPaint = !1;
    if ($cbf9651fe4890f47$var$isMessageLoopRunning) {
        var currentTime = $cbf9651fe4890f47$export$c4744153514ff05d();
        $cbf9651fe4890f47$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $cbf9651fe4890f47$var$isHostCallbackScheduled = !1;
                $cbf9651fe4890f47$var$isHostTimeoutScheduled && ($cbf9651fe4890f47$var$isHostTimeoutScheduled = !1, $cbf9651fe4890f47$var$localClearTimeout($cbf9651fe4890f47$var$taskTimeoutID), $cbf9651fe4890f47$var$taskTimeoutID = -1);
                $cbf9651fe4890f47$var$isPerformingWork = !0;
                var previousPriorityLevel = $cbf9651fe4890f47$var$currentPriorityLevel;
                try {
                    b: {
                        $cbf9651fe4890f47$var$advanceTimers(currentTime);
                        for($cbf9651fe4890f47$var$currentTask = $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$taskQueue); null !== $cbf9651fe4890f47$var$currentTask && !($cbf9651fe4890f47$var$currentTask.expirationTime > currentTime && $cbf9651fe4890f47$var$shouldYieldToHost());){
                            var callback = $cbf9651fe4890f47$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $cbf9651fe4890f47$var$currentTask.callback = null;
                                $cbf9651fe4890f47$var$currentPriorityLevel = $cbf9651fe4890f47$var$currentTask.priorityLevel;
                                var continuationCallback = callback($cbf9651fe4890f47$var$currentTask.expirationTime <= currentTime);
                                currentTime = $cbf9651fe4890f47$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $cbf9651fe4890f47$var$currentTask.callback = continuationCallback;
                                    $cbf9651fe4890f47$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $cbf9651fe4890f47$var$currentTask === $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$taskQueue) && $cbf9651fe4890f47$var$pop($cbf9651fe4890f47$var$taskQueue);
                                $cbf9651fe4890f47$var$advanceTimers(currentTime);
                            } else $cbf9651fe4890f47$var$pop($cbf9651fe4890f47$var$taskQueue);
                            $cbf9651fe4890f47$var$currentTask = $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$taskQueue);
                        }
                        if (null !== $cbf9651fe4890f47$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$timerQueue);
                            null !== firstTimer && $cbf9651fe4890f47$var$requestHostTimeout($cbf9651fe4890f47$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $cbf9651fe4890f47$var$currentTask = null, $cbf9651fe4890f47$var$currentPriorityLevel = previousPriorityLevel, $cbf9651fe4890f47$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline() : $cbf9651fe4890f47$var$isMessageLoopRunning = !1;
        }
    }
}
var $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $cbf9651fe4890f47$var$localSetImmediate) $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline = function() {
    $cbf9651fe4890f47$var$localSetImmediate($cbf9651fe4890f47$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $cbf9651fe4890f47$var$channel = new MessageChannel(), $cbf9651fe4890f47$var$port = $cbf9651fe4890f47$var$channel.port2;
    $cbf9651fe4890f47$var$channel.port1.onmessage = $cbf9651fe4890f47$var$performWorkUntilDeadline;
    $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline = function() {
        $cbf9651fe4890f47$var$port.postMessage(null);
    };
} else $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline = function() {
    $cbf9651fe4890f47$var$localSetTimeout($cbf9651fe4890f47$var$performWorkUntilDeadline, 0);
};
function $cbf9651fe4890f47$var$requestHostTimeout(callback, ms) {
    $cbf9651fe4890f47$var$taskTimeoutID = $cbf9651fe4890f47$var$localSetTimeout(function() {
        callback($cbf9651fe4890f47$export$c4744153514ff05d());
    }, ms);
}
$cbf9651fe4890f47$export$3e506c1ccc9cc1a7 = 5;
$cbf9651fe4890f47$export$e26fe2ed2fa76875 = 1;
$cbf9651fe4890f47$export$502329bbf4b505b1 = 4;
$cbf9651fe4890f47$export$6e3807111c4874c4 = 3;
$cbf9651fe4890f47$export$c27134553091fb3a = null;
$cbf9651fe4890f47$export$33ee1acdc04fd2a2 = 2;
$cbf9651fe4890f47$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$cbf9651fe4890f47$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $cbf9651fe4890f47$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$cbf9651fe4890f47$export$d3dfb8e4810cb555 = function() {
    return $cbf9651fe4890f47$var$currentPriorityLevel;
};
$cbf9651fe4890f47$export$72fdf0e06517287b = function(eventHandler) {
    switch($cbf9651fe4890f47$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $cbf9651fe4890f47$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $cbf9651fe4890f47$var$currentPriorityLevel;
    $cbf9651fe4890f47$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $cbf9651fe4890f47$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$cbf9651fe4890f47$export$816d2913ae6b83b1 = function() {
    $cbf9651fe4890f47$var$needsPaint = !0;
};
$cbf9651fe4890f47$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $cbf9651fe4890f47$var$currentPriorityLevel;
    $cbf9651fe4890f47$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $cbf9651fe4890f47$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$cbf9651fe4890f47$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $cbf9651fe4890f47$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $cbf9651fe4890f47$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $cbf9651fe4890f47$var$push($cbf9651fe4890f47$var$timerQueue, priorityLevel), null === $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$taskQueue) && priorityLevel === $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$timerQueue) && ($cbf9651fe4890f47$var$isHostTimeoutScheduled ? ($cbf9651fe4890f47$var$localClearTimeout($cbf9651fe4890f47$var$taskTimeoutID), $cbf9651fe4890f47$var$taskTimeoutID = -1) : $cbf9651fe4890f47$var$isHostTimeoutScheduled = !0, $cbf9651fe4890f47$var$requestHostTimeout($cbf9651fe4890f47$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $cbf9651fe4890f47$var$push($cbf9651fe4890f47$var$taskQueue, priorityLevel), $cbf9651fe4890f47$var$isHostCallbackScheduled || $cbf9651fe4890f47$var$isPerformingWork || ($cbf9651fe4890f47$var$isHostCallbackScheduled = !0, $cbf9651fe4890f47$var$isMessageLoopRunning || ($cbf9651fe4890f47$var$isMessageLoopRunning = !0, $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$cbf9651fe4890f47$export$b5836b71941fa3ed = $cbf9651fe4890f47$var$shouldYieldToHost;
$cbf9651fe4890f47$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $cbf9651fe4890f47$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $cbf9651fe4890f47$var$currentPriorityLevel;
        $cbf9651fe4890f47$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $cbf9651fe4890f47$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("5iwRF", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2Ypn1"));

});

parcelRegister("epKkp", function(module, exports) {
'use strict';
function $a7e75646b57b0d4f$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($a7e75646b57b0d4f$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$a7e75646b57b0d4f$var$checkDCE();

module.exports = (parcelRequire("4Z6LX"));

});
parcelRegister("4Z6LX", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $3a121ccf49b435d4$export$69ce8ef3fe5cead0, (v) => $3a121ccf49b435d4$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $3a121ccf49b435d4$export$d39a5bbd09211389, (v) => $3a121ccf49b435d4$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $3a121ccf49b435d4$export$cd75ccfd720a3cd4, (v) => $3a121ccf49b435d4$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $3a121ccf49b435d4$export$a0816fa17a9e79be, (v) => $3a121ccf49b435d4$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $3a121ccf49b435d4$export$7292efcadded39f3, (v) => $3a121ccf49b435d4$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $3a121ccf49b435d4$export$da407abadb9b8f86, (v) => $3a121ccf49b435d4$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $3a121ccf49b435d4$export$314cfea32580671c, (v) => $3a121ccf49b435d4$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $3a121ccf49b435d4$export$513ccb98c53b8039, (v) => $3a121ccf49b435d4$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $3a121ccf49b435d4$export$dbca993bc2d264a, (v) => $3a121ccf49b435d4$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $3a121ccf49b435d4$export$4797a8006f0655d0, (v) => $3a121ccf49b435d4$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $3a121ccf49b435d4$export$c78a37762a8d58e1, (v) => $3a121ccf49b435d4$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $3a121ccf49b435d4$export$606f11b2eb45ecc6, (v) => $3a121ccf49b435d4$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $3a121ccf49b435d4$export$f7e8a0bf92324b1e, (v) => $3a121ccf49b435d4$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $3a121ccf49b435d4$export$83d89fbfd8236492, (v) => $3a121ccf49b435d4$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3a121ccf49b435d4$export$69ce8ef3fe5cead0;
var $3a121ccf49b435d4$export$d39a5bbd09211389;
var $3a121ccf49b435d4$export$cd75ccfd720a3cd4;
var $3a121ccf49b435d4$export$a0816fa17a9e79be;
var $3a121ccf49b435d4$export$7292efcadded39f3;
var $3a121ccf49b435d4$export$da407abadb9b8f86;
var $3a121ccf49b435d4$export$314cfea32580671c;
var $3a121ccf49b435d4$export$513ccb98c53b8039;
var $3a121ccf49b435d4$export$dbca993bc2d264a;
var $3a121ccf49b435d4$export$4797a8006f0655d0;
var $3a121ccf49b435d4$export$c78a37762a8d58e1;
var $3a121ccf49b435d4$export$606f11b2eb45ecc6;
var $3a121ccf49b435d4$export$f7e8a0bf92324b1e;
var $3a121ccf49b435d4$export$83d89fbfd8236492;
"use strict";

var $5iwRF = parcelRequire("5iwRF");
function $3a121ccf49b435d4$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $3a121ccf49b435d4$var$noop() {}
var $3a121ccf49b435d4$var$Internals = {
    d: {
        f: $3a121ccf49b435d4$var$noop,
        r: function() {
            throw Error($3a121ccf49b435d4$var$formatProdErrorMessage(522));
        },
        D: $3a121ccf49b435d4$var$noop,
        C: $3a121ccf49b435d4$var$noop,
        L: $3a121ccf49b435d4$var$noop,
        m: $3a121ccf49b435d4$var$noop,
        X: $3a121ccf49b435d4$var$noop,
        S: $3a121ccf49b435d4$var$noop,
        M: $3a121ccf49b435d4$var$noop
    },
    p: 0,
    findDOMNode: null
}, $3a121ccf49b435d4$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $3a121ccf49b435d4$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $3a121ccf49b435d4$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $3a121ccf49b435d4$var$ReactSharedInternals = $5iwRF.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $3a121ccf49b435d4$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$3a121ccf49b435d4$export$69ce8ef3fe5cead0 = $3a121ccf49b435d4$var$Internals;
$3a121ccf49b435d4$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($3a121ccf49b435d4$var$formatProdErrorMessage(299));
    return $3a121ccf49b435d4$var$createPortal$1(children, container, null, key);
};
$3a121ccf49b435d4$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $3a121ccf49b435d4$var$ReactSharedInternals.T, previousUpdatePriority = $3a121ccf49b435d4$var$Internals.p;
    try {
        if ($3a121ccf49b435d4$var$ReactSharedInternals.T = null, $3a121ccf49b435d4$var$Internals.p = 2, fn) return fn();
    } finally{
        $3a121ccf49b435d4$var$ReactSharedInternals.T = previousTransition, $3a121ccf49b435d4$var$Internals.p = previousUpdatePriority, $3a121ccf49b435d4$var$Internals.d.f();
    }
};
$3a121ccf49b435d4$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $3a121ccf49b435d4$var$Internals.d.C(href, options));
};
$3a121ccf49b435d4$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $3a121ccf49b435d4$var$Internals.d.D(href);
};
$3a121ccf49b435d4$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $3a121ccf49b435d4$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $3a121ccf49b435d4$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $3a121ccf49b435d4$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$3a121ccf49b435d4$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $3a121ccf49b435d4$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $3a121ccf49b435d4$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $3a121ccf49b435d4$var$Internals.d.M(href);
    }
};
$3a121ccf49b435d4$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $3a121ccf49b435d4$var$getCrossOriginStringAs(as, options.crossOrigin);
        $3a121ccf49b435d4$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$3a121ccf49b435d4$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $3a121ccf49b435d4$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $3a121ccf49b435d4$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $3a121ccf49b435d4$var$Internals.d.m(href);
    }
};
$3a121ccf49b435d4$export$4797a8006f0655d0 = function(form) {
    $3a121ccf49b435d4$var$Internals.d.r(form);
};
$3a121ccf49b435d4$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$3a121ccf49b435d4$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $3a121ccf49b435d4$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$3a121ccf49b435d4$export$f7e8a0bf92324b1e = function() {
    return $3a121ccf49b435d4$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$3a121ccf49b435d4$export$83d89fbfd8236492 = "19.2.6";

});



parcelRegister("dflA0", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $lNqgI = parcelRequire("lNqgI");
function $9a4d6a57aaaab11e$var$emptyFunction() {}
function $9a4d6a57aaaab11e$var$emptyFunctionWithReset() {}
$9a4d6a57aaaab11e$var$emptyFunctionWithReset.resetWarningCache = $9a4d6a57aaaab11e$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $lNqgI) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $9a4d6a57aaaab11e$var$emptyFunctionWithReset,
        resetWarningCache: $9a4d6a57aaaab11e$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("lNqgI", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $fde28cfe61c36500$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $fde28cfe61c36500$var$ReactPropTypesSecret;

});


var $f0ae0fbdb7754737$exports = {};
'use strict';

$f0ae0fbdb7754737$exports = (parcelRequire("j4DCz"));


parcelRequire("5iwRF");
var $3b466bc134990405$exports = {};
'use strict';
function $3b466bc134990405$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($3b466bc134990405$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$3b466bc134990405$var$checkDCE();

$3b466bc134990405$exports = (parcelRequire("7N7uP"));


/**
 * react-router v7.15.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $5iwRF = parcelRequire("5iwRF");
var $6fd199a57804d61d$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/.pnpm/react-router@7.15.1_react-dom@19.2.6_react@19.2.6/node_modules/react-router/dist/development/chunk-4N6VE7H7.mjs"
});
var $6fd199a57804d61d$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $6fd199a57804d61d$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $6fd199a57804d61d$var$__typeError("Cannot " + msg);
var $6fd199a57804d61d$var$__privateGet = (obj, member, getter)=>($6fd199a57804d61d$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $6fd199a57804d61d$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $6fd199a57804d61d$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var $6fd199a57804d61d$var$__privateSet = (obj, member, value, setter)=>($6fd199a57804d61d$var$__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
// lib/router/history.ts
var $6fd199a57804d61d$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($6fd199a57804d61d$export$e19cd5f9376f8cee || {});
var $6fd199a57804d61d$var$PopStateEventType = "popstate";
function $6fd199a57804d61d$var$isLocation(obj) {
    return typeof obj === "object" && obj != null && "pathname" in obj && "search" in obj && "hash" in obj && "state" in obj && "key" in obj;
}
function $6fd199a57804d61d$export$2b76ad033c6e6d08(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0, typeof entry === "string" ? void 0 : entry.mask));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key, mask) {
        let location = $6fd199a57804d61d$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key, mask);
        $6fd199a57804d61d$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $6fd199a57804d61d$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $6fd199a57804d61d$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = $6fd199a57804d61d$var$isLocation(to) ? to : createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = $6fd199a57804d61d$var$isLocation(to) ? to : createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $6fd199a57804d61d$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let maskedLocation = globalHistory.state?.masked;
        let { pathname: pathname, search: search, hash: hash } = maskedLocation || window2.location;
        return $6fd199a57804d61d$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default", maskedLocation ? {
            pathname: window2.location.pathname,
            search: window2.location.search,
            hash: window2.location.hash
        } : void 0);
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $6fd199a57804d61d$export$fe53371bee54353d(to);
    }
    return $6fd199a57804d61d$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $6fd199a57804d61d$export$b71fdd3798280242(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $6fd199a57804d61d$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $6fd199a57804d61d$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $6fd199a57804d61d$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $6fd199a57804d61d$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $6fd199a57804d61d$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $6fd199a57804d61d$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $6fd199a57804d61d$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $6fd199a57804d61d$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $6fd199a57804d61d$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index,
        masked: location.mask ? {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash
        } : void 0
    };
}
function $6fd199a57804d61d$var$createLocation(current, to, state = null, key, mask) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $6fd199a57804d61d$export$8ccf933b0513f8d0(to) : to,
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $6fd199a57804d61d$var$createKey(),
        mask: mask
    };
    return location;
}
function $6fd199a57804d61d$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $6fd199a57804d61d$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $6fd199a57804d61d$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $6fd199a57804d61d$var$isLocation(to) ? to : $6fd199a57804d61d$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $6fd199a57804d61d$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $6fd199a57804d61d$var$isLocation(to) ? to : $6fd199a57804d61d$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $6fd199a57804d61d$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $6fd199a57804d61d$var$createBrowserURLImpl(to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($6fd199a57804d61d$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($6fd199a57804d61d$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $6fd199a57804d61d$var$createBrowserURLImpl(to, isAbsolute = false) {
    let base = "http://localhost";
    if (typeof window !== "undefined") base = window.location.origin !== "null" ? window.location.origin : window.location.href;
    $6fd199a57804d61d$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $6fd199a57804d61d$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && href.startsWith("//")) href = base + href;
    return new URL(href, base);
}
// lib/router/utils.ts
function $6fd199a57804d61d$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
var $6fd199a57804d61d$var$_map;
var $6fd199a57804d61d$export$b8d3e69d4b3eff04 = class {
    /**
   * Create a new `RouterContextProvider` instance
   * @param init An optional initial context map to populate the provider with
   */ constructor(init){
        $6fd199a57804d61d$var$__privateAdd(this, $6fd199a57804d61d$var$_map, /* @__PURE__ */ new Map());
        if (init) for (let [context, value] of init)this.set(context, value);
    }
    /**
   * Access a value from the context. If no value has been set for the context,
   * it will return the context's `defaultValue` if provided, or throw an error
   * if no `defaultValue` was set.
   * @param context The context to get the value for
   * @returns The value for the context, or the context's `defaultValue` if no
   * value was set
   */ get(context) {
        if ($6fd199a57804d61d$var$__privateGet(this, $6fd199a57804d61d$var$_map).has(context)) return $6fd199a57804d61d$var$__privateGet(this, $6fd199a57804d61d$var$_map).get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
   * Set a value for the context. If the context already has a value set, this
   * will overwrite it.
   *
   * @param context The context to set the value for
   * @param value The value to set for the context
   * @returns {void}
   */ set(context, value) {
        $6fd199a57804d61d$var$__privateGet(this, $6fd199a57804d61d$var$_map).set(context, value);
    }
};
$6fd199a57804d61d$var$_map = new WeakMap();
var $6fd199a57804d61d$var$unsupportedLazyRouteObjectKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $6fd199a57804d61d$var$isUnsupportedLazyRouteObjectKey(key) {
    return $6fd199a57804d61d$var$unsupportedLazyRouteObjectKeys.has(key);
}
var $6fd199a57804d61d$var$unsupportedLazyRouteFunctionKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children"
]);
function $6fd199a57804d61d$var$isUnsupportedLazyRouteFunctionKey(key) {
    return $6fd199a57804d61d$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $6fd199a57804d61d$var$isIndexRoute(route) {
    return route.index === true;
}
function $6fd199a57804d61d$export$87cb1a9238dc3fba(routes, mapRouteProperties2, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $6fd199a57804d61d$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $6fd199a57804d61d$export$f5708dca728d7177(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($6fd199a57804d61d$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                id: id
            };
            manifest[id] = $6fd199a57804d61d$var$mergeRouteUpdates(indexRoute, mapRouteProperties2(indexRoute));
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                id: id,
                children: void 0
            };
            manifest[id] = $6fd199a57804d61d$var$mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties2(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = $6fd199a57804d61d$export$87cb1a9238dc3fba(route.children, mapRouteProperties2, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $6fd199a57804d61d$var$mergeRouteUpdates(route, updates) {
    return Object.assign(route, {
        ...updates,
        ...typeof updates.lazy === "object" && updates.lazy != null ? {
            lazy: {
                ...route.lazy,
                ...updates.lazy
            }
        } : {}
    });
}
function $6fd199a57804d61d$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $6fd199a57804d61d$export$5c7b09132f833c25(routes, locationArg, basename, false);
}
function $6fd199a57804d61d$export$5c7b09132f833c25(routes, locationArg, basename, allowPartial, precomputedBranches) {
    let location = typeof locationArg === "string" ? $6fd199a57804d61d$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $6fd199a57804d61d$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = precomputedBranches ?? $6fd199a57804d61d$var$flattenAndRankRoutes(routes);
    let matches = null;
    let decoded = $6fd199a57804d61d$var$decodePath(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $6fd199a57804d61d$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $6fd199a57804d61d$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $6fd199a57804d61d$var$flattenAndRankRoutes(routes) {
    let branches = $6fd199a57804d61d$var$flattenRoutes(routes);
    $6fd199a57804d61d$var$rankRouteBranches(branches);
    return branches;
}
function $6fd199a57804d61d$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            $6fd199a57804d61d$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $6fd199a57804d61d$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $6fd199a57804d61d$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $6fd199a57804d61d$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $6fd199a57804d61d$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $6fd199a57804d61d$var$explodeOptionalSegments(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $6fd199a57804d61d$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $6fd199a57804d61d$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $6fd199a57804d61d$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $6fd199a57804d61d$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $6fd199a57804d61d$var$paramRe = /^:[\w-]+$/;
var $6fd199a57804d61d$var$dynamicSegmentValue = 3;
var $6fd199a57804d61d$var$indexRouteValue = 2;
var $6fd199a57804d61d$var$emptySegmentValue = 1;
var $6fd199a57804d61d$var$staticSegmentValue = 10;
var $6fd199a57804d61d$var$splatPenalty = -2;
var $6fd199a57804d61d$var$isSplat = (s)=>s === "*";
function $6fd199a57804d61d$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($6fd199a57804d61d$var$isSplat)) initialScore += $6fd199a57804d61d$var$splatPenalty;
    if (index) initialScore += $6fd199a57804d61d$var$indexRouteValue;
    return segments.filter((s)=>!$6fd199a57804d61d$var$isSplat(s)).reduce((score, segment)=>score + ($6fd199a57804d61d$var$paramRe.test(segment) ? $6fd199a57804d61d$var$dynamicSegmentValue : segment === "" ? $6fd199a57804d61d$var$emptySegmentValue : $6fd199a57804d61d$var$staticSegmentValue), initialScore);
}
function $6fd199a57804d61d$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $6fd199a57804d61d$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $6fd199a57804d61d$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $6fd199a57804d61d$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $6fd199a57804d61d$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $6fd199a57804d61d$var$normalizePathname($6fd199a57804d61d$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $6fd199a57804d61d$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $6fd199a57804d61d$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $6fd199a57804d61d$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify2 = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") return stringify2(params["*"]);
        const keyMatch = segment.match(/^:([\w-]+)(\??)(.*)/);
        if (keyMatch) {
            const [, key, optional, suffix] = keyMatch;
            let param = params[key];
            $6fd199a57804d61d$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return encodeURIComponent(stringify2(param)) + suffix;
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $6fd199a57804d61d$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $6fd199a57804d61d$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $6fd199a57804d61d$var$compilePath(path, caseSensitive = false, end = true) {
    $6fd199a57804d61d$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (match, paramName, isOptional, index, str)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        if (isOptional) {
            let nextChar = str.charAt(index + match.length);
            if (nextChar && nextChar !== "/") return "/([^\\/]*)";
            return "(?:/([^\\/]*))?";
        }
        return "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $6fd199a57804d61d$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $6fd199a57804d61d$var$warning(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $6fd199a57804d61d$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $6fd199a57804d61d$var$prependBasename({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $6fd199a57804d61d$var$joinPaths([
        basename,
        pathname
    ]);
}
var $6fd199a57804d61d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $6fd199a57804d61d$var$isAbsoluteUrl = (url)=>$6fd199a57804d61d$var$ABSOLUTE_URL_REGEX.test(url);
function $6fd199a57804d61d$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $6fd199a57804d61d$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = $6fd199a57804d61d$var$removeDoubleSlashes(toPathname);
        if (toPathname.startsWith("/")) pathname = $6fd199a57804d61d$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $6fd199a57804d61d$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $6fd199a57804d61d$var$normalizeSearch(search),
        hash: $6fd199a57804d61d$var$normalizeHash(hash)
    };
}
function $6fd199a57804d61d$var$resolvePathname(relativePath, fromPathname) {
    let segments = $6fd199a57804d61d$var$removeTrailingSlash(fromPathname).split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $6fd199a57804d61d$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $6fd199a57804d61d$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $6fd199a57804d61d$var$getResolveToMatches(matches) {
    let pathMatches = $6fd199a57804d61d$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $6fd199a57804d61d$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $6fd199a57804d61d$export$8ccf933b0513f8d0(toArg);
    else {
        to = {
            ...toArg
        };
        $6fd199a57804d61d$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $6fd199a57804d61d$var$getInvalidPathError("?", "pathname", "search", to));
        $6fd199a57804d61d$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $6fd199a57804d61d$var$getInvalidPathError("#", "pathname", "hash", to));
        $6fd199a57804d61d$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $6fd199a57804d61d$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $6fd199a57804d61d$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $6fd199a57804d61d$var$removeDoubleSlashes = (path)=>path.replace(/\/\/+/g, "/");
var $6fd199a57804d61d$var$joinPaths = (paths)=>$6fd199a57804d61d$var$removeDoubleSlashes(paths.join("/"));
var $6fd199a57804d61d$var$removeTrailingSlash = (path)=>path.replace(/\/+$/, "");
var $6fd199a57804d61d$var$normalizePathname = (pathname)=>$6fd199a57804d61d$var$removeTrailingSlash(pathname).replace(/^\/*/, "/");
var $6fd199a57804d61d$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $6fd199a57804d61d$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $6fd199a57804d61d$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $6fd199a57804d61d$export$4051a07651545597(data2, init) {
    return new $6fd199a57804d61d$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $6fd199a57804d61d$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
var $6fd199a57804d61d$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $6fd199a57804d61d$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $6fd199a57804d61d$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $6fd199a57804d61d$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $6fd199a57804d61d$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $6fd199a57804d61d$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function $6fd199a57804d61d$var$getRoutePattern(matches) {
    let parts = matches.map((m)=>m.route.path).filter(Boolean);
    return $6fd199a57804d61d$var$joinPaths(parts) || "/";
}
var $6fd199a57804d61d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function $6fd199a57804d61d$var$parseToInfo(_to, basename) {
    let to = _to;
    if (typeof to !== "string" || !$6fd199a57804d61d$var$ABSOLUTE_URL_REGEX.test(to)) return {
        absoluteURL: void 0,
        isExternal: false,
        to: to
    };
    let absoluteURL = to;
    let isExternal = false;
    if ($6fd199a57804d61d$var$isBrowser) try {
        let currentUrl = new URL(window.location.href);
        let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
        let path = $6fd199a57804d61d$export$b69e3301ce081aa3(targetUrl.pathname, basename);
        if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
        else isExternal = true;
    } catch (e) {
        $6fd199a57804d61d$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
    }
    return {
        absoluteURL: absoluteURL,
        isExternal: isExternal,
        to: to
    };
}
// lib/router/instrumentation.ts
var $6fd199a57804d61d$var$UninstrumentedSymbol = Symbol("Uninstrumented");
function $6fd199a57804d61d$var$getRouteInstrumentationUpdates(fns, route) {
    let aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach((fn)=>fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument (i) {
                let keys = Object.keys(aggregated);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        let instrumented = $6fd199a57804d61d$var$wrapImpl(aggregated.lazy, route.lazy, ()=>void 0);
        if (instrumented) updates.lazy = instrumented;
    }
    if (typeof route.lazy === "object") {
        let lazyObject = route.lazy;
        [
            "middleware",
            "loader",
            "action"
        ].forEach((key)=>{
            let lazyFn = lazyObject[key];
            let instrumentations = aggregated[`lazy.${key}`];
            if (typeof lazyFn === "function" && instrumentations.length > 0) {
                let instrumented = $6fd199a57804d61d$var$wrapImpl(instrumentations, lazyFn, ()=>void 0);
                if (instrumented) updates.lazy = Object.assign(updates.lazy || {}, {
                    [key]: instrumented
                });
            }
        });
    }
    [
        "loader",
        "action"
    ].forEach((key)=>{
        let handler = route[key];
        if (typeof handler === "function" && aggregated[key].length > 0) {
            let original = handler[$6fd199a57804d61d$var$UninstrumentedSymbol] ?? handler;
            let instrumented = $6fd199a57804d61d$var$wrapImpl(aggregated[key], original, (...args)=>$6fd199a57804d61d$var$getHandlerInfo(args[0]));
            if (instrumented) {
                if (key === "loader" && original.hydrate === true) instrumented.hydrate = true;
                instrumented[$6fd199a57804d61d$var$UninstrumentedSymbol] = original;
                updates[key] = instrumented;
            }
        }
    });
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map((middleware)=>{
        let original = middleware[$6fd199a57804d61d$var$UninstrumentedSymbol] ?? middleware;
        let instrumented = $6fd199a57804d61d$var$wrapImpl(aggregated.middleware, original, (...args)=>$6fd199a57804d61d$var$getHandlerInfo(args[0]));
        if (instrumented) {
            instrumented[$6fd199a57804d61d$var$UninstrumentedSymbol] = original;
            return instrumented;
        }
        return middleware;
    });
    return updates;
}
function $6fd199a57804d61d$var$instrumentClientSideRouter(router, fns) {
    let aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    if (aggregated.navigate.length > 0) {
        let navigate = router.navigate[$6fd199a57804d61d$var$UninstrumentedSymbol] ?? router.navigate;
        let instrumentedNavigate = $6fd199a57804d61d$var$wrapImpl(aggregated.navigate, navigate, (...args)=>{
            let [to, opts] = args;
            return {
                to: typeof to === "number" || typeof to === "string" ? to : to ? $6fd199a57804d61d$export$fe53371bee54353d(to) : ".",
                ...$6fd199a57804d61d$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedNavigate) {
            instrumentedNavigate[$6fd199a57804d61d$var$UninstrumentedSymbol] = navigate;
            router.navigate = instrumentedNavigate;
        }
    }
    if (aggregated.fetch.length > 0) {
        let fetch2 = router.fetch[$6fd199a57804d61d$var$UninstrumentedSymbol] ?? router.fetch;
        let instrumentedFetch = $6fd199a57804d61d$var$wrapImpl(aggregated.fetch, fetch2, (...args)=>{
            let [key, , href, opts] = args;
            return {
                href: href ?? ".",
                fetcherKey: key,
                ...$6fd199a57804d61d$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedFetch) {
            instrumentedFetch[$6fd199a57804d61d$var$UninstrumentedSymbol] = fetch2;
            router.fetch = instrumentedFetch;
        }
    }
    return router;
}
function $6fd199a57804d61d$export$8f7a8e481272777(handler, fns) {
    let aggregated = {
        request: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = $6fd199a57804d61d$var$wrapImpl(aggregated.request, handler, (...args)=>{
        let [request, context] = args;
        return {
            request: $6fd199a57804d61d$var$getReadonlyRequest(request),
            context: context != null ? $6fd199a57804d61d$var$getReadonlyContext(context) : context
        };
    });
    return instrumentedHandler;
}
function $6fd199a57804d61d$var$wrapImpl(impls, handler, getInfo) {
    if (impls.length === 0) return null;
    return async (...args)=>{
        let result = await $6fd199a57804d61d$var$recurseRight(impls, getInfo(...args), ()=>handler(...args), impls.length - 1);
        if (result.type === "error") throw result.value;
        return result.value;
    };
}
async function $6fd199a57804d61d$var$recurseRight(impls, info, handler, index) {
    let impl = impls[index];
    let result;
    if (!impl) try {
        let value = await handler();
        result = {
            type: "success",
            value: value
        };
    } catch (e) {
        result = {
            type: "error",
            value: e
        };
    }
    else {
        let handlerPromise = void 0;
        let callHandler = async ()=>{
            if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
            else handlerPromise = $6fd199a57804d61d$var$recurseRight(impls, info, handler, index - 1);
            result = await handlerPromise;
            $6fd199a57804d61d$export$f5708dca728d7177(result, "Expected a result");
            if (result.type === "error" && result.value instanceof Error) return {
                status: "error",
                error: result.value
            };
            return {
                status: "success",
                error: void 0
            };
        };
        try {
            await impl(callHandler, info);
        } catch (e) {
            console.error("An instrumentation function threw an error:", e);
        }
        if (!handlerPromise) await callHandler();
        await handlerPromise;
    }
    if (result) return result;
    return {
        type: "error",
        value: new Error("No result assigned in instrumentation chain.")
    };
}
function $6fd199a57804d61d$var$getHandlerInfo(args) {
    let { request: request, context: context, params: params, pattern: pattern } = args;
    return {
        request: $6fd199a57804d61d$var$getReadonlyRequest(request),
        params: {
            ...params
        },
        pattern: pattern,
        context: $6fd199a57804d61d$var$getReadonlyContext(context)
    };
}
function $6fd199a57804d61d$var$getRouterInfo(router, opts) {
    return {
        currentUrl: $6fd199a57804d61d$export$fe53371bee54353d(router.state.location),
        ..."formMethod" in opts ? {
            formMethod: opts.formMethod
        } : {},
        ..."formEncType" in opts ? {
            formEncType: opts.formEncType
        } : {},
        ..."formData" in opts ? {
            formData: opts.formData
        } : {},
        ..."body" in opts ? {
            body: opts.body
        } : {}
    };
}
function $6fd199a57804d61d$var$getReadonlyRequest(request) {
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: (...args)=>request.headers.get(...args)
        }
    };
}
function $6fd199a57804d61d$var$getReadonlyContext(context) {
    if ($6fd199a57804d61d$var$isPlainObject(context)) {
        let frozen = {
            ...context
        };
        Object.freeze(frozen);
        return frozen;
    } else return {
        get: (ctx)=>context.get(ctx)
    };
}
var $6fd199a57804d61d$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $6fd199a57804d61d$var$isPlainObject(thing) {
    if (thing === null || typeof thing !== "object") return false;
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $6fd199a57804d61d$var$objectProtoNames;
}
// lib/router/router.ts
var $6fd199a57804d61d$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $6fd199a57804d61d$var$validMutationMethods = new Set($6fd199a57804d61d$var$validMutationMethodsArr);
var $6fd199a57804d61d$var$validRequestMethodsArr = [
    "GET",
    ...$6fd199a57804d61d$var$validMutationMethodsArr
];
var $6fd199a57804d61d$var$validRequestMethods = new Set($6fd199a57804d61d$var$validRequestMethodsArr);
var $6fd199a57804d61d$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $6fd199a57804d61d$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $6fd199a57804d61d$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    matches: void 0,
    historyAction: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $6fd199a57804d61d$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $6fd199a57804d61d$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $6fd199a57804d61d$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $6fd199a57804d61d$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $6fd199a57804d61d$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
var $6fd199a57804d61d$var$_routes, $6fd199a57804d61d$var$_branches, $6fd199a57804d61d$var$_hmrRoutes, $6fd199a57804d61d$var$_hmrBranches;
var $6fd199a57804d61d$var$DataRoutes = class {
    constructor(routes){
        $6fd199a57804d61d$var$__privateAdd(this, $6fd199a57804d61d$var$_routes);
        $6fd199a57804d61d$var$__privateAdd(this, $6fd199a57804d61d$var$_branches);
        $6fd199a57804d61d$var$__privateAdd(this, $6fd199a57804d61d$var$_hmrRoutes);
        $6fd199a57804d61d$var$__privateAdd(this, $6fd199a57804d61d$var$_hmrBranches);
        $6fd199a57804d61d$var$__privateSet(this, $6fd199a57804d61d$var$_routes, routes);
        $6fd199a57804d61d$var$__privateSet(this, $6fd199a57804d61d$var$_branches, $6fd199a57804d61d$var$flattenAndRankRoutes(routes));
    }
    /** The stable route tree */ get stableRoutes() {
        return $6fd199a57804d61d$var$__privateGet(this, $6fd199a57804d61d$var$_routes);
    }
    /** The in-flight route tree if one is active, otherwise the stable tree */ get activeRoutes() {
        return $6fd199a57804d61d$var$__privateGet(this, $6fd199a57804d61d$var$_hmrRoutes) ?? $6fd199a57804d61d$var$__privateGet(this, $6fd199a57804d61d$var$_routes);
    }
    /** Pre-computed branches */ get branches() {
        return $6fd199a57804d61d$var$__privateGet(this, $6fd199a57804d61d$var$_hmrBranches) ?? $6fd199a57804d61d$var$__privateGet(this, $6fd199a57804d61d$var$_branches);
    }
    get hasHMRRoutes() {
        return $6fd199a57804d61d$var$__privateGet(this, $6fd199a57804d61d$var$_hmrRoutes) != null;
    }
    /** Replace the stable route tree and recompute its branches */ setRoutes(routes) {
        $6fd199a57804d61d$var$__privateSet(this, $6fd199a57804d61d$var$_routes, routes);
        $6fd199a57804d61d$var$__privateSet(this, $6fd199a57804d61d$var$_branches, $6fd199a57804d61d$var$flattenAndRankRoutes(routes));
    }
    /** Set a new in-flight route tree and recompute its branches */ setHmrRoutes(routes) {
        $6fd199a57804d61d$var$__privateSet(this, $6fd199a57804d61d$var$_hmrRoutes, routes);
        $6fd199a57804d61d$var$__privateSet(this, $6fd199a57804d61d$var$_hmrBranches, $6fd199a57804d61d$var$flattenAndRankRoutes(routes));
    }
    /** Commit in-flight routes/branches to the stable slot and clear in-flight */ commitHmrRoutes() {
        if ($6fd199a57804d61d$var$__privateGet(this, $6fd199a57804d61d$var$_hmrRoutes)) {
            $6fd199a57804d61d$var$__privateSet(this, $6fd199a57804d61d$var$_routes, $6fd199a57804d61d$var$__privateGet(this, $6fd199a57804d61d$var$_hmrRoutes));
            $6fd199a57804d61d$var$__privateSet(this, $6fd199a57804d61d$var$_branches, $6fd199a57804d61d$var$__privateGet(this, $6fd199a57804d61d$var$_hmrBranches));
            $6fd199a57804d61d$var$__privateSet(this, $6fd199a57804d61d$var$_hmrRoutes, void 0);
            $6fd199a57804d61d$var$__privateSet(this, $6fd199a57804d61d$var$_hmrBranches, void 0);
        }
    }
};
$6fd199a57804d61d$var$_routes = new WeakMap();
$6fd199a57804d61d$var$_branches = new WeakMap();
$6fd199a57804d61d$var$_hmrRoutes = new WeakMap();
$6fd199a57804d61d$var$_hmrBranches = new WeakMap();
function $6fd199a57804d61d$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser3 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $6fd199a57804d61d$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties2 = init.hydrationRouteProperties || [];
    let _mapRouteProperties = init.mapRouteProperties || $6fd199a57804d61d$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (init.instrumentations) {
        let instrumentations = init.instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$6fd199a57804d61d$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let manifest = {};
    let dataRoutes = new $6fd199a57804d61d$var$DataRoutes($6fd199a57804d61d$export$87cb1a9238dc3fba(init.routes, mapRouteProperties2, void 0, manifest));
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataStrategyImpl = init.dataStrategy || $6fd199a57804d61d$var$defaultDataStrategyWithMiddleware;
    let future = {
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let bufferedInitialStateUpdate = null;
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $6fd199a57804d61d$export$5c7b09132f833c25(dataRoutes.activeRoutes, init.history.location, basename, false, dataRoutes.branches);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    let renderFallback;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $6fd199a57804d61d$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $6fd199a57804d61d$var$getShortCircuitMatches(dataRoutes.activeRoutes);
        initialized = true;
        renderFallback = !initialized;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            let fogOfWar = checkFogOfWar(initialMatches, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            renderFallback = !initialized;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) {
            initialized = false;
            renderFallback = !initialized;
        } else if (!initialMatches.some((m)=>$6fd199a57804d61d$var$routeHasLoaderOrMiddleware(m.route))) {
            initialized = true;
            renderFallback = !initialized;
        } else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            let relevantMatches = initialMatches;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                relevantMatches = relevantMatches.slice(0, idx + 1);
            }
            renderFallback = false;
            initialized = true;
            relevantMatches.forEach((m)=>{
                let status = $6fd199a57804d61d$var$getRouteHydrationStatus(m.route, loaderData, errors);
                renderFallback = renderFallback || status.renderFallback;
                initialized = initialized && !status.shouldLoad;
            });
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        renderFallback: renderFallback,
        navigation: $6fd199a57804d61d$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPopstateNavigationDfd = null;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $6fd199a57804d61d$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $6fd199a57804d61d$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd?.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser3) {
            $6fd199a57804d61d$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$6fd199a57804d61d$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(state.fetchers, key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        if (bufferedInitialStateUpdate) {
            let { newErrors: newErrors } = bufferedInitialStateUpdate;
            bufferedInitialStateUpdate = null;
            fn(state, {
                deletedFetchers: [],
                newErrors: newErrors,
                viewTransitionOpts: void 0,
                flushSync: false
            });
        }
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        if (subscribers.size === 0) bufferedInitialStateUpdate = {
            newErrors: newState.errors ?? null
        };
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: newState.errors ?? null,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(state.fetchers, key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $6fd199a57804d61d$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $6fd199a57804d61d$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $6fd199a57804d61d$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $6fd199a57804d61d$export$cbae47800eb95bc3(state.navigation.formMethod) && location.state?._isRedirect !== true;
        dataRoutes.commitHmrRoutes();
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */ ) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            renderFallback: false,
            navigation: $6fd199a57804d61d$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        if (typeof to === "number") {
            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = $6fd199a57804d61d$var$createDeferred();
            let promise = pendingPopstateNavigationDfd.promise;
            init.history.go(to);
            return promise;
        }
        let normalizedPath = $6fd199a57804d61d$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative);
        let { path: path, submission: submission, error: error } = $6fd199a57804d61d$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let maskPath;
        if (opts?.mask) {
            let partialPath = typeof opts.mask === "string" ? $6fd199a57804d61d$export$8ccf933b0513f8d0(opts.mask) : {
                ...state.location.mask,
                ...opts.mask
            };
            maskPath = {
                pathname: "",
                search: "",
                hash: "",
                ...partialPath
            };
        }
        let currentLocation = state.location;
        let nextLocation = $6fd199a57804d61d$var$createLocation(currentLocation, path, opts && opts.state, void 0, maskPath);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $6fd199a57804d61d$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $6fd199a57804d61d$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync,
            callSiteDefaultShouldRevalidate: opts && opts.defaultShouldRevalidate
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $6fd199a57804d61d$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $6fd199a57804d61d$export$5c7b09132f833c25(routesToUse, location, basename, false, dataRoutes.branches);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $6fd199a57804d61d$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $6fd199a57804d61d$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        let loadingNavigation = opts && opts.overrideNavigation ? {
            ...opts.overrideNavigation,
            matches: matches,
            historyAction: historyAction
        } : void 0;
        pendingNavigationController = new AbortController();
        let request = $6fd199a57804d61d$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = init.getContext ? await init.getContext() : new $6fd199a57804d61d$export$b8d3e69d4b3eff04();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $6fd199a57804d61d$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $6fd199a57804d61d$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, historyAction, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($6fd199a57804d61d$var$isErrorResult(result) && $6fd199a57804d61d$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $6fd199a57804d61d$var$getLoadingNavigation(location, matches, historyAction, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $6fd199a57804d61d$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors, workingFetchers: workingFetchers } = await handleLoaders(request, location, matches, historyAction, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult, opts && opts.callSiteDefaultShouldRevalidate);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$6fd199a57804d61d$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors,
            ...workingFetchers ? {
                fetchers: workingFetchers
            } : {}
        });
    }
    async function handleAction(request, location, submission, matches, historyAction, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        let navigation = $6fd199a57804d61d$var$getSubmittingNavigation(location, matches, historyAction, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $6fd199a57804d61d$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches2,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error" /* error */ ,
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $6fd199a57804d61d$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $6fd199a57804d61d$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $6fd199a57804d61d$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let dsMatches = $6fd199a57804d61d$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties2, scopedContext);
            let results = await callDataStrategy(request, location, dsMatches, scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($6fd199a57804d61d$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $6fd199a57804d61d$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($6fd199a57804d61d$var$isErrorResult(result)) {
            let boundaryMatch = $6fd199a57804d61d$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, historyAction, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult, callSiteDefaultShouldRevalidate) {
        let loadingNavigation = overrideNavigation || $6fd199a57804d61d$var$getLoadingNavigation(location, matches, historyAction, submission);
        let activeSubmission = submission || fetcherSubmission || $6fd199a57804d61d$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $6fd199a57804d61d$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches2,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $6fd199a57804d61d$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = dataRoutes.activeRoutes;
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $6fd199a57804d61d$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties2, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, pendingActionResult, callSiteDefaultShouldRevalidate);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let workingFetchers2 = new Map(state.fetchers);
            let didUpdateFetcherRedirects2 = markFetchRedirectsDone(workingFetchers2);
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $6fd199a57804d61d$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$6fd199a57804d61d$var$getActionDataForCommit(pendingActionResult),
                ...didUpdateFetcherRedirects2 ? {
                    fetchers: workingFetchers2
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, location, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $6fd199a57804d61d$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $6fd199a57804d61d$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let workingFetchers = new Map(state.fetchers);
        let { loaderData: loaderData, errors: errors } = $6fd199a57804d61d$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let didUpdateFetcherRedirects = markFetchRedirectsDone(workingFetchers);
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId, workingFetchers);
        let shouldUpdateFetchers = didUpdateFetcherRedirects || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                workingFetchers: workingFetchers
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$6fd199a57804d61d$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        let workingFetchers = new Map(state.fetchers);
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = workingFetchers.get(rf.key);
            let revalidatingFetcher = $6fd199a57804d61d$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            workingFetchers.set(rf.key, revalidatingFetcher);
        });
        return workingFetchers;
    }
    async function fetch2(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let normalizedPath = $6fd199a57804d61d$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = $6fd199a57804d61d$export$5c7b09132f833c25(routesToUse, normalizedPath, basename, false, dataRoutes.branches);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $6fd199a57804d61d$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $6fd199a57804d61d$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new $6fd199a57804d61d$export$b8d3e69d4b3eff04();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $6fd199a57804d61d$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission, opts && opts.defaultShouldRevalidate);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission, callSiteDefaultShouldRevalidate) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $6fd199a57804d61d$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $6fd199a57804d61d$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $6fd199a57804d61d$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $6fd199a57804d61d$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            let error = $6fd199a57804d61d$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $6fd199a57804d61d$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, requestMatches, match, hydrationRouteProperties2, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, path, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (!actionResult) {
            for (let match2 of fetchMatches)if (actionResults[match2.route.id]) {
                actionResult = actionResults[match2.route.id];
                break;
            }
        }
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($6fd199a57804d61d$var$isRedirectResult(actionResult) || $6fd199a57804d61d$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $6fd199a57804d61d$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($6fd199a57804d61d$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $6fd199a57804d61d$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $6fd199a57804d61d$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($6fd199a57804d61d$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $6fd199a57804d61d$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = dataRoutes.activeRoutes;
        let matches = state.navigation.state !== "idle" ? $6fd199a57804d61d$export$5c7b09132f833c25(routesToUse, state.navigation.location, basename, false, dataRoutes.branches) : state.matches;
        $6fd199a57804d61d$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $6fd199a57804d61d$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties2, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, [
            match.route.id,
            actionResult
        ], callSiteDefaultShouldRevalidate);
        let loadFetcher = $6fd199a57804d61d$var$getLoadingFetcher(submission, actionResult.data);
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, loadFetcher);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = workingFetchers.get(staleKey);
            let revalidatingFetcher = $6fd199a57804d61d$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            workingFetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: workingFetchers
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, nextLocation, scopedContext);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let fetcherIsMounted = state.fetchers.has(key);
        let getRedirectStateWithDoneFetcher = (s)=>{
            if (!fetcherIsMounted) return s;
            let workingFetchers2 = new Map(s.fetchers);
            workingFetchers2.set(key, $6fd199a57804d61d$var$getDoneFetcher(actionResult.data));
            return {
                ...s,
                fetchers: workingFetchers2
            };
        };
        let redirect2 = $6fd199a57804d61d$var$findRedirect(loaderResults);
        if (redirect2) {
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        redirect2 = $6fd199a57804d61d$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let finalFetchers = new Map(state.fetchers);
        if (fetcherIsMounted) finalFetchers.set(key, $6fd199a57804d61d$var$getDoneFetcher(actionResult.data));
        let { loaderData: loaderData, errors: errors } = $6fd199a57804d61d$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults, finalFetchers);
        abortStaleFetchLoads(loadId, finalFetchers);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $6fd199a57804d61d$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: finalFetchers
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $6fd199a57804d61d$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: finalFetchers
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $6fd199a57804d61d$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $6fd199a57804d61d$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $6fd199a57804d61d$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else matches = discoverResult.matches;
        }
        let match = $6fd199a57804d61d$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let dsMatches = $6fd199a57804d61d$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, matches, match, hydrationRouteProperties2, scopedContext);
        let results = await callDataStrategy(fetchRequest, path, dsMatches, scopedContext, key);
        let result = results[match.route.id];
        if (!result) {
            for (let match2 of matches)if (results[match2.route.id]) {
                result = results[match2.route.id];
                break;
            }
        }
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $6fd199a57804d61d$var$getDoneFetcher(void 0));
            return;
        }
        if ($6fd199a57804d61d$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $6fd199a57804d61d$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($6fd199a57804d61d$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $6fd199a57804d61d$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (!isNavigation) {
            pendingPopstateNavigationDfd?.resolve();
            pendingPopstateNavigationDfd = null;
        }
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $6fd199a57804d61d$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        location = $6fd199a57804d61d$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $6fd199a57804d61d$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser3) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($6fd199a57804d61d$var$isAbsoluteUrl(location)) {
                const url = $6fd199a57804d61d$var$createBrowserURLImpl(location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $6fd199a57804d61d$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $6fd199a57804d61d$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($6fd199a57804d61d$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $6fd199a57804d61d$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $6fd199a57804d61d$var$getLoadingNavigation(redirectLocation, [], redirectNavigationType, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(request, path, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $6fd199a57804d61d$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        if (!$6fd199a57804d61d$export$cbae47800eb95bc3(request.method)) for (let match of matches){
            if (results[match.route.id]?.type === "error" /* error */ ) break;
            if (!results.hasOwnProperty(match.route.id) && !state.loaderData.hasOwnProperty(match.route.id) && (!state.errors || !state.errors.hasOwnProperty(match.route.id)) && match.shouldCallHandler()) results[match.route.id] = {
                type: "error" /* error */ ,
                result: new Error(`No result returned from dataStrategy for route ${match.route.id}`)
            };
        }
        for (let [routeId, result] of Object.entries(results))if ($6fd199a57804d61d$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $6fd199a57804d61d$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $6fd199a57804d61d$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, location, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, location, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let results = await callDataStrategy(f.request, f.path, f.matches, scopedContext, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $6fd199a57804d61d$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, fetcher);
        updateState({
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $6fd199a57804d61d$var$findNearestBoundary(state.matches, routeId);
        let workingFetchers = new Map(state.fetchers);
        deleteFetcher(workingFetchers, key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $6fd199a57804d61d$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts?.reason);
        updateFetcherState(key, $6fd199a57804d61d$var$getDoneFetcher(null));
    }
    function deleteFetcher(fetchers, key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys, fetchers) {
        for (let key of keys){
            let fetcher = fetchers.get(key);
            $6fd199a57804d61d$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            let doneFetcher = $6fd199a57804d61d$var$getDoneFetcher(fetcher.data);
            fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone(fetchers) {
        let doneKeys = [];
        let didUpdateFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = fetchers.get(key);
            $6fd199a57804d61d$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                didUpdateFetchers = true;
            }
        }
        markFetchersDone(doneKeys, fetchers);
        return didUpdateFetchers;
    }
    function abortStaleFetchLoads(landedId, fetchers) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = fetchers.get(key);
            $6fd199a57804d61d$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys, fetchers);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $6fd199a57804d61d$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $6fd199a57804d61d$export$386d57f03f0b2883;
        $6fd199a57804d61d$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $6fd199a57804d61d$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $6fd199a57804d61d$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = dataRoutes.activeRoutes;
        let { matches: matches, route: route } = $6fd199a57804d61d$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $6fd199a57804d61d$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$6fd199a57804d61d$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            let activeBranches = dataRoutes.branches;
            if (!matches) {
                let fogMatches = $6fd199a57804d61d$export$5c7b09132f833c25(routesToUse, pathname, basename, true, activeBranches);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $6fd199a57804d61d$export$5c7b09132f833c25(routesToUse, pathname, basename, true, activeBranches);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $6fd199a57804d61d$var$patchRoutesImpl(routeId, children, dataRoutes, localManifest, mapRouteProperties2, false);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let activeBranches = dataRoutes.branches;
            let newMatches = $6fd199a57804d61d$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, false, activeBranches);
            let newPartialMatches = null;
            if (newMatches) {
                if (Object.keys(newMatches[0].params).length === 0) return {
                    type: "success",
                    matches: newMatches
                };
                else {
                    newPartialMatches = $6fd199a57804d61d$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
                    let matchedDeeper = newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length));
                    if (!matchedDeeper) return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            if (!newPartialMatches) newPartialMatches = $6fd199a57804d61d$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
            if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every((m, i)=>m.route.id === b[i].route.id);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        dataRoutes.setHmrRoutes($6fd199a57804d61d$export$87cb1a9238dc3fba(newRoutes, mapRouteProperties2, void 0, manifest));
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        $6fd199a57804d61d$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties2, unstable_allowElementMutations);
        if (!dataRoutes.hasHMRRoutes) updateState({});
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes.stableRoutes;
        },
        get branches () {
            return dataRoutes.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    if (init.instrumentations) router = $6fd199a57804d61d$var$instrumentClientSideRouter(router, init.instrumentations.map((i)=>i.router).filter(Boolean));
    return router;
}
function $6fd199a57804d61d$export$3336b097a6fbc59a(routes, opts) {
    $6fd199a57804d61d$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let _mapRouteProperties = opts?.mapRouteProperties || $6fd199a57804d61d$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    let future = {
        ...opts?.future
    };
    if (opts?.instrumentations) {
        let instrumentations = opts.instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$6fd199a57804d61d$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let dataRoutes = $6fd199a57804d61d$export$87cb1a9238dc3fba(routes, mapRouteProperties2, void 0, manifest);
    let routeBranches = $6fd199a57804d61d$var$flattenAndRankRoutes(dataRoutes);
    async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $6fd199a57804d61d$var$defaultNormalizePath;
        let method = request.method;
        let location = $6fd199a57804d61d$var$createLocation("", normalizePathImpl(request), null, "default");
        let matches = $6fd199a57804d61d$export$5c7b09132f833c25(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new $6fd199a57804d61d$export$b8d3e69d4b3eff04();
        if (!$6fd199a57804d61d$var$isValidMethod(method) && method !== "HEAD") {
            let error = $6fd199a57804d61d$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $6fd199a57804d61d$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $6fd199a57804d61d$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $6fd199a57804d61d$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            $6fd199a57804d61d$export$f5708dca728d7177(requestContext instanceof $6fd199a57804d61d$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $6fd199a57804d61d$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
                let renderedStaticContext;
                let response = await $6fd199a57804d61d$var$runServerMiddlewarePipeline({
                    request: request,
                    url: $6fd199a57804d61d$var$createDataFunctionUrl(request, location),
                    pattern: $6fd199a57804d61d$var$getRoutePattern(matches),
                    matches: matches,
                    params: matches[0].params,
                    // If we're calling middleware then it must be enabled so we can cast
                    // this to the proper type knowing it's not an `AppLoadContext`
                    context: requestContext
                }, async ()=>{
                    let res = await generateMiddlewareResponse(async (revalidationRequest, opts2 = {})=>{
                        let result2 = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts2 ? opts2.filterMatchesToLoad ?? null : filterMatchesToLoad ?? null, skipRevalidation === true);
                        if ($6fd199a57804d61d$export$3f1eb41d9a6a6a27(result2)) return result2;
                        renderedStaticContext = {
                            location: location,
                            basename: basename,
                            ...result2
                        };
                        return renderedStaticContext;
                    });
                    return res;
                }, async (error, routeId)=>{
                    if ($6fd199a57804d61d$export$6e80290866a84dd4(error)) return error;
                    if ($6fd199a57804d61d$export$3f1eb41d9a6a6a27(error)) try {
                        error = new $6fd199a57804d61d$export$f2680fa305b734ca(error.status, error.statusText, await $6fd199a57804d61d$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($6fd199a57804d61d$export$e0163cfdf7bc9cfa(error)) error = $6fd199a57804d61d$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $6fd199a57804d61d$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $6fd199a57804d61d$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        let boundaryRouteId = skipLoaderErrorBubbling ? routeId : $6fd199a57804d61d$var$findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id;
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [boundaryRouteId]: error
                            },
                            statusCode: $6fd199a57804d61d$export$972111febbeef05b(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {}
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                $6fd199a57804d61d$export$f5708dca728d7177($6fd199a57804d61d$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($6fd199a57804d61d$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($6fd199a57804d61d$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $6fd199a57804d61d$var$defaultNormalizePath;
        let method = request.method;
        let location = $6fd199a57804d61d$var$createLocation("", normalizePathImpl(request), null, "default");
        let matches = $6fd199a57804d61d$export$5c7b09132f833c25(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new $6fd199a57804d61d$export$b8d3e69d4b3eff04();
        if (!$6fd199a57804d61d$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $6fd199a57804d61d$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $6fd199a57804d61d$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $6fd199a57804d61d$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $6fd199a57804d61d$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $6fd199a57804d61d$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            $6fd199a57804d61d$export$f5708dca728d7177(requestContext instanceof $6fd199a57804d61d$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $6fd199a57804d61d$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
            let response = await $6fd199a57804d61d$var$runServerMiddlewarePipeline({
                request: request,
                url: $6fd199a57804d61d$var$createDataFunctionUrl(request, location),
                pattern: $6fd199a57804d61d$var$getRoutePattern(matches),
                matches: matches,
                params: matches[0].params,
                // If we're calling middleware then it must be enabled so we can cast
                // this to the proper type knowing it's not an `AppLoadContext`
                context: requestContext
            }, async ()=>{
                let res = await generateMiddlewareResponse(async (innerRequest)=>{
                    let result2 = await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false);
                    let processed = handleQueryResult(result2);
                    return $6fd199a57804d61d$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
                return res;
            }, (error)=>{
                if ($6fd199a57804d61d$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($6fd199a57804d61d$var$dataWithResponseInitToResponse(error));
                if ($6fd199a57804d61d$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
            return response;
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false);
        return handleQueryResult(result);
        function handleQueryResult(result2) {
            if ($6fd199a57804d61d$export$3f1eb41d9a6a6a27(result2)) return result2;
            let error = result2.errors ? Object.values(result2.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result2.actionData) return Object.values(result2.actionData)[0];
            if (result2.loaderData) return Object.values(result2.loaderData)[0];
            return void 0;
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        $6fd199a57804d61d$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($6fd199a57804d61d$export$cbae47800eb95bc3(request.method)) {
                let result2 = await submit(request, location, matches, routeMatch || $6fd199a57804d61d$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
                return result2;
            }
            let result = await loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $6fd199a57804d61d$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($6fd199a57804d61d$var$isDataStrategyResult(e) && $6fd199a57804d61d$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($6fd199a57804d61d$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, location, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $6fd199a57804d61d$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let dsMatches = $6fd199a57804d61d$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, [], requestContext);
            let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $6fd199a57804d61d$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($6fd199a57804d61d$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($6fd199a57804d61d$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($6fd199a57804d61d$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $6fd199a57804d61d$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: $6fd199a57804d61d$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($6fd199a57804d61d$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $6fd199a57804d61d$var$findNearestBoundary(matches, actionMatch.route.id);
            let handlerContext2 = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...handlerContext2,
                statusCode: $6fd199a57804d61d$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let handlerContext = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad);
        return {
            ...handlerContext,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $6fd199a57804d61d$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $6fd199a57804d61d$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $6fd199a57804d61d$var$isErrorResult(pendingActionResult[1]) ? // Up to but not including the boundary
            matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            let pattern = $6fd199a57804d61d$var$getRoutePattern(matches);
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $6fd199a57804d61d$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, false);
                return $6fd199a57804d61d$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $6fd199a57804d61d$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $6fd199a57804d61d$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let handlerContext = $6fd199a57804d61d$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        return {
            ...handlerContext,
            matches: matches
        };
    }
    async function callDataStrategy(request, location, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $6fd199a57804d61d$var$callDataStrategyImpl(dataStrategy || $6fd199a57804d61d$var$defaultDataStrategy, request, location, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($6fd199a57804d61d$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $6fd199a57804d61d$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($6fd199a57804d61d$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($6fd199a57804d61d$export$e0163cfdf7bc9cfa(result.result)) throw $6fd199a57804d61d$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $6fd199a57804d61d$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        _internalRouteBranches: routeBranches,
        query: query,
        queryRoute: queryRoute
    };
}
function $6fd199a57804d61d$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: $6fd199a57804d61d$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $6fd199a57804d61d$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $6fd199a57804d61d$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $6fd199a57804d61d$var$defaultNormalizePath(request) {
    let url = new URL(request.url);
    return {
        pathname: url.pathname,
        search: url.search,
        hash: url.hash
    };
}
function $6fd199a57804d61d$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $6fd199a57804d61d$var$resolveTo(to ? to : ".", $6fd199a57804d61d$var$getResolveToMatches(contextualMatches), $6fd199a57804d61d$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $6fd199a57804d61d$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = $6fd199a57804d61d$var$prependBasename({
        basename: basename,
        pathname: path.pathname
    });
    return $6fd199a57804d61d$export$fe53371bee54353d(path);
}
function $6fd199a57804d61d$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$6fd199a57804d61d$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$6fd199a57804d61d$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $6fd199a57804d61d$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $6fd199a57804d61d$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $6fd199a57804d61d$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$6fd199a57804d61d$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$6fd199a57804d61d$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $6fd199a57804d61d$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $6fd199a57804d61d$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $6fd199a57804d61d$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $6fd199a57804d61d$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $6fd199a57804d61d$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($6fd199a57804d61d$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $6fd199a57804d61d$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $6fd199a57804d61d$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $6fd199a57804d61d$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $6fd199a57804d61d$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, branches, pendingActionResult, callSiteDefaultShouldRevalidate) {
    let actionResult = pendingActionResult ? $6fd199a57804d61d$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $6fd199a57804d61d$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let pattern = $6fd199a57804d61d$var$getRoutePattern(matches);
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$6fd199a57804d61d$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) {
            let { shouldLoad: shouldLoad2 } = $6fd199a57804d61d$var$getRouteHydrationStatus(route, state.loaderData, state.errors);
            forceShouldLoad = shouldLoad2;
        } else if ($6fd199a57804d61d$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $6fd199a57804d61d$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = false;
        if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
        else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
        else if (isRevalidationRequired) defaultShouldRevalidate = true;
        else if (currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search) defaultShouldRevalidate = true;
        else if (currentUrl.search !== nextUrl.search) defaultShouldRevalidate = true;
        else if ($6fd199a57804d61d$var$isNewRouteInstance(state.matches[index], match)) defaultShouldRevalidate = true;
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        let shouldLoad = $6fd199a57804d61d$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        return $6fd199a57804d61d$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs, callSiteDefaultShouldRevalidate);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = $6fd199a57804d61d$export$5c7b09132f833c25(routesToUse, f.path, basename ?? "/", false, branches);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $6fd199a57804d61d$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $6fd199a57804d61d$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $6fd199a57804d61d$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $6fd199a57804d61d$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let defaultShouldRevalidate;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
            else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
            else defaultShouldRevalidate = isRevalidationRequired;
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            };
            if ($6fd199a57804d61d$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $6fd199a57804d61d$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $6fd199a57804d61d$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $6fd199a57804d61d$var$getRouteHydrationStatus(route, loaderData, errors) {
    if (route.lazy) return {
        shouldLoad: true,
        renderFallback: true
    };
    if (!$6fd199a57804d61d$var$routeHasLoaderOrMiddleware(route)) return {
        shouldLoad: false,
        renderFallback: false
    };
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return {
        shouldLoad: false,
        renderFallback: false
    };
    if (typeof route.loader === "function" && route.loader.hydrate === true) return {
        shouldLoad: true,
        renderFallback: !hasData
    };
    let shouldLoad = !hasData && !hasError;
    return {
        shouldLoad: shouldLoad,
        renderFallback: shouldLoad
    };
}
function $6fd199a57804d61d$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $6fd199a57804d61d$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $6fd199a57804d61d$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $6fd199a57804d61d$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties2, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $6fd199a57804d61d$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = dataRoutes.activeRoutes;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute2)=>$6fd199a57804d61d$var$isSameRoute(newRoute, existingRoute2));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = $6fd199a57804d61d$export$87cb1a9238dc3fba(uniqueChildren, mapRouteProperties2, [
            routeId || "_",
            "patch",
            String(childrenToPatch?.length || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = $6fd199a57804d61d$export$87cb1a9238dc3fba([
            newRoute
        ], mapRouteProperties2, [], // Doesn't matter for mutated routes since they already have an id
        {}, // Don't touch the manifest here since we're updating in place
        true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
    if (!dataRoutes.hasHMRRoutes) dataRoutes.setRoutes([
        ...dataRoutes.activeRoutes
    ]);
}
function $6fd199a57804d61d$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children?.every((aChild, i)=>existingRoute.children?.some((bChild)=>$6fd199a57804d61d$var$isSameRoute(aChild, bChild))) ?? false;
}
var $6fd199a57804d61d$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var $6fd199a57804d61d$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties2 })=>{
    let routeToUpdate = manifest[route.id];
    $6fd199a57804d61d$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $6fd199a57804d61d$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $6fd199a57804d61d$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = $6fd199a57804d61d$var$isUnsupportedLazyRouteObjectKey(key);
        let staticRouteValue = routeToUpdate[key];
        let isStaticallyDefined = staticRouteValue !== void 0 && key !== "hasErrorBoundary";
        if (isUnsupported) {
            $6fd199a57804d61d$var$warning(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) $6fd199a57804d61d$var$warning(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties2(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var $6fd199a57804d61d$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
function $6fd199a57804d61d$var$loadLazyRoute(route, type, manifest, mapRouteProperties2, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    $6fd199a57804d61d$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $6fd199a57804d61d$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise2 = (async ()=>{
            $6fd199a57804d61d$export$f5708dca728d7177(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = $6fd199a57804d61d$var$isUnsupportedLazyRouteFunctionKey(lazyRouteProperty);
                let staticRouteValue = routeToUpdate[lazyRouteProperty];
                let isStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                // on the route updates
                lazyRouteProperty !== "hasErrorBoundary";
                if (isUnsupported) $6fd199a57804d61d$var$warning(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) $6fd199a57804d61d$var$warning(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                // To keep things framework agnostic, we use the provided `mapRouteProperties`
                // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
                // since the logic will differ between frameworks.
                ...mapRouteProperties2(routeToUpdate),
                lazy: void 0
            });
        })();
        $6fd199a57804d61d$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise2);
        lazyRoutePromise2.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise2,
            lazyHandlerPromise: lazyRoutePromise2
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $6fd199a57804d61d$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $6fd199a57804d61d$var$isNonNullable(value) {
    return value !== void 0;
}
function $6fd199a57804d61d$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return void 0;
        return $6fd199a57804d61d$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
    }).filter($6fd199a57804d61d$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $6fd199a57804d61d$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    results.forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $6fd199a57804d61d$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $6fd199a57804d61d$var$defaultDataStrategy(args);
    return $6fd199a57804d61d$var$runClientMiddlewarePipeline(args, ()=>$6fd199a57804d61d$var$defaultDataStrategy(args));
}
function $6fd199a57804d61d$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $6fd199a57804d61d$var$runMiddlewarePipeline(args, handler, processResult, $6fd199a57804d61d$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $6fd199a57804d61d$export$e0163cfdf7bc9cfa(result) ? $6fd199a57804d61d$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $6fd199a57804d61d$var$runClientMiddlewarePipeline(args, handler) {
    return $6fd199a57804d61d$var$runMiddlewarePipeline(args, handler, (r)=>{
        if ($6fd199a57804d61d$export$6e80290866a84dd4(r)) throw r;
        return r;
    }, $6fd199a57804d61d$var$isDataStrategyResults, errorHandler);
    function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Promise.resolve(Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        }));
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(// Throwing route
            Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), // or the shallowest route that needs to load data
            Math.max(matches.findIndex((m)=>m.shouldCallHandler()), 0));
            let boundaryRouteId = $6fd199a57804d61d$var$findNearestBoundary(matches, matches[maxBoundaryIdx].route.id).route.id;
            return Promise.resolve({
                [boundaryRouteId]: {
                    type: "error",
                    result: error
                }
            });
        }
    }
}
async function $6fd199a57804d61d$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches, ...dataFnArgs } = args;
    let tuples = matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []);
    let result = await $6fd199a57804d61d$var$callRouteMiddleware(dataFnArgs, tuples, handler, processResult, isResult, errorHandler);
    return result;
}
async function $6fd199a57804d61d$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    if (request.signal.aborted) throw request.signal.reason ?? new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) {
        let result = await handler();
        return result;
    }
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            let result = await $6fd199a57804d61d$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1);
            nextResult = {
                value: result
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result ?? nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        let response = await errorHandler(error, routeId, nextResult);
        return response;
    }
}
function $6fd199a57804d61d$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $6fd199a57804d61d$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties2
    });
    let lazyRoutePromises = $6fd199a57804d61d$var$loadLazyRoute(match.route, $6fd199a57804d61d$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties2, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $6fd199a57804d61d$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs = null, callSiteDefaultShouldRevalidate) {
    let isUsingNewApi = false;
    let _lazyPromises = $6fd199a57804d61d$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") return $6fd199a57804d61d$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: callSiteDefaultShouldRevalidate
            });
            if (typeof defaultShouldRevalidate === "boolean") return $6fd199a57804d61d$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $6fd199a57804d61d$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$6fd199a57804d61d$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($6fd199a57804d61d$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $6fd199a57804d61d$var$callLoaderOrAction({
                request: request,
                path: path,
                pattern: pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        }
    };
}
function $6fd199a57804d61d$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, path, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: ()=>false,
            _lazyPromises: $6fd199a57804d61d$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $6fd199a57804d61d$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, $6fd199a57804d61d$var$getRoutePattern(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $6fd199a57804d61d$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request: request,
        url: $6fd199a57804d61d$var$createDataFunctionUrl(request, path),
        pattern: $6fd199a57804d61d$var$getRoutePattern(matches),
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $6fd199a57804d61d$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            });
        });
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch (e) {}
    return results;
}
async function $6fd199a57804d61d$var$callLoaderOrAction({ request: request, path: path, pattern: pattern, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $6fd199a57804d61d$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                url: $6fd199a57804d61d$var$createDataFunctionUrl(request, path),
                pattern: pattern,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    // Ensure all lazy route promises are resolved before continuing
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler2 = isAction ? match.route.action : match.route.loader;
                if (handler2) [result] = await Promise.all([
                    runHandler(handler2),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $6fd199a57804d61d$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $6fd199a57804d61d$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $6fd199a57804d61d$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $6fd199a57804d61d$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($6fd199a57804d61d$export$3f1eb41d9a6a6a27(result)) {
        let data2;
        try {
            data2 = await $6fd199a57804d61d$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $6fd199a57804d61d$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($6fd199a57804d61d$export$e0163cfdf7bc9cfa(result)) {
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error" /* error */ ,
                error: $6fd199a57804d61d$var$dataWithResponseInitToErrorResponse(result),
                statusCode: $6fd199a57804d61d$export$972111febbeef05b(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $6fd199a57804d61d$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($6fd199a57804d61d$export$e0163cfdf7bc9cfa(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $6fd199a57804d61d$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $6fd199a57804d61d$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$6fd199a57804d61d$var$isAbsoluteUrl(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $6fd199a57804d61d$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
var $6fd199a57804d61d$export$30ab200a1a0a2def = [
    "about:",
    "blob:",
    "chrome:",
    "chrome-untrusted:",
    "content:",
    "data:",
    "devtools:",
    "file:",
    "filesystem:",
    // eslint-disable-next-line no-script-url
    "javascript:"
];
function $6fd199a57804d61d$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    if ($6fd199a57804d61d$var$isAbsoluteUrl(location)) {
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if ($6fd199a57804d61d$export$30ab200a1a0a2def.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $6fd199a57804d61d$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return $6fd199a57804d61d$var$removeDoubleSlashes(url.pathname) + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if ($6fd199a57804d61d$export$30ab200a1a0a2def.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
function $6fd199a57804d61d$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($6fd199a57804d61d$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $6fd199a57804d61d$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $6fd199a57804d61d$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $6fd199a57804d61d$var$createDataFunctionUrl(request, path) {
    let url = new URL(request.url);
    let parsed = typeof path === "string" ? $6fd199a57804d61d$export$8ccf933b0513f8d0(path) : path;
    url.pathname = parsed.pathname || "/";
    if (parsed.search) {
        let searchParams = new URLSearchParams(parsed.search);
        let indexValues = searchParams.getAll("index");
        searchParams.delete("index");
        for (let value of indexValues.filter(Boolean))searchParams.append("index", value);
        url.search = searchParams.size ? `?${searchParams.toString()}` : "";
    } else url.search = "";
    url.hash = parsed.hash || "";
    return url;
}
function $6fd199a57804d61d$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $6fd199a57804d61d$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $6fd199a57804d61d$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $6fd199a57804d61d$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $6fd199a57804d61d$export$f5708dca728d7177(!$6fd199a57804d61d$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($6fd199a57804d61d$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $6fd199a57804d61d$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $6fd199a57804d61d$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $6fd199a57804d61d$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $6fd199a57804d61d$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers) {
    let { loaderData: loaderData, errors: errors } = $6fd199a57804d61d$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        $6fd199a57804d61d$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if ($6fd199a57804d61d$var$isErrorResult(result)) {
            let boundaryMatch = $6fd199a57804d61d$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            workingFetchers.delete(key);
        } else if ($6fd199a57804d61d$var$isRedirectResult(result)) $6fd199a57804d61d$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $6fd199a57804d61d$var$getDoneFetcher(result.data);
            workingFetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $6fd199a57804d61d$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $6fd199a57804d61d$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $6fd199a57804d61d$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $6fd199a57804d61d$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $6fd199a57804d61d$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $6fd199a57804d61d$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $6fd199a57804d61d$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $6fd199a57804d61d$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $6fd199a57804d61d$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($6fd199a57804d61d$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $6fd199a57804d61d$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $6fd199a57804d61d$export$8ccf933b0513f8d0(path) : path;
    return $6fd199a57804d61d$export$fe53371bee54353d({
        ...parsedPath,
        hash: ""
    });
}
function $6fd199a57804d61d$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $6fd199a57804d61d$var$dataWithResponseInitToResponse(data2) {
    return Response.json(data2.data, data2.init ?? void 0);
}
function $6fd199a57804d61d$var$dataWithResponseInitToErrorResponse(data2) {
    return new $6fd199a57804d61d$export$f2680fa305b734ca(data2.init?.status ?? 500, data2.init?.statusText ?? "Internal Server Error", data2.data);
}
function $6fd199a57804d61d$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $6fd199a57804d61d$var$isDataStrategyResult(value));
}
function $6fd199a57804d61d$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $6fd199a57804d61d$var$isRedirectDataStrategyResult(result) {
    return $6fd199a57804d61d$export$3f1eb41d9a6a6a27(result.result) && $6fd199a57804d61d$var$redirectStatusCodes.has(result.result.status);
}
function $6fd199a57804d61d$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $6fd199a57804d61d$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $6fd199a57804d61d$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $6fd199a57804d61d$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $6fd199a57804d61d$export$794b2760043cf8cd(statusCode) {
    return $6fd199a57804d61d$var$redirectStatusCodes.has(statusCode);
}
function $6fd199a57804d61d$export$6e80290866a84dd4(result) {
    return $6fd199a57804d61d$export$3f1eb41d9a6a6a27(result) && $6fd199a57804d61d$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $6fd199a57804d61d$var$isValidMethod(method) {
    return $6fd199a57804d61d$var$validRequestMethods.has(method.toUpperCase());
}
function $6fd199a57804d61d$export$cbae47800eb95bc3(method) {
    return $6fd199a57804d61d$var$validMutationMethods.has(method.toUpperCase());
}
function $6fd199a57804d61d$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $6fd199a57804d61d$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $6fd199a57804d61d$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $6fd199a57804d61d$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $6fd199a57804d61d$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $6fd199a57804d61d$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $6fd199a57804d61d$var$getLoadingNavigation(location, matches, historyAction, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            matches: matches,
            historyAction: historyAction,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            matches: matches,
            historyAction: historyAction,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $6fd199a57804d61d$var$getSubmittingNavigation(location, matches, historyAction, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $6fd199a57804d61d$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $6fd199a57804d61d$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $6fd199a57804d61d$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $6fd199a57804d61d$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($6fd199a57804d61d$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $6fd199a57804d61d$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($6fd199a57804d61d$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $6fd199a57804d61d$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $6fd199a57804d61d$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $6fd199a57804d61d$export$2eeee58951ff3c1c = $5iwRF.createContext(null);
$6fd199a57804d61d$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $6fd199a57804d61d$export$315e3ffb01f217 = $5iwRF.createContext(null);
$6fd199a57804d61d$export$315e3ffb01f217.displayName = "DataRouterState";
var $6fd199a57804d61d$export$717f757c655223f1 = $5iwRF.createContext(false);
function $6fd199a57804d61d$var$useIsRSCRouterContext() {
    return $5iwRF.useContext($6fd199a57804d61d$export$717f757c655223f1);
}
var $6fd199a57804d61d$export$3681f408decb40d1 = $5iwRF.createContext({
    isTransitioning: false
});
$6fd199a57804d61d$export$3681f408decb40d1.displayName = "ViewTransition";
var $6fd199a57804d61d$export$cb3f1df1bef00a39 = $5iwRF.createContext(/* @__PURE__ */ new Map());
$6fd199a57804d61d$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $6fd199a57804d61d$var$AwaitContext = $5iwRF.createContext(null);
$6fd199a57804d61d$var$AwaitContext.displayName = "Await";
var $6fd199a57804d61d$export$2666c20e15407622 = (props)=>$5iwRF.createElement($6fd199a57804d61d$var$AwaitContext.Provider, props);
var $6fd199a57804d61d$export$3044ab7fdabeaee6 = $5iwRF.createContext(null);
$6fd199a57804d61d$export$3044ab7fdabeaee6.displayName = "Navigation";
var $6fd199a57804d61d$export$e6a44b110a0c44d3 = $5iwRF.createContext(null);
$6fd199a57804d61d$export$e6a44b110a0c44d3.displayName = "Location";
var $6fd199a57804d61d$export$aac280ed165a4397 = $5iwRF.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$6fd199a57804d61d$export$aac280ed165a4397.displayName = "Route";
var $6fd199a57804d61d$var$RouteErrorContext = $5iwRF.createContext(null);
$6fd199a57804d61d$var$RouteErrorContext.displayName = "RouteError";
var $6fd199a57804d61d$export$945fecf35a8ef089 = true;
// lib/errors.ts
var $6fd199a57804d61d$var$ERROR_DIGEST_BASE = "REACT_ROUTER_ERROR";
var $6fd199a57804d61d$var$ERROR_DIGEST_REDIRECT = "REDIRECT";
var $6fd199a57804d61d$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE = "ROUTE_ERROR_RESPONSE";
function $6fd199a57804d61d$export$30db792b333fd2ee(digest) {
    if (digest.startsWith(`${$6fd199a57804d61d$var$ERROR_DIGEST_BASE}:${$6fd199a57804d61d$var$ERROR_DIGEST_REDIRECT}:{`)) try {
        let parsed = JSON.parse(digest.slice(28));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string" && typeof parsed.location === "string" && typeof parsed.reloadDocument === "boolean" && typeof parsed.replace === "boolean") return parsed;
    } catch  {}
}
function $6fd199a57804d61d$export$2b5950305b3e7eaf(digest) {
    if (digest.startsWith(`${$6fd199a57804d61d$var$ERROR_DIGEST_BASE}:${$6fd199a57804d61d$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE}:{`)) try {
        let parsed = JSON.parse(digest.slice(40));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string") return new $6fd199a57804d61d$export$f2680fa305b734ca(parsed.status, parsed.statusText, parsed.data);
    } catch  {}
}
// lib/hooks.tsx
function $6fd199a57804d61d$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $6fd199a57804d61d$export$f5708dca728d7177($6fd199a57804d61d$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $5iwRF.useContext($6fd199a57804d61d$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $6fd199a57804d61d$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $6fd199a57804d61d$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $6fd199a57804d61d$export$9c954a9d03d32f4a() {
    return $5iwRF.useContext($6fd199a57804d61d$export$e6a44b110a0c44d3) != null;
}
function $6fd199a57804d61d$export$45d76561a5302f2b() {
    $6fd199a57804d61d$export$f5708dca728d7177($6fd199a57804d61d$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $5iwRF.useContext($6fd199a57804d61d$export$e6a44b110a0c44d3).location;
}
function $6fd199a57804d61d$export$1b3f31771c5d07c() {
    return $5iwRF.useContext($6fd199a57804d61d$export$e6a44b110a0c44d3).navigationType;
}
function $6fd199a57804d61d$export$6c330e8992e8a295(pattern) {
    $6fd199a57804d61d$export$f5708dca728d7177($6fd199a57804d61d$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $6fd199a57804d61d$export$45d76561a5302f2b();
    return $5iwRF.useMemo(()=>$6fd199a57804d61d$export$81336c211d5ff295(pattern, $6fd199a57804d61d$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $6fd199a57804d61d$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $6fd199a57804d61d$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $5iwRF.useContext($6fd199a57804d61d$export$3044ab7fdabeaee6).static;
    if (!isStatic) $5iwRF.useLayoutEffect(cb);
}
function $6fd199a57804d61d$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $5iwRF.useContext($6fd199a57804d61d$export$aac280ed165a4397);
    return isDataRoute ? $6fd199a57804d61d$var$useNavigateStable() : $6fd199a57804d61d$var$useNavigateUnstable();
}
function $6fd199a57804d61d$var$useNavigateUnstable() {
    $6fd199a57804d61d$export$f5708dca728d7177($6fd199a57804d61d$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $5iwRF.useContext($6fd199a57804d61d$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator } = $5iwRF.useContext($6fd199a57804d61d$export$3044ab7fdabeaee6);
    let { matches: matches } = $5iwRF.useContext($6fd199a57804d61d$export$aac280ed165a4397);
    let { pathname: locationPathname } = $6fd199a57804d61d$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($6fd199a57804d61d$var$getResolveToMatches(matches));
    let activeRef = $5iwRF.useRef(false);
    $6fd199a57804d61d$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $5iwRF.useCallback((to, options = {})=>{
        $6fd199a57804d61d$var$warning(activeRef.current, $6fd199a57804d61d$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $6fd199a57804d61d$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $6fd199a57804d61d$var$joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $6fd199a57804d61d$var$OutletContext = $5iwRF.createContext(null);
function $6fd199a57804d61d$export$4138103a3ae699cc() {
    return $5iwRF.useContext($6fd199a57804d61d$var$OutletContext);
}
function $6fd199a57804d61d$export$a3be3530d8e40d0b(context) {
    let outlet = $5iwRF.useContext($6fd199a57804d61d$export$aac280ed165a4397).outlet;
    return $5iwRF.useMemo(()=>outlet && /* @__PURE__ */ $5iwRF.createElement($6fd199a57804d61d$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
function $6fd199a57804d61d$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $5iwRF.useContext($6fd199a57804d61d$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    return routeMatch?.params ?? {};
}
function $6fd199a57804d61d$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $5iwRF.useContext($6fd199a57804d61d$export$aac280ed165a4397);
    let { pathname: locationPathname } = $6fd199a57804d61d$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($6fd199a57804d61d$var$getResolveToMatches(matches));
    return $5iwRF.useMemo(()=>$6fd199a57804d61d$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $6fd199a57804d61d$export$5d3fca4a98652595(routes, locationArg) {
    return $6fd199a57804d61d$var$useRoutesImpl(routes, locationArg);
}
function $6fd199a57804d61d$var$useRoutesImpl(routes, locationArg, dataRouterOpts) {
    $6fd199a57804d61d$export$f5708dca728d7177($6fd199a57804d61d$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $5iwRF.useContext($6fd199a57804d61d$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $5iwRF.useContext($6fd199a57804d61d$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($6fd199a57804d61d$export$945fecf35a8ef089) {
        let parentPath = parentRoute && parentRoute.path || "";
        $6fd199a57804d61d$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $6fd199a57804d61d$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? $6fd199a57804d61d$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $6fd199a57804d61d$export$f5708dca728d7177(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = dataRouterOpts && dataRouterOpts.state.matches.length ? // If we're in a data router, use the matches we've already identified but ensure
    // we have the latest route instances from the manifest in case elements have changed
    dataRouterOpts.state.matches.map((m)=>Object.assign(m, {
            route: dataRouterOpts.manifest[m.route.id] || m.route
        })) : $6fd199a57804d61d$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($6fd199a57804d61d$export$945fecf35a8ef089) {
        $6fd199a57804d61d$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $6fd199a57804d61d$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $6fd199a57804d61d$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $6fd199a57804d61d$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes.
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $6fd199a57804d61d$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterOpts);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $5iwRF.createElement($6fd199a57804d61d$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                mask: void 0,
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $6fd199a57804d61d$var$DefaultErrorComponent() {
    let error = $6fd199a57804d61d$export$ed527bf60f6e05f2();
    let message = $6fd199a57804d61d$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($6fd199a57804d61d$export$945fecf35a8ef089) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $5iwRF.createElement($5iwRF.Fragment, null, /* @__PURE__ */ $5iwRF.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /* @__PURE__ */ $5iwRF.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $5iwRF.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $5iwRF.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $5iwRF.createElement($5iwRF.Fragment, null, /* @__PURE__ */ $5iwRF.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $5iwRF.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $5iwRF.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $6fd199a57804d61d$var$defaultErrorElement = /* @__PURE__ */ $5iwRF.createElement($6fd199a57804d61d$var$DefaultErrorComponent, null);
var $6fd199a57804d61d$var$RenderErrorBoundary = class extends $5iwRF.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        let error = this.state.error;
        if (this.context && typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
            const decoded = $6fd199a57804d61d$export$2b5950305b3e7eaf(error.digest);
            if (decoded) error = decoded;
        }
        let result = error !== void 0 ? /* @__PURE__ */ $5iwRF.createElement($6fd199a57804d61d$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $5iwRF.createElement($6fd199a57804d61d$var$RouteErrorContext.Provider, {
            value: error,
            children: this.props.component
        })) : this.props.children;
        if (this.context) return /* @__PURE__ */ $5iwRF.createElement($6fd199a57804d61d$var$RSCErrorHandler, {
            error: error
        }, result);
        return result;
    }
};
$6fd199a57804d61d$var$RenderErrorBoundary.contextType = $6fd199a57804d61d$export$717f757c655223f1;
var $6fd199a57804d61d$var$errorRedirectHandledMap = /* @__PURE__ */ new WeakMap();
function $6fd199a57804d61d$var$RSCErrorHandler({ children: children, error: error }) {
    let { basename: basename } = $5iwRF.useContext($6fd199a57804d61d$export$3044ab7fdabeaee6);
    if (typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
        let redirect2 = $6fd199a57804d61d$export$30db792b333fd2ee(error.digest);
        if (redirect2) {
            let existingRedirect = $6fd199a57804d61d$var$errorRedirectHandledMap.get(error);
            if (existingRedirect) throw existingRedirect;
            let parsed = $6fd199a57804d61d$var$parseToInfo(redirect2.location, basename);
            if ($6fd199a57804d61d$var$isBrowser && !$6fd199a57804d61d$var$errorRedirectHandledMap.get(error)) {
                if (parsed.isExternal || redirect2.reloadDocument) window.location.href = parsed.absoluteURL || parsed.to;
                else {
                    const redirectPromise = Promise.resolve().then(()=>window.__reactRouterDataRouter.navigate(parsed.to, {
                            replace: redirect2.replace
                        }));
                    $6fd199a57804d61d$var$errorRedirectHandledMap.set(error, redirectPromise);
                    throw redirectPromise;
                }
            }
            return /* @__PURE__ */ $5iwRF.createElement("meta", {
                httpEquiv: "refresh",
                content: `0;url=${parsed.absoluteURL || parsed.to}`
            });
        }
    }
    return children;
}
function $6fd199a57804d61d$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $5iwRF.useContext($6fd199a57804d61d$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $5iwRF.createElement($6fd199a57804d61d$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $6fd199a57804d61d$var$_renderMatches(matches, parentMatches = [], dataRouterOpts) {
    let dataRouterState = dataRouterOpts?.state;
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        $6fd199a57804d61d$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterOpts && dataRouterState) {
        renderFallback = dataRouterState.renderFallback;
        for(let i = 0; i < renderedMatches.length; i++){
            let match = renderedMatches[i];
            if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
            if (match.route.id) {
                let { loaderData: loaderData, errors: errors2 } = dataRouterState;
                let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
                if (match.route.lazy || needsToRunLoader) {
                    if (dataRouterOpts.isStatic) renderFallback = true;
                    if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                    else renderedMatches = [
                        renderedMatches[0]
                    ];
                    break;
                }
            }
        }
    }
    let onErrorHandler = dataRouterOpts?.onError;
    let onError = dataRouterState && onErrorHandler ? (error, errorInfo)=>{
        onErrorHandler(error, {
            location: dataRouterState.location,
            params: dataRouterState.matches?.[0]?.params ?? {},
            pattern: $6fd199a57804d61d$var$getRoutePattern(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $6fd199a57804d61d$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $6fd199a57804d61d$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $5iwRF.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $5iwRF.createElement($6fd199a57804d61d$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $5iwRF.createElement($6fd199a57804d61d$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function $6fd199a57804d61d$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $6fd199a57804d61d$var$useDataRouterContext(hookName) {
    let ctx = $5iwRF.useContext($6fd199a57804d61d$export$2eeee58951ff3c1c);
    $6fd199a57804d61d$export$f5708dca728d7177(ctx, $6fd199a57804d61d$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $6fd199a57804d61d$var$useDataRouterState(hookName) {
    let state = $5iwRF.useContext($6fd199a57804d61d$export$315e3ffb01f217);
    $6fd199a57804d61d$export$f5708dca728d7177(state, $6fd199a57804d61d$var$getDataRouterConsoleError(hookName));
    return state;
}
function $6fd199a57804d61d$var$useRouteContext(hookName) {
    let route = $5iwRF.useContext($6fd199a57804d61d$export$aac280ed165a4397);
    $6fd199a57804d61d$export$f5708dca728d7177(route, $6fd199a57804d61d$var$getDataRouterConsoleError(hookName));
    return route;
}
function $6fd199a57804d61d$var$useCurrentRouteId(hookName) {
    let route = $6fd199a57804d61d$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $6fd199a57804d61d$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $6fd199a57804d61d$var$useRouteId() {
    return $6fd199a57804d61d$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $6fd199a57804d61d$export$d0fd4b7106de2769() {
    let state = $6fd199a57804d61d$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return $5iwRF.useMemo(()=>{
        let { matches: matches, historyAction: historyAction, ...rest } = state.navigation;
        return rest;
    }, [
        state.navigation
    ]);
}
function $6fd199a57804d61d$export$600dc272ed516c15() {
    let dataRouterContext = $6fd199a57804d61d$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $6fd199a57804d61d$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    let revalidate = $5iwRF.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $5iwRF.useMemo(()=>({
            revalidate: revalidate,
            state: state.revalidation
        }), [
        revalidate,
        state.revalidation
    ]);
}
function $6fd199a57804d61d$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $6fd199a57804d61d$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $5iwRF.useMemo(()=>matches.map((m)=>$6fd199a57804d61d$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $6fd199a57804d61d$export$1448a5050d252c4d() {
    let state = $6fd199a57804d61d$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $6fd199a57804d61d$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $6fd199a57804d61d$export$fd5d37484eab868d(routeId) {
    let state = $6fd199a57804d61d$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $6fd199a57804d61d$export$fdc00f3f26066d5e() {
    let state = $6fd199a57804d61d$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $6fd199a57804d61d$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $6fd199a57804d61d$export$ed527bf60f6e05f2() {
    let error = $5iwRF.useContext($6fd199a57804d61d$var$RouteErrorContext);
    let state = $6fd199a57804d61d$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $6fd199a57804d61d$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
function $6fd199a57804d61d$export$78a72ddb39bdd145() {
    let value = $5iwRF.useContext($6fd199a57804d61d$var$AwaitContext);
    return value?._data;
}
function $6fd199a57804d61d$export$17f53340677d5831() {
    let value = $5iwRF.useContext($6fd199a57804d61d$var$AwaitContext);
    return value?._error;
}
var $6fd199a57804d61d$var$blockerId = 0;
function $6fd199a57804d61d$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $6fd199a57804d61d$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $6fd199a57804d61d$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $5iwRF.useState("");
    let blockerFunction = $5iwRF.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: $6fd199a57804d61d$export$b69e3301ce081aa3(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: $6fd199a57804d61d$export$b69e3301ce081aa3(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $5iwRF.useEffect(()=>{
        let key = String(++$6fd199a57804d61d$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $5iwRF.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $6fd199a57804d61d$export$386d57f03f0b2883;
}
function $6fd199a57804d61d$var$useNavigateStable() {
    let { router: router } = $6fd199a57804d61d$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $6fd199a57804d61d$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $5iwRF.useRef(false);
    $6fd199a57804d61d$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $5iwRF.useCallback(async (to, options = {})=>{
        $6fd199a57804d61d$var$warning(activeRef.current, $6fd199a57804d61d$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") await router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var $6fd199a57804d61d$var$alreadyWarned = {};
function $6fd199a57804d61d$var$warningOnce(key, cond, message) {
    if (!cond && !$6fd199a57804d61d$var$alreadyWarned[key]) {
        $6fd199a57804d61d$var$alreadyWarned[key] = true;
        $6fd199a57804d61d$var$warning(false, message);
    }
}
function $6fd199a57804d61d$export$3f79f0b98112cf57(...args) {
    const currentRouteId = $6fd199a57804d61d$var$useCurrentRouteId("useRoute" /* UseRoute */ );
    const id = args[0] ?? currentRouteId;
    const state = $6fd199a57804d61d$var$useDataRouterState("useRoute" /* UseRoute */ );
    const route = state.matches.find(({ route: route2 })=>route2.id === id);
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: state.loaderData[id],
        actionData: state.actionData?.[id]
    };
}
function $6fd199a57804d61d$var$toRouterStateMatch(match) {
    return {
        id: match.route.id,
        pathname: match.pathname,
        params: match.params,
        handle: match.route.handle
    };
}
function $6fd199a57804d61d$export$dbb5ccc270afbbb4() {
    let { location: location, historyAction: type, matches: matches, navigation: navigation } = $6fd199a57804d61d$var$useDataRouterState("unstable_useRouterState" /* UseRouterState */ );
    let active = $5iwRF.useMemo(()=>({
            type: type,
            location: location,
            searchParams: new URLSearchParams(location.search),
            params: matches[matches.length - 1]?.params ?? {},
            matches: matches.map((m)=>$6fd199a57804d61d$var$toRouterStateMatch(m))
        }), [
        location,
        matches,
        type
    ]);
    let pending = $5iwRF.useMemo(()=>{
        if (navigation.state === "idle") return null;
        let shared = {
            type: navigation.historyAction,
            location: navigation.location,
            searchParams: new URLSearchParams(navigation.location.search),
            params: navigation.matches[navigation.matches.length - 1]?.params ?? {},
            matches: navigation.matches.map((m)=>$6fd199a57804d61d$var$toRouterStateMatch(m))
        };
        return navigation.state === "loading" ? {
            ...shared,
            state: "loading",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        } : {
            ...shared,
            state: "submitting",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        };
    }, [
        navigation
    ]);
    return $5iwRF.useMemo(()=>({
            active: active,
            pending: pending
        }), [
        active,
        pending
    ]);
}
// lib/server-runtime/warnings.ts
var $6fd199a57804d61d$var$alreadyWarned2 = {};
function $6fd199a57804d61d$export$5b28268982f175ba(condition, message) {
    if (!condition && !$6fd199a57804d61d$var$alreadyWarned2[message]) {
        $6fd199a57804d61d$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
var $6fd199a57804d61d$var$USE_OPTIMISTIC = "useOptimistic";
var $6fd199a57804d61d$var$useOptimisticImpl = $5iwRF[$6fd199a57804d61d$var$USE_OPTIMISTIC];
var $6fd199a57804d61d$var$stableUseOptimisticSetter = ()=>void 0;
function $6fd199a57804d61d$var$useOptimisticSafe(val) {
    if ($6fd199a57804d61d$var$useOptimisticImpl) return $6fd199a57804d61d$var$useOptimisticImpl(val);
    else return [
        val,
        $6fd199a57804d61d$var$stableUseOptimisticSetter
    ];
}
function $6fd199a57804d61d$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($6fd199a57804d61d$export$945fecf35a8ef089) {
            if (route.element) $6fd199a57804d61d$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $5iwRF.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($6fd199a57804d61d$export$945fecf35a8ef089) {
            if (route.hydrateFallbackElement) $6fd199a57804d61d$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $5iwRF.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($6fd199a57804d61d$export$945fecf35a8ef089) {
            if (route.errorElement) $6fd199a57804d61d$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $5iwRF.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
var $6fd199a57804d61d$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
function $6fd199a57804d61d$export$f30f7e456d254e83(routes, opts) {
    return $6fd199a57804d61d$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $6fd199a57804d61d$export$2b76ad033c6e6d08({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        hydrationRouteProperties: $6fd199a57804d61d$export$e2fd2c03906469db,
        mapRouteProperties: $6fd199a57804d61d$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        instrumentations: opts?.instrumentations
    }).initialize();
}
var $6fd199a57804d61d$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $6fd199a57804d61d$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, onError: onError, useTransitions: useTransitions }) {
    let unstable_rsc = $6fd199a57804d61d$var$useIsRSCRouterContext();
    useTransitions = unstable_rsc || useTransitions;
    let [_state, setStateImpl] = $5iwRF.useState(router.state);
    let [state, setOptimisticState] = $6fd199a57804d61d$var$useOptimisticSafe(_state);
    let [pendingState, setPendingState] = $5iwRF.useState();
    let [vtContext, setVtContext] = $5iwRF.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $5iwRF.useState();
    let [transition, setTransition] = $5iwRF.useState();
    let [interruption, setInterruption] = $5iwRF.useState();
    let fetcherData = $5iwRF.useRef(/* @__PURE__ */ new Map());
    let setState = $5iwRF.useCallback((newState, { deletedFetchers: deletedFetchers, newErrors: newErrors, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        if (newErrors && onError) Object.values(newErrors).forEach((error)=>onError(error, {
                location: newState.location,
                params: newState.matches[0]?.params ?? {},
                pattern: $6fd199a57804d61d$var$getRoutePattern(newState.matches)
            }));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        $6fd199a57804d61d$export$5b28268982f175ba(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $6fd199a57804d61d$export$5b28268982f175ba(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else if (useTransitions === false) setStateImpl(newState);
            else $5iwRF.startTransition(()=>{
                if (useTransitions === true) setOptimisticState((s)=>$6fd199a57804d61d$var$getOptimisticRouterState(s, newState));
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd?.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd?.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        useTransitions,
        setOptimisticState,
        onError
    ]);
    $5iwRF.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $5iwRF.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $6fd199a57804d61d$var$Deferred());
    }, [
        vtContext
    ]);
    $5iwRF.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                if (useTransitions === false) setStateImpl(newState);
                else $5iwRF.startTransition(()=>{
                    if (useTransitions === true) setOptimisticState((s)=>$6fd199a57804d61d$var$getOptimisticRouterState(s, newState));
                    setStateImpl(newState);
                });
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        useTransitions,
        setOptimisticState
    ]);
    $5iwRF.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $5iwRF.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $5iwRF.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $5iwRF.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            onError: onError
        }), [
        router,
        navigator,
        basename,
        onError
    ]);
    return /* @__PURE__ */ $5iwRF.createElement($5iwRF.Fragment, null, /* @__PURE__ */ $5iwRF.createElement($6fd199a57804d61d$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $5iwRF.createElement($6fd199a57804d61d$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $5iwRF.createElement($6fd199a57804d61d$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $5iwRF.createElement($6fd199a57804d61d$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $5iwRF.createElement($6fd199a57804d61d$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        useTransitions: useTransitions
    }, /* @__PURE__ */ $5iwRF.createElement($6fd199a57804d61d$var$MemoizedDataRoutes, {
        routes: router.routes,
        manifest: router.manifest,
        future: router.future,
        state: state,
        isStatic: false,
        onError: onError
    })))))), null);
}
function $6fd199a57804d61d$var$getOptimisticRouterState(currentState, newState) {
    return {
        // Don't surface "current location specific" stuff mid-navigation
        // (historyAction, location, matches, loaderData, errors, initialized,
        // restoreScroll, preventScrollReset, blockers, etc.)
        ...currentState,
        // Only surface "pending/in-flight stuff"
        // (navigation, revalidation, actionData, fetchers, )
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    };
}
var $6fd199a57804d61d$var$MemoizedDataRoutes = $5iwRF.memo($6fd199a57804d61d$var$DataRoutes2);
function $6fd199a57804d61d$var$DataRoutes2({ routes: routes, manifest: manifest, future: future, state: state, isStatic: isStatic, onError: onError }) {
    return $6fd199a57804d61d$var$useRoutesImpl(routes, void 0, {
        manifest: manifest,
        state: state,
        isStatic: isStatic,
        onError: onError,
        future: future
    });
}
function $6fd199a57804d61d$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, useTransitions: useTransitions }) {
    let historyRef = $5iwRF.useRef();
    if (historyRef.current == null) historyRef.current = $6fd199a57804d61d$export$2b76ad033c6e6d08({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $5iwRF.useState({
        action: history.action,
        location: history.location
    });
    let setState = $5iwRF.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $5iwRF.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $5iwRF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $5iwRF.createElement($6fd199a57804d61d$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $6fd199a57804d61d$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $6fd199a57804d61d$export$f5708dca728d7177($6fd199a57804d61d$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic } = $5iwRF.useContext($6fd199a57804d61d$export$3044ab7fdabeaee6);
    $6fd199a57804d61d$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $5iwRF.useContext($6fd199a57804d61d$export$aac280ed165a4397);
    let { pathname: locationPathname } = $6fd199a57804d61d$export$45d76561a5302f2b();
    let navigate = $6fd199a57804d61d$export$9770f232ac06a008();
    let path = $6fd199a57804d61d$var$resolveTo(to, $6fd199a57804d61d$var$getResolveToMatches(matches), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $5iwRF.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $6fd199a57804d61d$export$910ae8079b2c2852(props) {
    return $6fd199a57804d61d$export$a3be3530d8e40d0b(props.context);
}
function $6fd199a57804d61d$export$e7b0ac011bb776c6(props) {
    $6fd199a57804d61d$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $6fd199a57804d61d$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator, static: staticProp = false, useTransitions: useTransitions }) {
    $6fd199a57804d61d$export$f5708dca728d7177(!$6fd199a57804d61d$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $5iwRF.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            useTransitions: useTransitions,
            future: {}
        }), [
        basename,
        navigator,
        staticProp,
        useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = $6fd199a57804d61d$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default", mask: mask } = locationProp;
    let locationContext = $5iwRF.useMemo(()=>{
        let trailingPathname = $6fd199a57804d61d$export$b69e3301ce081aa3(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key,
                mask: mask
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType,
        mask
    ]);
    $6fd199a57804d61d$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $5iwRF.createElement($6fd199a57804d61d$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $5iwRF.createElement($6fd199a57804d61d$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $6fd199a57804d61d$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $6fd199a57804d61d$export$5d3fca4a98652595($6fd199a57804d61d$export$16da398f5434bdec(children), location);
}
function $6fd199a57804d61d$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    let dataRouterContext = $5iwRF.useContext($6fd199a57804d61d$export$2eeee58951ff3c1c);
    let dataRouterStateContext = $5iwRF.useContext($6fd199a57804d61d$export$315e3ffb01f217);
    let onError = $5iwRF.useCallback((error, errorInfo)=>{
        if (dataRouterContext && dataRouterContext.onError && dataRouterStateContext) dataRouterContext.onError(error, {
            location: dataRouterStateContext.location,
            params: dataRouterStateContext.matches[0]?.params || {},
            pattern: $6fd199a57804d61d$var$getRoutePattern(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    return /* @__PURE__ */ $5iwRF.createElement($6fd199a57804d61d$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $5iwRF.createElement($6fd199a57804d61d$var$ResolveAwait, null, children));
}
var $6fd199a57804d61d$var$AwaitErrorBoundary = class extends $5iwRF.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>{
                this.props.onError?.(error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $5iwRF.createElement($6fd199a57804d61d$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $5iwRF.createElement($6fd199a57804d61d$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $6fd199a57804d61d$var$ResolveAwait({ children: children }) {
    let data2 = $6fd199a57804d61d$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $5iwRF.createElement($5iwRF.Fragment, null, toRender);
}
function $6fd199a57804d61d$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $5iwRF.Children.forEach(children, (element, index)=>{
        if (!$5iwRF.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $5iwRF.Fragment) {
            routes.push.apply(routes, $6fd199a57804d61d$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $6fd199a57804d61d$export$f5708dca728d7177(element.type === $6fd199a57804d61d$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $6fd199a57804d61d$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            middleware: element.props.middleware,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $6fd199a57804d61d$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var $6fd199a57804d61d$export$9b5b6d122dea0c88 = $6fd199a57804d61d$export$16da398f5434bdec;
function $6fd199a57804d61d$export$daf73786167a7f72(matches) {
    return $6fd199a57804d61d$var$_renderMatches(matches);
}
function $6fd199a57804d61d$var$useRouteComponentProps() {
    return {
        params: $6fd199a57804d61d$export$99eaa27ddbbb95ef(),
        loaderData: $6fd199a57804d61d$export$1448a5050d252c4d(),
        actionData: $6fd199a57804d61d$export$fdc00f3f26066d5e(),
        matches: $6fd199a57804d61d$export$2378eb7f5ff86053()
    };
}
function $6fd199a57804d61d$export$6c4f3826290c37af({ children: children }) {
    const props = $6fd199a57804d61d$var$useRouteComponentProps();
    return $5iwRF.cloneElement(children, props);
}
function $6fd199a57804d61d$export$1a5de91a5c3255e0(Component4) {
    return function WithComponentProps2() {
        const props = $6fd199a57804d61d$var$useRouteComponentProps();
        return $5iwRF.createElement(Component4, props);
    };
}
function $6fd199a57804d61d$var$useHydrateFallbackProps() {
    return {
        params: $6fd199a57804d61d$export$99eaa27ddbbb95ef(),
        loaderData: $6fd199a57804d61d$export$1448a5050d252c4d(),
        actionData: $6fd199a57804d61d$export$fdc00f3f26066d5e()
    };
}
function $6fd199a57804d61d$export$f8cff34f39c1932a({ children: children }) {
    const props = $6fd199a57804d61d$var$useHydrateFallbackProps();
    return $5iwRF.cloneElement(children, props);
}
function $6fd199a57804d61d$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps2() {
        const props = $6fd199a57804d61d$var$useHydrateFallbackProps();
        return $5iwRF.createElement(HydrateFallback, props);
    };
}
function $6fd199a57804d61d$var$useErrorBoundaryProps() {
    return {
        params: $6fd199a57804d61d$export$99eaa27ddbbb95ef(),
        loaderData: $6fd199a57804d61d$export$1448a5050d252c4d(),
        actionData: $6fd199a57804d61d$export$fdc00f3f26066d5e(),
        error: $6fd199a57804d61d$export$ed527bf60f6e05f2()
    };
}
function $6fd199a57804d61d$export$e5afde5c4b6d747b({ children: children }) {
    const props = $6fd199a57804d61d$var$useErrorBoundaryProps();
    return $5iwRF.cloneElement(children, props);
}
function $6fd199a57804d61d$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps2() {
        const props = $6fd199a57804d61d$var$useErrorBoundaryProps();
        return $5iwRF.createElement(ErrorBoundary, props);
    };
}
// lib/dom/dom.ts
var $6fd199a57804d61d$var$defaultMethod = "get";
var $6fd199a57804d61d$var$defaultEncType = "application/x-www-form-urlencoded";
function $6fd199a57804d61d$var$isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function $6fd199a57804d61d$var$isButtonElement(object) {
    return $6fd199a57804d61d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $6fd199a57804d61d$var$isFormElement(object) {
    return $6fd199a57804d61d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $6fd199a57804d61d$var$isInputElement(object) {
    return $6fd199a57804d61d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $6fd199a57804d61d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $6fd199a57804d61d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$6fd199a57804d61d$var$isModifiedEvent(event);
}
function $6fd199a57804d61d$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $6fd199a57804d61d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $6fd199a57804d61d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $6fd199a57804d61d$var$_formDataSupportsSubmitter = null;
function $6fd199a57804d61d$var$isFormDataSubmitterSupported() {
    if ($6fd199a57804d61d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $6fd199a57804d61d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $6fd199a57804d61d$var$_formDataSupportsSubmitter = true;
    }
    return $6fd199a57804d61d$var$_formDataSupportsSubmitter;
}
var $6fd199a57804d61d$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $6fd199a57804d61d$var$getFormEncType(encType) {
    if (encType != null && !$6fd199a57804d61d$var$supportedFormEncTypes.has(encType)) {
        $6fd199a57804d61d$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$6fd199a57804d61d$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $6fd199a57804d61d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($6fd199a57804d61d$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $6fd199a57804d61d$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("method") || $6fd199a57804d61d$var$defaultMethod;
        encType = $6fd199a57804d61d$var$getFormEncType(target.getAttribute("enctype")) || $6fd199a57804d61d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($6fd199a57804d61d$var$isButtonElement(target) || $6fd199a57804d61d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $6fd199a57804d61d$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $6fd199a57804d61d$var$defaultMethod;
        encType = $6fd199a57804d61d$var$getFormEncType(target.getAttribute("formenctype")) || $6fd199a57804d61d$var$getFormEncType(form.getAttribute("enctype")) || $6fd199a57804d61d$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$6fd199a57804d61d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($6fd199a57804d61d$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $6fd199a57804d61d$var$defaultMethod;
        action = null;
        encType = $6fd199a57804d61d$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// vendor/turbo-stream-v2/utils.ts
var $6fd199a57804d61d$var$HOLE = -1;
var $6fd199a57804d61d$var$NAN = -2;
var $6fd199a57804d61d$var$NEGATIVE_INFINITY = -3;
var $6fd199a57804d61d$var$NEGATIVE_ZERO = -4;
var $6fd199a57804d61d$var$NULL = -5;
var $6fd199a57804d61d$var$POSITIVE_INFINITY = -6;
var $6fd199a57804d61d$var$UNDEFINED = -7;
var $6fd199a57804d61d$var$TYPE_BIGINT = "B";
var $6fd199a57804d61d$var$TYPE_DATE = "D";
var $6fd199a57804d61d$var$TYPE_ERROR = "E";
var $6fd199a57804d61d$var$TYPE_MAP = "M";
var $6fd199a57804d61d$var$TYPE_NULL_OBJECT = "N";
var $6fd199a57804d61d$var$TYPE_PROMISE = "P";
var $6fd199a57804d61d$var$TYPE_REGEXP = "R";
var $6fd199a57804d61d$var$TYPE_SET = "S";
var $6fd199a57804d61d$var$TYPE_SYMBOL = "Y";
var $6fd199a57804d61d$var$TYPE_URL = "U";
var $6fd199a57804d61d$var$TYPE_PREVIOUS_RESOLVED = "Z";
var $6fd199a57804d61d$var$SUPPORTED_ERROR_TYPES = [
    "EvalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
];
var $6fd199a57804d61d$var$Deferred2 = class {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $6fd199a57804d61d$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// vendor/turbo-stream-v2/flatten.ts
var $6fd199a57804d61d$var$TIME_LIMIT_MS = 1;
var $6fd199a57804d61d$var$getNow = ()=>Date.now();
var $6fd199a57804d61d$var$yieldToMain = ()=>new Promise((resolve)=>setTimeout(resolve, 0));
async function $6fd199a57804d61d$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return $6fd199a57804d61d$var$UNDEFINED;
    if (input === null) return $6fd199a57804d61d$var$NULL;
    if (Number.isNaN(input)) return $6fd199a57804d61d$var$NAN;
    if (input === Number.POSITIVE_INFINITY) return $6fd199a57804d61d$var$POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $6fd199a57804d61d$var$NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $6fd199a57804d61d$var$NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    const stack = [
        [
            input,
            index
        ]
    ];
    await $6fd199a57804d61d$var$stringify.call(this, stack);
    return index;
}
async function $6fd199a57804d61d$var$stringify(stack) {
    const { deferred: deferred, indices: indices, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    let lastYieldTime = $6fd199a57804d61d$var$getNow();
    const flattenValue = (value)=>{
        const existing = indices.get(value);
        if (existing) return [
            existing
        ];
        if (value === void 0) return $6fd199a57804d61d$var$UNDEFINED;
        if (value === null) return $6fd199a57804d61d$var$NULL;
        if (Number.isNaN(value)) return $6fd199a57804d61d$var$NAN;
        if (value === Number.POSITIVE_INFINITY) return $6fd199a57804d61d$var$POSITIVE_INFINITY;
        if (value === Number.NEGATIVE_INFINITY) return $6fd199a57804d61d$var$NEGATIVE_INFINITY;
        if (value === 0 && 1 / value < 0) return $6fd199a57804d61d$var$NEGATIVE_ZERO;
        const index = this.index++;
        indices.set(value, index);
        stack.push([
            value,
            index
        ]);
        return index;
    };
    let i = 0;
    while(stack.length > 0){
        const now = $6fd199a57804d61d$var$getNow();
        if (++i % 6e3 === 0 && now - lastYieldTime >= $6fd199a57804d61d$var$TIME_LIMIT_MS) {
            await $6fd199a57804d61d$var$yieldToMain();
            lastYieldTime = $6fd199a57804d61d$var$getNow();
        }
        const [input, index] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${flattenValue(k)}":${flattenValue(obj[k])}`).join(",");
        let error = null;
        switch(typeof input){
            case "boolean":
            case "number":
            case "string":
                str[index] = JSON.stringify(input);
                break;
            case "bigint":
                str[index] = `["${$6fd199a57804d61d$var$TYPE_BIGINT}","${input}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index] = `["${$6fd199a57804d61d$var$TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input) {
                        str[index] = `${$6fd199a57804d61d$var$NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i2 = 0; i2 < input.length; i2++)result += (i2 ? "," : "") + (i2 in input ? flattenValue(input[i2]) : $6fd199a57804d61d$var$HOLE);
                            str[index] = `${result}]`;
                        } else if (input instanceof Date) {
                            const dateTime = input.getTime();
                            str[index] = `["${$6fd199a57804d61d$var$TYPE_DATE}",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input instanceof URL) str[index] = `["${$6fd199a57804d61d$var$TYPE_URL}",${JSON.stringify(input.href)}]`;
                        else if (input instanceof RegExp) str[index] = `["${$6fd199a57804d61d$var$TYPE_REGEXP}",${JSON.stringify(input.source)},${JSON.stringify(input.flags)}]`;
                        else if (input instanceof Set) {
                            if (input.size > 0) str[index] = `["${$6fd199a57804d61d$var$TYPE_SET}",${[
                                ...input
                            ].map((val)=>flattenValue(val)).join(",")}]`;
                            else str[index] = `["${$6fd199a57804d61d$var$TYPE_SET}"]`;
                        } else if (input instanceof Map) {
                            if (input.size > 0) str[index] = `["${$6fd199a57804d61d$var$TYPE_MAP}",${[
                                ...input
                            ].flatMap(([k, v])=>[
                                    flattenValue(k),
                                    flattenValue(v)
                                ]).join(",")}]`;
                            else str[index] = `["${$6fd199a57804d61d$var$TYPE_MAP}"]`;
                        } else if (input instanceof Promise) {
                            str[index] = `["${$6fd199a57804d61d$var$TYPE_PROMISE}",${index}]`;
                            deferred[index] = input;
                        } else if (input instanceof Error) {
                            str[index] = `["${$6fd199a57804d61d$var$TYPE_ERROR}",${JSON.stringify(input.message)}`;
                            if (input.name !== "Error") str[index] += `,${JSON.stringify(input.name)}`;
                            str[index] += "]";
                        } else if (Object.getPrototypeOf(input) === null) str[index] = `["${$6fd199a57804d61d$var$TYPE_NULL_OBJECT}",{${partsForObj(input)}}]`;
                        else if ($6fd199a57804d61d$var$isPlainObject2(input)) str[index] = `{${partsForObj(input)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                    str[index] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
var $6fd199a57804d61d$var$objectProtoNames2 = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $6fd199a57804d61d$var$isPlainObject2(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $6fd199a57804d61d$var$objectProtoNames2;
}
// vendor/turbo-stream-v2/unflatten.ts
var $6fd199a57804d61d$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $6fd199a57804d61d$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $6fd199a57804d61d$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $6fd199a57804d61d$var$hydrate.call(this, startIndex);
}
function $6fd199a57804d61d$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index2, set] = stack.pop();
        switch(index2){
            case $6fd199a57804d61d$var$UNDEFINED:
                set(void 0);
                continue;
            case $6fd199a57804d61d$var$NULL:
                set(null);
                continue;
            case $6fd199a57804d61d$var$NAN:
                set(NaN);
                continue;
            case $6fd199a57804d61d$var$POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $6fd199a57804d61d$var$NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $6fd199a57804d61d$var$NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        if (hydrated[index2]) {
            set(hydrated[index2]);
            continue;
        }
        const value = values[index2];
        if (!value || typeof value !== "object") {
            hydrated[index2] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $6fd199a57804d61d$var$TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        continue;
                    case $6fd199a57804d61d$var$TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        continue;
                    case $6fd199a57804d61d$var$TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        continue;
                    case $6fd199a57804d61d$var$TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        continue;
                    case $6fd199a57804d61d$var$TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        continue;
                    case $6fd199a57804d61d$var$TYPE_SET:
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $6fd199a57804d61d$var$TYPE_MAP:
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $6fd199a57804d61d$var$TYPE_NULL_OBJECT:
                        const obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $6fd199a57804d61d$var$TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            const d = new $6fd199a57804d61d$var$Deferred2();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        continue;
                    case $6fd199a57804d61d$var$TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $6fd199a57804d61d$var$globalObj && $6fd199a57804d61d$var$SUPPORTED_ERROR_TYPES.includes(errorType) && errorType in $6fd199a57804d61d$var$globalObj && typeof $6fd199a57804d61d$var$globalObj[errorType] === "function" ? new $6fd199a57804d61d$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        continue;
                    case $6fd199a57804d61d$var$TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index2] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v2)=>{
                                        r[i] = v2;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result2 = plugin(value[0], ...r);
                                    if (result2) {
                                        set(hydrated[index2] = result2.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index2] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $6fd199a57804d61d$var$HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index2] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
// vendor/turbo-stream-v2/turbo-stream.ts
async function $6fd199a57804d61d$var$decode(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new $6fd199a57804d61d$var$Deferred2();
    const reader = readable.pipeThrough($6fd199a57804d61d$var$createLineSplittingTransform()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $6fd199a57804d61d$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $6fd199a57804d61d$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $6fd199a57804d61d$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $6fd199a57804d61d$var$unflatten.call(this, line)
    };
}
async function $6fd199a57804d61d$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $6fd199a57804d61d$var$TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $6fd199a57804d61d$var$unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $6fd199a57804d61d$var$TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $6fd199a57804d61d$var$unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $6fd199a57804d61d$export$c564cdbbe6da493(input, options) {
    const { onComplete: onComplete, plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = await $6fd199a57804d61d$var$flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}
`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]
`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            let processingChain = Promise.resolve();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                        encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            processingChain = processingChain.then(async ()=>{
                                const id2 = await $6fd199a57804d61d$var$flatten.call(encoder, resolved);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$6fd199a57804d61d$var$TYPE_PROMISE}${deferredId}:[["${$6fd199a57804d61d$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$6fd199a57804d61d$var$TYPE_PROMISE}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$6fd199a57804d61d$var$TYPE_PROMISE}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }, (reason)=>{
                            processingChain = processingChain.then(async ()=>{
                                if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                                const id2 = await $6fd199a57804d61d$var$flatten.call(encoder, reason);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$6fd199a57804d61d$var$TYPE_ERROR}${deferredId}:[["${$6fd199a57804d61d$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$6fd199a57804d61d$var$TYPE_ERROR}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$6fd199a57804d61d$var$TYPE_ERROR}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            await processingChain;
            controller.close();
            onComplete?.();
        }
    });
    return readable;
}
// lib/dom/ssr/data.ts
async function $6fd199a57804d61d$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/markup.ts
var $6fd199a57804d61d$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $6fd199a57804d61d$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $6fd199a57804d61d$export$4cf11838cdc2a8a8(html) {
    return html.replace($6fd199a57804d61d$var$ESCAPE_REGEX, (match)=>$6fd199a57804d61d$var$ESCAPE_LOOKUP[match]);
}
// lib/dom/ssr/invariant.ts
function $6fd199a57804d61d$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/single-fetch.tsx
var $6fd199a57804d61d$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $6fd199a57804d61d$var$SingleFetchNoResultError = class extends Error {
};
var $6fd199a57804d61d$export$ae9272e641ead836 = 202;
var $6fd199a57804d61d$export$e35ccdcde387134d = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205
]);
function $6fd199a57804d61d$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $5iwRF.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$6fd199a57804d61d$export$4cf11838cdc2a8a8(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $5iwRF.createElement($5iwRF.Fragment, null, scriptTag, /* @__PURE__ */ $5iwRF.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $5iwRF.createElement($5iwRF.Fragment, null, scriptTag, /* @__PURE__ */ $5iwRF.createElement($5iwRF.Suspense, null, /* @__PURE__ */ $5iwRF.createElement($6fd199a57804d61d$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $6fd199a57804d61d$export$77d7799427e365da(getRouter, manifest, routeModules, ssr, basename, trailingSlashAware) {
    let dataStrategy = $6fd199a57804d61d$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        $6fd199a57804d61d$var$invariant2(manifestRoute, "Route not found in manifest");
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader
        };
    }, $6fd199a57804d61d$var$fetchAndDecodeViaTurboStream, ssr, basename, trailingSlashAware);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $6fd199a57804d61d$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $6fd199a57804d61d$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $6fd199a57804d61d$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware);
        if (fetcherKey) return $6fd199a57804d61d$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        return $6fd199a57804d61d$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut);
    };
}
async function $6fd199a57804d61d$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let actionMatch = args.matches.find((m)=>m.shouldCallHandler());
    $6fd199a57804d61d$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let { data: data2, status: status } = await fetchAndDecode(args, basename, trailingSlashAware, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $6fd199a57804d61d$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($6fd199a57804d61d$export$3f1eb41d9a6a6a27(result.result) || $6fd199a57804d61d$export$972111febbeef05b(result.result) || $6fd199a57804d61d$export$e0163cfdf7bc9cfa(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $6fd199a57804d61d$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $6fd199a57804d61d$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
            try {
                let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
                let routeId = m.route.id;
                let result = hasClientLoader ? await handler(async ()=>{
                    let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                        routeId
                    ]);
                    return $6fd199a57804d61d$var$unwrapSingleFetchResult(data2, routeId);
                }) : await handler();
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    return results;
}
async function $6fd199a57804d61d$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$6fd199a57804d61d$var$createDeferred2());
    let singleFetchDfd = $6fd199a57804d61d$var$createDeferred2();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
            let shouldCall = m.shouldCallHandler(defaultShouldRevalidate);
            if (!shouldCall) {
                foundOptOutRoute || (foundOptOutRoute = m.shouldRevalidateArgs != null && // This is a revalidation,
                hasLoader);
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    let result = await handler(async ()=>{
                        let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                            routeId
                        ]);
                        return $6fd199a57804d61d$var$unwrapSingleFetchResult(data2, routeId);
                    });
                    results[routeId] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $6fd199a57804d61d$var$unwrapSingleFetchResult(data2, routeId);
                });
                results[routeId] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    let isInitialLoad = !router.state.initialized && router.state.navigation.state === "idle";
    if ((isInitialLoad || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data2 = await fetchAndDecode(args, basename, trailingSlashAware, targetRoutes);
            singleFetchDfd.resolve(data2.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $6fd199a57804d61d$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $6fd199a57804d61d$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    if (results[match.route.id]?.result == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $6fd199a57804d61d$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch (e) {}
}
async function $6fd199a57804d61d$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let fetcherMatch = args.matches.find((m)=>m.shouldCallHandler());
    $6fd199a57804d61d$var$invariant2(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                routeId
            ]);
            return $6fd199a57804d61d$var$unwrapSingleFetchResult(data2, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $6fd199a57804d61d$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $6fd199a57804d61d$export$7b977381851b2c(reqUrl, basename, trailingSlashAware, extension) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (trailingSlashAware) {
        if (url.pathname.endsWith("/")) url.pathname = `${url.pathname}_.${extension}`;
        else url.pathname = `${url.pathname}.${extension}`;
    } else {
        if (url.pathname === "/") url.pathname = `_root.${extension}`;
        else if (basename && $6fd199a57804d61d$export$b69e3301ce081aa3(url.pathname, basename) === "/") url.pathname = `${$6fd199a57804d61d$var$removeTrailingSlash(basename)}/_root.${extension}`;
        else url.pathname = `${$6fd199a57804d61d$var$removeTrailingSlash(url.pathname)}.${extension}`;
    }
    return url;
}
async function $6fd199a57804d61d$var$fetchAndDecodeViaTurboStream(args, basename, trailingSlashAware, targetRoutes) {
    let { request: request } = args;
    let url = $6fd199a57804d61d$export$7b977381851b2c(request.url, basename, trailingSlashAware, "data");
    if (request.method === "GET") {
        url = $6fd199a57804d61d$export$425969b7f98e2c9c(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await $6fd199a57804d61d$export$a30aa2a0fce6c468(request));
    if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new $6fd199a57804d61d$export$f2680fa305b734ca(res.status, res.statusText, await res.text());
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: $6fd199a57804d61d$export$ae9272e641ead836,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($6fd199a57804d61d$export$e35ccdcde387134d.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    $6fd199a57804d61d$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $6fd199a57804d61d$export$4023ad4ecd4126a2(res.body, window);
        let data2;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($6fd199a57804d61d$export$60644022b8b46aaa in typed) data2 = {
                redirect: typed[$6fd199a57804d61d$export$60644022b8b46aaa]
            };
            else data2 = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes?.[0];
            $6fd199a57804d61d$var$invariant2(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data2 = {
                redirect: typed
            };
            else data2 = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data2
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $6fd199a57804d61d$export$4023ad4ecd4126a2(body, global) {
    return $6fd199a57804d61d$var$decode(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && $6fd199a57804d61d$var$SUPPORTED_ERROR_TYPES.includes(name) && name in global && // @ts-expect-error
                    typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $6fd199a57804d61d$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$6fd199a57804d61d$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $6fd199a57804d61d$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace2, status: status } = result.redirect;
        throw $6fd199a57804d61d$export$89e12c5b50f7529d(location, {
            status: status,
            headers: {
                // Three R's of redirecting (lol Veep)
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace2 ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $6fd199a57804d61d$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $6fd199a57804d61d$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
// lib/dom/ssr/routeModules.ts
async function $6fd199a57804d61d$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $6fd199a57804d61d$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $6fd199a57804d61d$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2);
    let preloads = $6fd199a57804d61d$var$getModuleLinkHrefs(matches, manifest);
    return $6fd199a57804d61d$var$dedupeLinkDescriptors(descriptors, preloads);
}
function $6fd199a57804d61d$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $6fd199a57804d61d$var$prefetchRouteCss(route) {
    if (!route.css) return;
    let descriptors = $6fd199a57804d61d$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($6fd199a57804d61d$var$prefetchStyleLink));
}
async function $6fd199a57804d61d$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$6fd199a57804d61d$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$6fd199a57804d61d$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$6fd199a57804d61d$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($6fd199a57804d61d$var$prefetchStyleLink));
}
async function $6fd199a57804d61d$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $6fd199a57804d61d$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $6fd199a57804d61d$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $6fd199a57804d61d$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $6fd199a57804d61d$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $6fd199a57804d61d$var$dedupeLinkDescriptors(links.flat(1).filter($6fd199a57804d61d$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $6fd199a57804d61d$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $6fd199a57804d61d$var$getModuleLinkHrefs(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $6fd199a57804d61d$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $6fd199a57804d61d$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $6fd199a57804d61d$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $6fd199a57804d61d$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$6fd199a57804d61d$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($6fd199a57804d61d$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $6fd199a57804d61d$var$_isPreloadSupported;
function $6fd199a57804d61d$var$isPreloadSupported() {
    if ($6fd199a57804d61d$var$_isPreloadSupported !== void 0) return $6fd199a57804d61d$var$_isPreloadSupported;
    let el = document.createElement("link");
    $6fd199a57804d61d$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $6fd199a57804d61d$var$_isPreloadSupported;
}
function $6fd199a57804d61d$var$RemixRootDefaultHydrateFallback() {
    return /* @__PURE__ */ $5iwRF.createElement($6fd199a57804d61d$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, $6fd199a57804d61d$export$945fecf35a8ef089 ? /* @__PURE__ */ $5iwRF.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://reactrouter.com/start/framework/route-module#hydratefallback " +
                "for more information."
              );
            `
        }
    }) : null);
}
// lib/dom/ssr/routes.tsx
function $6fd199a57804d61d$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $6fd199a57804d61d$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $6fd199a57804d61d$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $6fd199a57804d61d$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $5iwRF.createElement($6fd199a57804d61d$var$RemixRootDefaultErrorBoundary, {
            error: $6fd199a57804d61d$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ $5iwRF.createElement(routeModule.Layout, null, /* @__PURE__ */ $5iwRF.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $5iwRF.createElement(routeModule.Layout, null, /* @__PURE__ */ $5iwRF.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $5iwRF.createElement(routeModule.Layout, null, /* @__PURE__ */ $5iwRF.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $6fd199a57804d61d$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $6fd199a57804d61d$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $6fd199a57804d61d$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$6fd199a57804d61d$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $6fd199a57804d61d$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $6fd199a57804d61d$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $6fd199a57804d61d$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $6fd199a57804d61d$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $6fd199a57804d61d$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new $6fd199a57804d61d$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $6fd199a57804d61d$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $6fd199a57804d61d$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $6fd199a57804d61d$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $6fd199a57804d61d$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $6fd199a57804d61d$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $6fd199a57804d61d$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $6fd199a57804d61d$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$6fd199a57804d61d$var$getRouteComponents(route, routeModule, isSpaMode),
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $6fd199a57804d61d$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                let _isHydrationRequest = isHydrationRequest;
                isHydrationRequest = false;
                let result = await prefetchStylesAndCallHandler(async ()=>{
                    $6fd199a57804d61d$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                    if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                    return routeModule.clientLoader({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverLoader () {
                            $6fd199a57804d61d$var$preventInvalidServerHandlerCall("loader", route);
                            if (_isHydrationRequest) {
                                if (hasInitialData) return initialData;
                                if (hasInitialError) throw initialError;
                            }
                            return fetchServerLoader(singleFetch);
                        }
                    });
                });
                return result;
            };
            dataRoute.loader.hydrate = $6fd199a57804d61d$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $6fd199a57804d61d$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $6fd199a57804d61d$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverAction () {
                            $6fd199a57804d61d$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $6fd199a57804d61d$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $6fd199a57804d61d$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    $6fd199a57804d61d$var$invariant2(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $6fd199a57804d61d$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    $6fd199a57804d61d$var$invariant2(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $6fd199a57804d61d$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    $6fd199a57804d61d$var$invariant2(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $6fd199a57804d61d$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                // No need to wrap these in layout since the root route is never
                // loaded via route.lazy()
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $6fd199a57804d61d$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $6fd199a57804d61d$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $6fd199a57804d61d$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? $6fd199a57804d61d$var$compilePath(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    return route.shouldRevalidate;
}
function $6fd199a57804d61d$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $6fd199a57804d61d$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = $6fd199a57804d61d$var$loadRouteModule(route, routeModules);
    let prefetchRouteCssPromise = $6fd199a57804d61d$var$prefetchRouteCss(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        $6fd199a57804d61d$var$prefetchStyleLinks(route, routeModule)
    ]);
    return {
        Component: $6fd199a57804d61d$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $6fd199a57804d61d$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $6fd199a57804d61d$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $6fd199a57804d61d$var$nextPaths = /* @__PURE__ */ new Set();
var $6fd199a57804d61d$var$discoveredPathsMaxSize = 1e3;
var $6fd199a57804d61d$var$discoveredPaths = /* @__PURE__ */ new Set();
var $6fd199a57804d61d$export$b5915cf27fa06b9f = 7680;
function $6fd199a57804d61d$var$isFogOfWarEnabled(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function $6fd199a57804d61d$var$getPartialManifest({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $6fd199a57804d61d$export$5c7b09132f833c25(router.routes, path, router.basename || "/", false, router.branches);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $6fd199a57804d61d$export$72ab377a1030deb9(getRouter, manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$6fd199a57804d61d$var$isFogOfWarEnabled(routeDiscovery, ssr)) return void 0;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($6fd199a57804d61d$var$discoveredPaths.has(path)) return;
        let { state: state } = getRouter();
        await $6fd199a57804d61d$var$fetchAndApplyManifestPatches([
            path
        ], // If we're patching for a fetcher call, reload the current location
        // Otherwise prefer any ongoing navigation location
        fetcherKey ? window.location.href : $6fd199a57804d61d$export$fe53371bee54353d(state.navigation.location || state.location), manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $6fd199a57804d61d$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $5iwRF.useEffect(()=>{
        if (!$6fd199a57804d61d$var$isFogOfWarEnabled(routeDiscovery, ssr) || // @ts-expect-error - TS doesn't know about this yet
        window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$6fd199a57804d61d$var$discoveredPaths.has(pathname)) $6fd199a57804d61d$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($6fd199a57804d61d$var$nextPaths.keys()).filter((path)=>{
                if ($6fd199a57804d61d$var$discoveredPaths.has(path)) {
                    $6fd199a57804d61d$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $6fd199a57804d61d$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $6fd199a57804d61d$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $6fd199a57804d61d$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    return basename == null ? manifestPath : $6fd199a57804d61d$var$joinPaths([
        basename,
        manifestPath
    ]);
}
var $6fd199a57804d61d$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
async function $6fd199a57804d61d$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    const searchParams = new URLSearchParams();
    searchParams.set("paths", paths.sort().join(","));
    searchParams.set("version", manifest.version);
    let url = new URL($6fd199a57804d61d$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > $6fd199a57804d61d$export$b5915cf27fa06b9f) {
        $6fd199a57804d61d$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        else if (res.status === 204 && res.headers.has("X-Remix-Reload-Document")) {
            if (!errorReloadPath) {
                console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                return;
            }
            try {
                if (sessionStorage.getItem($6fd199a57804d61d$var$MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                    console.error("Unable to discover routes due to manifest version mismatch.");
                    return;
                }
                sessionStorage.setItem($6fd199a57804d61d$var$MANIFEST_VERSION_STORAGE_KEY, manifest.version);
            } catch  {}
            window.location.href = errorReloadPath;
            console.warn("Detected manifest version mismatch, reloading...");
            await new Promise(()=>{});
        } else if (res.status >= 400) throw new Error(await res.text());
        try {
            sessionStorage.removeItem($6fd199a57804d61d$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch  {}
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$6fd199a57804d61d$var$addToFifoQueue(p, $6fd199a57804d61d$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $6fd199a57804d61d$export$af76e85f27ba0229(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $6fd199a57804d61d$var$addToFifoQueue(path, queue) {
    if (queue.size >= $6fd199a57804d61d$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $6fd199a57804d61d$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $6fd199a57804d61d$var$useDataRouterContext2() {
    let context = $5iwRF.useContext($6fd199a57804d61d$export$2eeee58951ff3c1c);
    $6fd199a57804d61d$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $6fd199a57804d61d$var$useDataRouterStateContext() {
    let context = $5iwRF.useContext($6fd199a57804d61d$export$315e3ffb01f217);
    $6fd199a57804d61d$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $6fd199a57804d61d$export$208d6a3bc3aa62bd = $5iwRF.createContext(void 0);
$6fd199a57804d61d$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $6fd199a57804d61d$var$useFrameworkContext() {
    let context = $5iwRF.useContext($6fd199a57804d61d$export$208d6a3bc3aa62bd);
    $6fd199a57804d61d$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $6fd199a57804d61d$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $5iwRF.useContext($6fd199a57804d61d$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $5iwRF.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $5iwRF.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $5iwRF.useRef(null);
    $5iwRF.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $5iwRF.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $6fd199a57804d61d$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $6fd199a57804d61d$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $6fd199a57804d61d$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $6fd199a57804d61d$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $6fd199a57804d61d$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $6fd199a57804d61d$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $6fd199a57804d61d$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$6fd199a57804d61d$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
var $6fd199a57804d61d$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
function $6fd199a57804d61d$export$b2e089eb3692b073({ nonce: nonce, crossOrigin: crossOrigin }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss } = $6fd199a57804d61d$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $6fd199a57804d61d$var$useDataRouterStateContext();
    let matches = $6fd199a57804d61d$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $5iwRF.useMemo(()=>$6fd199a57804d61d$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    return /* @__PURE__ */ $5iwRF.createElement($5iwRF.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $5iwRF.createElement("style", {
        [$6fd199a57804d61d$export$7e4ed4715c00dab0]: "",
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $5iwRF.createElement("link", {
        [$6fd199a57804d61d$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce,
        crossOrigin: crossOrigin
    }) : null, keyedLinks.map(({ key: key, link: link })=>$6fd199a57804d61d$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $5iwRF.createElement($6fd199a57804d61d$export$60dcec93e67386bd, {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        }) : /* @__PURE__ */ $5iwRF.createElement("link", {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        })));
}
function $6fd199a57804d61d$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let rsc = $6fd199a57804d61d$var$useIsRSCRouterContext();
    let { router: router } = $6fd199a57804d61d$var$useDataRouterContext2();
    let matches = $5iwRF.useMemo(()=>$6fd199a57804d61d$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    if (rsc) return /* @__PURE__ */ $5iwRF.createElement($6fd199a57804d61d$var$RSCPrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
    return /* @__PURE__ */ $5iwRF.createElement($6fd199a57804d61d$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $6fd199a57804d61d$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $6fd199a57804d61d$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $5iwRF.useState([]);
    $5iwRF.useEffect(()=>{
        let interrupted = false;
        $6fd199a57804d61d$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $6fd199a57804d61d$var$RSCPrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $6fd199a57804d61d$export$45d76561a5302f2b();
    let { future: future } = $6fd199a57804d61d$var$useFrameworkContext();
    let { basename: basename } = $6fd199a57804d61d$var$useDataRouterContext2();
    let dataHrefs = $5iwRF.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let url = $6fd199a57804d61d$export$7b977381851b2c(page, basename, future.unstable_trailingSlashAwareDataRequests, "rsc");
        let hasSomeRoutesWithShouldRevalidate = false;
        let targetRoutes = [];
        for (let match of nextMatches)if (typeof match.route.shouldRevalidate === "function") hasSomeRoutesWithShouldRevalidate = true;
        else targetRoutes.push(match.route.id);
        if (hasSomeRoutesWithShouldRevalidate && targetRoutes.length > 0) url.searchParams.set("_routes", targetRoutes.join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.unstable_trailingSlashAwareDataRequests,
        page,
        location,
        nextMatches
    ]);
    return /* @__PURE__ */ $5iwRF.createElement($5iwRF.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $5iwRF.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })));
}
function $6fd199a57804d61d$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $6fd199a57804d61d$export$45d76561a5302f2b();
    let { future: future, manifest: manifest, routeModules: routeModules } = $6fd199a57804d61d$var$useFrameworkContext();
    let { basename: basename } = $6fd199a57804d61d$var$useDataRouterContext2();
    let { loaderData: loaderData, matches: matches } = $6fd199a57804d61d$var$useDataRouterStateContext();
    let newMatchesForData = $5iwRF.useMemo(()=>$6fd199a57804d61d$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $5iwRF.useMemo(()=>$6fd199a57804d61d$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $5iwRF.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $6fd199a57804d61d$export$7b977381851b2c(page, basename, future.unstable_trailingSlashAwareDataRequests, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.unstable_trailingSlashAwareDataRequests,
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $5iwRF.useMemo(()=>$6fd199a57804d61d$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $6fd199a57804d61d$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $5iwRF.createElement($5iwRF.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $5iwRF.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $5iwRF.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $5iwRF.createElement("link", {
            key: key,
            nonce: linkProps.nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? linkProps.crossOrigin
        })));
}
function $6fd199a57804d61d$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $6fd199a57804d61d$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $6fd199a57804d61d$var$useDataRouterStateContext();
    let location = $6fd199a57804d61d$export$45d76561a5302f2b();
    let _matches = $6fd199a57804d61d$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            loaderData: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            loaderData: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://reactrouter.com/start/framework/route-module#meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $5iwRF.createElement($5iwRF.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$6fd199a57804d61d$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $5iwRF.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $5iwRF.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ?? (metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $5iwRF.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $5iwRF.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: $6fd199a57804d61d$export$4cf11838cdc2a8a8(json)
                }
            });
        } catch (e) {
            return null;
        }
        return /* @__PURE__ */ $5iwRF.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $6fd199a57804d61d$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $6fd199a57804d61d$var$isHydrated = false;
function $6fd199a57804d61d$export$3be068dde909e563() {
    $6fd199a57804d61d$var$isHydrated = true;
}
function $6fd199a57804d61d$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr } = $6fd199a57804d61d$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $6fd199a57804d61d$var$useDataRouterContext2();
    let { matches: routerMatches } = $6fd199a57804d61d$var$useDataRouterStateContext();
    let isRSCRouterContext = $6fd199a57804d61d$var$useIsRSCRouterContext();
    let enableFogOfWar = $6fd199a57804d61d$var$isFogOfWarEnabled(routeDiscovery, ssr);
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $6fd199a57804d61d$var$getActiveMatches(routerMatches, null, isSpaMode);
    $5iwRF.useEffect(()=>{
        $6fd199a57804d61d$export$3be068dde909e563();
    }, []);
    let initialScripts = $5iwRF.useMemo(()=>{
        if (isRSCRouterContext) return null;
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            $6fd199a57804d61d$var$invariant2(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            let chunkImportsSnippet = chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n");
            let mergedChunksSnippet = `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`;
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($6fd199a57804d61d$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $5iwRF.createElement($5iwRF.Fragment, null, /* @__PURE__ */ $5iwRF.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        }), /* @__PURE__ */ $5iwRF.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $6fd199a57804d61d$var$isHydrated || isRSCRouterContext ? [] : [
        // Dedupe through a Set
        ...new Set(manifest.entry.imports.concat($6fd199a57804d61d$var$getModuleLinkHrefs(matches, manifest, {
            includeHydrateFallback: true
        })))
    ];
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    $6fd199a57804d61d$export$5b28268982f175ba(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $6fd199a57804d61d$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $5iwRF.createElement($5iwRF.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $5iwRF.createElement("script", {
        ...scriptProps,
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $5iwRF.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $5iwRF.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $5iwRF.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            nonce: scriptProps.nonce,
            suppressHydrationWarning: true
        })), initialScripts);
}
function $6fd199a57804d61d$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/ssr/errorBoundaries.tsx
var $6fd199a57804d61d$export$32e57f52df4b6e34 = class extends $5iwRF.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $5iwRF.createElement($6fd199a57804d61d$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
function $6fd199a57804d61d$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $5iwRF.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ($6fd199a57804d61d$export$972111febbeef05b(error)) return /* @__PURE__ */ $5iwRF.createElement($6fd199a57804d61d$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $5iwRF.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), $6fd199a57804d61d$export$945fecf35a8ef089 ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $5iwRF.createElement($6fd199a57804d61d$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $5iwRF.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $5iwRF.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $6fd199a57804d61d$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = $6fd199a57804d61d$var$useFrameworkContext();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $5iwRF.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $5iwRF.createElement("head", null, /* @__PURE__ */ $5iwRF.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $5iwRF.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $5iwRF.createElement("title", null, title)), /* @__PURE__ */ $5iwRF.createElement("body", null, /* @__PURE__ */ $5iwRF.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $5iwRF.createElement($6fd199a57804d61d$export$ff0bf87698939488, null) : null)));
}
var $6fd199a57804d61d$var$isBrowser2 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($6fd199a57804d61d$var$isBrowser2) window.__reactRouterVersion = "7.15.1";
} catch (e) {}
function $6fd199a57804d61d$export$1f3f55432a00e06d(routes, opts) {
    return $6fd199a57804d61d$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $6fd199a57804d61d$export$719fc203c4e16dee({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $6fd199a57804d61d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $6fd199a57804d61d$export$9269a41d8c4635e,
        hydrationRouteProperties: $6fd199a57804d61d$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $6fd199a57804d61d$export$1ba7ed8a3a7b3765(routes, opts) {
    return $6fd199a57804d61d$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $6fd199a57804d61d$export$b71fdd3798280242({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $6fd199a57804d61d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $6fd199a57804d61d$export$9269a41d8c4635e,
        hydrationRouteProperties: $6fd199a57804d61d$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $6fd199a57804d61d$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $6fd199a57804d61d$var$deserializeErrors(state.errors)
    };
    return state;
}
function $6fd199a57804d61d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $6fd199a57804d61d$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $6fd199a57804d61d$export$9ba4e89fdfa1fc54({ basename: basename, children: children, useTransitions: useTransitions, window: window2 }) {
    let historyRef = $5iwRF.useRef();
    if (historyRef.current == null) historyRef.current = $6fd199a57804d61d$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $5iwRF.useState({
        action: history.action,
        location: history.location
    });
    let setState = $5iwRF.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $5iwRF.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $5iwRF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $5iwRF.createElement($6fd199a57804d61d$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $6fd199a57804d61d$export$7221d69dcfc8e36b({ basename: basename, children: children, useTransitions: useTransitions, window: window2 }) {
    let historyRef = $5iwRF.useRef();
    if (historyRef.current == null) historyRef.current = $6fd199a57804d61d$export$b71fdd3798280242({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $5iwRF.useState({
        action: history.action,
        location: history.location
    });
    let setState = $5iwRF.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $5iwRF.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $5iwRF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $5iwRF.createElement($6fd199a57804d61d$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $6fd199a57804d61d$export$de73885c9336221c({ basename: basename, children: children, history: history, useTransitions: useTransitions }) {
    let [state, setStateImpl] = $5iwRF.useState({
        action: history.action,
        location: history.location
    });
    let setState = $5iwRF.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $5iwRF.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $5iwRF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $5iwRF.createElement($6fd199a57804d61d$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
$6fd199a57804d61d$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $6fd199a57804d61d$var$ABSOLUTE_URL_REGEX2 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $6fd199a57804d61d$export$a6c7ac8248d6e38a = $5iwRF.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, mask: mask, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...rest }, forwardedRef) {
    let { basename: basename, navigator: navigator, useTransitions: useTransitions } = $5iwRF.useContext($6fd199a57804d61d$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $6fd199a57804d61d$var$ABSOLUTE_URL_REGEX2.test(to);
    let parsed = $6fd199a57804d61d$var$parseToInfo(to, basename);
    to = parsed.to;
    let href = $6fd199a57804d61d$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let location = $6fd199a57804d61d$export$45d76561a5302f2b();
    let maskedHref = null;
    if (mask) {
        let resolved = $6fd199a57804d61d$var$resolveTo(mask, [], location.mask ? location.mask.pathname : "/", true);
        if (basename !== "/") resolved.pathname = resolved.pathname === "/" ? basename : $6fd199a57804d61d$var$joinPaths([
            basename,
            resolved.pathname
        ]);
        maskedHref = navigator.createHref(resolved);
    }
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $6fd199a57804d61d$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $6fd199a57804d61d$export$67621102c14d847(to, {
        replace: replace2,
        mask: mask,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        defaultShouldRevalidate: defaultShouldRevalidate,
        useTransitions: useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let isSpaLink = !(parsed.isExternal || reloadDocument);
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $5iwRF.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: (isSpaLink ? maskedHref : void 0) || parsed.absoluteURL || href,
        onClick: isSpaLink ? handleClick : onClick,
        ref: $6fd199a57804d61d$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $5iwRF.createElement($5iwRF.Fragment, null, link, /* @__PURE__ */ $5iwRF.createElement($6fd199a57804d61d$export$60dcec93e67386bd, {
        page: href
    })) : link;
});
$6fd199a57804d61d$export$a6c7ac8248d6e38a.displayName = "Link";
var $6fd199a57804d61d$export$b0d92dbee9b5b60d = $5iwRF.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = $6fd199a57804d61d$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $6fd199a57804d61d$export$45d76561a5302f2b();
    let routerState = $5iwRF.useContext($6fd199a57804d61d$export$315e3ffb01f217);
    let { navigator: navigator, basename: basename } = $5iwRF.useContext($6fd199a57804d61d$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $6fd199a57804d61d$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $6fd199a57804d61d$export$b69e3301ce081aa3(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $5iwRF.createElement($6fd199a57804d61d$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$6fd199a57804d61d$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $6fd199a57804d61d$export$a7fed597f4b8afd8 = $5iwRF.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $6fd199a57804d61d$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...props }, forwardedRef)=>{
    let { useTransitions: useTransitions } = $5iwRF.useContext($6fd199a57804d61d$export$3044ab7fdabeaee6);
    let submit = $6fd199a57804d61d$export$47c85c6e3a081d3();
    let formAction = $6fd199a57804d61d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $6fd199a57804d61d$var$ABSOLUTE_URL_REGEX2.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        let doSubmit = ()=>submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace2,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
        if (useTransitions && navigate !== false) $5iwRF.startTransition(()=>doSubmit());
        else doSubmit();
    };
    return /* @__PURE__ */ $5iwRF.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$6fd199a57804d61d$export$a7fed597f4b8afd8.displayName = "Form";
function $6fd199a57804d61d$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $5iwRF.useContext($6fd199a57804d61d$export$208d6a3bc3aa62bd);
    let { basename: basename } = $5iwRF.useContext($6fd199a57804d61d$export$3044ab7fdabeaee6);
    let location = $6fd199a57804d61d$export$45d76561a5302f2b();
    let matches = $6fd199a57804d61d$export$2378eb7f5ff86053();
    $6fd199a57804d61d$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $5iwRF.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $6fd199a57804d61d$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    return /* @__PURE__ */ $5iwRF.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${$6fd199a57804d61d$export$4cf11838cdc2a8a8(JSON.stringify(storageKey || $6fd199a57804d61d$var$SCROLL_RESTORATION_STORAGE_KEY))}, ${$6fd199a57804d61d$export$4cf11838cdc2a8a8(JSON.stringify(ssrKey))})`
        }
    });
}
$6fd199a57804d61d$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $6fd199a57804d61d$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $6fd199a57804d61d$var$useDataRouterContext3(hookName) {
    let ctx = $5iwRF.useContext($6fd199a57804d61d$export$2eeee58951ff3c1c);
    $6fd199a57804d61d$export$f5708dca728d7177(ctx, $6fd199a57804d61d$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $6fd199a57804d61d$var$useDataRouterState2(hookName) {
    let state = $5iwRF.useContext($6fd199a57804d61d$export$315e3ffb01f217);
    $6fd199a57804d61d$export$f5708dca728d7177(state, $6fd199a57804d61d$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $6fd199a57804d61d$export$67621102c14d847(to, { target: target, replace: replaceProp, mask: mask, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, useTransitions: useTransitions } = {}) {
    let navigate = $6fd199a57804d61d$export$9770f232ac06a008();
    let location = $6fd199a57804d61d$export$45d76561a5302f2b();
    let path = $6fd199a57804d61d$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $5iwRF.useCallback((event)=>{
        if ($6fd199a57804d61d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $6fd199a57804d61d$export$fe53371bee54353d(location) === $6fd199a57804d61d$export$fe53371bee54353d(path);
            let doNavigate = ()=>navigate(to, {
                    replace: replace2,
                    mask: mask,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition,
                    defaultShouldRevalidate: defaultShouldRevalidate
                });
            if (useTransitions) $5iwRF.startTransition(()=>doNavigate());
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        mask,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        defaultShouldRevalidate,
        useTransitions
    ]);
}
function $6fd199a57804d61d$export$f1a78c17382fe22a(defaultInit) {
    $6fd199a57804d61d$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $5iwRF.useRef($6fd199a57804d61d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $5iwRF.useRef(false);
    let location = $6fd199a57804d61d$export$45d76561a5302f2b();
    let searchParams = $5iwRF.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $6fd199a57804d61d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $6fd199a57804d61d$export$9770f232ac06a008();
    let setSearchParams = $5iwRF.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $6fd199a57804d61d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $6fd199a57804d61d$var$fetcherId = 0;
var $6fd199a57804d61d$var$getUniqueFetcherId = ()=>`__${String(++$6fd199a57804d61d$var$fetcherId)}__`;
function $6fd199a57804d61d$export$47c85c6e3a081d3() {
    let { router: router } = $6fd199a57804d61d$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $5iwRF.useContext($6fd199a57804d61d$export$3044ab7fdabeaee6);
    let currentRouteId = $6fd199a57804d61d$var$useRouteId();
    let routerFetch = router.fetch;
    let routerNavigate = router.navigate;
    return $5iwRF.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $6fd199a57804d61d$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $6fd199a57804d61d$var$getUniqueFetcherId();
            await routerFetch(key, currentRouteId, options.action || action, {
                defaultShouldRevalidate: options.defaultShouldRevalidate,
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await routerNavigate(options.action || action, {
            defaultShouldRevalidate: options.defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
function $6fd199a57804d61d$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $5iwRF.useContext($6fd199a57804d61d$export$3044ab7fdabeaee6);
    let routeContext = $5iwRF.useContext($6fd199a57804d61d$export$aac280ed165a4397);
    $6fd199a57804d61d$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...$6fd199a57804d61d$export$e75d2a2d1b3c245b(action ? action : ".", {
            relative: relative
        })
    };
    let location = $6fd199a57804d61d$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $6fd199a57804d61d$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $6fd199a57804d61d$export$fe53371bee54353d(path);
}
function $6fd199a57804d61d$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = $6fd199a57804d61d$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $6fd199a57804d61d$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $5iwRF.useContext($6fd199a57804d61d$export$cb3f1df1bef00a39);
    let route = $5iwRF.useContext($6fd199a57804d61d$export$aac280ed165a4397);
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    $6fd199a57804d61d$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $6fd199a57804d61d$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $6fd199a57804d61d$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $5iwRF.useId();
    let [fetcherKey, setFetcherKey] = $5iwRF.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    let { deleteFetcher: deleteFetcher, getFetcher: getFetcher, resetFetcher: resetFetcher, fetch: routerFetch } = router;
    $5iwRF.useEffect(()=>{
        getFetcher(fetcherKey);
        return ()=>deleteFetcher(fetcherKey);
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    let load = $5iwRF.useCallback(async (href, opts)=>{
        $6fd199a57804d61d$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await routerFetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    let submitImpl = $6fd199a57804d61d$export$47c85c6e3a081d3();
    let submit = $5iwRF.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let reset = $5iwRF.useCallback((opts)=>resetFetcher(fetcherKey, opts), [
        resetFetcher,
        fetcherKey
    ]);
    let FetcherForm = $5iwRF.useMemo(()=>{
        let FetcherForm2 = $5iwRF.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $5iwRF.createElement($6fd199a57804d61d$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $6fd199a57804d61d$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $5iwRF.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $6fd199a57804d61d$export$fa996778a3a31087() {
    let state = $6fd199a57804d61d$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return $5iwRF.useMemo(()=>Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
                ...fetcher,
                key: key
            })), [
        state.fetchers
    ]);
}
var $6fd199a57804d61d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $6fd199a57804d61d$var$savedScrollPositions = {};
function $6fd199a57804d61d$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: $6fd199a57804d61d$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $6fd199a57804d61d$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $6fd199a57804d61d$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $6fd199a57804d61d$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $5iwRF.useContext($6fd199a57804d61d$export$3044ab7fdabeaee6);
    let location = $6fd199a57804d61d$export$45d76561a5302f2b();
    let matches = $6fd199a57804d61d$export$2378eb7f5ff86053();
    let navigation = $6fd199a57804d61d$export$d0fd4b7106de2769();
    $5iwRF.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $6fd199a57804d61d$var$usePageHide($5iwRF.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $6fd199a57804d61d$var$getScrollRestorationKey(location, matches, basename, getKey);
            $6fd199a57804d61d$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $6fd199a57804d61d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($6fd199a57804d61d$var$savedScrollPositions));
        } catch (error) {
            $6fd199a57804d61d$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $5iwRF.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $6fd199a57804d61d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $6fd199a57804d61d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $5iwRF.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($6fd199a57804d61d$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$6fd199a57804d61d$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $5iwRF.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                $6fd199a57804d61d$var$warning(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $6fd199a57804d61d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $5iwRF.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $6fd199a57804d61d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $5iwRF.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $6fd199a57804d61d$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $6fd199a57804d61d$export$b273b3273281a049(when);
    $5iwRF.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $5iwRF.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $6fd199a57804d61d$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $5iwRF.useContext($6fd199a57804d61d$export$3681f408decb40d1);
    $6fd199a57804d61d$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $6fd199a57804d61d$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $6fd199a57804d61d$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $6fd199a57804d61d$export$b69e3301ce081aa3(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $6fd199a57804d61d$export$b69e3301ce081aa3(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $6fd199a57804d61d$export$81336c211d5ff295(path.pathname, nextPath) != null || $6fd199a57804d61d$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $6fd199a57804d61d$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $6fd199a57804d61d$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default",
        mask: void 0
    };
    let staticNavigator = $6fd199a57804d61d$var$getStatelessNavigator();
    return /* @__PURE__ */ $5iwRF.createElement($6fd199a57804d61d$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true,
        useTransitions: false
    });
}
function $6fd199a57804d61d$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate2 = true, nonce: nonce }) {
    $6fd199a57804d61d$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $6fd199a57804d61d$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate2 !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $6fd199a57804d61d$var$serializeErrors(context.errors)
        };
        let json = $6fd199a57804d61d$export$4cf11838cdc2a8a8(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $5iwRF.createElement($5iwRF.Fragment, null, /* @__PURE__ */ $5iwRF.createElement($6fd199a57804d61d$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $5iwRF.createElement($6fd199a57804d61d$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $5iwRF.createElement($6fd199a57804d61d$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $5iwRF.createElement($6fd199a57804d61d$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $5iwRF.createElement($6fd199a57804d61d$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static,
        useTransitions: false
    }, /* @__PURE__ */ $5iwRF.createElement($6fd199a57804d61d$var$DataRoutes2, {
        manifest: router.manifest,
        routes: router.routes,
        future: router.future,
        state: state,
        isStatic: true
    })))))), hydrateScript ? /* @__PURE__ */ $5iwRF.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $6fd199a57804d61d$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($6fd199a57804d61d$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $6fd199a57804d61d$var$getStatelessNavigator() {
    return {
        createHref: $6fd199a57804d61d$var$createHref,
        encodeLocation: $6fd199a57804d61d$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $6fd199a57804d61d$export$69163f0b72ec60d9(routes, opts) {
    return $6fd199a57804d61d$export$3336b097a6fbc59a(routes, {
        ...opts,
        mapRouteProperties: $6fd199a57804d61d$export$9269a41d8c4635e
    });
}
function $6fd199a57804d61d$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $6fd199a57804d61d$export$87cb1a9238dc3fba(routes, $6fd199a57804d61d$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                v8_middleware: false,
                v8_passThroughRequests: false,
                ...opts?.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                renderFallback: false,
                navigation: $6fd199a57804d61d$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get branches () {
            return opts.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $6fd199a57804d61d$var$createHref,
        encodeLocation: $6fd199a57804d61d$var$encodeLocation,
        getFetcher () {
            return $6fd199a57804d61d$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        resetFetcher () {
            throw msg("resetFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $6fd199a57804d61d$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        },
        _internalSetStateDoNotUseOrYouWillBreakYourApp () {
            throw msg("_internalSetStateDoNotUseOrYouWillBreakYourApp");
        }
    };
}
function $6fd199a57804d61d$var$createHref(to) {
    return typeof to === "string" ? to : $6fd199a57804d61d$export$fe53371bee54353d(to);
}
function $6fd199a57804d61d$var$encodeLocation(to) {
    let href = typeof to === "string" ? to : $6fd199a57804d61d$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    let encoded = $6fd199a57804d61d$var$ABSOLUTE_URL_REGEX3.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}
var $6fd199a57804d61d$var$ABSOLUTE_URL_REGEX3 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;




var $5iwRF = parcelRequire("5iwRF");


var $5iwRF = parcelRequire("5iwRF");
var $d27e433b52638c64$var$e = "colors", $d27e433b52638c64$var$t = "sizes", $d27e433b52638c64$var$r = "space", $d27e433b52638c64$export$22deaee80f3d7c38 = {
    gap: $d27e433b52638c64$var$r,
    gridGap: $d27e433b52638c64$var$r,
    columnGap: $d27e433b52638c64$var$r,
    gridColumnGap: $d27e433b52638c64$var$r,
    rowGap: $d27e433b52638c64$var$r,
    gridRowGap: $d27e433b52638c64$var$r,
    inset: $d27e433b52638c64$var$r,
    insetBlock: $d27e433b52638c64$var$r,
    insetBlockEnd: $d27e433b52638c64$var$r,
    insetBlockStart: $d27e433b52638c64$var$r,
    insetInline: $d27e433b52638c64$var$r,
    insetInlineEnd: $d27e433b52638c64$var$r,
    insetInlineStart: $d27e433b52638c64$var$r,
    margin: $d27e433b52638c64$var$r,
    marginTop: $d27e433b52638c64$var$r,
    marginRight: $d27e433b52638c64$var$r,
    marginBottom: $d27e433b52638c64$var$r,
    marginLeft: $d27e433b52638c64$var$r,
    marginBlock: $d27e433b52638c64$var$r,
    marginBlockEnd: $d27e433b52638c64$var$r,
    marginBlockStart: $d27e433b52638c64$var$r,
    marginInline: $d27e433b52638c64$var$r,
    marginInlineEnd: $d27e433b52638c64$var$r,
    marginInlineStart: $d27e433b52638c64$var$r,
    padding: $d27e433b52638c64$var$r,
    paddingTop: $d27e433b52638c64$var$r,
    paddingRight: $d27e433b52638c64$var$r,
    paddingBottom: $d27e433b52638c64$var$r,
    paddingLeft: $d27e433b52638c64$var$r,
    paddingBlock: $d27e433b52638c64$var$r,
    paddingBlockEnd: $d27e433b52638c64$var$r,
    paddingBlockStart: $d27e433b52638c64$var$r,
    paddingInline: $d27e433b52638c64$var$r,
    paddingInlineEnd: $d27e433b52638c64$var$r,
    paddingInlineStart: $d27e433b52638c64$var$r,
    top: $d27e433b52638c64$var$r,
    right: $d27e433b52638c64$var$r,
    bottom: $d27e433b52638c64$var$r,
    left: $d27e433b52638c64$var$r,
    scrollMargin: $d27e433b52638c64$var$r,
    scrollMarginTop: $d27e433b52638c64$var$r,
    scrollMarginRight: $d27e433b52638c64$var$r,
    scrollMarginBottom: $d27e433b52638c64$var$r,
    scrollMarginLeft: $d27e433b52638c64$var$r,
    scrollMarginX: $d27e433b52638c64$var$r,
    scrollMarginY: $d27e433b52638c64$var$r,
    scrollMarginBlock: $d27e433b52638c64$var$r,
    scrollMarginBlockEnd: $d27e433b52638c64$var$r,
    scrollMarginBlockStart: $d27e433b52638c64$var$r,
    scrollMarginInline: $d27e433b52638c64$var$r,
    scrollMarginInlineEnd: $d27e433b52638c64$var$r,
    scrollMarginInlineStart: $d27e433b52638c64$var$r,
    scrollPadding: $d27e433b52638c64$var$r,
    scrollPaddingTop: $d27e433b52638c64$var$r,
    scrollPaddingRight: $d27e433b52638c64$var$r,
    scrollPaddingBottom: $d27e433b52638c64$var$r,
    scrollPaddingLeft: $d27e433b52638c64$var$r,
    scrollPaddingX: $d27e433b52638c64$var$r,
    scrollPaddingY: $d27e433b52638c64$var$r,
    scrollPaddingBlock: $d27e433b52638c64$var$r,
    scrollPaddingBlockEnd: $d27e433b52638c64$var$r,
    scrollPaddingBlockStart: $d27e433b52638c64$var$r,
    scrollPaddingInline: $d27e433b52638c64$var$r,
    scrollPaddingInlineEnd: $d27e433b52638c64$var$r,
    scrollPaddingInlineStart: $d27e433b52638c64$var$r,
    fontSize: "fontSizes",
    background: $d27e433b52638c64$var$e,
    backgroundColor: $d27e433b52638c64$var$e,
    backgroundImage: $d27e433b52638c64$var$e,
    borderImage: $d27e433b52638c64$var$e,
    border: $d27e433b52638c64$var$e,
    borderBlock: $d27e433b52638c64$var$e,
    borderBlockEnd: $d27e433b52638c64$var$e,
    borderBlockStart: $d27e433b52638c64$var$e,
    borderBottom: $d27e433b52638c64$var$e,
    borderBottomColor: $d27e433b52638c64$var$e,
    borderColor: $d27e433b52638c64$var$e,
    borderInline: $d27e433b52638c64$var$e,
    borderInlineEnd: $d27e433b52638c64$var$e,
    borderInlineStart: $d27e433b52638c64$var$e,
    borderLeft: $d27e433b52638c64$var$e,
    borderLeftColor: $d27e433b52638c64$var$e,
    borderRight: $d27e433b52638c64$var$e,
    borderRightColor: $d27e433b52638c64$var$e,
    borderTop: $d27e433b52638c64$var$e,
    borderTopColor: $d27e433b52638c64$var$e,
    caretColor: $d27e433b52638c64$var$e,
    color: $d27e433b52638c64$var$e,
    columnRuleColor: $d27e433b52638c64$var$e,
    fill: $d27e433b52638c64$var$e,
    outline: $d27e433b52638c64$var$e,
    outlineColor: $d27e433b52638c64$var$e,
    stroke: $d27e433b52638c64$var$e,
    textDecorationColor: $d27e433b52638c64$var$e,
    fontFamily: "fonts",
    fontWeight: "fontWeights",
    lineHeight: "lineHeights",
    letterSpacing: "letterSpacings",
    blockSize: $d27e433b52638c64$var$t,
    minBlockSize: $d27e433b52638c64$var$t,
    maxBlockSize: $d27e433b52638c64$var$t,
    inlineSize: $d27e433b52638c64$var$t,
    minInlineSize: $d27e433b52638c64$var$t,
    maxInlineSize: $d27e433b52638c64$var$t,
    width: $d27e433b52638c64$var$t,
    minWidth: $d27e433b52638c64$var$t,
    maxWidth: $d27e433b52638c64$var$t,
    height: $d27e433b52638c64$var$t,
    minHeight: $d27e433b52638c64$var$t,
    maxHeight: $d27e433b52638c64$var$t,
    flexBasis: $d27e433b52638c64$var$t,
    gridTemplateColumns: $d27e433b52638c64$var$t,
    gridTemplateRows: $d27e433b52638c64$var$t,
    borderWidth: "borderWidths",
    borderTopWidth: "borderWidths",
    borderRightWidth: "borderWidths",
    borderBottomWidth: "borderWidths",
    borderLeftWidth: "borderWidths",
    borderStyle: "borderStyles",
    borderTopStyle: "borderStyles",
    borderRightStyle: "borderStyles",
    borderBottomStyle: "borderStyles",
    borderLeftStyle: "borderStyles",
    borderRadius: "radii",
    borderTopLeftRadius: "radii",
    borderTopRightRadius: "radii",
    borderBottomRightRadius: "radii",
    borderBottomLeftRadius: "radii",
    boxShadow: "shadows",
    textShadow: "shadows",
    transition: "transitions",
    zIndex: "zIndices"
}, $d27e433b52638c64$var$i = (e, t)=>"function" == typeof t ? {
        "()": Function.prototype.toString.call(t)
    } : t, $d27e433b52638c64$var$o = ()=>{
    const e = Object.create(null);
    return (t, r, ...n)=>{
        const o = ((e)=>JSON.stringify(e, $d27e433b52638c64$var$i))(t);
        return o in e ? e[o] : e[o] = r(t, ...n);
    };
}, $d27e433b52638c64$var$l = Symbol.for("sxs.internal"), $d27e433b52638c64$var$s = (e, t)=>Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)), $d27e433b52638c64$var$a = (e)=>{
    for(const t in e)return !0;
    return !1;
}, { hasOwnProperty: $d27e433b52638c64$var$c } = Object.prototype, $d27e433b52638c64$var$d = (e)=>e.includes("-") ? e : e.replace(/[A-Z]/g, (e)=>"-" + e.toLowerCase()), $d27e433b52638c64$var$g = /\s+(?![^()]*\))/, $d27e433b52638c64$var$p = (e)=>(t)=>e(..."string" == typeof t ? String(t).split($d27e433b52638c64$var$g) : [
            t
        ]), $d27e433b52638c64$var$u = {
    appearance: (e)=>({
            WebkitAppearance: e,
            appearance: e
        }),
    backfaceVisibility: (e)=>({
            WebkitBackfaceVisibility: e,
            backfaceVisibility: e
        }),
    backdropFilter: (e)=>({
            WebkitBackdropFilter: e,
            backdropFilter: e
        }),
    backgroundClip: (e)=>({
            WebkitBackgroundClip: e,
            backgroundClip: e
        }),
    boxDecorationBreak: (e)=>({
            WebkitBoxDecorationBreak: e,
            boxDecorationBreak: e
        }),
    clipPath: (e)=>({
            WebkitClipPath: e,
            clipPath: e
        }),
    content: (e)=>({
            content: e.includes('"') || e.includes("'") || /^([A-Za-z]+\([^]*|[^]*-quote|inherit|initial|none|normal|revert|unset)$/.test(e) ? e : `"${e}"`
        }),
    hyphens: (e)=>({
            WebkitHyphens: e,
            hyphens: e
        }),
    maskImage: (e)=>({
            WebkitMaskImage: e,
            maskImage: e
        }),
    maskSize: (e)=>({
            WebkitMaskSize: e,
            maskSize: e
        }),
    tabSize: (e)=>({
            MozTabSize: e,
            tabSize: e
        }),
    textSizeAdjust: (e)=>({
            WebkitTextSizeAdjust: e,
            textSizeAdjust: e
        }),
    userSelect: (e)=>({
            WebkitUserSelect: e,
            userSelect: e
        }),
    marginBlock: $d27e433b52638c64$var$p((e, t)=>({
            marginBlockStart: e,
            marginBlockEnd: t || e
        })),
    marginInline: $d27e433b52638c64$var$p((e, t)=>({
            marginInlineStart: e,
            marginInlineEnd: t || e
        })),
    maxSize: $d27e433b52638c64$var$p((e, t)=>({
            maxBlockSize: e,
            maxInlineSize: t || e
        })),
    minSize: $d27e433b52638c64$var$p((e, t)=>({
            minBlockSize: e,
            minInlineSize: t || e
        })),
    paddingBlock: $d27e433b52638c64$var$p((e, t)=>({
            paddingBlockStart: e,
            paddingBlockEnd: t || e
        })),
    paddingInline: $d27e433b52638c64$var$p((e, t)=>({
            paddingInlineStart: e,
            paddingInlineEnd: t || e
        }))
}, $d27e433b52638c64$var$h = /([\d.]+)([^]*)/, $d27e433b52638c64$var$f = (e, t)=>e.length ? e.reduce((e, r)=>(e.push(...t.map((e)=>e.includes("&") ? e.replace(/&/g, /[ +>|~]/.test(r) && /&.*&/.test(e) ? `:is(${r})` : r) : r + " " + e)), e), []) : t, $d27e433b52638c64$var$m = (e, t)=>e in $d27e433b52638c64$var$b && "string" == typeof t ? t.replace(/^((?:[^]*[^\w-])?)(fit-content|stretch)((?:[^\w-][^]*)?)$/, (t, r, n, i)=>r + ("stretch" === n ? `-moz-available${i};${$d27e433b52638c64$var$d(e)}:${r}-webkit-fill-available` : `-moz-fit-content${i};${$d27e433b52638c64$var$d(e)}:${r}fit-content`) + i) : String(t), $d27e433b52638c64$var$b = {
    blockSize: 1,
    height: 1,
    inlineSize: 1,
    maxBlockSize: 1,
    maxHeight: 1,
    maxInlineSize: 1,
    maxWidth: 1,
    minBlockSize: 1,
    minHeight: 1,
    minInlineSize: 1,
    minWidth: 1,
    width: 1
}, $d27e433b52638c64$var$S = (e)=>e ? e + "-" : "", $d27e433b52638c64$var$k = (e, t, r)=>e.replace(/([+-])?((?:\d+(?:\.\d*)?|\.\d+)(?:[Ee][+-]?\d+)?)?(\$|--)([$\w-]+)/g, (e, n, i, o, l)=>"$" == o == !!i ? e : (n || "--" == o ? "calc(" : "") + "var(--" + ("$" === o ? $d27e433b52638c64$var$S(t) + (l.includes("$") ? "" : $d27e433b52638c64$var$S(r)) + l.replace(/\$/g, "-") : l) + ")" + (n || "--" == o ? "*" + (n || "") + (i || "1") + ")" : "")), $d27e433b52638c64$var$y = /\s*,\s*(?![^()]*\))/, $d27e433b52638c64$var$B = Object.prototype.toString, $d27e433b52638c64$var$$ = (e, t, r, n, i)=>{
    let o, l, s;
    const a = (e, t, r)=>{
        let c, g;
        const p = (e)=>{
            for(c in e){
                const R = 64 === c.charCodeAt(0), z = R && Array.isArray(e[c]) ? e[c] : [
                    e[c]
                ];
                for (g of z){
                    const e = /[A-Z]/.test($ = c) ? $ : $.replace(/-[^]/g, (e)=>e[1].toUpperCase()), z = "object" == typeof g && g && g.toString === $d27e433b52638c64$var$B && (!n.utils[e] || !t.length);
                    if (e in n.utils && !z) {
                        const t = n.utils[e];
                        if (t !== l) {
                            l = t, p(t(g)), l = null;
                            continue;
                        }
                    } else if (e in $d27e433b52638c64$var$u) {
                        const t = $d27e433b52638c64$var$u[e];
                        if (t !== s) {
                            s = t, p(t(g)), s = null;
                            continue;
                        }
                    }
                    if (R && (b = c.slice(1) in n.media ? "@media " + n.media[c.slice(1)] : c, c = b.replace(/\(\s*([\w-]+)\s*(=|<|<=|>|>=)\s*([\w-]+)\s*(?:(<|<=|>|>=)\s*([\w-]+)\s*)?\)/g, (e, t, r, n, i, o)=>{
                        const l = $d27e433b52638c64$var$h.test(t), s = .0625 * (l ? -1 : 1), [a, c] = l ? [
                            n,
                            t
                        ] : [
                            t,
                            n
                        ];
                        return "(" + ("=" === r[0] ? "" : ">" === r[0] === l ? "max-" : "min-") + a + ":" + ("=" !== r[0] && 1 === r.length ? c.replace($d27e433b52638c64$var$h, (e, t, n)=>Number(t) + s * (">" === r ? 1 : -1) + n) : c) + (i ? ") and (" + (">" === i[0] ? "min-" : "max-") + a + ":" + (1 === i.length ? o.replace($d27e433b52638c64$var$h, (e, t, r)=>Number(t) + s * (">" === i ? -1 : 1) + r) : o) : "") + ")";
                    })), z) {
                        const e = R ? r.concat(c) : [
                            ...r
                        ], n = R ? [
                            ...t
                        ] : $d27e433b52638c64$var$f(t, c.split($d27e433b52638c64$var$y));
                        void 0 !== o && i($d27e433b52638c64$var$x(...o)), o = void 0, a(g, n, e);
                    } else void 0 === o && (o = [
                        [],
                        t,
                        r
                    ]), c = R || 36 !== c.charCodeAt(0) ? c : `--${$d27e433b52638c64$var$S(n.prefix)}${c.slice(1).replace(/\$/g, "-")}`, g = z ? g : "number" == typeof g ? g && e in $d27e433b52638c64$var$I ? String(g) + "px" : String(g) : $d27e433b52638c64$var$k($d27e433b52638c64$var$m(e, null == g ? "" : g), n.prefix, n.themeMap[e]), o[0].push(`${R ? `${c} ` : `${$d27e433b52638c64$var$d(c)}:`}${g}`);
                }
            }
            var b, $;
        };
        p(e), void 0 !== o && i($d27e433b52638c64$var$x(...o)), o = void 0;
    };
    a(e, t, r);
}, $d27e433b52638c64$var$x = (e, t, r)=>`${r.map((e)=>`${e}{`).join("")}${t.length ? `${t.join(",")}{` : ""}${e.join(";")}${t.length ? "}" : ""}${Array(r.length ? r.length + 1 : 0).join("}")}`, $d27e433b52638c64$var$I = {
    animationDelay: 1,
    animationDuration: 1,
    backgroundSize: 1,
    blockSize: 1,
    border: 1,
    borderBlock: 1,
    borderBlockEnd: 1,
    borderBlockEndWidth: 1,
    borderBlockStart: 1,
    borderBlockStartWidth: 1,
    borderBlockWidth: 1,
    borderBottom: 1,
    borderBottomLeftRadius: 1,
    borderBottomRightRadius: 1,
    borderBottomWidth: 1,
    borderEndEndRadius: 1,
    borderEndStartRadius: 1,
    borderInlineEnd: 1,
    borderInlineEndWidth: 1,
    borderInlineStart: 1,
    borderInlineStartWidth: 1,
    borderInlineWidth: 1,
    borderLeft: 1,
    borderLeftWidth: 1,
    borderRadius: 1,
    borderRight: 1,
    borderRightWidth: 1,
    borderSpacing: 1,
    borderStartEndRadius: 1,
    borderStartStartRadius: 1,
    borderTop: 1,
    borderTopLeftRadius: 1,
    borderTopRightRadius: 1,
    borderTopWidth: 1,
    borderWidth: 1,
    bottom: 1,
    columnGap: 1,
    columnRule: 1,
    columnRuleWidth: 1,
    columnWidth: 1,
    containIntrinsicSize: 1,
    flexBasis: 1,
    fontSize: 1,
    gap: 1,
    gridAutoColumns: 1,
    gridAutoRows: 1,
    gridTemplateColumns: 1,
    gridTemplateRows: 1,
    height: 1,
    inlineSize: 1,
    inset: 1,
    insetBlock: 1,
    insetBlockEnd: 1,
    insetBlockStart: 1,
    insetInline: 1,
    insetInlineEnd: 1,
    insetInlineStart: 1,
    left: 1,
    letterSpacing: 1,
    margin: 1,
    marginBlock: 1,
    marginBlockEnd: 1,
    marginBlockStart: 1,
    marginBottom: 1,
    marginInline: 1,
    marginInlineEnd: 1,
    marginInlineStart: 1,
    marginLeft: 1,
    marginRight: 1,
    marginTop: 1,
    maxBlockSize: 1,
    maxHeight: 1,
    maxInlineSize: 1,
    maxWidth: 1,
    minBlockSize: 1,
    minHeight: 1,
    minInlineSize: 1,
    minWidth: 1,
    offsetDistance: 1,
    offsetRotate: 1,
    outline: 1,
    outlineOffset: 1,
    outlineWidth: 1,
    overflowClipMargin: 1,
    padding: 1,
    paddingBlock: 1,
    paddingBlockEnd: 1,
    paddingBlockStart: 1,
    paddingBottom: 1,
    paddingInline: 1,
    paddingInlineEnd: 1,
    paddingInlineStart: 1,
    paddingLeft: 1,
    paddingRight: 1,
    paddingTop: 1,
    perspective: 1,
    right: 1,
    rowGap: 1,
    scrollMargin: 1,
    scrollMarginBlock: 1,
    scrollMarginBlockEnd: 1,
    scrollMarginBlockStart: 1,
    scrollMarginBottom: 1,
    scrollMarginInline: 1,
    scrollMarginInlineEnd: 1,
    scrollMarginInlineStart: 1,
    scrollMarginLeft: 1,
    scrollMarginRight: 1,
    scrollMarginTop: 1,
    scrollPadding: 1,
    scrollPaddingBlock: 1,
    scrollPaddingBlockEnd: 1,
    scrollPaddingBlockStart: 1,
    scrollPaddingBottom: 1,
    scrollPaddingInline: 1,
    scrollPaddingInlineEnd: 1,
    scrollPaddingInlineStart: 1,
    scrollPaddingLeft: 1,
    scrollPaddingRight: 1,
    scrollPaddingTop: 1,
    shapeMargin: 1,
    textDecoration: 1,
    textDecorationThickness: 1,
    textIndent: 1,
    textUnderlineOffset: 1,
    top: 1,
    transitionDelay: 1,
    transitionDuration: 1,
    verticalAlign: 1,
    width: 1,
    wordSpacing: 1
}, $d27e433b52638c64$var$R = (e)=>String.fromCharCode(e + (e > 25 ? 39 : 97)), $d27e433b52638c64$var$z = (e)=>((e)=>{
        let t, r = "";
        for(t = Math.abs(e); t > 52; t = t / 52 | 0)r = $d27e433b52638c64$var$R(t % 52) + r;
        return $d27e433b52638c64$var$R(t % 52) + r;
    })(((e, t)=>{
        let r = t.length;
        for(; r;)e = 33 * e ^ t.charCodeAt(--r);
        return e;
    })(5381, JSON.stringify(e)) >>> 0), $d27e433b52638c64$var$W = [
    "themed",
    "global",
    "styled",
    "onevar",
    "resonevar",
    "allvar",
    "inline"
], $d27e433b52638c64$var$j = (e)=>{
    if (e.href && !e.href.startsWith(location.origin)) return !1;
    try {
        return !!e.cssRules;
    } catch (e) {
        return !1;
    }
}, $d27e433b52638c64$var$E = (e)=>{
    let t;
    const r = ()=>{
        const { cssRules: e } = t.sheet;
        return [].map.call(e, (r, n)=>{
            const { cssText: i } = r;
            let o = "";
            if (i.startsWith("--sxs")) return "";
            if (e[n - 1] && (o = e[n - 1].cssText).startsWith("--sxs")) {
                if (!r.cssRules.length) return "";
                for(const e in t.rules)if (t.rules[e].group === r) return `--sxs{--sxs:${[
                    ...t.rules[e].cache
                ].join(" ")}}${i}`;
                return r.cssRules.length ? `${o}${i}` : "";
            }
            return i;
        }).join("");
    }, n = ()=>{
        if (t) {
            const { rules: e, sheet: r } = t;
            if (!r.deleteRule) {
                for(; 3 === Object(Object(r.cssRules)[0]).type;)r.cssRules.splice(0, 1);
                r.cssRules = [];
            }
            for(const t in e)delete e[t];
        }
        const i = Object(e).styleSheets || [];
        for (const e of i)if ($d27e433b52638c64$var$j(e)) {
            for(let i = 0, o = e.cssRules; o[i]; ++i){
                const l = Object(o[i]);
                if (1 !== l.type) continue;
                const s = Object(o[i + 1]);
                if (4 !== s.type) continue;
                ++i;
                const { cssText: a } = l;
                if (!a.startsWith("--sxs")) continue;
                const c = a.slice(14, -3).trim().split(/\s+/), d = $d27e433b52638c64$var$W[c[0]];
                d && (t || (t = {
                    sheet: e,
                    reset: n,
                    rules: {},
                    toString: r
                }), t.rules[d] = {
                    group: s,
                    index: i,
                    cache: new Set(c)
                });
            }
            if (t) break;
        }
        if (!t) {
            const i = (e, t)=>({
                    type: t,
                    cssRules: [],
                    insertRule (e, t) {
                        this.cssRules.splice(t, 0, i(e, {
                            import: 3,
                            undefined: 1
                        }[(e.toLowerCase().match(/^@([a-z]+)/) || [])[1]] || 4));
                    },
                    get cssText () {
                        return "@media{}" === e ? `@media{${[].map.call(this.cssRules, (e)=>e.cssText).join("")}}` : e;
                    }
                });
            t = {
                sheet: e ? (e.head || e).appendChild(document.createElement("style")).sheet : i("", "text/css"),
                rules: {},
                reset: n,
                toString: r
            };
        }
        const { sheet: o, rules: l } = t;
        for(let e = $d27e433b52638c64$var$W.length - 1; e >= 0; --e){
            const t = $d27e433b52638c64$var$W[e];
            if (!l[t]) {
                const r = $d27e433b52638c64$var$W[e + 1], n = l[r] ? l[r].index : o.cssRules.length;
                o.insertRule("@media{}", n), o.insertRule(`--sxs{--sxs:${e}}`, n), l[t] = {
                    group: o.cssRules[n + 1],
                    index: n,
                    cache: new Set([
                        e
                    ])
                };
            }
            $d27e433b52638c64$var$v(l[t]);
        }
    };
    return n(), t;
}, $d27e433b52638c64$var$v = (e)=>{
    const t = e.group;
    let r = t.cssRules.length;
    e.apply = (e)=>{
        try {
            t.insertRule(e, r), ++r;
        } catch (e) {}
    };
}, $d27e433b52638c64$var$T = Symbol(), $d27e433b52638c64$var$w = $d27e433b52638c64$var$o(), $d27e433b52638c64$var$M = (e, t)=>$d27e433b52638c64$var$w(e, ()=>(...r)=>{
            let n = {
                type: null,
                composers: new Set
            };
            for (const t of r)if (null != t) {
                if (t[$d27e433b52638c64$var$l]) {
                    null == n.type && (n.type = t[$d27e433b52638c64$var$l].type);
                    for (const e of t[$d27e433b52638c64$var$l].composers)n.composers.add(e);
                } else t.constructor !== Object || t.$$typeof ? null == n.type && (n.type = t) : n.composers.add($d27e433b52638c64$var$C(t, e));
            }
            return null == n.type && (n.type = "span"), n.composers.size || n.composers.add([
                "PJLV",
                {},
                [],
                [],
                {},
                []
            ]), $d27e433b52638c64$var$P(e, n, t);
        }), $d27e433b52638c64$var$C = ({ variants: e, compoundVariants: t, defaultVariants: r, ...n }, i)=>{
    const o = `${$d27e433b52638c64$var$S(i.prefix)}c-${$d27e433b52638c64$var$z(n)}`, l = [], s = [], d = Object.create(null), g = [];
    for(const e in r)d[e] = String(r[e]);
    if ("object" == typeof e && e) for(const t in e){
        p = d, u = t, $d27e433b52638c64$var$c.call(p, u) || (d[t] = "undefined");
        const r = e[t];
        for(const e in r){
            const n = {
                [t]: String(e)
            };
            "undefined" === String(e) && g.push(t);
            const i = r[e], o = [
                n,
                i,
                !$d27e433b52638c64$var$a(i)
            ];
            l.push(o);
        }
    }
    var p, u;
    if ("object" == typeof t && t) for (const e of t){
        let { css: t, ...r } = e;
        t = "object" == typeof t && t || {};
        for(const e in r)r[e] = String(r[e]);
        const n = [
            r,
            t,
            !$d27e433b52638c64$var$a(t)
        ];
        s.push(n);
    }
    return [
        o,
        n,
        l,
        s,
        d,
        g
    ];
}, $d27e433b52638c64$var$P = (e, t, r)=>{
    const [n, i, o, a] = $d27e433b52638c64$var$L(t.composers), c = "function" == typeof t.type || t.type.$$typeof ? ((e)=>{
        function t() {
            for(let r = 0; r < t[$d27e433b52638c64$var$T].length; r++){
                const [n, i] = t[$d27e433b52638c64$var$T][r];
                e.rules[n].apply(i);
            }
            return t[$d27e433b52638c64$var$T] = [], null;
        }
        return t[$d27e433b52638c64$var$T] = [], t.rules = {}, $d27e433b52638c64$var$W.forEach((e)=>t.rules[e] = {
                apply: (r)=>t[$d27e433b52638c64$var$T].push([
                        e,
                        r
                    ])
            }), t;
    })(r) : null, d = (c || r).rules, g = `.${n}${i.length > 1 ? `:where(.${i.slice(1).join(".")})` : ""}`, p = (l)=>{
        l = "object" == typeof l && l || $d27e433b52638c64$var$A;
        const { css: s, ...p } = l, u = {};
        for(const e in o)if (delete p[e], e in l) {
            let t = l[e];
            "object" == typeof t && t ? u[e] = {
                "@initial": o[e],
                ...t
            } : (t = String(t), u[e] = "undefined" !== t || a.has(e) ? t : o[e]);
        } else u[e] = o[e];
        const h = new Set([
            ...i
        ]);
        for (const [n, i, o, l] of t.composers){
            r.rules.styled.cache.has(n) || (r.rules.styled.cache.add(n), $d27e433b52638c64$var$$(i, [
                `.${n}`
            ], [], e, (e)=>{
                d.styled.apply(e);
            }));
            const t = $d27e433b52638c64$var$O(o, u, e.media), s = $d27e433b52638c64$var$O(l, u, e.media, !0);
            for (const i of t)if (void 0 !== i) for (const [t, o, l] of i){
                const i = `${n}-${$d27e433b52638c64$var$z(o)}-${t}`;
                h.add(i);
                const s = (l ? r.rules.resonevar : r.rules.onevar).cache, a = l ? d.resonevar : d.onevar;
                s.has(i) || (s.add(i), $d27e433b52638c64$var$$(o, [
                    `.${i}`
                ], [], e, (e)=>{
                    a.apply(e);
                }));
            }
            for (const t of s)if (void 0 !== t) for (const [i, o] of t){
                const t = `${n}-${$d27e433b52638c64$var$z(o)}-${i}`;
                h.add(t), r.rules.allvar.cache.has(t) || (r.rules.allvar.cache.add(t), $d27e433b52638c64$var$$(o, [
                    `.${t}`
                ], [], e, (e)=>{
                    d.allvar.apply(e);
                }));
            }
        }
        if ("object" == typeof s && s) {
            const t = `${n}-i${$d27e433b52638c64$var$z(s)}-css`;
            h.add(t), r.rules.inline.cache.has(t) || (r.rules.inline.cache.add(t), $d27e433b52638c64$var$$(s, [
                `.${t}`
            ], [], e, (e)=>{
                d.inline.apply(e);
            }));
        }
        for (const e of String(l.className || "").trim().split(/\s+/))e && h.add(e);
        const f = p.className = [
            ...h
        ].join(" ");
        return {
            type: t.type,
            className: f,
            selector: g,
            props: p,
            toString: ()=>f,
            deferredInjector: c
        };
    };
    return $d27e433b52638c64$var$s(p, {
        className: n,
        selector: g,
        [$d27e433b52638c64$var$l]: t,
        toString: ()=>(r.rules.styled.cache.has(n) || p(), n)
    });
}, $d27e433b52638c64$var$L = (e)=>{
    let t = "";
    const r = [], n = {}, i = [];
    for (const [o, , , , l, s] of e){
        "" === t && (t = o), r.push(o), i.push(...s);
        for(const e in l){
            const t = l[e];
            (void 0 === n[e] || "undefined" !== t || s.includes(t)) && (n[e] = t);
        }
    }
    return [
        t,
        r,
        n,
        new Set(i)
    ];
}, $d27e433b52638c64$var$O = (e, t, r, n)=>{
    const i = [];
    e: for (let [o, l, s] of e){
        if (s) continue;
        let e, a = 0, c = !1;
        for(e in o){
            const n = o[e];
            let i = t[e];
            if (i !== n) {
                if ("object" != typeof i || !i) continue e;
                {
                    let e, t, o = 0;
                    for(const l in i){
                        if (n === String(i[l])) {
                            if ("@initial" !== l) {
                                const e = l.slice(1);
                                (t = t || []).push(e in r ? r[e] : l.replace(/^@media ?/, "")), c = !0;
                            }
                            a += o, e = !0;
                        }
                        ++o;
                    }
                    if (t && t.length && (l = {
                        ["@media " + t.join(", ")]: l
                    }), !e) continue e;
                }
            }
        }
        (i[a] = i[a] || []).push([
            n ? "cv" : `${e}-${o[e]}`,
            l,
            c
        ]);
    }
    return i;
}, $d27e433b52638c64$var$A = {}, $d27e433b52638c64$var$N = $d27e433b52638c64$var$o(), $d27e433b52638c64$var$D = (e, t)=>$d27e433b52638c64$var$N(e, ()=>(...r)=>{
            const n = ()=>{
                for (let n of r){
                    n = "object" == typeof n && n || {};
                    let r = $d27e433b52638c64$var$z(n);
                    if (!t.rules.global.cache.has(r)) {
                        if (t.rules.global.cache.add(r), "@import" in n) {
                            let e = [].indexOf.call(t.sheet.cssRules, t.rules.themed.group) - 1;
                            for (let r of [].concat(n["@import"]))r = r.includes('"') || r.includes("'") ? r : `"${r}"`, t.sheet.insertRule(`@import ${r};`, e++);
                            delete n["@import"];
                        }
                        $d27e433b52638c64$var$$(n, [], [], e, (e)=>{
                            t.rules.global.apply(e);
                        });
                    }
                }
                return "";
            };
            return $d27e433b52638c64$var$s(n, {
                toString: n
            });
        }), $d27e433b52638c64$var$H = $d27e433b52638c64$var$o(), $d27e433b52638c64$var$V = (e, t)=>$d27e433b52638c64$var$H(e, ()=>(r)=>{
            const n = `${$d27e433b52638c64$var$S(e.prefix)}k-${$d27e433b52638c64$var$z(r)}`, i = ()=>{
                if (!t.rules.global.cache.has(n)) {
                    t.rules.global.cache.add(n);
                    const i = [];
                    $d27e433b52638c64$var$$(r, [], [], e, (e)=>i.push(e));
                    const o = `@keyframes ${n}{${i.join("")}}`;
                    t.rules.global.apply(o);
                }
                return n;
            };
            return $d27e433b52638c64$var$s(i, {
                get name () {
                    return i();
                },
                toString: i
            });
        }), $d27e433b52638c64$var$G = class {
    constructor(e, t, r, n){
        this.token = null == e ? "" : String(e), this.value = null == t ? "" : String(t), this.scale = null == r ? "" : String(r), this.prefix = null == n ? "" : String(n);
    }
    get computedValue() {
        return "var(" + this.variable + ")";
    }
    get variable() {
        return "--" + $d27e433b52638c64$var$S(this.prefix) + $d27e433b52638c64$var$S(this.scale) + this.token;
    }
    toString() {
        return this.computedValue;
    }
}, $d27e433b52638c64$var$F = $d27e433b52638c64$var$o(), $d27e433b52638c64$var$J = (e, t)=>$d27e433b52638c64$var$F(e, ()=>(r, n)=>{
            n = "object" == typeof r && r || Object(n);
            const i = `.${r = (r = "string" == typeof r ? r : "") || `${$d27e433b52638c64$var$S(e.prefix)}t-${$d27e433b52638c64$var$z(n)}`}`, o = {}, l = [];
            for(const t in n){
                o[t] = {};
                for(const r in n[t]){
                    const i = `--${$d27e433b52638c64$var$S(e.prefix)}${t}-${r}`, s = $d27e433b52638c64$var$k(String(n[t][r]), e.prefix, t);
                    o[t][r] = new $d27e433b52638c64$var$G(r, s, t, e.prefix), l.push(`${i}:${s}`);
                }
            }
            const s = ()=>{
                if (l.length && !t.rules.themed.cache.has(r)) {
                    t.rules.themed.cache.add(r);
                    const i = `${n === e.theme ? ":root," : ""}.${r}{${l.join(";")}}`;
                    t.rules.themed.apply(i);
                }
                return r;
            };
            return {
                ...o,
                get className () {
                    return s();
                },
                selector: i,
                toString: s
            };
        }), $d27e433b52638c64$var$U = $d27e433b52638c64$var$o();
var $d27e433b52638c64$var$X, $d27e433b52638c64$var$Y = $d27e433b52638c64$var$o(), $d27e433b52638c64$export$3c6706659c99b84e = (e)=>{
    const t = ((e)=>{
        let t = !1;
        const r = $d27e433b52638c64$var$U(e, (e)=>{
            t = !0;
            const r = "prefix" in (e = "object" == typeof e && e || {}) ? String(e.prefix) : "", i = "object" == typeof e.media && e.media || {}, o = "object" == typeof e.root ? e.root || null : globalThis.document || null, l = "object" == typeof e.theme && e.theme || {}, s = {
                prefix: r,
                media: i,
                theme: l,
                themeMap: "object" == typeof e.themeMap && e.themeMap || {
                    ...$d27e433b52638c64$export$22deaee80f3d7c38
                },
                utils: "object" == typeof e.utils && e.utils || {}
            }, a = $d27e433b52638c64$var$E(o), c = {
                css: $d27e433b52638c64$var$M(s, a),
                globalCss: $d27e433b52638c64$var$D(s, a),
                keyframes: $d27e433b52638c64$var$V(s, a),
                createTheme: $d27e433b52638c64$var$J(s, a),
                reset () {
                    a.reset(), c.theme.toString();
                },
                theme: {},
                sheet: a,
                config: s,
                prefix: r,
                getCssText: a.toString,
                toString: a.toString
            };
            return String(c.theme = c.createTheme(l)), c;
        });
        return t || r.reset(), r;
    })(e);
    return t.styled = (({ config: e, sheet: t })=>$d27e433b52638c64$var$Y(e, ()=>{
            const r = $d27e433b52638c64$var$M(e, t);
            return (...e)=>{
                const t = r(...e), n = t[$d27e433b52638c64$var$l].type, i = (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).forwardRef((e, r)=>{
                    const i = e && e.as || n, { props: o, deferredInjector: l } = t(e);
                    return delete o.as, o.ref = r, l ? (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).createElement(i, o), (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).createElement(l, null)) : (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).createElement(i, o);
                });
                return i.className = t.className, i.displayName = `Styled.${n.displayName || n.name || n}`, i.selector = t.selector, i.toString = ()=>t.selector, i[$d27e433b52638c64$var$l] = t[$d27e433b52638c64$var$l], i;
            };
        }))(t), t;
}, $d27e433b52638c64$var$K = ()=>$d27e433b52638c64$var$X || ($d27e433b52638c64$var$X = $d27e433b52638c64$export$3c6706659c99b84e()), $d27e433b52638c64$export$25d302a5b900a763 = (...e)=>$d27e433b52638c64$var$K().createTheme(...e), $d27e433b52638c64$export$db53682eef82cc11 = (...e)=>$d27e433b52638c64$var$K().globalCss(...e), $d27e433b52638c64$export$d25ddfdf17c3ad3e = (...e)=>$d27e433b52638c64$var$K().keyframes(...e), $d27e433b52638c64$export$dbf350e5966cf602 = (...e)=>$d27e433b52638c64$var$K().css(...e), $d27e433b52638c64$export$3817b7a54a07cec7 = (...e)=>$d27e433b52638c64$var$K().styled(...e);
 //# sourceMappingUrl=index.map



parcelRequire("5iwRF");


const $7b6c01ba3c095c23$export$98eff9c5659394e3 = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('div', {
    padding: "1rem",
    "@media only screen and (min-width : 992px)": {
        width: '100%',
        maxWidth: 1140,
        margin: '0 auto',
        padding: "1rem 1rem"
    }
});
const $7b6c01ba3c095c23$export$be58b4326e23250f = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('span', {
    color: "rgb(95, 95, 95)",
    display: "inline-flex",
    transition: "ease 400ms",
    "&:hover": {
        color: "rgb(23, 23, 23)"
    },
    svg: {
        width: "2.2rem",
        height: "2.2rem"
    }
});



parcelRequire("5iwRF");
function $e908cfa9f077af86$export$54a08461bc4e9944({ title: title, ...props }) {
    return /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsxs)("svg", {
        viewBox: "0 0 28 28",
        fill: "currentColor",
        "aria-hidden": title ? undefined : true,
        ...props,
        children: [
            /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)("path", {
                d: "M3.375 18.266l9.422 6.281v-5.609l-5.219-3.484zM2.406 16.016l3.016-2.016-3.016-2.016v4.031zM15.203 24.547l9.422-6.281-4.203-2.812-5.219 3.484v5.609zM14 16.844l4.25-2.844-4.25-2.844-4.25 2.844zM7.578 12.547l5.219-3.484v-5.609l-9.422 6.281zM22.578 14l3.016 2.016v-4.031zM20.422 12.547l4.203-2.812-9.422-6.281v5.609zM28 9.734v8.531c0 0.391-0.203 0.781-0.531 1l-12.797 8.531c-0.203 0.125-0.438 0.203-0.672 0.203s-0.469-0.078-0.672-0.203l-12.797-8.531c-0.328-0.219-0.531-0.609-0.531-1v-8.531c0-0.391 0.203-0.781 0.531-1l12.797-8.531c0.203-0.125 0.438-0.203 0.672-0.203s0.469 0.078 0.672 0.203l12.797 8.531c0.328 0.219 0.531 0.609 0.531 1z"
            })
        ]
    });
}
function $e908cfa9f077af86$export$2c71112b202a47c({ title: title, ...props }) {
    return /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsxs)("svg", {
        viewBox: "0 0 32 32",
        fill: "currentColor",
        "aria-hidden": title ? undefined : true,
        ...props,
        children: [
            /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)("path", {
                d: "M9.893 13.4c-0.24-0.213-0.613-0.307-1.12-0.307h-0.773l0.027 3.253 0.053 3.267 0.747-0.027c0.547 0 0.84-0.093 1.107-0.347 0.32-0.32 0.347-0.48 0.347-2.933 0-2.547-0.027-2.613-0.387-2.907z"
            }),
            /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)("path", {
                d: "M0 6.587v18.827h32v-18.827h-32zM11.413 20.4c-0.587 0.773-1.413 1.027-3.373 1.027h-1.76v-10.053h1.867c2.227 0 2.88 0.24 3.467 1.2 0.36 0.573 0.387 0.8 0.427 3.427 0.067 2.973-0.027 3.64-0.627 4.4zM18.2 13.107h-3.293v2.36h2.027v1.707l-0.96 0.053-1 0.040v2.36l1.627 0.040 1.6 0.053v1.707h-2.133c-2.040 0-2.133-0.013-2.493-0.4l-0.4-0.373v-4.213c0-4.027 0.013-4.24 0.333-4.64 0.307-0.413 0.333-0.413 2.507-0.413h2.187v1.733zM24.44 20.373c-0.227 0.573-0.853 1.053-1.333 1.053-0.24 0-0.6-0.2-0.893-0.52-0.427-0.427-0.6-0.84-1.093-2.773l-1.2-4.52-0.6-2.227h1.013c0.533 0 1 0.027 1 0.067 0 0.080 1.547 6.053 1.68 6.44 0.053 0.2 0.427-0.933 0.973-3.067l0.88-3.36 0.987-0.053c0.533-0.027 0.973 0 0.973 0.053 0 0.187-2.227 8.507-2.4 8.907z"
            })
        ]
    });
}
function $e908cfa9f077af86$export$e8e65f186ccd8749({ title: title, ...props }) {
    return /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsxs)("svg", {
        viewBox: "0 0 24 28",
        fill: "currentColor",
        "aria-hidden": title ? undefined : true,
        ...props,
        children: [
            /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)("path", {
                d: "M12 2c6.625 0 12 5.375 12 12 0 5.297-3.437 9.797-8.203 11.391-0.609 0.109-0.828-0.266-0.828-0.578 0-0.391 0.016-1.687 0.016-3.297 0-1.125-0.375-1.844-0.812-2.219 2.672-0.297 5.484-1.313 5.484-5.922 0-1.313-0.469-2.375-1.234-3.219 0.125-0.313 0.531-1.531-0.125-3.187-1-0.313-3.297 1.234-3.297 1.234-0.953-0.266-1.984-0.406-3-0.406s-2.047 0.141-3 0.406c0 0-2.297-1.547-3.297-1.234-0.656 1.656-0.25 2.875-0.125 3.187-0.766 0.844-1.234 1.906-1.234 3.219 0 4.594 2.797 5.625 5.469 5.922-0.344 0.313-0.656 0.844-0.766 1.609-0.688 0.313-2.438 0.844-3.484-1-0.656-1.141-1.844-1.234-1.844-1.234-1.172-0.016-0.078 0.734-0.078 0.734 0.781 0.359 1.328 1.75 1.328 1.75 0.703 2.141 4.047 1.422 4.047 1.422 0 1 0.016 1.937 0.016 2.234 0 0.313-0.219 0.688-0.828 0.578-4.766-1.594-8.203-6.094-8.203-11.391 0-6.625 5.375-12 12-12zM4.547 19.234c0.031-0.063-0.016-0.141-0.109-0.187-0.094-0.031-0.172-0.016-0.203 0.031-0.031 0.063 0.016 0.141 0.109 0.187 0.078 0.047 0.172 0.031 0.203-0.031zM5.031 19.766c0.063-0.047 0.047-0.156-0.031-0.25-0.078-0.078-0.187-0.109-0.25-0.047-0.063 0.047-0.047 0.156 0.031 0.25 0.078 0.078 0.187 0.109 0.25 0.047zM5.5 20.469c0.078-0.063 0.078-0.187 0-0.297-0.063-0.109-0.187-0.156-0.266-0.094-0.078 0.047-0.078 0.172 0 0.281s0.203 0.156 0.266 0.109zM6.156 21.125c0.063-0.063 0.031-0.203-0.063-0.297-0.109-0.109-0.25-0.125-0.313-0.047-0.078 0.063-0.047 0.203 0.063 0.297 0.109 0.109 0.25 0.125 0.313 0.047zM7.047 21.516c0.031-0.094-0.063-0.203-0.203-0.25-0.125-0.031-0.266 0.016-0.297 0.109s0.063 0.203 0.203 0.234c0.125 0.047 0.266 0 0.297-0.094zM8.031 21.594c0-0.109-0.125-0.187-0.266-0.172-0.141 0-0.25 0.078-0.25 0.172 0 0.109 0.109 0.187 0.266 0.172 0.141 0 0.25-0.078 0.25-0.172zM8.937 21.438c-0.016-0.094-0.141-0.156-0.281-0.141-0.141 0.031-0.234 0.125-0.219 0.234 0.016 0.094 0.141 0.156 0.281 0.125s0.234-0.125 0.219-0.219z"
            })
        ]
    });
}
function $e908cfa9f077af86$export$66b2b327480e491c({ title: title, ...props }) {
    return /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsxs)("svg", {
        viewBox: "0 0 32 32",
        fill: "currentColor",
        "aria-hidden": title ? undefined : true,
        ...props,
        children: [
            /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)("path", {
                d: "M12.973 19.32l2.32-2.32h-5.63c-0.024 0.061-0.060 0.118-0.108 0.166l-1.421 1.421c-0.198 0.198-0.509 0.192-0.704-0.003-0.19-0.19-0.197-0.51-0.003-0.704l0.88-0.88h-0.799c-0.282 0-0.508-0.224-0.508-0.5 0-0.268 0.228-0.5 0.508-0.5h0.753l-0.834-0.834c-0.193-0.193-0.186-0.514 0.003-0.704 0.195-0.195 0.506-0.201 0.704-0.003l1.421 1.421c0.036 0.036 0.065 0.077 0.088 0.12v0h5.65l-2.307-2.307c-0.054 0.021-0.112 0.032-0.174 0.032h-2.009c-0.28 0-0.495-0.224-0.495-0.5 0-0.268 0.222-0.5 0.495-0.5h1.215l-0.823-0.823c-0.195-0.195-0.189-0.517 0.001-0.706 0.195-0.195 0.512-0.195 0.706-0.001l0.819 0.819v-1.208c0-0.274 0.232-0.495 0.5-0.495 0.276 0 0.5 0.216 0.5 0.495v2.009c0 0.059-0.011 0.116-0.031 0.168l2.308 2.308v-5.637c-0.047-0.023-0.090-0.053-0.129-0.092l-1.421-1.421c-0.198-0.198-0.192-0.509 0.003-0.704 0.19-0.19 0.51-0.197 0.704-0.003l0.843 0.843v-0.77c0-0.282 0.224-0.508 0.5-0.508 0.268 0 0.5 0.228 0.5 0.508v0.799l0.871-0.871c0.193-0.193 0.514-0.186 0.704 0.003 0.195 0.195 0.201 0.506 0.003 0.704l-1.421 1.421c-0.046 0.046-0.1 0.081-0.157 0.105v5.624l2.308-2.308c-0.016-0.048-0.025-0.1-0.025-0.154v-2.009c0-0.28 0.224-0.495 0.5-0.495 0.268 0 0.5 0.222 0.5 0.495v1.188l0.814-0.814c0.195-0.195 0.511-0.195 0.706 0.001 0.19 0.19 0.196 0.512 0.001 0.706l-0.838 0.838h1.235c0.274 0 0.495 0.232 0.495 0.5 0 0.276-0.216 0.5-0.495 0.5h-2.009c-0.067 0-0.13-0.014-0.188-0.038v0l-2.298 2.298h5.679c0.022-0.043 0.051-0.084 0.087-0.12l1.421-1.421c0.198-0.198 0.509-0.192 0.704 0.003 0.19 0.19 0.197 0.51 0.003 0.704l-0.834 0.834h0.724c0.282 0 0.508 0.224 0.508 0.5 0 0.268-0.228 0.5-0.508 0.5h-0.77l0.88 0.88c0.193 0.193 0.186 0.514-0.003 0.704-0.195 0.195-0.506 0.201-0.704 0.003l-1.421-1.421c-0.049-0.049-0.085-0.106-0.108-0.166v0h-5.658l2.324 2.324c0.046-0.015 0.095-0.023 0.146-0.023h2.009c0.28 0 0.495 0.224 0.495 0.5 0 0.268-0.222 0.5-0.495 0.5h-1.178l0.795 0.795c0.195 0.195 0.189 0.517-0.001 0.706-0.195 0.195-0.512 0.195-0.706 0.001l-0.829-0.829v1.245c0 0.274-0.232 0.495-0.5 0.495-0.276 0-0.5-0.216-0.5-0.495v-2.009c0-0.069 0.015-0.135 0.041-0.195l-2.309-2.309v5.671c0.057 0.024 0.111 0.058 0.157 0.105l1.421 1.421c0.198 0.198 0.192 0.509-0.003 0.704-0.19 0.19-0.51 0.197-0.704 0.003l-0.871-0.871v0.753c0 0.282-0.224 0.508-0.5 0.508-0.268 0-0.5-0.228-0.5-0.508v-0.724l-0.843 0.843c-0.193 0.193-0.514 0.186-0.704-0.003-0.195-0.195-0.201-0.506-0.003-0.704l1.421-1.421c0.039-0.039 0.082-0.069 0.129-0.092v-5.683l-2.322 2.322c0.019 0.052 0.030 0.108 0.030 0.166v2.009c0 0.28-0.224 0.495-0.5 0.495-0.268 0-0.5-0.222-0.5-0.495v-1.206l-0.804 0.804c-0.195 0.195-0.511 0.195-0.706-0.001-0.19-0.19-0.196-0.512-0.001-0.706l0.81-0.81h-1.218c-0.274 0-0.495-0.232-0.495-0.5 0-0.276 0.216-0.5 0.495-0.5h2.009c0.062 0 0.121 0.012 0.175 0.033v0zM16.5 28c6.351 0 11.5-5.149 11.5-11.5s-5.149-11.5-11.5-11.5c-6.351 0-11.5 5.149-11.5 11.5s5.149 11.5 11.5 11.5v0z"
            })
        ]
    });
}


function $6606e5f4ea82c065$export$d9b273488cd8ce6f() {
    return /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $7b6c01ba3c095c23$export$98eff9c5659394e3), {
        children: /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $6fd199a57804d61d$export$a6c7ac8248d6e38a), {
            to: "/",
            children: /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $7b6c01ba3c095c23$export$be58b4326e23250f), {
                children: /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $e908cfa9f077af86$export$66b2b327480e491c), {
                    title: "Yuki Cheung's Portfolio"
                })
            })
        })
    });
}



parcelRequire("5iwRF");
var $38b29c2dc0019b47$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $38b29c2dc0019b47$var$ReactIs, $38b29c2dc0019b47$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$38b29c2dc0019b47$exports = (parcelRequire("dflA0"))();


var $f35d49ba1628cf59$exports = {};
'use strict';
function $f35d49ba1628cf59$var$_interopDefault(ex) {
    return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $5iwRF = parcelRequire("5iwRF");
var $f35d49ba1628cf59$var$React__default = $f35d49ba1628cf59$var$_interopDefault($5iwRF);
function $f35d49ba1628cf59$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f35d49ba1628cf59$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $f35d49ba1628cf59$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $f35d49ba1628cf59$var$withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
    if (typeof reducePropsToState !== 'function') throw new Error('Expected reducePropsToState to be a function.');
    if (typeof handleStateChangeOnClient !== 'function') throw new Error('Expected handleStateChangeOnClient to be a function.');
    if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') throw new Error('Expected mapStateOnServer to either be undefined or a function.');
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        if (typeof WrappedComponent !== 'function') throw new Error('Expected WrappedComponent to be a React component.');
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            if (SideEffect.canUseDOM) handleStateChangeOnClient(state);
            else if (mapStateOnServer) state = mapStateOnServer(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            $f35d49ba1628cf59$var$_inheritsLoose(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            // Expose canUseDOM so tests can monkeypatch it
            SideEffect.peek = function peek() {
                return state;
            };
            SideEffect.rewind = function rewind() {
                if (SideEffect.canUseDOM) throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
                var recordedState = state;
                state = undefined;
                mountedInstances = [];
                return recordedState;
            };
            var _proto = SideEffect.prototype;
            _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return $f35d49ba1628cf59$var$React__default.createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }($5iwRF.PureComponent);
        $f35d49ba1628cf59$var$_defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        $f35d49ba1628cf59$var$_defineProperty(SideEffect, "canUseDOM", $f35d49ba1628cf59$var$canUseDOM);
        return SideEffect;
    };
}
$f35d49ba1628cf59$exports = $f35d49ba1628cf59$var$withSideEffect;


var $a55a48cb99565f6d$exports = {};
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $a55a48cb99565f6d$var$hasElementType = typeof Element !== 'undefined';
var $a55a48cb99565f6d$var$hasMap = typeof Map === 'function';
var $a55a48cb99565f6d$var$hasSet = typeof Set === 'function';
var $a55a48cb99565f6d$var$hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $a55a48cb99565f6d$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$a55a48cb99565f6d$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($a55a48cb99565f6d$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$a55a48cb99565f6d$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($a55a48cb99565f6d$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($a55a48cb99565f6d$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($a55a48cb99565f6d$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$a55a48cb99565f6d$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
$a55a48cb99565f6d$exports = function isEqual(a, b) {
    try {
        return $a55a48cb99565f6d$var$equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};



var $5iwRF = parcelRequire("5iwRF");
var $1bd7be12f41d51a4$exports = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $1bd7be12f41d51a4$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $1bd7be12f41d51a4$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $1bd7be12f41d51a4$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $1bd7be12f41d51a4$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $1bd7be12f41d51a4$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
$1bd7be12f41d51a4$exports = $1bd7be12f41d51a4$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $1bd7be12f41d51a4$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($1bd7be12f41d51a4$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($1bd7be12f41d51a4$var$getOwnPropertySymbols) {
            symbols = $1bd7be12f41d51a4$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($1bd7be12f41d51a4$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};


var $d7b37fea0f6203ad$var$ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};
var $d7b37fea0f6203ad$var$TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};
var $d7b37fea0f6203ad$var$VALID_TAG_NAMES = Object.keys($d7b37fea0f6203ad$var$TAG_NAMES).map(function(name) {
    return $d7b37fea0f6203ad$var$TAG_NAMES[name];
});
var $d7b37fea0f6203ad$var$TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src",
    TARGET: "target"
};
var $d7b37fea0f6203ad$var$REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};
var $d7b37fea0f6203ad$var$HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};
var $d7b37fea0f6203ad$var$HTML_TAG_MAP = Object.keys($d7b37fea0f6203ad$var$REACT_TAG_MAP).reduce(function(obj, key) {
    obj[$d7b37fea0f6203ad$var$REACT_TAG_MAP[key]] = key;
    return obj;
}, {});
var $d7b37fea0f6203ad$var$SELF_CLOSING_TAGS = [
    $d7b37fea0f6203ad$var$TAG_NAMES.NOSCRIPT,
    $d7b37fea0f6203ad$var$TAG_NAMES.SCRIPT,
    $d7b37fea0f6203ad$var$TAG_NAMES.STYLE
];
var $d7b37fea0f6203ad$var$HELMET_ATTRIBUTE = "data-react-helmet";
var $d7b37fea0f6203ad$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $d7b37fea0f6203ad$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $d7b37fea0f6203ad$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $d7b37fea0f6203ad$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $d7b37fea0f6203ad$var$inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $d7b37fea0f6203ad$var$objectWithoutProperties = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var $d7b37fea0f6203ad$var$possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var $d7b37fea0f6203ad$var$encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (encode === false) return String(str);
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var $d7b37fea0f6203ad$var$getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = $d7b37fea0f6203ad$var$getInnermostProperty(propsList, $d7b37fea0f6203ad$var$TAG_NAMES.TITLE);
    var innermostTemplate = $d7b37fea0f6203ad$var$getInnermostProperty(propsList, $d7b37fea0f6203ad$var$HELMET_PROPS.TITLE_TEMPLATE);
    if (innermostTemplate && innermostTitle) // use function arg to avoid need to escape $ characters
    return innermostTemplate.replace(/%s/g, function() {
        return Array.isArray(innermostTitle) ? innermostTitle.join("") : innermostTitle;
    });
    var innermostDefaultTitle = $d7b37fea0f6203ad$var$getInnermostProperty(propsList, $d7b37fea0f6203ad$var$HELMET_PROPS.DEFAULT_TITLE);
    return innermostTitle || innermostDefaultTitle || undefined;
};
var $d7b37fea0f6203ad$var$getOnChangeClientState = function getOnChangeClientState(propsList) {
    return $d7b37fea0f6203ad$var$getInnermostProperty(propsList, $d7b37fea0f6203ad$var$HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function() {};
};
var $d7b37fea0f6203ad$var$getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function(props) {
        return typeof props[tagType] !== "undefined";
    }).map(function(props) {
        return props[tagType];
    }).reduce(function(tagAttrs, current) {
        return $d7b37fea0f6203ad$var$_extends({}, tagAttrs, current);
    }, {});
};
var $d7b37fea0f6203ad$var$getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function(props) {
        return typeof props[$d7b37fea0f6203ad$var$TAG_NAMES.BASE] !== "undefined";
    }).map(function(props) {
        return props[$d7b37fea0f6203ad$var$TAG_NAMES.BASE];
    }).reverse().reduce(function(innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) return innermostBaseTag.concat(tag);
            }
        }
        return innermostBaseTag;
    }, []);
};
var $d7b37fea0f6203ad$var$getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};
    return propsList.filter(function(props) {
        if (Array.isArray(props[tagName])) return true;
        if (typeof props[tagName] !== "undefined") $d7b37fea0f6203ad$var$warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + $d7b37fea0f6203ad$var$_typeof(props[tagName]) + "\"");
        return false;
    }).map(function(props) {
        return props[tagName];
    }).reverse().reduce(function(approvedTags, instanceTags) {
        var instanceSeenTags = {};
        instanceTags.filter(function(tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === $d7b37fea0f6203ad$var$TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === $d7b37fea0f6203ad$var$TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) primaryAttributeKey = lowerCaseAttributeKey;
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === $d7b37fea0f6203ad$var$TAG_PROPERTIES.INNER_HTML || attributeKey === $d7b37fea0f6203ad$var$TAG_PROPERTIES.CSS_TEXT || attributeKey === $d7b37fea0f6203ad$var$TAG_PROPERTIES.ITEM_PROP)) primaryAttributeKey = attributeKey;
            }
            if (!primaryAttributeKey || !tag[primaryAttributeKey]) return false;
            var value = tag[primaryAttributeKey].toLowerCase();
            if (!approvedSeenTags[primaryAttributeKey]) approvedSeenTags[primaryAttributeKey] = {};
            if (!instanceSeenTags[primaryAttributeKey]) instanceSeenTags[primaryAttributeKey] = {};
            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }
            return false;
        }).reverse().forEach(function(tag) {
            return approvedTags.push(tag);
        });
        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for(var i = 0; i < keys.length; i++){
            var attributeKey = keys[i];
            var tagUnion = (0, (/*@__PURE__*/$parcel$interopDefault($1bd7be12f41d51a4$exports)))({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
            approvedSeenTags[attributeKey] = tagUnion;
        }
        return approvedTags;
    }, []).reverse();
};
var $d7b37fea0f6203ad$var$getInnermostProperty = function getInnermostProperty(propsList, property) {
    for(var i = propsList.length - 1; i >= 0; i--){
        var props = propsList[i];
        if (props.hasOwnProperty(property)) return props[property];
    }
    return null;
};
var $d7b37fea0f6203ad$var$reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: $d7b37fea0f6203ad$var$getBaseTagFromPropsList([
            $d7b37fea0f6203ad$var$TAG_PROPERTIES.HREF,
            $d7b37fea0f6203ad$var$TAG_PROPERTIES.TARGET
        ], propsList),
        bodyAttributes: $d7b37fea0f6203ad$var$getAttributesFromPropsList($d7b37fea0f6203ad$var$ATTRIBUTE_NAMES.BODY, propsList),
        defer: $d7b37fea0f6203ad$var$getInnermostProperty(propsList, $d7b37fea0f6203ad$var$HELMET_PROPS.DEFER),
        encode: $d7b37fea0f6203ad$var$getInnermostProperty(propsList, $d7b37fea0f6203ad$var$HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: $d7b37fea0f6203ad$var$getAttributesFromPropsList($d7b37fea0f6203ad$var$ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: $d7b37fea0f6203ad$var$getTagsFromPropsList($d7b37fea0f6203ad$var$TAG_NAMES.LINK, [
            $d7b37fea0f6203ad$var$TAG_PROPERTIES.REL,
            $d7b37fea0f6203ad$var$TAG_PROPERTIES.HREF
        ], propsList),
        metaTags: $d7b37fea0f6203ad$var$getTagsFromPropsList($d7b37fea0f6203ad$var$TAG_NAMES.META, [
            $d7b37fea0f6203ad$var$TAG_PROPERTIES.NAME,
            $d7b37fea0f6203ad$var$TAG_PROPERTIES.CHARSET,
            $d7b37fea0f6203ad$var$TAG_PROPERTIES.HTTPEQUIV,
            $d7b37fea0f6203ad$var$TAG_PROPERTIES.PROPERTY,
            $d7b37fea0f6203ad$var$TAG_PROPERTIES.ITEM_PROP
        ], propsList),
        noscriptTags: $d7b37fea0f6203ad$var$getTagsFromPropsList($d7b37fea0f6203ad$var$TAG_NAMES.NOSCRIPT, [
            $d7b37fea0f6203ad$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        onChangeClientState: $d7b37fea0f6203ad$var$getOnChangeClientState(propsList),
        scriptTags: $d7b37fea0f6203ad$var$getTagsFromPropsList($d7b37fea0f6203ad$var$TAG_NAMES.SCRIPT, [
            $d7b37fea0f6203ad$var$TAG_PROPERTIES.SRC,
            $d7b37fea0f6203ad$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        styleTags: $d7b37fea0f6203ad$var$getTagsFromPropsList($d7b37fea0f6203ad$var$TAG_NAMES.STYLE, [
            $d7b37fea0f6203ad$var$TAG_PROPERTIES.CSS_TEXT
        ], propsList),
        title: $d7b37fea0f6203ad$var$getTitleFromPropsList(propsList),
        titleAttributes: $d7b37fea0f6203ad$var$getAttributesFromPropsList($d7b37fea0f6203ad$var$ATTRIBUTE_NAMES.TITLE, propsList)
    };
};
var $d7b37fea0f6203ad$var$rafPolyfill = function() {
    var clock = Date.now();
    return function(callback) {
        var currentTime = Date.now();
        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else setTimeout(function() {
            $d7b37fea0f6203ad$var$rafPolyfill(callback);
        }, 0);
    };
}();
var $d7b37fea0f6203ad$var$cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};
var $d7b37fea0f6203ad$var$requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || $d7b37fea0f6203ad$var$rafPolyfill : $parcel$global.requestAnimationFrame || $d7b37fea0f6203ad$var$rafPolyfill;
var $d7b37fea0f6203ad$var$cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || $d7b37fea0f6203ad$var$cafPolyfill : $parcel$global.cancelAnimationFrame || $d7b37fea0f6203ad$var$cafPolyfill;
var $d7b37fea0f6203ad$var$warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};
var $d7b37fea0f6203ad$var$_helmetCallback = null;
var $d7b37fea0f6203ad$var$handleClientStateChange = function handleClientStateChange(newState) {
    if ($d7b37fea0f6203ad$var$_helmetCallback) $d7b37fea0f6203ad$var$cancelAnimationFrame($d7b37fea0f6203ad$var$_helmetCallback);
    if (newState.defer) $d7b37fea0f6203ad$var$_helmetCallback = $d7b37fea0f6203ad$var$requestAnimationFrame(function() {
        $d7b37fea0f6203ad$var$commitTagChanges(newState, function() {
            $d7b37fea0f6203ad$var$_helmetCallback = null;
        });
    });
    else {
        $d7b37fea0f6203ad$var$commitTagChanges(newState);
        $d7b37fea0f6203ad$var$_helmetCallback = null;
    }
};
var $d7b37fea0f6203ad$var$commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag, bodyAttributes = newState.bodyAttributes, htmlAttributes = newState.htmlAttributes, linkTags = newState.linkTags, metaTags = newState.metaTags, noscriptTags = newState.noscriptTags, onChangeClientState = newState.onChangeClientState, scriptTags = newState.scriptTags, styleTags = newState.styleTags, title = newState.title, titleAttributes = newState.titleAttributes;
    $d7b37fea0f6203ad$var$updateAttributes($d7b37fea0f6203ad$var$TAG_NAMES.BODY, bodyAttributes);
    $d7b37fea0f6203ad$var$updateAttributes($d7b37fea0f6203ad$var$TAG_NAMES.HTML, htmlAttributes);
    $d7b37fea0f6203ad$var$updateTitle(title, titleAttributes);
    var tagUpdates = {
        baseTag: $d7b37fea0f6203ad$var$updateTags($d7b37fea0f6203ad$var$TAG_NAMES.BASE, baseTag),
        linkTags: $d7b37fea0f6203ad$var$updateTags($d7b37fea0f6203ad$var$TAG_NAMES.LINK, linkTags),
        metaTags: $d7b37fea0f6203ad$var$updateTags($d7b37fea0f6203ad$var$TAG_NAMES.META, metaTags),
        noscriptTags: $d7b37fea0f6203ad$var$updateTags($d7b37fea0f6203ad$var$TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: $d7b37fea0f6203ad$var$updateTags($d7b37fea0f6203ad$var$TAG_NAMES.SCRIPT, scriptTags),
        styleTags: $d7b37fea0f6203ad$var$updateTags($d7b37fea0f6203ad$var$TAG_NAMES.STYLE, styleTags)
    };
    var addedTags = {};
    var removedTags = {};
    Object.keys(tagUpdates).forEach(function(tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType], newTags = _tagUpdates$tagType.newTags, oldTags = _tagUpdates$tagType.oldTags;
        if (newTags.length) addedTags[tagType] = newTags;
        if (oldTags.length) removedTags[tagType] = tagUpdates[tagType].oldTags;
    });
    cb && cb();
    onChangeClientState(newState, addedTags, removedTags);
};
var $d7b37fea0f6203ad$var$flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};
var $d7b37fea0f6203ad$var$updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) document.title = $d7b37fea0f6203ad$var$flattenArray(title);
    $d7b37fea0f6203ad$var$updateAttributes($d7b37fea0f6203ad$var$TAG_NAMES.TITLE, attributes);
};
var $d7b37fea0f6203ad$var$updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];
    if (!elementTag) return;
    var helmetAttributeString = elementTag.getAttribute($d7b37fea0f6203ad$var$HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);
    for(var i = 0; i < attributeKeys.length; i++){
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";
        if (elementTag.getAttribute(attribute) !== value) elementTag.setAttribute(attribute, value);
        if (helmetAttributes.indexOf(attribute) === -1) helmetAttributes.push(attribute);
        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) attributesToRemove.splice(indexToSave, 1);
    }
    for(var _i = attributesToRemove.length - 1; _i >= 0; _i--)elementTag.removeAttribute(attributesToRemove[_i]);
    if (helmetAttributes.length === attributesToRemove.length) elementTag.removeAttribute($d7b37fea0f6203ad$var$HELMET_ATTRIBUTE);
    else if (elementTag.getAttribute($d7b37fea0f6203ad$var$HELMET_ATTRIBUTE) !== attributeKeys.join(",")) elementTag.setAttribute($d7b37fea0f6203ad$var$HELMET_ATTRIBUTE, attributeKeys.join(","));
};
var $d7b37fea0f6203ad$var$updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector($d7b37fea0f6203ad$var$TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + $d7b37fea0f6203ad$var$HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;
    if (tags && tags.length) tags.forEach(function(tag) {
        var newElement = document.createElement(type);
        for(var attribute in tag)if (tag.hasOwnProperty(attribute)) {
            if (attribute === $d7b37fea0f6203ad$var$TAG_PROPERTIES.INNER_HTML) newElement.innerHTML = tag.innerHTML;
            else if (attribute === $d7b37fea0f6203ad$var$TAG_PROPERTIES.CSS_TEXT) {
                if (newElement.styleSheet) newElement.styleSheet.cssText = tag.cssText;
                else newElement.appendChild(document.createTextNode(tag.cssText));
            } else {
                var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                newElement.setAttribute(attribute, value);
            }
        }
        newElement.setAttribute($d7b37fea0f6203ad$var$HELMET_ATTRIBUTE, "true");
        // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
        if (oldTags.some(function(existingTag, index) {
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
        })) oldTags.splice(indexToDelete, 1);
        else newTags.push(newElement);
    });
    oldTags.forEach(function(tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function(tag) {
        return headElement.appendChild(tag);
    });
    return {
        oldTags: oldTags,
        newTags: newTags
    };
};
var $d7b37fea0f6203ad$var$generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function(str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};
var $d7b37fea0f6203ad$var$generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = $d7b37fea0f6203ad$var$generateElementAttributesAsString(attributes);
    var flattenedTitle = $d7b37fea0f6203ad$var$flattenArray(title);
    return attributeString ? "<" + type + " " + $d7b37fea0f6203ad$var$HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + $d7b37fea0f6203ad$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + $d7b37fea0f6203ad$var$HELMET_ATTRIBUTE + "=\"true\">" + $d7b37fea0f6203ad$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};
var $d7b37fea0f6203ad$var$generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function(str, tag) {
        var attributeHtml = Object.keys(tag).filter(function(attribute) {
            return !(attribute === $d7b37fea0f6203ad$var$TAG_PROPERTIES.INNER_HTML || attribute === $d7b37fea0f6203ad$var$TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function(string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + $d7b37fea0f6203ad$var$encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");
        var tagContent = tag.innerHTML || tag.cssText || "";
        var isSelfClosing = $d7b37fea0f6203ad$var$SELF_CLOSING_TAGS.indexOf(type) === -1;
        return str + "<" + type + " " + $d7b37fea0f6203ad$var$HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};
var $d7b37fea0f6203ad$var$convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(attributes).reduce(function(obj, key) {
        obj[$d7b37fea0f6203ad$var$REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};
var $d7b37fea0f6203ad$var$convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(props).reduce(function(obj, key) {
        obj[$d7b37fea0f6203ad$var$HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};
var $d7b37fea0f6203ad$var$generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;
    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[$d7b37fea0f6203ad$var$HELMET_ATTRIBUTE] = true, _initProps);
    var props = $d7b37fea0f6203ad$var$convertElementAttributestoReactProps(attributes, initProps);
    return [
        (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).createElement($d7b37fea0f6203ad$var$TAG_NAMES.TITLE, props, title)
    ];
};
var $d7b37fea0f6203ad$var$generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function(tag, i) {
        var _mappedTag;
        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[$d7b37fea0f6203ad$var$HELMET_ATTRIBUTE] = true, _mappedTag);
        Object.keys(tag).forEach(function(attribute) {
            var mappedAttribute = $d7b37fea0f6203ad$var$REACT_TAG_MAP[attribute] || attribute;
            if (mappedAttribute === $d7b37fea0f6203ad$var$TAG_PROPERTIES.INNER_HTML || mappedAttribute === $d7b37fea0f6203ad$var$TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = {
                    __html: content
                };
            } else mappedTag[mappedAttribute] = tag[attribute];
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).createElement(type, mappedTag);
    });
};
var $d7b37fea0f6203ad$var$getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch(type){
        case $d7b37fea0f6203ad$var$TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return $d7b37fea0f6203ad$var$generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return $d7b37fea0f6203ad$var$generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case $d7b37fea0f6203ad$var$ATTRIBUTE_NAMES.BODY:
        case $d7b37fea0f6203ad$var$ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return $d7b37fea0f6203ad$var$convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return $d7b37fea0f6203ad$var$generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return $d7b37fea0f6203ad$var$generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return $d7b37fea0f6203ad$var$generateTagsAsString(type, tags, encode);
                }
            };
    }
};
var $d7b37fea0f6203ad$var$mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag, bodyAttributes = _ref.bodyAttributes, encode = _ref.encode, htmlAttributes = _ref.htmlAttributes, linkTags = _ref.linkTags, metaTags = _ref.metaTags, noscriptTags = _ref.noscriptTags, scriptTags = _ref.scriptTags, styleTags = _ref.styleTags, _ref$title = _ref.title, title = _ref$title === undefined ? "" : _ref$title, titleAttributes = _ref.titleAttributes;
    return {
        base: $d7b37fea0f6203ad$var$getMethodsForTag($d7b37fea0f6203ad$var$TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: $d7b37fea0f6203ad$var$getMethodsForTag($d7b37fea0f6203ad$var$ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: $d7b37fea0f6203ad$var$getMethodsForTag($d7b37fea0f6203ad$var$ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: $d7b37fea0f6203ad$var$getMethodsForTag($d7b37fea0f6203ad$var$TAG_NAMES.LINK, linkTags, encode),
        meta: $d7b37fea0f6203ad$var$getMethodsForTag($d7b37fea0f6203ad$var$TAG_NAMES.META, metaTags, encode),
        noscript: $d7b37fea0f6203ad$var$getMethodsForTag($d7b37fea0f6203ad$var$TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: $d7b37fea0f6203ad$var$getMethodsForTag($d7b37fea0f6203ad$var$TAG_NAMES.SCRIPT, scriptTags, encode),
        style: $d7b37fea0f6203ad$var$getMethodsForTag($d7b37fea0f6203ad$var$TAG_NAMES.STYLE, styleTags, encode),
        title: $d7b37fea0f6203ad$var$getMethodsForTag($d7b37fea0f6203ad$var$TAG_NAMES.TITLE, {
            title: title,
            titleAttributes: titleAttributes
        }, encode)
    };
};
var $d7b37fea0f6203ad$var$Helmet = function Helmet(Component) {
    var _class, _temp;
    return _temp = _class = function(_React$Component) {
        $d7b37fea0f6203ad$var$inherits(HelmetWrapper, _React$Component);
        function HelmetWrapper() {
            $d7b37fea0f6203ad$var$classCallCheck(this, HelmetWrapper);
            return $d7b37fea0f6203ad$var$possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }
        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, (/*@__PURE__*/$parcel$interopDefault($a55a48cb99565f6d$exports)))(this.props, nextProps);
        };
        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) return null;
            switch(child.type){
                case $d7b37fea0f6203ad$var$TAG_NAMES.SCRIPT:
                case $d7b37fea0f6203ad$var$TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };
                case $d7b37fea0f6203ad$var$TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }
            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };
        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _babelHelpers$extends;
            var child = _ref.child, arrayTypeChildren = _ref.arrayTypeChildren, newChildProps = _ref.newChildProps, nestedChildren = _ref.nestedChildren;
            return $d7b37fea0f6203ad$var$_extends({}, arrayTypeChildren, (_babelHelpers$extends = {}, _babelHelpers$extends[child.type] = [].concat(arrayTypeChildren[child.type] || [], [
                $d7b37fea0f6203ad$var$_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))
            ]), _babelHelpers$extends));
        };
        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _babelHelpers$extends2, _babelHelpers$extends3;
            var child = _ref2.child, newProps = _ref2.newProps, newChildProps = _ref2.newChildProps, nestedChildren = _ref2.nestedChildren;
            switch(child.type){
                case $d7b37fea0f6203ad$var$TAG_NAMES.TITLE:
                    return $d7b37fea0f6203ad$var$_extends({}, newProps, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[child.type] = nestedChildren, _babelHelpers$extends2.titleAttributes = $d7b37fea0f6203ad$var$_extends({}, newChildProps), _babelHelpers$extends2));
                case $d7b37fea0f6203ad$var$TAG_NAMES.BODY:
                    return $d7b37fea0f6203ad$var$_extends({}, newProps, {
                        bodyAttributes: $d7b37fea0f6203ad$var$_extends({}, newChildProps)
                    });
                case $d7b37fea0f6203ad$var$TAG_NAMES.HTML:
                    return $d7b37fea0f6203ad$var$_extends({}, newProps, {
                        htmlAttributes: $d7b37fea0f6203ad$var$_extends({}, newChildProps)
                    });
            }
            return $d7b37fea0f6203ad$var$_extends({}, newProps, (_babelHelpers$extends3 = {}, _babelHelpers$extends3[child.type] = $d7b37fea0f6203ad$var$_extends({}, newChildProps), _babelHelpers$extends3));
        };
        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = $d7b37fea0f6203ad$var$_extends({}, newProps);
            Object.keys(arrayTypeChildren).forEach(function(arrayChildName) {
                var _babelHelpers$extends4;
                newFlattenedProps = $d7b37fea0f6203ad$var$_extends({}, newFlattenedProps, (_babelHelpers$extends4 = {}, _babelHelpers$extends4[arrayChildName] = arrayTypeChildren[arrayChildName], _babelHelpers$extends4));
            });
            return newFlattenedProps;
        };
        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            return true;
        };
        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;
            var arrayTypeChildren = {};
            (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).Children.forEach(children, function(child) {
                if (!child || !child.props) return;
                var _child$props = child.props, nestedChildren = _child$props.children, childProps = $d7b37fea0f6203ad$var$objectWithoutProperties(_child$props, [
                    "children"
                ]);
                var newChildProps = $d7b37fea0f6203ad$var$convertReactPropstoHtmlAttributes(childProps);
                _this2.warnOnInvalidChildren(child, nestedChildren);
                switch(child.type){
                    case $d7b37fea0f6203ad$var$TAG_NAMES.LINK:
                    case $d7b37fea0f6203ad$var$TAG_NAMES.META:
                    case $d7b37fea0f6203ad$var$TAG_NAMES.NOSCRIPT:
                    case $d7b37fea0f6203ad$var$TAG_NAMES.SCRIPT:
                    case $d7b37fea0f6203ad$var$TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });
            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };
        HelmetWrapper.prototype.render = function render() {
            var _props = this.props, children = _props.children, props = $d7b37fea0f6203ad$var$objectWithoutProperties(_props, [
                "children"
            ]);
            var newProps = $d7b37fea0f6203ad$var$_extends({}, props);
            if (children) newProps = this.mapChildrenToProps(children, newProps);
            return (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).createElement(Component, newProps);
        };
        $d7b37fea0f6203ad$var$createClass(HelmetWrapper, null, [
            {
                key: "canUseDOM",
                // Component.peek comes from react-side-effect:
                // For testing, you may use a static peek() method available on the returned component.
                // It lets you get the current state without resetting the mounted instance stack.
                // Don’t use it for anything other than testing.
                /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */ set: function set$$1(canUseDOM) {
                    Component.canUseDOM = canUseDOM;
                }
            }
        ]);
        return HelmetWrapper;
    }((0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).Component), _class.propTypes = {
        base: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).object,
        bodyAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).object,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).node),
            (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).node
        ]),
        defaultTitle: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
        defer: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool,
        encodeSpecialCharacters: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool,
        htmlAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).object,
        link: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).object),
        meta: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).object),
        noscript: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).object),
        onChangeClientState: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).func,
        script: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).object),
        style: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).object),
        title: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
        titleAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).object,
        titleTemplate: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function() {
        var mappedState = Component.rewind();
        if (!mappedState) // provide fallback if mappedState is undefined
        mappedState = $d7b37fea0f6203ad$var$mapStateOnServer({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
        });
        return mappedState;
    }, _temp;
};
var $d7b37fea0f6203ad$var$NullComponent = function NullComponent() {
    return null;
};
var $d7b37fea0f6203ad$var$HelmetSideEffects = (0, (/*@__PURE__*/$parcel$interopDefault($f35d49ba1628cf59$exports)))($d7b37fea0f6203ad$var$reducePropsToState, $d7b37fea0f6203ad$var$handleClientStateChange, $d7b37fea0f6203ad$var$mapStateOnServer)($d7b37fea0f6203ad$var$NullComponent);
var $d7b37fea0f6203ad$export$dcef8f9bb9a41431 = $d7b37fea0f6203ad$var$Helmet($d7b37fea0f6203ad$var$HelmetSideEffects);
$d7b37fea0f6203ad$export$dcef8f9bb9a41431.renderStatic = $d7b37fea0f6203ad$export$dcef8f9bb9a41431.rewind;
var $d7b37fea0f6203ad$export$2e2bcd8739ae039 = $d7b37fea0f6203ad$export$dcef8f9bb9a41431;



parcelRequire("5iwRF");


const $ebfa7bd3c0bd7228$export$579a1e9bab103f15 = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('section', {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignContent: "center",
    backgroundSize: "cover",
    height: "100vh",
    maxHeight: "50rem",
    transition: "ease 400ms",
    backgrounPosition: "30% 0%",
    "@media only screen and (min-width : 768px)": {
        backgroundPosition: "10% 30%",
        height: "50vh",
        minHeight: "28em"
    },
    "@media only screen and (min-width : 992px)": {
        height: "70vh",
        backgroundPosition: "10% 60%",
        minHeight: "35rem"
    }
});
const $ebfa7bd3c0bd7228$export$3b4e64e77073e307 = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('div', {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignContent: "center",
    margin: "auto 0 auto auto",
    padding: "1rem 1rem",
    "@media only screen and (min-width : 768px)": {
        padding: "1rem 4rem"
    }
});
const $ebfa7bd3c0bd7228$export$d5992c1fec905475 = (0, $d27e433b52638c64$export$3817b7a54a07cec7)((0, $6fd199a57804d61d$export$a6c7ac8248d6e38a), {
    display: "inline-block",
    width: "auto",
    fontFamily: "'Montserrat',Helvetica,Arial,sans-serif",
    fontWeight: 500,
    backgroundColor: "rgb(16, 201, 195)",
    padding: "0.8em 1.6em",
    color: "white",
    border: 0,
    cursor: "pointer",
    margin: "0.5em 0",
    transition: "ease 400ms",
    textDecoration: "none",
    "&:hover": {
        backgroundColor: "rgb(37, 37, 37)",
        color: "white"
    }
});
const $ebfa7bd3c0bd7228$export$960a49cc3d27a090 = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('div', {
    "@media only screen and (min-width : 768px)": {
        width: "100%",
        maxWidth: "65vw",
        minWidth: 500
    },
    "only screen and (min-width : 992px)": {
        width: "100%",
        maxWidth: 600,
        minWidth: 600
    },
    "@media only screen and (min-width : 1680px)": {
        width: "100%",
        maxWidth: "44vw",
        minWidth: "40%",
        padding: "2em"
    }
});
const $ebfa7bd3c0bd7228$export$7c309220fd1fb205 = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('p', {
    textShadow: "1px 1px 2px rgba(255,255,255,0.5)",
    paddingBottom: "1rem"
});



var $f116926e361b8380$exports = {};
$f116926e361b8380$exports = import.meta.resolve("gcupy");


const $28a3ebeb835906c3$var$ryugakuFair1 = new URL($f116926e361b8380$exports).toString();
var $f98ede1b0d90fb87$exports = {};
$f98ede1b0d90fb87$exports = import.meta.resolve("dTLN0");


const $28a3ebeb835906c3$var$ryugakuFair2 = new URL($f98ede1b0d90fb87$exports).toString();
var $90b106f0c005de60$exports = {};
$90b106f0c005de60$exports = import.meta.resolve("jh2WY");


const $28a3ebeb835906c3$var$ryugakuFair3 = new URL($90b106f0c005de60$exports).toString();
var $94dcb329ec8e382d$exports = {};
$94dcb329ec8e382d$exports = import.meta.resolve("jsTg3");


const $28a3ebeb835906c3$var$ryugakuFair4 = new URL($94dcb329ec8e382d$exports).toString();
var $a68e297c176161d8$exports = {};
$a68e297c176161d8$exports = import.meta.resolve("59p8Y");


const $28a3ebeb835906c3$var$ryugakuFairBG = new URL($a68e297c176161d8$exports).toString();
var $be7c41095702bea7$exports = {};
$be7c41095702bea7$exports = import.meta.resolve("A4Bjl");


const $28a3ebeb835906c3$var$uniquizBG = new URL($be7c41095702bea7$exports).toString();
var $a7743cb491eb7293$exports = {};
$a7743cb491eb7293$exports = import.meta.resolve("gccm9");


const $28a3ebeb835906c3$var$uniquiz1 = new URL($a7743cb491eb7293$exports).toString();
var $a0786b76b5bcd6c3$exports = {};
$a0786b76b5bcd6c3$exports = import.meta.resolve("kHtX9");


const $28a3ebeb835906c3$var$uniquiz2 = new URL($a0786b76b5bcd6c3$exports).toString();
var $11c5785e0bef6520$exports = {};
$11c5785e0bef6520$exports = import.meta.resolve("erlBS");


const $28a3ebeb835906c3$var$uniquiz3 = new URL($11c5785e0bef6520$exports).toString();
var $3c4ef438b4b96ad5$exports = {};
$3c4ef438b4b96ad5$exports = import.meta.resolve("2wUkf");


const $28a3ebeb835906c3$var$uniquiz4 = new URL($3c4ef438b4b96ad5$exports).toString();
var $cd2e8df29af10a24$exports = {};
$cd2e8df29af10a24$exports = import.meta.resolve("hm5tv");


const $28a3ebeb835906c3$var$weLoveLanguagesBG = new URL($cd2e8df29af10a24$exports).toString();
var $2e282b18908e5444$exports = {};
$2e282b18908e5444$exports = import.meta.resolve("dO5ih");


const $28a3ebeb835906c3$var$weLoveLanguages1 = new URL($2e282b18908e5444$exports).toString();
var $6b23314027e68664$exports = {};
$6b23314027e68664$exports = import.meta.resolve("2NLtJ");


const $28a3ebeb835906c3$var$weLoveLanguages2 = new URL($6b23314027e68664$exports).toString();
var $5e1cfbcb7de069b4$exports = {};
$5e1cfbcb7de069b4$exports = import.meta.resolve("hH5bD");


const $28a3ebeb835906c3$var$weLoveLanguages3 = new URL($5e1cfbcb7de069b4$exports).toString();
var $2ce2a664f84cc88d$exports = {};
$2ce2a664f84cc88d$exports = import.meta.resolve("bp8Rt");


const $28a3ebeb835906c3$var$weLoveLanguages4 = new URL($2ce2a664f84cc88d$exports).toString();
var $1bf1528f49cbaf22$exports = {};
$1bf1528f49cbaf22$exports = import.meta.resolve("jDKYg");


const $28a3ebeb835906c3$var$zooplaDashboardBg = new URL($1bf1528f49cbaf22$exports).toString();
var $f531312134d5c204$exports = {};
$f531312134d5c204$exports = import.meta.resolve("cKNSA");


const $28a3ebeb835906c3$var$zooplaDashboard1 = new URL($f531312134d5c204$exports).toString();
var $061b262d9dd88de0$exports = {};
$061b262d9dd88de0$exports = import.meta.resolve("goGqi");


const $28a3ebeb835906c3$var$zooplaDashboard2 = new URL($061b262d9dd88de0$exports).toString();
var $57e1b83854663426$exports = {};
$57e1b83854663426$exports = import.meta.resolve("7dT8y");


const $28a3ebeb835906c3$var$zooplaDashboard3 = new URL($57e1b83854663426$exports).toString();
var $0e93b2121e72c524$exports = {};
$0e93b2121e72c524$exports = import.meta.resolve("3a0gU");


const $28a3ebeb835906c3$var$zooplaDashboard4 = new URL($0e93b2121e72c524$exports).toString();
var $5df701c2fdb0939b$exports = {};
$5df701c2fdb0939b$exports = import.meta.resolve("3m4IM");


const $28a3ebeb835906c3$var$zooplaMapsBg = new URL($5df701c2fdb0939b$exports).toString();
var $e731f0dd038e8cfb$exports = {};
$e731f0dd038e8cfb$exports = import.meta.resolve("9GrOZ");


const $28a3ebeb835906c3$var$zooplaMaps1 = new URL($e731f0dd038e8cfb$exports).toString();
var $fcd2d161aa54a140$exports = {};
$fcd2d161aa54a140$exports = import.meta.resolve("jAjtJ");


const $28a3ebeb835906c3$var$zooplaMaps2 = new URL($fcd2d161aa54a140$exports).toString();
var $09f7f566a2cdb1c4$exports = {};
$09f7f566a2cdb1c4$exports = import.meta.resolve("6Cyfq");


const $28a3ebeb835906c3$var$autocompleteBg = new URL($09f7f566a2cdb1c4$exports).toString();
var $ca0d08af12b0db80$exports = {};
$ca0d08af12b0db80$exports = import.meta.resolve("cZOle");


const $28a3ebeb835906c3$var$autocomplete1 = new URL($ca0d08af12b0db80$exports).toString();
var $dd8db20958ba9568$exports = {};
$dd8db20958ba9568$exports = import.meta.resolve("8m7LY");


const $28a3ebeb835906c3$var$autocomplete2 = new URL($dd8db20958ba9568$exports).toString();
var $5722e03c952eb2fb$exports = {};
$5722e03c952eb2fb$exports = import.meta.resolve("75MCJ");


const $28a3ebeb835906c3$var$zooplaMcp = new URL($5722e03c952eb2fb$exports).toString();
var $39861ec6f1add8bd$exports = {};
$39861ec6f1add8bd$exports = import.meta.resolve("hWT6X");


const $28a3ebeb835906c3$var$zooplaMcp1 = new URL($39861ec6f1add8bd$exports).toString();
var $24485f0e095a8ef1$exports = {};
$24485f0e095a8ef1$exports = import.meta.resolve("fpgEz");


const $28a3ebeb835906c3$var$zooplaMcp2 = new URL($24485f0e095a8ef1$exports).toString();
var $11f1a6a8d90d0f7a$exports = {};
$11f1a6a8d90d0f7a$exports = import.meta.resolve("1vNvB");


const $28a3ebeb835906c3$var$zooplaMcp3 = new URL($11f1a6a8d90d0f7a$exports).toString();
var $28a3ebeb835906c3$export$2e2bcd8739ae039 = {
    "header": "Grow and Develop",
    "headerText": "A front-end engineer emphasised on quality, accessibility and user experience. Created professional websites for serveral companies, mainly focused on React/Next.js. Enjoy writing in free time.",
    "aboutHeader": "I am Yuki Cheung",
    "aboutText": "I am a front-end engineer emphasised on quality, accessibility and user experience",
    "aboutDesc": "Hello, I am Yuki! A front-end web developer emphasised UI/UX. Good at building user interfaces and work with various designers. Equipped with automated unit test and end-to-end test skills.",
    "aboutDesc1": "Love writing and learning new languages. Native in Cantonese, fluent in Japanese and English. Feel free to drop me a line!",
    "skills": {
        "frontend": [
            "React/Next.js",
            "Gatsby.js",
            "Cypress",
            "Storybook",
            "CSS-in-JS",
            "TypeScript",
            "CSS/SASS/LESS"
        ],
        "backend": [
            "GraphQL",
            "Node.js/Express",
            "MySQL/PostgresQL",
            "Linux",
            "Python"
        ],
        "tools": [
            "AWS",
            "CI/CD",
            "Cypress",
            "Figma",
            "git",
            "Docker",
            "Jest",
            "Monorepo",
            "Webpack",
            "axe"
        ]
    },
    "aboutButton": "Contact Me",
    "headerButton": "About Me",
    "projectsTitle": [
        "all",
        "side projects"
    ],
    "brandList": [
        "zoopla",
        "ef",
        "dbs"
    ],
    "blogTitle": "Recent Articles",
    "projects": [
        {
            "id": 7,
            "urlKey": "zoopla-chatgpt-apps",
            "category": "Commercial",
            "name": "Zoopla ChatGPT Apps",
            "link": "https://chatgpt.com/apps/zoopla/asdk_app_694547c513008191a7b8f44c95fb14c3",
            "desc": "This commercial project for Zoopla explored building a customer-facing ChatGPT app experience, combining a custom MCP server with a new interactive UI surface inside ChatGPT. I led the initial frontend architecture and took the UI foundation from 0 to 1 while the backend MCP server work was still in progress, creating enough structure, patterns, and reusable templates for the wider team to continue development independently.",
            "techDesc": "Created the initial ChatGPT Apps UI template from scratch and contributed to the MCP server integration approach. Established the frontend architecture, component structure, data-flow assumptions, and development patterns needed to support iterative product work while backend capabilities were still being defined.",
            "client": "Zoopla (London, United Kingdom)",
            "date": "Feb 2026",
            "bg": $28a3ebeb835906c3$var$zooplaMcp,
            "gallery": [
                $28a3ebeb835906c3$var$zooplaMcp1,
                $28a3ebeb835906c3$var$zooplaMcp2,
                $28a3ebeb835906c3$var$zooplaMcp3
            ]
        },
        {
            "id": 6,
            "urlKey": "autocomplete",
            "category": "Commercial",
            "name": "House Prices Address Autocompletion on Zoopla Mobile App",
            "link": "https://www.zoopla.co.uk/",
            "desc": "This commercial project for Zoopla introduced address autocompletion to the House Prices journey on the mobile app, enabling users to search across a dataset of 35 million UK addresses. The work covered the full discovery and delivery process, from analysing address-search behaviour and OpenSearch query strategies through to validating relevance improvements in a production-safe way. A key part of the project was finding the best possible query approach without risking regressions to the live experience.",
            "techDesc": "Built the address autocomplete experience with OpenSearch and React Native, including query optimisation, relevance tuning, performance analysis, and production-safe experimentation. Integrated the final solution into the Zoopla mobile app while balancing search quality, latency, and operational risk across a large-scale UK address index.",
            "client": "Zoopla (London, United Kingdom)",
            "date": "Mar 2025",
            "bg": $28a3ebeb835906c3$var$autocompleteBg,
            "gallery": [
                $28a3ebeb835906c3$var$autocomplete1,
                $28a3ebeb835906c3$var$autocomplete2
            ]
        },
        {
            "id": 5,
            "urlKey": "zoopla-maps",
            "category": "Commercial",
            "name": "In-house Static Maps Image Alternatives",
            "link": "https://www.zoopla.co.uk/",
            "desc": "This project aimed to reduce static map costs for Zoopla, transitioning from Google Static Maps to a self-hosted solution. The project is projected to save \xa330,000 per year, significantly reducing operational costs. Led the project from the discovery phase, evaluating multiple solutions and selecting the one best suited to the company\u2019s needs. Collaborated closely with the infrastructure team and the Head of Engineering to ensure a smooth transition. Took the lead on the front-end implementation and coordinated with the infra team.",
            "techDesc": "Implemented a service using TileServer GL, Amazon ECS, Amazon CloudFront, and other cloud services.",
            "client": "Zoopla (London, United Kingdom)",
            "date": "Dec 2024 - Mar 2025",
            "bg": $28a3ebeb835906c3$var$zooplaMapsBg,
            "gallery": [
                $28a3ebeb835906c3$var$zooplaMaps1,
                $28a3ebeb835906c3$var$zooplaMaps2
            ]
        },
        {
            "id": 4,
            "urlKey": "zoopla-account-dashboard",
            "category": "Commercial",
            "name": "My Zoopla \u2013 Account Page Revamp",
            "link": "https://www.zoopla.co.uk/my-zoopla/",
            "desc": "This project was a complete overhaul of the existing Zoopla account page, improving both functionality and user experience. Revamped all key sections of the account page, including Tracked Properties, Saved Searches, Saved Listings, and more. Previously, these sections had inconsistent styles, and they were now unified with a modern, cohesive design.",
            "techDesc": "Developed the account page with Next.js, React, GraphQL, Cypress, Jest, and other modern technologies.",
            "client": "Zoopla (London, United Kingdom)",
            "date": "2023",
            "bg": $28a3ebeb835906c3$var$zooplaDashboardBg,
            "gallery": [
                $28a3ebeb835906c3$var$zooplaDashboard1,
                $28a3ebeb835906c3$var$zooplaDashboard2,
                $28a3ebeb835906c3$var$zooplaDashboard3,
                $28a3ebeb835906c3$var$zooplaDashboard4
            ]
        },
        {
            "id": 3,
            "urlKey": "ryugaku-fair",
            "category": "Commercial",
            "name": "Ryugaku Fair",
            "link": "https://www.efjapan.co.jp/hub/asia/ryugaku-fair",
            "desc": "This page is created for EF Japan for promoting their education fairs and generating leads. Using Gatsby to programmatically generate pages for office/testimonials and office details.",
            "techDesc": "The main technologies are Gatsby/React, SASS/CSS.",
            "client": "EF Education First (Japan)",
            "date": "Aug, 2019",
            "bg": $28a3ebeb835906c3$var$ryugakuFairBG,
            "gallery": [
                $28a3ebeb835906c3$var$ryugakuFair1,
                $28a3ebeb835906c3$var$ryugakuFair2,
                $28a3ebeb835906c3$var$ryugakuFair3,
                $28a3ebeb835906c3$var$ryugakuFair4
            ]
        },
        {
            "id": 2,
            "urlKey": "uniquiz",
            "category": "Commercial",
            "name": "Uniquiz - Quiz Template",
            "link": "https://www.ef.com/hub/asia/quizzes/uniquiz",
            "desc": "This is a quiz template created for EF Asia. Users can create different types of quizzes, like adding/removing point-based, category-based questions/answers by editing in Sitecore. Customers can change to different by using different paths, like moms-quiz, uniquiz etc.",
            "techDesc": "The main technologies are React and React hook/router, SASS/CSS. Using react-testing-library for unit testing.",
            "client": "EF Education First (Asia)",
            "date": "July, 2019",
            "bg": $28a3ebeb835906c3$var$uniquizBG,
            "gallery": [
                $28a3ebeb835906c3$var$uniquiz1,
                $28a3ebeb835906c3$var$uniquiz2,
                $28a3ebeb835906c3$var$uniquiz3,
                $28a3ebeb835906c3$var$uniquiz4
            ]
        },
        {
            "id": 1,
            "category": "Commercial",
            "urlKey": "we-love-languages",
            "name": "Card Game - We Love Languages",
            "link": "https://www.ef.com.hk/hub/asia/we-love-languages/",
            "desc": "This is a campaign page developed for EF Asia, for boosting awareness and sales of EF Asia offices, included EF Japan, Hong Kong, Indonesia, South Korea, Thailand, Vietnam. User needs to play and match six pairs of card and the end, they can get discounts on EF's courses.",
            "techDesc": "The main technologies are React, SASS/CSS and webpack.",
            "client": "EF Education First (Japan)",
            "date": "November, 2018",
            "bg": $28a3ebeb835906c3$var$weLoveLanguagesBG,
            "gallery": [
                $28a3ebeb835906c3$var$weLoveLanguages1,
                $28a3ebeb835906c3$var$weLoveLanguages2,
                $28a3ebeb835906c3$var$weLoveLanguages3,
                $28a3ebeb835906c3$var$weLoveLanguages4
            ]
        }
    ],
    "contactHeader": "Contact Me",
    "contactText": "Interested in working together or discussing a project? Get in touch and I\u2019ll be happy to connect.",
    "footer": [
        {
            "id": "github",
            "url": "https://github.com/snowleo208/"
        },
        {
            "id": "codepen",
            "url": "https://codepen.io/snowleo208/"
        },
        {
            "id": "dev-dot-to",
            "url": "https://dev.to/snowleo208/"
        }
    ]
};


var $5e29a662fb334684$exports = {};
$5e29a662fb334684$exports = import.meta.resolve("lB3Je");


const $de2430378eeafd03$var$bgImage = new URL($5e29a662fb334684$exports).toString();
function $de2430378eeafd03$export$8b251419efc915eb() {
    return /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)("header", {
        children: /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsxs)((0, $ebfa7bd3c0bd7228$export$579a1e9bab103f15), {
            style: {
                backgroundImage: `url(${$de2430378eeafd03$var$bgImage})`
            },
            children: [
                /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $6606e5f4ea82c065$export$d9b273488cd8ce6f), {}),
                /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $ebfa7bd3c0bd7228$export$3b4e64e77073e307), {
                    children: /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsxs)((0, $ebfa7bd3c0bd7228$export$960a49cc3d27a090), {
                        children: [
                            /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)("h1", {
                                children: (0, $28a3ebeb835906c3$export$2e2bcd8739ae039).header
                            }),
                            /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $ebfa7bd3c0bd7228$export$7c309220fd1fb205), {
                                children: (0, $28a3ebeb835906c3$export$2e2bcd8739ae039).headerText
                            }),
                            /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $ebfa7bd3c0bd7228$export$d5992c1fec905475), {
                                to: "/about",
                                children: (0, $28a3ebeb835906c3$export$2e2bcd8739ae039).headerButton
                            })
                        ]
                    })
                })
            ]
        })
    });
}





parcelRequire("5iwRF");



const $2464ebda50233e24$export$493c2362ae8a339f = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('div', {
    padding: "2rem 0"
});
const $2464ebda50233e24$export$f99233281efd08a0 = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('p', {
    fontSize: "0.9rem",
    textAlign: "center"
});
const $2464ebda50233e24$export$68b407ab6a568768 = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('div', {
    display: "grid",
    "@media only screen and (min-width : 768px)": {
        gridTemplateColumns: "repeat(3, 1fr)"
    }
});
const $2464ebda50233e24$export$45f026a0d68a9fee = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('div', {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center",
    width: "100%",
    height: "100%",
    padding: "2rem",
    backgroundColor: "rgba(23, 23, 23, 0.9)",
    opacity: 0,
    transition: "opacity ease 400ms",
    "h2": {
        color: "white",
        fontSize: "1.25rem",
        textAlign: "center"
    },
    "p": {
        fontSize: "0.7rem",
        color: "white",
        textTransform: 'uppercase',
        fontWeight: 600
    }
});
const $2464ebda50233e24$export$7dfec255c8103ea4 = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('div', {
    backgroundSize: "cover",
    backgroundPosition: "center",
    minHeight: "100vw",
    "@media only screen and (min-width : 768px)": {
        minHeight: "calc(100vw / 3)"
    },
    "&:hover": {
        "div": {
            opacity: 1
        }
    }
});


function $4803f1b3b0b75f38$export$b6032183171af19f() {
    const list = (0, $28a3ebeb835906c3$export$2e2bcd8739ae039).projects;
    const itemList = list.map((item)=>/*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $2464ebda50233e24$export$7dfec255c8103ea4), {
            style: {
                backgroundImage: `url(${item?.bg})`
            },
            children: /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $6fd199a57804d61d$export$a6c7ac8248d6e38a), {
                to: `/project/${item.urlKey}/`,
                children: /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsxs)((0, $2464ebda50233e24$export$45f026a0d68a9fee), {
                    children: [
                        /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)("h2", {
                            children: item.name
                        }),
                        /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)("p", {
                            children: item.category
                        })
                    ]
                })
            })
        }, item?.urlKey));
    return /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsxs)((0, $f0ae0fbdb7754737$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $2464ebda50233e24$export$493c2362ae8a339f), {
                children: /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $2464ebda50233e24$export$f99233281efd08a0), {
                    children: "All projects"
                })
            }),
            /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $2464ebda50233e24$export$68b407ab6a568768), {
                children: itemList
            })
        ]
    });
}






var $5iwRF = parcelRequire("5iwRF");


const $50511cb14ba165f3$export$d5770e6ea9382be9 = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('div', {
    display: "flex",
    backgroundColor: "#f6f6f6",
    padding: "4em 1em",
    alignItems: "center",
    alignContent: "center",
    flexDirection: "column"
});
const $50511cb14ba165f3$export$fb38abf53ed292dd = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('h2', {
    textAlign: "center",
    margin: "0 0 1em"
});
const $50511cb14ba165f3$export$8f831744a5122006 = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('div', {
    display: "grid",
    rowGap: "1.5rem",
    "@media only screen and (min-width : 992px)": {
        gridTemplateColumns: "repeat(3, 18.75rem)",
        columnGap: "1.5rem"
    }
});
const $50511cb14ba165f3$export$fe3e80eb685e666e = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('p', {
    margin: 0,
    color: 'rgb(95, 95, 95)'
});
const $50511cb14ba165f3$export$4671e0d562514819 = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('div', {
    backgroundColor: "white",
    width: "100%",
    height: "100%",
    transitionProperty: 'box-shadow',
    transitionDuration: '150ms',
    transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)',
    borderRadius: '0.5rem',
    overflow: 'hidden',
    color: 'rgb(95, 95, 95)',
    '&:hover': {
        boxShadow: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)'
    },
    '&:visited': {
        color: 'rgb(95, 95, 95)'
    }
});
const $50511cb14ba165f3$export$874765af6ddcfe85 = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('div', {
    padding: "1rem"
});
const $50511cb14ba165f3$export$a15effe9bab1a861 = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('h3', {
    display: "block",
    margin: "0 0 0.5em 0",
    transition: "ease 400ms",
    fontSize: "1.05em",
    textDecoration: "none",
    "@media only screen and (min-width : 992px)": {
        fontSize: "1.17em"
    }
});
const $50511cb14ba165f3$export$a18b40b4990d8456 = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('img', {
    display: "block",
    width: "100%",
    transition: "ease 400ms",
    aspectRatio: '16 / 9'
});
const $50511cb14ba165f3$export$2a5f89b504d45237 = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('p', {
    textTransform: "uppercase",
    fontSize: "0.7rem",
    fontWeight: "bold"
});



parcelRequire("5iwRF");

const $3c760189ee6a5b12$export$e3cb9ef4a0c00f93 = (post)=>{
    return /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)("a", {
        href: post.url,
        target: "_blank",
        rel: "noopener noreferrer",
        children: /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsxs)((0, $50511cb14ba165f3$export$4671e0d562514819), {
            children: [
                /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $50511cb14ba165f3$export$a18b40b4990d8456), {
                    src: post.cover_image,
                    alt: "",
                    loading: "lazy"
                }),
                /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsxs)((0, $50511cb14ba165f3$export$874765af6ddcfe85), {
                    children: [
                        /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $50511cb14ba165f3$export$a15effe9bab1a861), {
                            children: post.title
                        }),
                        /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $50511cb14ba165f3$export$2a5f89b504d45237), {
                            children: post.readable_publish_date
                        })
                    ]
                })
            ]
        })
    });
};


const $4b389db3b020e661$export$60158244e544476a = 'https://blog.atrera.com/latest.json';



const $db902ce4556f80a8$export$a0bf0840e4729e25 = (value, property)=>{
    const descriptor = Object.getOwnPropertyDescriptor(value, property);
    if (!descriptor) return false;
    return typeof descriptor.value === 'string';
};


const $48f992444e497480$export$341cce4f60dfdf48 = (value)=>{
    if (typeof value !== 'object' || value === null) return false;
    return (0, $db902ce4556f80a8$export$a0bf0840e4729e25)(value, 'title') && (0, $db902ce4556f80a8$export$a0bf0840e4729e25)(value, 'description') && (0, $db902ce4556f80a8$export$a0bf0840e4729e25)(value, 'readable_publish_date') && (0, $db902ce4556f80a8$export$a0bf0840e4729e25)(value, 'url') && (0, $db902ce4556f80a8$export$a0bf0840e4729e25)(value, 'cover_image') && (0, $db902ce4556f80a8$export$a0bf0840e4729e25)(value, 'created_at');
};


const $c9f5c47ccc981703$export$22affd4f187a6300 = 'AbortError';
const $c9f5c47ccc981703$export$d2c30ea522b3259e = (error)=>{
    if (error instanceof DOMException) return error.name === $c9f5c47ccc981703$export$22affd4f187a6300;
    if (typeof error !== 'object' || error === null) return false;
    if (!('name' in error)) return false;
    return error.name === $c9f5c47ccc981703$export$22affd4f187a6300;
};


const $58587dea31968460$export$5ede777d8386dec4 = (signal)=>{
    if (!signal?.aborted) return;
    throw new DOMException('Latest articles request was aborted', (0, $c9f5c47ccc981703$export$22affd4f187a6300));
};


const $815b08a00f01b521$export$6ff0ff2059d92370 = async (signal)=>{
    (0, $58587dea31968460$export$5ede777d8386dec4)(signal);
    const response = await fetch((0, $4b389db3b020e661$export$60158244e544476a), {
        mode: 'cors',
        signal: signal
    });
    (0, $58587dea31968460$export$5ede777d8386dec4)(signal);
    if (!response.ok) throw new Error('Unable to fetch latest articles');
    const posts = await response.json();
    (0, $58587dea31968460$export$5ede777d8386dec4)(signal);
    if (!Array.isArray(posts) || !posts.every((0, $48f992444e497480$export$341cce4f60dfdf48))) throw new Error('Latest articles response is invalid');
    return posts;
};








const $50d25fef0551d6f2$export$b68be92453dfc5b6 = ()=>{
    const [post, setPost] = (0, $5iwRF.useState)([]);
    const [hasError, setHasError] = (0, $5iwRF.useState)(false);
    (0, $5iwRF.useEffect)(()=>{
        const controller = new AbortController();
        const loadPosts = async ()=>{
            try {
                const posts = await (0, $815b08a00f01b521$export$6ff0ff2059d92370)(controller.signal);
                if (controller.signal.aborted) return;
                setPost(posts);
                setHasError(false);
            } catch (error) {
                if ((0, $c9f5c47ccc981703$export$d2c30ea522b3259e)(error)) return;
                setPost([]);
                setHasError(true);
            }
        };
        loadPosts();
        return ()=>{
            controller.abort();
        };
    }, []);
    if (hasError) return /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsxs)((0, $50511cb14ba165f3$export$d5770e6ea9382be9), {
        children: [
            /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $50511cb14ba165f3$export$fb38abf53ed292dd), {
                children: (0, $28a3ebeb835906c3$export$2e2bcd8739ae039).blogTitle
            }),
            /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $50511cb14ba165f3$export$fe3e80eb685e666e), {
                role: "alert",
                children: "Unable to load recent articles."
            })
        ]
    });
    return /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsxs)((0, $50511cb14ba165f3$export$d5770e6ea9382be9), {
        children: [
            /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $50511cb14ba165f3$export$fb38abf53ed292dd), {
                children: (0, $28a3ebeb835906c3$export$2e2bcd8739ae039).blogTitle
            }),
            /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $50511cb14ba165f3$export$8f831744a5122006), {
                children: post.slice(0, 3).map((post)=>/*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $3c760189ee6a5b12$export$e3cb9ef4a0c00f93), {
                        ...post
                    }, post.url))
            }),
            /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)("div", {
                "aria-live": "polite",
                children: hasError && /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $50511cb14ba165f3$export$fe3e80eb685e666e), {
                    role: "alert",
                    children: "Unable to load recent articles."
                })
            })
        ]
    });
};





parcelRequire("5iwRF");


const $252d0c35314cf0b4$export$3afbe0a7d3e1935e = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('section', {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    padding: "2rem 1rem"
});
const $252d0c35314cf0b4$export$d43ffeaaec0b2a58 = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('div', {
    display: "flex",
    alignItems: "center",
    textAlign: "center"
});
const $252d0c35314cf0b4$export$28be41ac4e8a64c4 = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('img', {
    display: "inline-block",
    width: "100%",
    maxWidth: "6em",
    filter: "grayscale(100%)",
    marginRight: "1em",
    height: "auto",
    "@media only screen and (min-width : 992px)": {
        width: "9em",
        height: "auto"
    }
});


var $645fe4ea767f64aa$exports = {};
$645fe4ea767f64aa$exports = import.meta.resolve("f9Did");


const $2fdc1cc89313d290$var$EFLogo = new URL($645fe4ea767f64aa$exports).toString();
var $3bc4749a95ceb792$exports = {};
$3bc4749a95ceb792$exports = import.meta.resolve("2T5bb");


const $2fdc1cc89313d290$var$ZooplaLogo = new URL($3bc4749a95ceb792$exports).toString();
var $0d73e6177284ebf2$exports = {};
$0d73e6177284ebf2$exports = import.meta.resolve("kBpF7");


const $2fdc1cc89313d290$var$DBSLogo = new URL($0d73e6177284ebf2$exports).toString();
const $2fdc1cc89313d290$var$imageList = {
    zoopla: $2fdc1cc89313d290$var$ZooplaLogo,
    ef: $2fdc1cc89313d290$var$EFLogo,
    dbs: $2fdc1cc89313d290$var$DBSLogo
};
function $2fdc1cc89313d290$export$e6ff31bff12b7ff4() {
    return /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $252d0c35314cf0b4$export$3afbe0a7d3e1935e), {
        children: /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $252d0c35314cf0b4$export$d43ffeaaec0b2a58), {
            children: (0, $28a3ebeb835906c3$export$2e2bcd8739ae039).brandList.map((item)=>/*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $252d0c35314cf0b4$export$28be41ac4e8a64c4), {
                    alt: `${item} logo`,
                    loading: "lazy",
                    src: $2fdc1cc89313d290$var$imageList[item]
                }, `${item}-logo`))
        })
    });
}






var $5iwRF = parcelRequire("5iwRF");

var $5iwRF = parcelRequire("5iwRF");
var $89d38d99107ddd0f$var$isCheckBoxInput = (element)=>element.type === 'checkbox';
var $89d38d99107ddd0f$var$isDateObject = (value1)=>value1 instanceof Date;
var $89d38d99107ddd0f$var$isNullOrUndefined = (value1)=>value1 == null;
const $89d38d99107ddd0f$var$isObjectType = (value1)=>typeof value1 === 'object';
var $89d38d99107ddd0f$var$isObject = (value1)=>!$89d38d99107ddd0f$var$isNullOrUndefined(value1) && !Array.isArray(value1) && $89d38d99107ddd0f$var$isObjectType(value1) && !$89d38d99107ddd0f$var$isDateObject(value1);
var $89d38d99107ddd0f$var$getEventValue = (event)=>$89d38d99107ddd0f$var$isObject(event) && event.target ? $89d38d99107ddd0f$var$isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
var $89d38d99107ddd0f$var$getFieldArrayParentNames = (names, name)=>{
    const parts = name.split('.');
    const matches = [];
    let prefix = parts[0];
    for(let i = 1; i < parts.length; prefix += '.' + parts[i++])!isNaN(+parts[i]) && names.has(prefix) && matches.push(prefix);
    return matches;
};
var $89d38d99107ddd0f$var$isPlainObject = (tempObject)=>{
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return $89d38d99107ddd0f$var$isObject(prototypeCopy) && prototypeCopy.hasOwnProperty('isPrototypeOf');
};
var $89d38d99107ddd0f$var$isWeb = typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined' && typeof document !== 'undefined';
function $89d38d99107ddd0f$var$cloneObject(data) {
    if (data instanceof Date) return new Date(data);
    const isFileListInstance = typeof FileList !== 'undefined' && data instanceof FileList;
    if ($89d38d99107ddd0f$var$isWeb && (data instanceof Blob || isFileListInstance)) return data;
    const isArray = Array.isArray(data);
    if (!isArray && !($89d38d99107ddd0f$var$isObject(data) && $89d38d99107ddd0f$var$isPlainObject(data))) return data;
    const copy = isArray ? [] : Object.create(Object.getPrototypeOf(data));
    for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) copy[key] = $89d38d99107ddd0f$var$cloneObject(data[key]);
    return copy;
}
var $89d38d99107ddd0f$var$isKey = (value1)=>/^\w*$/.test(value1);
var $89d38d99107ddd0f$var$isUndefined = (val)=>val === undefined;
var $89d38d99107ddd0f$var$compact = (value1)=>Array.isArray(value1) ? value1.filter(Boolean) : [];
var $89d38d99107ddd0f$var$stringToPath = (input)=>$89d38d99107ddd0f$var$compact(input.replace(/["|']|\]/g, '').split(/\.|\[/));
var $89d38d99107ddd0f$export$3988ae62b71be9a3 = (object, path, defaultValue)=>{
    if (!path || !$89d38d99107ddd0f$var$isObject(object)) return defaultValue;
    const paths = $89d38d99107ddd0f$var$isKey(path) ? [
        path
    ] : $89d38d99107ddd0f$var$stringToPath(path);
    const result = paths.reduce((result, key)=>{
        return $89d38d99107ddd0f$var$isNullOrUndefined(result) ? undefined : result[key];
    }, object);
    return $89d38d99107ddd0f$var$isUndefined(result) || result === object ? $89d38d99107ddd0f$var$isUndefined(object[path]) ? defaultValue : object[path] : result;
};
var $89d38d99107ddd0f$var$isBoolean = (value1)=>typeof value1 === 'boolean';
var $89d38d99107ddd0f$var$isFunction = (value1)=>typeof value1 === 'function';
var $89d38d99107ddd0f$export$adaa4cf7ef1b65be = (object, path, value1)=>{
    let index = -1;
    const tempPath = $89d38d99107ddd0f$var$isKey(path) ? [
        path
    ] : $89d38d99107ddd0f$var$stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while(++index < length){
        const key = tempPath[index];
        let newValue = value1;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue = $89d38d99107ddd0f$var$isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
        }
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        object[key] = newValue;
        object = object[key];
    }
};
const $89d38d99107ddd0f$var$EVENTS = {
    BLUR: 'blur',
    FOCUS_OUT: 'focusout',
    CHANGE: 'change',
    SUBMIT: 'submit',
    TRIGGER: 'trigger',
    VALID: 'valid'
};
const $89d38d99107ddd0f$var$VALIDATION_MODE = {
    onBlur: 'onBlur',
    onChange: 'onChange',
    onSubmit: 'onSubmit',
    onTouched: 'onTouched',
    all: 'all'
};
const $89d38d99107ddd0f$var$INPUT_VALIDATION_RULES = {
    max: 'max',
    min: 'min',
    maxLength: 'maxLength',
    minLength: 'minLength',
    pattern: 'pattern',
    required: 'required',
    validate: 'validate'
};
const $89d38d99107ddd0f$var$FORM_ERROR_TYPE = 'form';
const $89d38d99107ddd0f$var$ROOT_ERROR_TYPE = 'root';
/**
 * Separate context for `control` to prevent unnecessary rerenders.
 * Internal hooks that only need control use this instead of full form context.
 */ const $89d38d99107ddd0f$var$HookFormControlContext = (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).createContext(null);
$89d38d99107ddd0f$var$HookFormControlContext.displayName = 'HookFormControlContext';
/**
 * @internal Internal hook to access only control from context.
 */ const $89d38d99107ddd0f$var$useFormControlContext = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useContext($89d38d99107ddd0f$var$HookFormControlContext);
var $89d38d99107ddd0f$var$getProxyFormState = (formState, control, localProxyFormState, isRoot = true)=>{
    const result = {};
    for(const key in formState)Object.defineProperty(result, key, {
        get: ()=>{
            const _key = key;
            if (control._proxyFormState[_key] !== $89d38d99107ddd0f$var$VALIDATION_MODE.all) control._proxyFormState[_key] = !isRoot || $89d38d99107ddd0f$var$VALIDATION_MODE.all;
            localProxyFormState && (localProxyFormState[_key] = true);
            return formState[_key];
        }
    });
    return result;
};
const $89d38d99107ddd0f$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useLayoutEffect : (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useEffect;
/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $89d38d99107ddd0f$export$606f11b2eb45ecc6(props) {
    const formControl = $89d38d99107ddd0f$var$useFormControlContext();
    const { control: control = formControl, disabled: disabled, name: name, exact: exact } = props || {};
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useState(()=>({
            ...control._formState,
            defaultValues: control._defaultValues
        }));
    const _localProxyFormState = (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        validatingFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    });
    $89d38d99107ddd0f$var$useIsomorphicLayoutEffect(()=>control._subscribe({
            name: name,
            formState: _localProxyFormState.current,
            exact: exact,
            callback: (formState)=>{
                !disabled && updateFormState({
                    ...control._formState,
                    ...formState,
                    defaultValues: control._defaultValues
                });
            }
        }), [
        name,
        disabled,
        exact
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useEffect(()=>{
        _localProxyFormState.current.isValid && control._setValid(true);
    }, [
        control
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useMemo(()=>$89d38d99107ddd0f$var$getProxyFormState(formState, control, _localProxyFormState.current, false), [
        formState,
        control
    ]);
}
var $89d38d99107ddd0f$var$isString = (value1)=>typeof value1 === 'string';
var $89d38d99107ddd0f$var$generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue)=>{
    if ($89d38d99107ddd0f$var$isString(names)) {
        isGlobal && _names.watch.add(names);
        return $89d38d99107ddd0f$export$3988ae62b71be9a3(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) return names.map((fieldName)=>(isGlobal && _names.watch.add(fieldName), $89d38d99107ddd0f$export$3988ae62b71be9a3(formValues, fieldName)));
    isGlobal && (_names.watchAll = true);
    return formValues;
};
var $89d38d99107ddd0f$var$isPrimitive = (value1)=>$89d38d99107ddd0f$var$isNullOrUndefined(value1) || !$89d38d99107ddd0f$var$isObjectType(value1);
function $89d38d99107ddd0f$var$deepEqual(object1, object2, visited = new WeakSet()) {
    if (object1 === object2) return true;
    if ($89d38d99107ddd0f$var$isPrimitive(object1) || $89d38d99107ddd0f$var$isPrimitive(object2)) return Object.is(object1, object2);
    if ($89d38d99107ddd0f$var$isDateObject(object1) && $89d38d99107ddd0f$var$isDateObject(object2)) return Object.is(object1.getTime(), object2.getTime());
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    if (visited.has(object1) || visited.has(object2)) return true;
    visited.add(object1);
    visited.add(object2);
    for (const key of keys1){
        const val1 = object1[key];
        if (!(key in object2)) return false;
        if (key !== 'ref') {
            const val2 = object2[key];
            if ($89d38d99107ddd0f$var$isDateObject(val1) && $89d38d99107ddd0f$var$isDateObject(val2) || ($89d38d99107ddd0f$var$isObject(val1) || Array.isArray(val1)) && ($89d38d99107ddd0f$var$isObject(val2) || Array.isArray(val2)) ? !$89d38d99107ddd0f$var$deepEqual(val1, val2, visited) : !Object.is(val1, val2)) return false;
        }
    }
    return true;
}
/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/docs/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { control } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */ function $89d38d99107ddd0f$export$3c773aa2b84f29e0(props) {
    const formControl = $89d38d99107ddd0f$var$useFormControlContext();
    const { control: control = formControl, name: name, defaultValue: defaultValue, disabled: disabled, exact: exact, compute: compute } = props || {};
    const _defaultValue = (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useRef(defaultValue);
    const _compute = (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useRef(compute);
    const _computeFormValues = (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useRef(undefined);
    const _prevControl = (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useRef(control);
    const _prevName = (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useRef(name);
    _compute.current = compute;
    const [value1, updateValue] = (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useState(()=>{
        const defaultValue = control._getWatch(name, _defaultValue.current);
        return _compute.current ? _compute.current(defaultValue) : defaultValue;
    });
    const getCurrentOutput = (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useCallback((values)=>{
        const formValues = $89d38d99107ddd0f$var$generateWatchOutput(name, control._names, values || control._formValues, false, _defaultValue.current);
        return _compute.current ? _compute.current(formValues) : formValues;
    }, [
        control._formValues,
        control._names,
        name
    ]);
    const refreshValue = (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useCallback((values)=>{
        if (!disabled) {
            const formValues = $89d38d99107ddd0f$var$generateWatchOutput(name, control._names, values || control._formValues, false, _defaultValue.current);
            if (_compute.current) {
                const computedFormValues = _compute.current(formValues);
                if (!$89d38d99107ddd0f$var$deepEqual(computedFormValues, _computeFormValues.current)) {
                    updateValue(computedFormValues);
                    _computeFormValues.current = computedFormValues;
                }
            } else updateValue(formValues);
        }
    }, [
        control._formValues,
        control._names,
        disabled,
        name
    ]);
    $89d38d99107ddd0f$var$useIsomorphicLayoutEffect(()=>{
        if (_prevControl.current !== control || !$89d38d99107ddd0f$var$deepEqual(_prevName.current, name)) {
            _prevControl.current = control;
            _prevName.current = name;
            refreshValue();
        }
        return control._subscribe({
            name: name,
            formState: {
                values: true
            },
            exact: exact,
            callback: (formState)=>{
                refreshValue(formState.values);
            }
        });
    }, [
        control,
        exact,
        name,
        refreshValue
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useEffect(()=>control._removeUnmounted());
    // If name or control changed for this render, synchronously reflect the
    // latest value so callers (like useController) see the correct value
    // immediately on the same render.
    // Optimize: Check control reference first before expensive deepEqual
    const controlChanged = _prevControl.current !== control;
    const prevName = _prevName.current;
    // Cache the computed output to avoid duplicate calls within the same render
    // We include shouldReturnImmediate in deps to ensure proper recomputation
    const computedOutput = (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useMemo(()=>{
        if (disabled) return null;
        const nameChanged = !controlChanged && !$89d38d99107ddd0f$var$deepEqual(prevName, name);
        const shouldReturnImmediate = controlChanged || nameChanged;
        return shouldReturnImmediate ? getCurrentOutput() : null;
    }, [
        disabled,
        controlChanged,
        name,
        prevName,
        getCurrentOutput
    ]);
    return computedOutput !== null ? computedOutput : value1;
}
/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */ function $89d38d99107ddd0f$export$e8c786024a2b0a79(props) {
    const formControl = $89d38d99107ddd0f$var$useFormControlContext();
    const { name: name, disabled: disabled, control: control = formControl, shouldUnregister: shouldUnregister, defaultValue: defaultValue, exact: exact = true } = props;
    const isArrayField = !!$89d38d99107ddd0f$var$getFieldArrayParentNames(control._names.array, name).length;
    const defaultValueMemo = (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useMemo(()=>$89d38d99107ddd0f$export$3988ae62b71be9a3(control._formValues, name, $89d38d99107ddd0f$export$3988ae62b71be9a3(control._defaultValues, name, defaultValue)), [
        control,
        name,
        defaultValue
    ]);
    const value1 = $89d38d99107ddd0f$export$3c773aa2b84f29e0({
        control: control,
        name: name,
        defaultValue: defaultValueMemo,
        exact: exact
    });
    const formState = $89d38d99107ddd0f$export$606f11b2eb45ecc6({
        control: control,
        name: name,
        exact: exact
    });
    const _props = (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useRef(props);
    const _registerProps = (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useRef(control.register(name, {
        ...props.rules,
        value: value1,
        ...$89d38d99107ddd0f$var$isBoolean(props.disabled) ? {
            disabled: props.disabled
        } : {}
    }));
    _props.current = props;
    const fieldState = (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useMemo(()=>Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: ()=>!!$89d38d99107ddd0f$export$3988ae62b71be9a3(formState.errors, name)
            },
            isDirty: {
                enumerable: true,
                get: ()=>!!$89d38d99107ddd0f$export$3988ae62b71be9a3(formState.dirtyFields, name)
            },
            isTouched: {
                enumerable: true,
                get: ()=>!!$89d38d99107ddd0f$export$3988ae62b71be9a3(formState.touchedFields, name)
            },
            isValidating: {
                enumerable: true,
                get: ()=>!!$89d38d99107ddd0f$export$3988ae62b71be9a3(formState.validatingFields, name)
            },
            error: {
                enumerable: true,
                get: ()=>$89d38d99107ddd0f$export$3988ae62b71be9a3(formState.errors, name)
            }
        }), [
        formState,
        name
    ]);
    const onChange = (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useCallback((event)=>_registerProps.current.onChange({
            target: {
                value: $89d38d99107ddd0f$var$getEventValue(event),
                name: name
            },
            type: $89d38d99107ddd0f$var$EVENTS.CHANGE
        }), [
        name
    ]);
    const onBlur = (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useCallback(()=>_registerProps.current.onBlur({
            target: {
                value: $89d38d99107ddd0f$export$3988ae62b71be9a3(control._formValues, name),
                name: name
            },
            type: $89d38d99107ddd0f$var$EVENTS.BLUR
        }), [
        name,
        control._formValues
    ]);
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useCallback((elm)=>{
        const field = $89d38d99107ddd0f$export$3988ae62b71be9a3(control._fields, name);
        if (field && field._f && elm) field._f.ref = {
            focus: ()=>$89d38d99107ddd0f$var$isFunction(elm.focus) && elm.focus(),
            select: ()=>$89d38d99107ddd0f$var$isFunction(elm.select) && elm.select(),
            setCustomValidity: (message)=>$89d38d99107ddd0f$var$isFunction(elm.setCustomValidity) && elm.setCustomValidity(message),
            reportValidity: ()=>$89d38d99107ddd0f$var$isFunction(elm.reportValidity) && elm.reportValidity()
        };
    }, [
        control._fields,
        name
    ]);
    const field = (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useMemo(()=>({
            name: name,
            value: value1,
            ...$89d38d99107ddd0f$var$isBoolean(disabled) || formState.disabled ? {
                disabled: formState.disabled || disabled
            } : {},
            onChange: onChange,
            onBlur: onBlur,
            ref: ref
        }), [
        name,
        disabled,
        formState.disabled,
        onChange,
        onBlur,
        ref,
        value1
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useEffect(()=>{
        const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        control.register(name, {
            ..._props.current.rules,
            ...$89d38d99107ddd0f$var$isBoolean(_props.current.disabled) ? {
                disabled: _props.current.disabled
            } : {}
        });
        const updateMounted = (name, value1)=>{
            const field = $89d38d99107ddd0f$export$3988ae62b71be9a3(control._fields, name);
            if (field && field._f) field._f.mount = value1;
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            const value1 = $89d38d99107ddd0f$var$cloneObject($89d38d99107ddd0f$export$3988ae62b71be9a3(control._defaultValues, name, $89d38d99107ddd0f$export$3988ae62b71be9a3(control._options.defaultValues, name, _props.current.defaultValue)));
            $89d38d99107ddd0f$export$adaa4cf7ef1b65be(control._defaultValues, name, value1);
            if ($89d38d99107ddd0f$var$isUndefined($89d38d99107ddd0f$export$3988ae62b71be9a3(control._formValues, name))) $89d38d99107ddd0f$export$adaa4cf7ef1b65be(control._formValues, name, value1);
        }
        !isArrayField && control.register(name);
        return ()=>{
            (isArrayField ? _shouldUnregisterField && !control._state.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        isArrayField,
        shouldUnregister
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useEffect(()=>{
        control._setDisabledField({
            disabled: disabled,
            name: name
        });
    }, [
        disabled,
        name,
        control
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useMemo(()=>({
            field: field,
            formState: formState,
            fieldState: fieldState
        }), [
        field,
        formState,
        fieldState
    ]);
}
/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */ const $89d38d99107ddd0f$export$bd0bf19f25da8474 = (props)=>props.render($89d38d99107ddd0f$export$e8c786024a2b0a79(props));
const $89d38d99107ddd0f$var$flatten = (obj)=>{
    const output = {};
    for (const key of Object.keys(obj))if ($89d38d99107ddd0f$var$isObjectType(obj[key]) && obj[key] !== null) {
        const nested = $89d38d99107ddd0f$var$flatten(obj[key]);
        for (const nestedKey of Object.keys(nested))output[`${key}.${nestedKey}`] = nested[nestedKey];
    } else output[key] = obj[key];
    return output;
};
const $89d38d99107ddd0f$var$HookFormContext = (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).createContext(null);
$89d38d99107ddd0f$var$HookFormContext.displayName = 'HookFormContext';
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $89d38d99107ddd0f$export$4d957a5e1be13b03 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useContext($89d38d99107ddd0f$var$HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://react.dev/reference/react/useContext) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $89d38d99107ddd0f$export$8ce1ff4f94d08846 = (props)=>{
    const { children: children, watch: watch, getValues: getValues, getFieldState: getFieldState, setError: setError, clearErrors: clearErrors, setValue: setValue, setValues: setValues, trigger: trigger, formState: formState, resetField: resetField, reset: reset, handleSubmit: handleSubmit, unregister: unregister, control: control, register: register, setFocus: setFocus, subscribe: subscribe } = props;
    const memoizedValue = (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useMemo(()=>({
            watch: watch,
            getValues: getValues,
            getFieldState: getFieldState,
            setError: setError,
            clearErrors: clearErrors,
            setValue: setValue,
            setValues: setValues,
            trigger: trigger,
            formState: formState,
            resetField: resetField,
            reset: reset,
            handleSubmit: handleSubmit,
            unregister: unregister,
            control: control,
            register: register,
            setFocus: setFocus,
            subscribe: subscribe
        }), [
        clearErrors,
        control,
        formState,
        getFieldState,
        getValues,
        handleSubmit,
        register,
        reset,
        resetField,
        setError,
        setFocus,
        setValue,
        setValues,
        subscribe,
        trigger,
        unregister,
        watch
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).createElement($89d38d99107ddd0f$var$HookFormContext.Provider, {
        value: memoizedValue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).createElement($89d38d99107ddd0f$var$HookFormControlContext.Provider, {
        value: memoizedValue.control
    }, children));
};
const $89d38d99107ddd0f$var$POST_REQUEST = 'post';
/**
 * Form component to manage submission.
 *
 * @param props - to setup submission detail. {@link FormProps}
 *
 * @returns form component or headless render prop.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control, formState: { errors } } = useForm();
 *
 *   return (
 *     <Form action="/api" control={control}>
 *       <input {...register("name")} />
 *       <p>{errors?.root?.server && 'Server error'}</p>
 *       <button>Submit</button>
 *     </Form>
 *   );
 * }
 * ```
 */ function $89d38d99107ddd0f$export$a7fed597f4b8afd8(props) {
    const methods = $89d38d99107ddd0f$export$4d957a5e1be13b03();
    const [mounted, setMounted] = (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useState(false);
    const { control: control = methods.control, onSubmit: onSubmit, children: children, action: action, method: method = $89d38d99107ddd0f$var$POST_REQUEST, headers: headers, encType: encType, onError: onError, render: render, onSuccess: onSuccess, validateStatus: validateStatus, ...rest } = props;
    const submit = (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useCallback(async (event)=>{
        let hasError = false;
        let type = '';
        await control.handleSubmit(async (data)=>{
            const formData = new FormData();
            let formDataJson = '';
            try {
                formDataJson = JSON.stringify(data);
            } catch (_a) {}
            const flattenFormValues = $89d38d99107ddd0f$var$flatten(data);
            for(const key in flattenFormValues)formData.append(key, flattenFormValues[key]);
            if (onSubmit) await onSubmit({
                data: data,
                event: event,
                method: method,
                formData: formData,
                formDataJson: formDataJson
            });
            if (action) try {
                const shouldStringifySubmissionData = [
                    headers && headers['Content-Type'],
                    encType
                ].some((value1)=>value1 && value1.includes('json'));
                const response = await fetch(String(action), {
                    method: method,
                    headers: {
                        ...headers,
                        ...encType && encType !== 'multipart/form-data' ? {
                            'Content-Type': encType
                        } : {}
                    },
                    body: shouldStringifySubmissionData ? formDataJson : formData
                });
                if (response && (validateStatus ? !validateStatus(response.status) : response.status < 200 || response.status >= 300)) {
                    hasError = true;
                    onError && onError({
                        response: response
                    });
                    type = String(response.status);
                } else onSuccess && onSuccess({
                    response: response
                });
            } catch (error) {
                hasError = true;
                onError && onError({
                    error: error
                });
            }
        })(event);
        if (hasError && control) {
            control._subjects.state.next({
                isSubmitSuccessful: false
            });
            control.setError('root.server', {
                type: type
            });
        }
    }, [
        control,
        onSubmit,
        method,
        action,
        headers,
        encType,
        validateStatus,
        onError,
        onSuccess
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useEffect(()=>{
        setMounted(true);
    }, []);
    return render ? (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).Fragment, null, render({
        submit: submit
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).createElement("form", {
        noValidate: mounted,
        action: action,
        method: method,
        encType: encType,
        onSubmit: submit,
        ...rest
    }, children);
}
const $89d38d99107ddd0f$export$6136af724020822e = ({ control: control, disabled: disabled, exact: exact, name: name, render: render })=>render($89d38d99107ddd0f$export$606f11b2eb45ecc6({
        control: control,
        name: name,
        disabled: disabled,
        exact: exact
    }));
var $89d38d99107ddd0f$export$b196c2a4f765bd30 = (name, validateAllFieldCriteria, errors, type, message)=>validateAllFieldCriteria ? {
        ...errors[name],
        types: {
            ...errors[name] && errors[name].types ? errors[name].types : {},
            [type]: message || true
        }
    } : {};
var $89d38d99107ddd0f$var$convertToArrayPayload = (value1)=>Array.isArray(value1) ? value1 : [
        value1
    ];
var $89d38d99107ddd0f$var$createSubject = ()=>{
    let _observers = [];
    const next = (value1)=>{
        for (const observer of _observers)observer.next && observer.next(value1);
    };
    const subscribe = (observer)=>{
        _observers.push(observer);
        return {
            unsubscribe: ()=>{
                _observers = _observers.filter((o)=>o !== observer);
            }
        };
    };
    const unsubscribe = ()=>{
        _observers = [];
    };
    return {
        get observers () {
            return _observers;
        },
        next: next,
        subscribe: subscribe,
        unsubscribe: unsubscribe
    };
};
function $89d38d99107ddd0f$var$extractFormValues(fieldsState, formValues) {
    const values = {};
    for(const key in fieldsState)if (fieldsState.hasOwnProperty(key)) {
        const fieldState = fieldsState[key];
        const fieldValue = formValues[key];
        if (fieldState && $89d38d99107ddd0f$var$isObject(fieldState) && fieldValue) {
            const nestedFieldsState = $89d38d99107ddd0f$var$extractFormValues(fieldState, fieldValue);
            if ($89d38d99107ddd0f$var$isObject(nestedFieldsState)) values[key] = nestedFieldsState;
        } else if (fieldsState[key]) values[key] = fieldValue;
    }
    return values;
}
var $89d38d99107ddd0f$var$isEmptyObject = (value1)=>$89d38d99107ddd0f$var$isObject(value1) && !Object.keys(value1).length;
var $89d38d99107ddd0f$var$isFileInput = (element)=>element.type === 'file';
var $89d38d99107ddd0f$var$isHTMLElement = (value1)=>{
    if (!$89d38d99107ddd0f$var$isWeb) return false;
    const owner = value1 ? value1.ownerDocument : 0;
    return value1 instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};
var $89d38d99107ddd0f$var$isMultipleSelect = (element)=>element.type === `select-multiple`;
var $89d38d99107ddd0f$var$isRadioInput = (element)=>element.type === 'radio';
var $89d38d99107ddd0f$var$isRadioOrCheckbox = (ref)=>$89d38d99107ddd0f$var$isRadioInput(ref) || $89d38d99107ddd0f$var$isCheckBoxInput(ref);
var $89d38d99107ddd0f$var$live = (ref)=>$89d38d99107ddd0f$var$isHTMLElement(ref) && ref.isConnected;
function $89d38d99107ddd0f$var$baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while(index < length){
        if ($89d38d99107ddd0f$var$isNullOrUndefined(object)) {
            object = undefined;
            break;
        }
        object = object[updatePath[index]];
        index++;
    }
    return object;
}
function $89d38d99107ddd0f$var$isEmptyArray(obj) {
    for(const key in obj){
        if (obj.hasOwnProperty(key) && !$89d38d99107ddd0f$var$isUndefined(obj[key])) return false;
    }
    return true;
}
function $89d38d99107ddd0f$var$unset(object, path) {
    if ($89d38d99107ddd0f$var$isString(path) && Object.prototype.hasOwnProperty.call(object, path)) {
        delete object[path];
        return object;
    }
    const paths = Array.isArray(path) ? path : $89d38d99107ddd0f$var$isKey(path) ? [
        path
    ] : $89d38d99107ddd0f$var$stringToPath(path);
    const childObject = paths.length === 1 ? object : $89d38d99107ddd0f$var$baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) delete childObject[key];
    if (index !== 0 && ($89d38d99107ddd0f$var$isObject(childObject) && $89d38d99107ddd0f$var$isEmptyObject(childObject) || Array.isArray(childObject) && $89d38d99107ddd0f$var$isEmptyArray(childObject))) $89d38d99107ddd0f$var$unset(object, paths.slice(0, -1));
    return object;
}
var $89d38d99107ddd0f$var$objectHasFunction = (data)=>{
    for(const key in data){
        if ($89d38d99107ddd0f$var$isFunction(data[key])) return true;
    }
    return false;
};
function $89d38d99107ddd0f$var$isTraversable(value1) {
    return Array.isArray(value1) || $89d38d99107ddd0f$var$isObject(value1) && !$89d38d99107ddd0f$var$objectHasFunction(value1);
}
function $89d38d99107ddd0f$var$markFieldsDirty(data, fields = {}) {
    for(const key in data){
        const value1 = data[key];
        if ($89d38d99107ddd0f$var$isTraversable(value1)) {
            fields[key] = Array.isArray(value1) ? [] : {};
            $89d38d99107ddd0f$var$markFieldsDirty(value1, fields[key]);
        } else if (!$89d38d99107ddd0f$var$isUndefined(value1)) fields[key] = true;
    }
    return fields;
}
function $89d38d99107ddd0f$var$pruneDirtyFields(value1) {
    if (value1 === false) return undefined;
    if (value1 === true) return true;
    if (Array.isArray(value1)) {
        const result = value1.map((value1)=>$89d38d99107ddd0f$var$pruneDirtyFields(value1));
        return result.some((value1)=>value1 !== undefined) ? result : undefined;
    }
    if ($89d38d99107ddd0f$var$isObject(value1)) {
        const result = {};
        for(const key in value1){
            const pruned = $89d38d99107ddd0f$var$pruneDirtyFields(value1[key]);
            if (!$89d38d99107ddd0f$var$isUndefined(pruned)) result[key] = pruned;
        }
        return Object.keys(result).length ? result : undefined;
    }
    return undefined;
}
function $89d38d99107ddd0f$var$getDirtyFields(data, formValues, dirtyFieldsFromValues) {
    if (!dirtyFieldsFromValues) dirtyFieldsFromValues = $89d38d99107ddd0f$var$markFieldsDirty(formValues);
    for(const key in data){
        const value1 = data[key];
        if ($89d38d99107ddd0f$var$isTraversable(value1)) {
            if ($89d38d99107ddd0f$var$isUndefined(formValues) || $89d38d99107ddd0f$var$isPrimitive(dirtyFieldsFromValues[key])) dirtyFieldsFromValues[key] = $89d38d99107ddd0f$var$markFieldsDirty(value1, Array.isArray(value1) ? [] : {});
            else $89d38d99107ddd0f$var$getDirtyFields(value1, $89d38d99107ddd0f$var$isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
        } else {
            const formValue = formValues[key];
            dirtyFieldsFromValues[key] = !$89d38d99107ddd0f$var$deepEqual(value1, formValue);
        }
    }
    return $89d38d99107ddd0f$var$pruneDirtyFields(dirtyFieldsFromValues) || {};
}
const $89d38d99107ddd0f$var$defaultResult = {
    value: false,
    isValid: false
};
const $89d38d99107ddd0f$var$validResult = {
    value: true,
    isValid: true
};
var $89d38d99107ddd0f$var$getCheckboxValue = (options)=>{
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options.filter((option)=>option && option.checked && !option.disabled).map((option)=>option.value);
            return {
                value: values,
                isValid: !!values.length
            };
        }
        return options[0].checked && !options[0].disabled ? options[0].attributes && !$89d38d99107ddd0f$var$isUndefined(options[0].attributes.value) ? $89d38d99107ddd0f$var$isUndefined(options[0].value) || options[0].value === '' ? $89d38d99107ddd0f$var$validResult : {
            value: options[0].value,
            isValid: true
        } : $89d38d99107ddd0f$var$validResult : $89d38d99107ddd0f$var$defaultResult;
    }
    return $89d38d99107ddd0f$var$defaultResult;
};
var $89d38d99107ddd0f$var$getFieldValueAs = (value1, { valueAsNumber: valueAsNumber, valueAsDate: valueAsDate, setValueAs: setValueAs })=>$89d38d99107ddd0f$var$isUndefined(value1) ? value1 : valueAsNumber ? value1 === '' ? NaN : value1 ? +value1 : value1 : valueAsDate && $89d38d99107ddd0f$var$isString(value1) ? new Date(value1) : setValueAs ? setValueAs(value1) : value1;
const $89d38d99107ddd0f$var$defaultReturn = {
    isValid: false,
    value: null
};
var $89d38d99107ddd0f$var$getRadioValue = (options)=>Array.isArray(options) ? options.reduce((previous, option)=>option && option.checked && !option.disabled ? {
            isValid: true,
            value: option.value
        } : previous, $89d38d99107ddd0f$var$defaultReturn) : $89d38d99107ddd0f$var$defaultReturn;
function $89d38d99107ddd0f$var$getFieldValue(_f) {
    const ref = _f.ref;
    if ($89d38d99107ddd0f$var$isFileInput(ref)) return ref.files;
    if ($89d38d99107ddd0f$var$isRadioInput(ref)) return $89d38d99107ddd0f$var$getRadioValue(_f.refs).value;
    if ($89d38d99107ddd0f$var$isMultipleSelect(ref)) return [
        ...ref.selectedOptions
    ].map(({ value: value1 })=>value1);
    if ($89d38d99107ddd0f$var$isCheckBoxInput(ref)) return $89d38d99107ddd0f$var$getCheckboxValue(_f.refs).value;
    return $89d38d99107ddd0f$var$getFieldValueAs($89d38d99107ddd0f$var$isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}
var $89d38d99107ddd0f$var$getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation)=>{
    const fields = {};
    for (const name of fieldsNames){
        const field = $89d38d99107ddd0f$export$3988ae62b71be9a3(_fields, name);
        field && $89d38d99107ddd0f$export$adaa4cf7ef1b65be(fields, name, field._f);
    }
    return {
        criteriaMode: criteriaMode,
        names: [
            ...fieldsNames
        ],
        fields: fields,
        shouldUseNativeValidation: shouldUseNativeValidation
    };
};
var $89d38d99107ddd0f$var$isRegex = (value1)=>value1 instanceof RegExp;
var $89d38d99107ddd0f$var$getRuleValue = (rule)=>$89d38d99107ddd0f$var$isUndefined(rule) ? rule : $89d38d99107ddd0f$var$isRegex(rule) ? rule.source : $89d38d99107ddd0f$var$isObject(rule) ? $89d38d99107ddd0f$var$isRegex(rule.value) ? rule.value.source : rule.value : rule;
var $89d38d99107ddd0f$var$getValidationModes = (mode)=>({
        isOnSubmit: !mode || mode === $89d38d99107ddd0f$var$VALIDATION_MODE.onSubmit,
        isOnBlur: mode === $89d38d99107ddd0f$var$VALIDATION_MODE.onBlur,
        isOnChange: mode === $89d38d99107ddd0f$var$VALIDATION_MODE.onChange,
        isOnAll: mode === $89d38d99107ddd0f$var$VALIDATION_MODE.all,
        isOnTouch: mode === $89d38d99107ddd0f$var$VALIDATION_MODE.onTouched
    });
const $89d38d99107ddd0f$var$ASYNC_FUNCTION = 'AsyncFunction';
var $89d38d99107ddd0f$var$hasPromiseValidation = (fieldReference)=>!!fieldReference && !!fieldReference.validate && !!($89d38d99107ddd0f$var$isFunction(fieldReference.validate) && fieldReference.validate.constructor.name === $89d38d99107ddd0f$var$ASYNC_FUNCTION || $89d38d99107ddd0f$var$isObject(fieldReference.validate) && Object.values(fieldReference.validate).find((validateFunction)=>validateFunction.constructor.name === $89d38d99107ddd0f$var$ASYNC_FUNCTION));
var $89d38d99107ddd0f$var$hasValidation = (options)=>options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
var $89d38d99107ddd0f$var$isWatched = (name, _names, isBlurEvent)=>!isBlurEvent && (_names.watchAll || _names.watch.has(name) || [
        ..._names.watch
    ].some((watchName)=>name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length))));
const $89d38d99107ddd0f$var$iterateFieldsByAction = (fields, action, fieldsNames, abortEarly)=>{
    for (const key of fieldsNames || Object.keys(fields)){
        const field = $89d38d99107ddd0f$export$3988ae62b71be9a3(fields, key);
        if (field) {
            const { _f: _f, ...currentField } = field;
            if (_f) {
                if (_f.refs && _f.refs[0] && action(_f.refs[0], key) && !abortEarly) return true;
                else if (_f.ref && action(_f.ref, _f.name) && !abortEarly) return true;
                else {
                    if ($89d38d99107ddd0f$var$iterateFieldsByAction(currentField, action)) break;
                }
            } else if ($89d38d99107ddd0f$var$isObject(currentField)) {
                if ($89d38d99107ddd0f$var$iterateFieldsByAction(currentField, action)) break;
            }
        }
    }
    return;
};
function $89d38d99107ddd0f$var$schemaErrorLookup(errors, _fields, name) {
    const error = $89d38d99107ddd0f$export$3988ae62b71be9a3(errors, name);
    if (error || $89d38d99107ddd0f$var$isKey(name)) return {
        error: error,
        name: name
    };
    const names = name.split('.');
    while(names.length){
        const fieldName = names.join('.');
        const field = $89d38d99107ddd0f$export$3988ae62b71be9a3(_fields, fieldName);
        const foundError = $89d38d99107ddd0f$export$3988ae62b71be9a3(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) return {
            name: name
        };
        if (foundError && foundError.type) return {
            name: fieldName,
            error: foundError
        };
        if (foundError && foundError.root && foundError.root.type) return {
            name: `${fieldName}.root`,
            error: foundError.root
        };
        names.pop();
    }
    return {
        name: name
    };
}
var $89d38d99107ddd0f$var$shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot)=>{
    updateFormState(formStateData);
    const { name: name, ...formState } = formStateData;
    return $89d38d99107ddd0f$var$isEmptyObject(formState) || isRoot && Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find((key)=>_proxyFormState[key] === (!isRoot || $89d38d99107ddd0f$var$VALIDATION_MODE.all));
};
var $89d38d99107ddd0f$var$shouldSubscribeByName = (name, signalName, exact)=>!name || !signalName || name === signalName || $89d38d99107ddd0f$var$convertToArrayPayload(name).some((currentName)=>currentName && (exact ? currentName === signalName : currentName.startsWith(signalName) || signalName.startsWith(currentName)));
var $89d38d99107ddd0f$var$skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode)=>{
    if (mode.isOnAll) return false;
    else if (!isSubmitted && mode.isOnTouch) return !(isTouched || isBlurEvent);
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) return !isBlurEvent;
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) return isBlurEvent;
    return true;
};
var $89d38d99107ddd0f$var$unsetEmptyArray = (ref, name)=>!$89d38d99107ddd0f$var$compact($89d38d99107ddd0f$export$3988ae62b71be9a3(ref, name)).length && $89d38d99107ddd0f$var$unset(ref, name);
var $89d38d99107ddd0f$var$updateFieldArrayRootError = (errors, error, name)=>{
    const fieldArrayErrors = $89d38d99107ddd0f$var$convertToArrayPayload($89d38d99107ddd0f$export$3988ae62b71be9a3(errors, name));
    $89d38d99107ddd0f$export$adaa4cf7ef1b65be(fieldArrayErrors, $89d38d99107ddd0f$var$ROOT_ERROR_TYPE, error[name]);
    $89d38d99107ddd0f$export$adaa4cf7ef1b65be(errors, name, fieldArrayErrors);
    return errors;
};
function $89d38d99107ddd0f$var$getValidateError(result, ref, type = 'validate') {
    if ($89d38d99107ddd0f$var$isString(result) || Array.isArray(result) && result.every($89d38d99107ddd0f$var$isString) || $89d38d99107ddd0f$var$isBoolean(result) && !result) return {
        type: type,
        message: $89d38d99107ddd0f$var$isString(result) ? result : '',
        ref: ref
    };
}
var $89d38d99107ddd0f$var$getValueAndMessage = (validationData)=>$89d38d99107ddd0f$var$isObject(validationData) && !$89d38d99107ddd0f$var$isRegex(validationData) ? validationData : {
        value: validationData,
        message: ''
    };
var $89d38d99107ddd0f$var$validateField = async (field, disabledFieldNames, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray)=>{
    const { ref: ref, refs: refs, required: required, maxLength: maxLength, minLength: minLength, min: min, max: max, pattern: pattern, validate: validate, name: name, valueAsNumber: valueAsNumber, mount: mount } = field._f;
    const inputValue = $89d38d99107ddd0f$export$3988ae62b71be9a3(formValues, name);
    if (!mount || disabledFieldNames.has(name)) return {};
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message)=>{
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity($89d38d99107ddd0f$var$isBoolean(message) ? '' : message || '');
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = $89d38d99107ddd0f$var$isRadioInput(ref);
    const isCheckBox = $89d38d99107ddd0f$var$isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = (valueAsNumber || $89d38d99107ddd0f$var$isFileInput(ref)) && $89d38d99107ddd0f$var$isUndefined(ref.value) && $89d38d99107ddd0f$var$isUndefined(inputValue) || $89d38d99107ddd0f$var$isHTMLElement(ref) && ref.value === '' || inputValue === '' || Array.isArray(inputValue) && !inputValue.length || valueAsNumber && typeof inputValue === 'number' && isNaN(inputValue);
    const appendErrorsCurry = $89d38d99107ddd0f$export$b196c2a4f765bd30.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = $89d38d99107ddd0f$var$INPUT_VALIDATION_RULES.maxLength, minType = $89d38d99107ddd0f$var$INPUT_VALIDATION_RULES.minLength)=>{
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message: message,
            ref: ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message)
        };
    };
    if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox && (isEmpty || $89d38d99107ddd0f$var$isNullOrUndefined(inputValue)) || $89d38d99107ddd0f$var$isBoolean(inputValue) && !inputValue || isCheckBox && !$89d38d99107ddd0f$var$getCheckboxValue(refs).isValid || isRadio && !$89d38d99107ddd0f$var$getRadioValue(refs).isValid)) {
        const { value: value1, message: message } = $89d38d99107ddd0f$var$isString(required) ? {
            value: !!required,
            message: required
        } : $89d38d99107ddd0f$var$getValueAndMessage(required);
        if (value1) {
            error[name] = {
                type: $89d38d99107ddd0f$var$INPUT_VALIDATION_RULES.required,
                message: message,
                ref: inputRef,
                ...appendErrorsCurry($89d38d99107ddd0f$var$INPUT_VALIDATION_RULES.required, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!$89d38d99107ddd0f$var$isNullOrUndefined(min) || !$89d38d99107ddd0f$var$isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = $89d38d99107ddd0f$var$getValueAndMessage(max);
        const minOutput = $89d38d99107ddd0f$var$getValueAndMessage(min);
        if (!$89d38d99107ddd0f$var$isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);
            if (!$89d38d99107ddd0f$var$isNullOrUndefined(maxOutput.value)) exceedMax = valueNumber > maxOutput.value;
            if (!$89d38d99107ddd0f$var$isNullOrUndefined(minOutput.value)) exceedMin = valueNumber < minOutput.value;
        } else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time)=>new Date(new Date().toDateString() + ' ' + time);
            const isTime = ref.type == 'time';
            const isWeek = ref.type == 'week';
            if ($89d38d99107ddd0f$var$isString(maxOutput.value) && inputValue) exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
            if ($89d38d99107ddd0f$var$isString(minOutput.value) && inputValue) exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, $89d38d99107ddd0f$var$INPUT_VALIDATION_RULES.max, $89d38d99107ddd0f$var$INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) && !isEmpty && ($89d38d99107ddd0f$var$isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
        const maxLengthOutput = $89d38d99107ddd0f$var$getValueAndMessage(maxLength);
        const minLengthOutput = $89d38d99107ddd0f$var$getValueAndMessage(minLength);
        const exceedMax = !$89d38d99107ddd0f$var$isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
        const exceedMin = !$89d38d99107ddd0f$var$isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && $89d38d99107ddd0f$var$isString(inputValue)) {
        const { value: patternValue, message: message } = $89d38d99107ddd0f$var$getValueAndMessage(pattern);
        if ($89d38d99107ddd0f$var$isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: $89d38d99107ddd0f$var$INPUT_VALIDATION_RULES.pattern,
                message: message,
                ref: ref,
                ...appendErrorsCurry($89d38d99107ddd0f$var$INPUT_VALIDATION_RULES.pattern, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if ($89d38d99107ddd0f$var$isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = $89d38d99107ddd0f$var$getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry($89d38d99107ddd0f$var$INPUT_VALIDATION_RULES.validate, validateError.message)
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        } else if ($89d38d99107ddd0f$var$isObject(validate)) {
            let validationResult = {};
            for(const key in validate){
                if (!$89d38d99107ddd0f$var$isEmptyObject(validationResult) && !validateAllFieldCriteria) break;
                const validateError = $89d38d99107ddd0f$var$getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message)
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) error[name] = validationResult;
                }
            }
            if (!$89d38d99107ddd0f$var$isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult
                };
                if (!validateAllFieldCriteria) return error;
            }
        }
    }
    setCustomValidity(true);
    return error;
};
const $89d38d99107ddd0f$var$defaultOptions = {
    mode: $89d38d99107ddd0f$var$VALIDATION_MODE.onSubmit,
    reValidateMode: $89d38d99107ddd0f$var$VALIDATION_MODE.onChange,
    shouldFocusError: true
};
const $89d38d99107ddd0f$var$DEFAULT_FORM_STATE = {
    submitCount: 0,
    isDirty: false,
    isReady: false,
    isValidating: false,
    isSubmitted: false,
    isSubmitting: false,
    isSubmitSuccessful: false,
    isValid: false,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {}
};
function $89d38d99107ddd0f$export$1361f5e0e4cca3c3(props = {}) {
    let _options = {
        ...$89d38d99107ddd0f$var$defaultOptions,
        ...props
    };
    let _formState = {
        ...$89d38d99107ddd0f$var$cloneObject($89d38d99107ddd0f$var$DEFAULT_FORM_STATE),
        isLoading: $89d38d99107ddd0f$var$isFunction(_options.defaultValues),
        errors: _options.errors || {},
        disabled: _options.disabled || false
    };
    let _fields = {};
    let _defaultValues = $89d38d99107ddd0f$var$isObject(_options.defaultValues) || $89d38d99107ddd0f$var$isObject(_options.values) ? $89d38d99107ddd0f$var$cloneObject(_options.defaultValues || _options.values) || {} : {};
    let _formValues = _options.shouldUnregister ? {} : $89d38d99107ddd0f$var$cloneObject(_defaultValues);
    let _state = {
        action: false,
        mount: false,
        watch: false,
        keepIsValid: false
    };
    let _names = {
        mount: new Set(),
        disabled: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set(),
        registerName: new Set()
    };
    let delayErrorCallback;
    let timer = 0;
    const defaultProxyFormState = {
        isDirty: false,
        dirtyFields: false,
        validatingFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    };
    const _proxyFormState = {
        ...defaultProxyFormState
    };
    let _proxySubscribeFormState = {
        ..._proxyFormState
    };
    const _subjects = {
        array: $89d38d99107ddd0f$var$createSubject(),
        state: $89d38d99107ddd0f$var$createSubject()
    };
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === $89d38d99107ddd0f$var$VALIDATION_MODE.all;
    const debounce = (callback)=>(wait)=>{
            clearTimeout(timer);
            timer = setTimeout(callback, wait);
        };
    const _setValid = async (shouldUpdateValid)=>{
        if (_state.keepIsValid) return;
        if (!_options.disabled && (_proxyFormState.isValid || _proxySubscribeFormState.isValid || shouldUpdateValid)) {
            let isValid;
            if (_options.resolver) {
                isValid = $89d38d99107ddd0f$var$isEmptyObject((await _runSchema()).errors);
                _updateIsValidating();
            } else isValid = await executeBuiltInValidation({
                fields: _fields,
                onlyCheckValid: true,
                eventType: $89d38d99107ddd0f$var$EVENTS.VALID
            });
            if (isValid !== _formState.isValid) _subjects.state.next({
                isValid: isValid
            });
        }
    };
    const _updateIsValidating = (names, isValidating)=>{
        if (!_options.disabled && (_proxyFormState.isValidating || _proxyFormState.validatingFields || _proxySubscribeFormState.isValidating || _proxySubscribeFormState.validatingFields)) {
            (names || Array.from(_names.mount)).forEach((name)=>{
                if (name) isValidating ? $89d38d99107ddd0f$export$adaa4cf7ef1b65be(_formState.validatingFields, name, isValidating) : $89d38d99107ddd0f$var$unset(_formState.validatingFields, name);
            });
            _subjects.state.next({
                validatingFields: _formState.validatingFields,
                isValidating: !$89d38d99107ddd0f$var$isEmptyObject(_formState.validatingFields)
            });
        }
    };
    const _updateDirtyFields = ()=>{
        _formState.dirtyFields = $89d38d99107ddd0f$var$getDirtyFields(_defaultValues, _formValues);
    };
    const _setFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true)=>{
        if (args && method && !_options.disabled) {
            _state.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray($89d38d99107ddd0f$export$3988ae62b71be9a3(_fields, name))) {
                const fieldValues = method($89d38d99107ddd0f$export$3988ae62b71be9a3(_fields, name), args.argA, args.argB);
                shouldSetValues && $89d38d99107ddd0f$export$adaa4cf7ef1b65be(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState && Array.isArray($89d38d99107ddd0f$export$3988ae62b71be9a3(_formState.errors, name))) {
                const errors = method($89d38d99107ddd0f$export$3988ae62b71be9a3(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && $89d38d99107ddd0f$export$adaa4cf7ef1b65be(_formState.errors, name, errors);
                $89d38d99107ddd0f$var$unsetEmptyArray(_formState.errors, name);
            }
            if ((_proxyFormState.touchedFields || _proxySubscribeFormState.touchedFields) && shouldUpdateFieldsAndState && Array.isArray($89d38d99107ddd0f$export$3988ae62b71be9a3(_formState.touchedFields, name))) {
                const touchedFields = method($89d38d99107ddd0f$export$3988ae62b71be9a3(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && $89d38d99107ddd0f$export$adaa4cf7ef1b65be(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields || _proxySubscribeFormState.dirtyFields) _updateDirtyFields();
            _subjects.state.next({
                name: name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid
            });
        } else $89d38d99107ddd0f$export$adaa4cf7ef1b65be(_formValues, name, values);
    };
    const updateErrors = (name, error)=>{
        $89d38d99107ddd0f$export$adaa4cf7ef1b65be(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors
        });
    };
    const _setErrors = (errors)=>{
        _formState.errors = errors;
        _subjects.state.next({
            errors: _formState.errors,
            isValid: false
        });
    };
    const hasExplicitNullIntermediate = (name)=>{
        const segments = $89d38d99107ddd0f$var$isKey(name) ? [
            name
        ] : $89d38d99107ddd0f$var$stringToPath(name);
        let formValues = _formValues;
        let defaultValues = _defaultValues;
        for(let i = 0; i < segments.length - 1; i++){
            const key = segments[i];
            formValues = $89d38d99107ddd0f$var$isNullOrUndefined(formValues) ? formValues : formValues[key];
            defaultValues = $89d38d99107ddd0f$var$isNullOrUndefined(defaultValues) ? defaultValues : defaultValues[key];
            if (formValues === null && defaultValues !== null) return true;
        }
        return false;
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value1, ref)=>{
        const field = $89d38d99107ddd0f$export$3988ae62b71be9a3(_fields, name);
        if (field) {
            if (hasExplicitNullIntermediate(name)) return;
            const wasUnsetInFormValues = $89d38d99107ddd0f$var$isUndefined($89d38d99107ddd0f$export$3988ae62b71be9a3(_formValues, name));
            const defaultValue = $89d38d99107ddd0f$export$3988ae62b71be9a3(_formValues, name, $89d38d99107ddd0f$var$isUndefined(value1) ? $89d38d99107ddd0f$export$3988ae62b71be9a3(_defaultValues, name) : value1);
            $89d38d99107ddd0f$var$isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? $89d38d99107ddd0f$export$adaa4cf7ef1b65be(_formValues, name, shouldSkipSetValueAs ? defaultValue : $89d38d99107ddd0f$var$getFieldValue(field._f)) : setFieldValue(name, defaultValue);
            if (_state.mount && !_state.action) {
                _setValid();
                // Re-registering a field after a prior unregister puts its key back
                // into _formValues, which can flip isDirty back to false (#13397).
                // Only run when we are currently dirty, otherwise an initial register
                // for a field with no defaultValue would flip isDirty to true. Reset
                // paths repopulate _formValues before re-register, so the key is
                // present then and this branch is skipped (preserves keepDirty).
                if (wasUnsetInFormValues && _formState.isDirty && (_proxyFormState.isDirty || _proxySubscribeFormState.isDirty)) {
                    const isDirty = _getDirty();
                    if (!isDirty) {
                        _formState.isDirty = false;
                        _subjects.state.next({
                            ..._formState
                        });
                    }
                }
            }
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender)=>{
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name: name
        };
        if (!_options.disabled) {
            if (!isBlurEvent || shouldDirty) {
                if (_proxyFormState.isDirty || _proxySubscribeFormState.isDirty) {
                    isPreviousDirty = _formState.isDirty;
                    _formState.isDirty = output.isDirty = _getDirty();
                    shouldUpdateField = isPreviousDirty !== output.isDirty;
                }
                const isCurrentFieldPristine = $89d38d99107ddd0f$var$deepEqual($89d38d99107ddd0f$export$3988ae62b71be9a3(_defaultValues, name), fieldValue);
                isPreviousDirty = !!$89d38d99107ddd0f$export$3988ae62b71be9a3(_formState.dirtyFields, name);
                if (isCurrentFieldPristine !== _formState.isDirty) _formState.dirtyFields = $89d38d99107ddd0f$var$getDirtyFields(_defaultValues, _formValues);
                else isCurrentFieldPristine ? $89d38d99107ddd0f$var$unset(_formState.dirtyFields, name) : $89d38d99107ddd0f$export$adaa4cf7ef1b65be(_formState.dirtyFields, name, true);
                output.dirtyFields = _formState.dirtyFields;
                shouldUpdateField = shouldUpdateField || (_proxyFormState.dirtyFields || _proxySubscribeFormState.dirtyFields) && isPreviousDirty !== !isCurrentFieldPristine;
            }
            if (isBlurEvent) {
                const isPreviousFieldTouched = $89d38d99107ddd0f$export$3988ae62b71be9a3(_formState.touchedFields, name);
                if (!isPreviousFieldTouched) {
                    $89d38d99107ddd0f$export$adaa4cf7ef1b65be(_formState.touchedFields, name, isBlurEvent);
                    output.touchedFields = _formState.touchedFields;
                    shouldUpdateField = shouldUpdateField || (_proxyFormState.touchedFields || _proxySubscribeFormState.touchedFields) && isPreviousFieldTouched !== isBlurEvent;
                }
            }
            shouldUpdateField && shouldRender && _subjects.state.next(output);
        }
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState)=>{
        const previousFieldError = $89d38d99107ddd0f$export$3988ae62b71be9a3(_formState.errors, name);
        const shouldUpdateValid = (_proxyFormState.isValid || _proxySubscribeFormState.isValid) && $89d38d99107ddd0f$var$isBoolean(isValid) && _formState.isValid !== isValid;
        if (_options.delayError && error) {
            delayErrorCallback = debounce(()=>updateErrors(name, error));
            delayErrorCallback(_options.delayError);
        } else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error ? $89d38d99107ddd0f$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $89d38d99107ddd0f$var$unset(_formState.errors, name);
        }
        if ((error ? !$89d38d99107ddd0f$var$deepEqual(previousFieldError, error) : previousFieldError) || !$89d38d99107ddd0f$var$isEmptyObject(fieldState) || shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...shouldUpdateValid && $89d38d99107ddd0f$var$isBoolean(isValid) ? {
                    isValid: isValid
                } : {},
                errors: _formState.errors,
                name: name
            };
            _formState = {
                ..._formState,
                ...updatedFormState
            };
            _subjects.state.next(updatedFormState);
        }
    };
    const _runSchema = async (name)=>{
        _updateIsValidating(name, true);
        return await _options.resolver(_formValues, _options.context, $89d38d99107ddd0f$var$getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
    };
    const executeSchemaAndUpdateState = async (names)=>{
        const { errors: errors } = await _runSchema(names);
        _updateIsValidating(names);
        if (names) for (const name of names){
            const error = $89d38d99107ddd0f$export$3988ae62b71be9a3(errors, name);
            error ? _names.array.has(name) && $89d38d99107ddd0f$var$isObject(error) ? $89d38d99107ddd0f$var$updateFieldArrayRootError(_formState.errors, {
                [name]: error
            }, name) : $89d38d99107ddd0f$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $89d38d99107ddd0f$var$unset(_formState.errors, name);
        }
        else _formState.errors = errors;
        return errors;
    };
    const validateForm = async ({ name: name, eventType: eventType })=>{
        if (props.validate) {
            const result = await props.validate({
                formValues: _formValues,
                formState: _formState,
                name: name,
                eventType: eventType
            });
            if ($89d38d99107ddd0f$var$isObject(result)) for(const key in result){
                const error = result[key];
                if (error) setError(`${$89d38d99107ddd0f$var$FORM_ERROR_TYPE}.${key}`, {
                    message: $89d38d99107ddd0f$var$isString(error.message) ? error.message : '',
                    type: error.type || $89d38d99107ddd0f$var$INPUT_VALIDATION_RULES.validate
                });
            }
            else if ($89d38d99107ddd0f$var$isString(result) || !result) setError($89d38d99107ddd0f$var$FORM_ERROR_TYPE, {
                message: result || '',
                type: $89d38d99107ddd0f$var$INPUT_VALIDATION_RULES.validate
            });
            else clearErrors($89d38d99107ddd0f$var$FORM_ERROR_TYPE);
            return result;
        }
        return true;
    };
    const executeBuiltInValidation = async ({ fields: fields, onlyCheckValid: onlyCheckValid, name: name, eventType: eventType, context: context = {
        valid: true,
        runRootValidation: false
    } })=>{
        if (props.validate) {
            context.runRootValidation = true;
            const result = await validateForm({
                name: name,
                eventType: eventType
            });
            if (!result) {
                context.valid = false;
                if (onlyCheckValid) return context.valid;
            }
        }
        for(const name in fields){
            const field = fields[name];
            if (field) {
                const { _f: _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const isPromiseFunction = field._f && $89d38d99107ddd0f$var$hasPromiseValidation(field._f);
                    const shouldTrackIsValidatingState = _proxyFormState.validatingFields || _proxyFormState.isValidating || _proxySubscribeFormState.validatingFields || _proxySubscribeFormState.isValidating;
                    if (isPromiseFunction && shouldTrackIsValidatingState) _updateIsValidating([
                        _f.name
                    ], true);
                    const fieldError = await $89d38d99107ddd0f$var$validateField(field, _names.disabled, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !onlyCheckValid, isFieldArrayRoot);
                    if (isPromiseFunction && shouldTrackIsValidatingState) _updateIsValidating([
                        _f.name
                    ]);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (onlyCheckValid) break;
                    }
                    !onlyCheckValid && ($89d38d99107ddd0f$export$3988ae62b71be9a3(fieldError, _f.name) ? isFieldArrayRoot ? $89d38d99107ddd0f$var$updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : $89d38d99107ddd0f$export$adaa4cf7ef1b65be(_formState.errors, _f.name, fieldError[_f.name]) : $89d38d99107ddd0f$var$unset(_formState.errors, _f.name));
                    if (props.shouldUseNativeValidation && fieldError[_f.name]) break;
                }
                !$89d38d99107ddd0f$var$isEmptyObject(fieldValue) && await executeBuiltInValidation({
                    context: context,
                    onlyCheckValid: onlyCheckValid,
                    fields: fieldValue,
                    name: name,
                    eventType: eventType
                });
            }
        }
        return context.valid;
    };
    const _removeUnmounted = ()=>{
        for (const name of _names.unMount){
            const field = $89d38d99107ddd0f$export$3988ae62b71be9a3(_fields, name);
            field && (field._f.refs ? field._f.refs.every((ref)=>!$89d38d99107ddd0f$var$live(ref)) : !$89d38d99107ddd0f$var$live(field._f.ref)) && unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data)=>!_options.disabled && (name && data && $89d38d99107ddd0f$export$adaa4cf7ef1b65be(_formValues, name, data), !$89d38d99107ddd0f$var$deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal)=>$89d38d99107ddd0f$var$generateWatchOutput(names, _names, {
            ..._state.mount ? _formValues : $89d38d99107ddd0f$var$isUndefined(defaultValue) ? _defaultValues : $89d38d99107ddd0f$var$isString(names) ? {
                [names]: defaultValue
            } : defaultValue
        }, isGlobal, defaultValue);
    const _getFieldArray = (name)=>$89d38d99107ddd0f$var$compact($89d38d99107ddd0f$export$3988ae62b71be9a3(_state.mount ? _formValues : _defaultValues, name, _options.shouldUnregister ? $89d38d99107ddd0f$export$3988ae62b71be9a3(_defaultValues, name, []) : []));
    const setFieldValue = (name, value1, options = {})=>{
        const field = $89d38d99107ddd0f$export$3988ae62b71be9a3(_fields, name);
        let fieldValue = value1;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled && $89d38d99107ddd0f$export$adaa4cf7ef1b65be(_formValues, name, $89d38d99107ddd0f$var$getFieldValueAs(value1, fieldReference));
                fieldValue = $89d38d99107ddd0f$var$isHTMLElement(fieldReference.ref) && $89d38d99107ddd0f$var$isNullOrUndefined(value1) ? '' : value1;
                if ($89d38d99107ddd0f$var$isMultipleSelect(fieldReference.ref)) [
                    ...fieldReference.ref.options
                ].forEach((optionRef)=>optionRef.selected = fieldValue.includes(optionRef.value));
                else if (fieldReference.refs) {
                    if ($89d38d99107ddd0f$var$isCheckBoxInput(fieldReference.ref)) fieldReference.refs.forEach((checkboxRef)=>{
                        if (!checkboxRef.defaultChecked || !checkboxRef.disabled) {
                            if (Array.isArray(fieldValue)) checkboxRef.checked = !!fieldValue.find((data)=>data === checkboxRef.value);
                            else checkboxRef.checked = fieldValue === checkboxRef.value || !!fieldValue;
                        }
                    });
                    else fieldReference.refs.forEach((radioRef)=>radioRef.checked = radioRef.value === fieldValue);
                } else if ($89d38d99107ddd0f$var$isFileInput(fieldReference.ref)) fieldReference.ref.value = '';
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) _subjects.state.next({
                        name: name,
                        values: $89d38d99107ddd0f$var$cloneObject(_formValues)
                    });
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setFieldValues = (name, value1, options)=>{
        for(const fieldKey in value1){
            if (!value1.hasOwnProperty(fieldKey)) return;
            const fieldValue = value1[fieldKey];
            const fieldName = name + '.' + fieldKey;
            const field = $89d38d99107ddd0f$export$3988ae62b71be9a3(_fields, fieldName);
            (_names.array.has(name) || $89d38d99107ddd0f$var$isObject(fieldValue) || field && !field._f) && !$89d38d99107ddd0f$var$isDateObject(fieldValue) ? setFieldValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value1, options = {})=>{
        const field = $89d38d99107ddd0f$export$3988ae62b71be9a3(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = $89d38d99107ddd0f$var$cloneObject(value1);
        const previousValue = $89d38d99107ddd0f$export$3988ae62b71be9a3(_formValues, name);
        const isValueUnchanged = $89d38d99107ddd0f$var$deepEqual(previousValue, cloneValue);
        if (!isValueUnchanged) $89d38d99107ddd0f$export$adaa4cf7ef1b65be(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name: name,
                values: $89d38d99107ddd0f$var$cloneObject(_formValues)
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields || _proxySubscribeFormState.isDirty || _proxySubscribeFormState.dirtyFields) && options.shouldDirty) {
                _updateDirtyFields();
                _subjects.state.next({
                    name: name,
                    dirtyFields: _formState.dirtyFields,
                    isDirty: _getDirty(name, cloneValue)
                });
            }
        } else {
            const isEmpty = Array.isArray(cloneValue) && !cloneValue.length || $89d38d99107ddd0f$var$isEmptyObject(cloneValue);
            if (!field || field._f || $89d38d99107ddd0f$var$isNullOrUndefined(cloneValue) || isEmpty) setFieldValue(name, cloneValue, options);
            else setFieldValues(name, cloneValue, options);
        }
        if (!isValueUnchanged) {
            const watched = $89d38d99107ddd0f$var$isWatched(name, _names);
            const values = $89d38d99107ddd0f$var$cloneObject(_formValues);
            if (!isFieldArray) for (const arrayName of $89d38d99107ddd0f$var$getFieldArrayParentNames(_names.array, name))_subjects.array.next({
                name: arrayName,
                values: values
            });
            _subjects.state.next({
                ...watched && _formState,
                name: _state.mount || watched ? name : undefined,
                values: values
            });
        }
    };
    const setValues = (formValues)=>{
        const updatedFormValues = $89d38d99107ddd0f$var$isFunction(formValues) ? formValues(_formValues) : formValues;
        if (!$89d38d99107ddd0f$var$deepEqual(_formValues, updatedFormValues)) {
            _formValues = {
                ..._formValues,
                ...updatedFormValues
            };
            for (const fieldName of _names.mount)setValue(fieldName, $89d38d99107ddd0f$export$3988ae62b71be9a3(updatedFormValues, fieldName));
            _subjects.state.next({
                ..._formState,
                values: _formValues
            });
        }
    };
    const onChange = async (event)=>{
        _state.mount = true;
        const target = event.target;
        let name = target.name;
        let isFieldValueUpdated = true;
        const field = $89d38d99107ddd0f$export$3988ae62b71be9a3(_fields, name);
        const _updateIsFieldValueUpdated = (fieldValue)=>{
            isFieldValueUpdated = Number.isNaN(fieldValue) || $89d38d99107ddd0f$var$isDateObject(fieldValue) && isNaN(fieldValue.getTime()) || $89d38d99107ddd0f$var$deepEqual(fieldValue, $89d38d99107ddd0f$export$3988ae62b71be9a3(_formValues, name, fieldValue));
        };
        const validationModeBeforeSubmit = $89d38d99107ddd0f$var$getValidationModes(_options.mode);
        const validationModeAfterSubmit = $89d38d99107ddd0f$var$getValidationModes(_options.reValidateMode);
        if (field) {
            let error;
            let isValid;
            const fieldValue = target.type ? $89d38d99107ddd0f$var$getFieldValue(field._f) : $89d38d99107ddd0f$var$getEventValue(event);
            const isBlurEvent = event.type === $89d38d99107ddd0f$var$EVENTS.BLUR || event.type === $89d38d99107ddd0f$var$EVENTS.FOCUS_OUT;
            const shouldSkipValidation = !$89d38d99107ddd0f$var$hasValidation(field._f) && !props.validate && !_options.resolver && !$89d38d99107ddd0f$export$3988ae62b71be9a3(_formState.errors, name) && !field._f.deps || $89d38d99107ddd0f$var$skipValidation(isBlurEvent, $89d38d99107ddd0f$export$3988ae62b71be9a3(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = $89d38d99107ddd0f$var$isWatched(name, _names, isBlurEvent);
            $89d38d99107ddd0f$export$adaa4cf7ef1b65be(_formValues, name, fieldValue);
            if (isBlurEvent) {
                if (!target || !target.readOnly) {
                    field._f.onBlur && field._f.onBlur(event);
                    delayErrorCallback && delayErrorCallback(0);
                }
            } else if (field._f.onChange) field._f.onChange(event);
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent);
            const shouldRender = !$89d38d99107ddd0f$var$isEmptyObject(fieldState) || watched;
            !isBlurEvent && _subjects.state.next({
                name: name,
                type: event.type,
                values: $89d38d99107ddd0f$var$cloneObject(_formValues)
            });
            if (shouldSkipValidation) {
                if (_proxyFormState.isValid || _proxySubscribeFormState.isValid) {
                    if (_options.mode === 'onBlur') {
                        if (isBlurEvent) _setValid();
                    } else if (!isBlurEvent) _setValid();
                }
                return shouldRender && _subjects.state.next({
                    name: name,
                    ...watched ? {} : fieldState
                });
            }
            if (!_options.resolver && props.validate) await validateForm({
                name: name,
                eventType: event.type
            });
            !isBlurEvent && watched && _subjects.state.next({
                ..._formState
            });
            if (_options.resolver) {
                const { errors: errors } = await _runSchema([
                    name
                ]);
                _updateIsValidating([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    const previousErrorLookupResult = $89d38d99107ddd0f$var$schemaErrorLookup(_formState.errors, _fields, name);
                    const errorLookupResult = $89d38d99107ddd0f$var$schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                    error = errorLookupResult.error;
                    name = errorLookupResult.name;
                    isValid = $89d38d99107ddd0f$var$isEmptyObject(errors);
                }
            } else {
                _updateIsValidating([
                    name
                ], true);
                error = (await $89d38d99107ddd0f$var$validateField(field, _names.disabled, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                _updateIsValidating([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    if (error) isValid = false;
                    else if (_proxyFormState.isValid || _proxySubscribeFormState.isValid) isValid = await executeBuiltInValidation({
                        fields: _fields,
                        onlyCheckValid: true,
                        name: name,
                        eventType: event.type
                    });
                }
            }
            if (isFieldValueUpdated) {
                field._f.deps && (!Array.isArray(field._f.deps) || field._f.deps.length > 0) && trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
            }
        }
    };
    const _focusInput = (ref, key)=>{
        if ($89d38d99107ddd0f$export$3988ae62b71be9a3(_formState.errors, key) && ref.focus) {
            ref.focus();
            return 1;
        }
        return;
    };
    const trigger = async (name, options = {})=>{
        let isValid;
        let validationResult;
        const fieldNames = $89d38d99107ddd0f$var$convertToArrayPayload(name);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState($89d38d99107ddd0f$var$isUndefined(name) ? name : fieldNames);
            isValid = $89d38d99107ddd0f$var$isEmptyObject(errors);
            validationResult = name ? !fieldNames.some((name)=>$89d38d99107ddd0f$export$3988ae62b71be9a3(errors, name)) : isValid;
        } else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName)=>{
                const field = $89d38d99107ddd0f$export$3988ae62b71be9a3(_fields, fieldName);
                return await executeBuiltInValidation({
                    fields: field && field._f ? {
                        [fieldName]: field
                    } : field,
                    eventType: $89d38d99107ddd0f$var$EVENTS.TRIGGER
                });
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _setValid();
        } else validationResult = isValid = await executeBuiltInValidation({
            fields: _fields,
            name: name,
            eventType: $89d38d99107ddd0f$var$EVENTS.TRIGGER
        });
        _subjects.state.next({
            ...!$89d38d99107ddd0f$var$isString(name) || (_proxyFormState.isValid || _proxySubscribeFormState.isValid) && isValid !== _formState.isValid ? {} : {
                name: name
            },
            ..._options.resolver || !name ? {
                isValid: isValid
            } : {},
            errors: _formState.errors
        });
        options.shouldFocus && !validationResult && $89d38d99107ddd0f$var$iterateFieldsByAction(_fields, _focusInput, name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames, config)=>{
        let values = {
            ..._state.mount ? _formValues : _defaultValues
        };
        if (config) values = $89d38d99107ddd0f$var$extractFormValues(config.dirtyFields ? _formState.dirtyFields : _formState.touchedFields, values);
        return $89d38d99107ddd0f$var$isUndefined(fieldNames) ? values : $89d38d99107ddd0f$var$isString(fieldNames) ? $89d38d99107ddd0f$export$3988ae62b71be9a3(values, fieldNames) : fieldNames.map((name)=>$89d38d99107ddd0f$export$3988ae62b71be9a3(values, name));
    };
    const getFieldState = (name, formState)=>({
            invalid: !!$89d38d99107ddd0f$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isDirty: !!$89d38d99107ddd0f$export$3988ae62b71be9a3((formState || _formState).dirtyFields, name),
            error: $89d38d99107ddd0f$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isValidating: !!$89d38d99107ddd0f$export$3988ae62b71be9a3(_formState.validatingFields, name),
            isTouched: !!$89d38d99107ddd0f$export$3988ae62b71be9a3((formState || _formState).touchedFields, name)
        });
    const clearErrors = (name)=>{
        const names = name ? $89d38d99107ddd0f$var$convertToArrayPayload(name) : undefined;
        names === null || names === void 0 || names.forEach((inputName)=>$89d38d99107ddd0f$var$unset(_formState.errors, inputName));
        if (names) // Emit for each cleared field with the field name so that
        // shouldSubscribeByName can filter and avoid broad re-renders
        names.forEach((inputName)=>{
            _subjects.state.next({
                name: inputName,
                errors: _formState.errors
            });
        });
        else // Clear all errors - emit without name to notify all subscribers
        _subjects.state.next({
            errors: {}
        });
    };
    const setError = (name, error, options)=>{
        const ref = ($89d38d99107ddd0f$export$3988ae62b71be9a3(_fields, name, {
            _f: {}
        })._f || {}).ref;
        const currentError = $89d38d99107ddd0f$export$3988ae62b71be9a3(_formState.errors, name) || {};
        // Don't override existing error messages elsewhere in the object tree.
        const { ref: currentRef, message: message, type: type, ...restOfErrorTree } = currentError;
        $89d38d99107ddd0f$export$adaa4cf7ef1b65be(_formState.errors, name, {
            ...restOfErrorTree,
            ...error,
            ref: ref
        });
        _subjects.state.next({
            name: name,
            errors: _formState.errors,
            isValid: false
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue)=>$89d38d99107ddd0f$var$isFunction(name) ? _subjects.state.subscribe({
            next: (payload)=>'values' in payload && name(payload.values || _getWatch(undefined, defaultValue), payload)
        }) : _getWatch(name, defaultValue, true);
    const _subscribe = (props)=>_subjects.state.subscribe({
            next: (formState)=>{
                if ($89d38d99107ddd0f$var$shouldSubscribeByName(props.name, formState.name, props.exact) && $89d38d99107ddd0f$var$shouldRenderFormState(formState, props.formState || _proxyFormState, _setFormState, props.reRenderRoot)) {
                    const snapshot = {
                        ..._formValues
                    };
                    props.callback({
                        values: snapshot,
                        ..._formState,
                        ...formState,
                        defaultValues: _defaultValues
                    });
                }
            }
        }).unsubscribe;
    const subscribe = (props)=>{
        _state.mount = true;
        _proxySubscribeFormState = {
            ..._proxySubscribeFormState,
            ...props.formState
        };
        return _subscribe({
            ...props,
            formState: {
                ...defaultProxyFormState,
                ...props.formState
            }
        });
    };
    const unregister = (name, options = {})=>{
        for (const fieldName of name ? $89d38d99107ddd0f$var$convertToArrayPayload(name) : _names.mount){
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (!options.keepValue) {
                $89d38d99107ddd0f$var$unset(_fields, fieldName);
                $89d38d99107ddd0f$var$unset(_formValues, fieldName);
            }
            !options.keepError && $89d38d99107ddd0f$var$unset(_formState.errors, fieldName);
            !options.keepDirty && $89d38d99107ddd0f$var$unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && $89d38d99107ddd0f$var$unset(_formState.touchedFields, fieldName);
            !options.keepIsValidating && $89d38d99107ddd0f$var$unset(_formState.validatingFields, fieldName);
            !_options.shouldUnregister && !options.keepDefaultValue && $89d38d99107ddd0f$var$unset(_defaultValues, fieldName);
        }
        _subjects.state.next({
            values: $89d38d99107ddd0f$var$cloneObject(_formValues)
        });
        _subjects.state.next({
            ..._formState,
            ...!options.keepDirty ? {} : {
                isDirty: _getDirty()
            }
        });
        !options.keepIsValid && _setValid();
    };
    const _setDisabledField = ({ disabled: disabled, name: name })=>{
        if ($89d38d99107ddd0f$var$isBoolean(disabled) && _state.mount || !!disabled || _names.disabled.has(name)) {
            const wasDisabled = _names.disabled.has(name);
            const isDisabled = !!disabled;
            const disabledStateChanged = wasDisabled !== isDisabled;
            disabled ? _names.disabled.add(name) : _names.disabled.delete(name);
            disabledStateChanged && _state.mount && !_state.action && _setValid();
        }
    };
    const register = (name, options = {})=>{
        let field = $89d38d99107ddd0f$export$3988ae62b71be9a3(_fields, name);
        const disabledIsDefined = $89d38d99107ddd0f$var$isBoolean(options.disabled) || $89d38d99107ddd0f$var$isBoolean(_options.disabled);
        const shouldRevalidateRemount = !_names.registerName.has(name) && field && field._f && !field._f.mount;
        $89d38d99107ddd0f$export$adaa4cf7ef1b65be(_fields, name, {
            ...field || {},
            _f: {
                ...field && field._f ? field._f : {
                    ref: {
                        name: name
                    }
                },
                name: name,
                mount: true,
                ...options
            }
        });
        _names.mount.add(name);
        if (field && !shouldRevalidateRemount) _setDisabledField({
            disabled: $89d38d99107ddd0f$var$isBoolean(options.disabled) ? options.disabled : _options.disabled,
            name: name
        });
        else updateValidAndValue(name, true, options.value);
        return {
            ...disabledIsDefined ? {
                disabled: options.disabled || _options.disabled
            } : {},
            ..._options.progressive ? {
                required: !!options.required,
                min: $89d38d99107ddd0f$var$getRuleValue(options.min),
                max: $89d38d99107ddd0f$var$getRuleValue(options.max),
                minLength: $89d38d99107ddd0f$var$getRuleValue(options.minLength),
                maxLength: $89d38d99107ddd0f$var$getRuleValue(options.maxLength),
                pattern: $89d38d99107ddd0f$var$getRuleValue(options.pattern)
            } : {},
            name: name,
            onChange: onChange,
            onBlur: onChange,
            ref: (ref)=>{
                if (ref) {
                    _names.registerName.add(name);
                    register(name, options);
                    _names.registerName.delete(name);
                    field = $89d38d99107ddd0f$export$3988ae62b71be9a3(_fields, name);
                    const fieldRef = $89d38d99107ddd0f$var$isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll('input,select,textarea')[0] || ref : ref : ref;
                    const radioOrCheckbox = $89d38d99107ddd0f$var$isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox ? refs.find((option)=>option === fieldRef) : fieldRef === field._f.ref) return;
                    $89d38d99107ddd0f$export$adaa4cf7ef1b65be(_fields, name, {
                        _f: {
                            ...field._f,
                            ...radioOrCheckbox ? {
                                refs: [
                                    ...refs.filter($89d38d99107ddd0f$var$live),
                                    fieldRef,
                                    ...Array.isArray($89d38d99107ddd0f$export$3988ae62b71be9a3(_defaultValues, name)) ? [
                                        {}
                                    ] : []
                                ],
                                ref: {
                                    type: fieldRef.type,
                                    name: name
                                }
                            } : {
                                ref: fieldRef
                            }
                        }
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                } else {
                    field = $89d38d99107ddd0f$export$3988ae62b71be9a3(_fields, name, {});
                    if (field._f) field._f.mount = false;
                    (_options.shouldUnregister || options.shouldUnregister) && !($89d38d99107ddd0f$var$getFieldArrayParentNames(_names.array, name).length && _state.action) && _names.unMount.add(name);
                }
            }
        };
    };
    const _focusError = ()=>_options.shouldFocusError && !_options.shouldUseNativeValidation && $89d38d99107ddd0f$var$iterateFieldsByAction(_fields, _focusInput, _names.mount);
    const _disableForm = (disabled)=>{
        if ($89d38d99107ddd0f$var$isBoolean(disabled)) {
            _subjects.state.next({
                disabled: disabled
            });
            $89d38d99107ddd0f$var$iterateFieldsByAction(_fields, (ref, name)=>{
                const currentField = $89d38d99107ddd0f$export$3988ae62b71be9a3(_fields, name);
                if (currentField) {
                    ref.disabled = currentField._f.disabled || disabled;
                    if (Array.isArray(currentField._f.refs)) currentField._f.refs.forEach((inputRef)=>{
                        inputRef.disabled = currentField._f.disabled || disabled;
                    });
                }
            }, 0, false);
        }
    };
    const handleSubmit = (onValid, onInvalid)=>async (e)=>{
            let onValidError = undefined;
            if (e) {
                e.preventDefault && e.preventDefault();
                e.persist && e.persist();
            }
            let fieldValues = $89d38d99107ddd0f$var$cloneObject(_formValues);
            _subjects.state.next({
                isSubmitting: true
            });
            if (_options.resolver) {
                const { errors: errors, values: values } = await _runSchema();
                _updateIsValidating();
                _formState.errors = errors;
                fieldValues = $89d38d99107ddd0f$var$cloneObject(values);
            } else await executeBuiltInValidation({
                fields: _fields,
                eventType: $89d38d99107ddd0f$var$EVENTS.SUBMIT
            });
            if (_names.disabled.size) for (const name of _names.disabled)$89d38d99107ddd0f$var$unset(fieldValues, name);
            $89d38d99107ddd0f$var$unset(_formState.errors, $89d38d99107ddd0f$var$ROOT_ERROR_TYPE);
            if ($89d38d99107ddd0f$var$isEmptyObject(_formState.errors)) {
                _subjects.state.next({
                    errors: {}
                });
                try {
                    await onValid(fieldValues, e);
                } catch (error) {
                    onValidError = error;
                }
            } else {
                if (onInvalid) await onInvalid({
                    ..._formState.errors
                }, e);
                _focusError();
                setTimeout(_focusError);
            }
            _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: $89d38d99107ddd0f$var$isEmptyObject(_formState.errors) && !onValidError,
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors
            });
            if (onValidError) throw onValidError;
        };
    const resetField = (name, options = {})=>{
        if ($89d38d99107ddd0f$export$3988ae62b71be9a3(_fields, name)) {
            if ($89d38d99107ddd0f$var$isUndefined(options.defaultValue)) setValue(name, $89d38d99107ddd0f$var$cloneObject($89d38d99107ddd0f$export$3988ae62b71be9a3(_defaultValues, name)));
            else {
                setValue(name, options.defaultValue);
                $89d38d99107ddd0f$export$adaa4cf7ef1b65be(_defaultValues, name, $89d38d99107ddd0f$var$cloneObject(options.defaultValue));
            }
            if (!options.keepTouched) $89d38d99107ddd0f$var$unset(_formState.touchedFields, name);
            if (!options.keepDirty) {
                $89d38d99107ddd0f$var$unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue ? _getDirty(name, $89d38d99107ddd0f$var$cloneObject($89d38d99107ddd0f$export$3988ae62b71be9a3(_defaultValues, name))) : _getDirty();
            }
            if (!options.keepError) {
                $89d38d99107ddd0f$var$unset(_formState.errors, name);
                _proxyFormState.isValid && _setValid();
            }
            _subjects.state.next({
                ..._formState
            });
        }
    };
    const _reset = (formValues, keepStateOptions = {})=>{
        const updatedValues = formValues ? $89d38d99107ddd0f$var$cloneObject(formValues) : _defaultValues;
        const cloneUpdatedValues = $89d38d99107ddd0f$var$cloneObject(updatedValues);
        const isEmptyResetValues = $89d38d99107ddd0f$var$isEmptyObject(formValues);
        const values = isEmptyResetValues ? _defaultValues : cloneUpdatedValues;
        if (!keepStateOptions.keepDefaultValues) _defaultValues = updatedValues;
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues) {
                const fieldsToCheck = new Set([
                    ..._names.mount,
                    ...Object.keys($89d38d99107ddd0f$var$getDirtyFields(_defaultValues, _formValues))
                ]);
                for (const fieldName of Array.from(fieldsToCheck)){
                    const isDirty = $89d38d99107ddd0f$export$3988ae62b71be9a3(_formState.dirtyFields, fieldName);
                    const existingValue = $89d38d99107ddd0f$export$3988ae62b71be9a3(_formValues, fieldName);
                    const newValue = $89d38d99107ddd0f$export$3988ae62b71be9a3(values, fieldName);
                    if (isDirty && !$89d38d99107ddd0f$var$isUndefined(existingValue)) $89d38d99107ddd0f$export$adaa4cf7ef1b65be(values, fieldName, existingValue);
                    else if (!isDirty && !$89d38d99107ddd0f$var$isUndefined(newValue)) setValue(fieldName, newValue);
                }
            } else {
                if ($89d38d99107ddd0f$var$isWeb && $89d38d99107ddd0f$var$isUndefined(formValues)) for (const name of _names.mount){
                    const field = $89d38d99107ddd0f$export$3988ae62b71be9a3(_fields, name);
                    if (field && field._f) {
                        const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
                        if ($89d38d99107ddd0f$var$isHTMLElement(fieldReference)) {
                            const form = fieldReference.closest('form');
                            if (form) {
                                form.reset();
                                break;
                            }
                        }
                    }
                }
                if (keepStateOptions.keepFieldsRef) for (const fieldName of _names.mount)setValue(fieldName, $89d38d99107ddd0f$export$3988ae62b71be9a3(values, fieldName));
                else _fields = {};
            }
            _formValues = _options.shouldUnregister ? keepStateOptions.keepDefaultValues ? $89d38d99107ddd0f$var$cloneObject(_defaultValues) : {} : $89d38d99107ddd0f$var$cloneObject(values);
            _subjects.array.next({
                values: {
                    ...values
                }
            });
            _subjects.state.next({
                values: {
                    ...values
                }
            });
        }
        _names = {
            mount: keepStateOptions.keepDirtyValues ? _names.mount : new Set(),
            unMount: new Set(),
            array: new Set(),
            registerName: new Set(),
            disabled: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: ''
        };
        _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid || !!keepStateOptions.keepDirtyValues || !_options.shouldUnregister && !$89d38d99107ddd0f$var$isEmptyObject(values);
        _state.watch = !!_options.shouldUnregister;
        _state.keepIsValid = !!keepStateOptions.keepIsValid;
        _state.action = false;
        // Clear errors synchronously to prevent validation errors on subsequent submissions
        // This fixes the issue where form.reset() causes validation errors on subsequent
        // submissions in Next.js 16 with Server Actions
        if (!keepStateOptions.keepErrors) _formState.errors = {};
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
            isDirty: isEmptyResetValues ? false : keepStateOptions.keepDirty ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !$89d38d99107ddd0f$var$deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
            dirtyFields: isEmptyResetValues ? {} : keepStateOptions.keepDirtyValues ? keepStateOptions.keepDefaultValues && _formValues ? $89d38d99107ddd0f$var$getDirtyFields(_defaultValues, _formValues) : _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? $89d38d99107ddd0f$var$getDirtyFields(_defaultValues, formValues) : keepStateOptions.keepDirty ? _formState.dirtyFields : {},
            touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful ? _formState.isSubmitSuccessful : false,
            isSubmitting: false,
            defaultValues: _defaultValues
        });
    };
    const reset = (formValues, keepStateOptions)=>_reset($89d38d99107ddd0f$var$isFunction(formValues) ? formValues(_formValues) : formValues, {
            ..._options.resetOptions,
            ...keepStateOptions
        });
    const setFocus = (name, options = {})=>{
        const field = $89d38d99107ddd0f$export$3988ae62b71be9a3(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
            if (fieldRef.focus) // Use setTimeout to ensure focus happens after any pending state updates
            // This fixes the issue where setFocus doesn't work immediately after setError
            setTimeout(()=>{
                fieldRef.focus();
                options.shouldSelect && $89d38d99107ddd0f$var$isFunction(fieldRef.select) && fieldRef.select();
            });
        }
    };
    const _setFormState = (updatedFormState)=>{
        _formState = {
            ..._formState,
            ...updatedFormState
        };
    };
    const _resetDefaultValues = ()=>$89d38d99107ddd0f$var$isFunction(_options.defaultValues) && _options.defaultValues().then((values)=>{
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false
            });
        });
    const methods = {
        control: {
            register: register,
            unregister: unregister,
            getFieldState: getFieldState,
            handleSubmit: handleSubmit,
            setError: setError,
            _subscribe: _subscribe,
            _runSchema: _runSchema,
            _updateIsValidating: _updateIsValidating,
            _focusError: _focusError,
            _getWatch: _getWatch,
            _getDirty: _getDirty,
            _setValid: _setValid,
            _setFieldArray: _setFieldArray,
            _setDisabledField: _setDisabledField,
            _setErrors: _setErrors,
            _getFieldArray: _getFieldArray,
            _reset: _reset,
            _resetDefaultValues: _resetDefaultValues,
            _removeUnmounted: _removeUnmounted,
            _disableForm: _disableForm,
            _subjects: _subjects,
            _proxyFormState: _proxyFormState,
            get _fields () {
                return _fields;
            },
            get _formValues () {
                return _formValues;
            },
            get _state () {
                return _state;
            },
            set _state (value){
                _state = value;
            },
            get _defaultValues () {
                return _defaultValues;
            },
            get _names () {
                return _names;
            },
            set _names (value){
                _names = value;
            },
            get _formState () {
                return _formState;
            },
            get _options () {
                return _options;
            },
            set _options (value){
                _options = {
                    ..._options,
                    ...value
                };
            }
        },
        subscribe: subscribe,
        trigger: trigger,
        register: register,
        handleSubmit: handleSubmit,
        watch: watch,
        setValue: setValue,
        setValues: setValues,
        getValues: getValues,
        reset: reset,
        resetField: resetField,
        clearErrors: clearErrors,
        unregister: unregister,
        setError: setError,
        setFocus: setFocus,
        getFieldState: getFieldState
    };
    return {
        ...methods,
        formControl: methods
    };
}
var $89d38d99107ddd0f$var$generateId = ()=>{
    if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
    const d = typeof performance === 'undefined' ? Date.now() : performance.now() * 1000;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
};
var $89d38d99107ddd0f$var$getFocusFieldName = (name, index, options = {})=>options.shouldFocus || $89d38d99107ddd0f$var$isUndefined(options.shouldFocus) ? options.focusName || `${name}.${$89d38d99107ddd0f$var$isUndefined(options.focusIndex) ? index : options.focusIndex}.` : '';
var $89d38d99107ddd0f$var$appendAt = (data, value1)=>[
        ...data,
        ...$89d38d99107ddd0f$var$convertToArrayPayload(value1)
    ];
var $89d38d99107ddd0f$var$fillEmptyArray = (value1)=>Array.isArray(value1) ? value1.map(()=>undefined) : undefined;
function $89d38d99107ddd0f$var$insert(data, index, value1) {
    return [
        ...data.slice(0, index),
        ...$89d38d99107ddd0f$var$convertToArrayPayload(value1),
        ...data.slice(index)
    ];
}
var $89d38d99107ddd0f$var$moveArrayAt = (data, from, to)=>{
    if (!Array.isArray(data)) return [];
    if ($89d38d99107ddd0f$var$isUndefined(data[to])) data[to] = undefined;
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};
var $89d38d99107ddd0f$var$prependAt = (data, value1)=>[
        ...$89d38d99107ddd0f$var$convertToArrayPayload(value1),
        ...$89d38d99107ddd0f$var$convertToArrayPayload(data)
    ];
function $89d38d99107ddd0f$var$removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [
        ...data
    ];
    for (const index of indexes){
        temp.splice(index - i, 1);
        i++;
    }
    return $89d38d99107ddd0f$var$compact(temp).length ? temp : [];
}
var $89d38d99107ddd0f$var$removeArrayAt = (data, index)=>$89d38d99107ddd0f$var$isUndefined(index) ? [] : $89d38d99107ddd0f$var$removeAtIndexes(data, $89d38d99107ddd0f$var$convertToArrayPayload(index).sort((a, b)=>a - b));
var $89d38d99107ddd0f$var$swapArrayAt = (data, indexA, indexB)=>{
    [data[indexA], data[indexB]] = [
        data[indexB],
        data[indexA]
    ];
};
var $89d38d99107ddd0f$var$updateAt = (fieldValues, index, value1)=>{
    fieldValues[index] = value1;
    return fieldValues;
};
/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $89d38d99107ddd0f$export$310131896651d559(props) {
    const formControl = $89d38d99107ddd0f$var$useFormControlContext();
    const { control: control = formControl, name: name, keyName: keyName = 'id', shouldUnregister: shouldUnregister, rules: rules } = props;
    const [fields, setFields] = (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useState(control._getFieldArray(name));
    const ids = (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useRef(control._getFieldArray(name).map($89d38d99107ddd0f$var$generateId));
    const _actioned = (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useRef(false);
    control._names.array.add(name);
    (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useMemo(()=>rules && fields.length >= 0 && control.register(name, rules), [
        control,
        name,
        fields.length,
        rules
    ]);
    $89d38d99107ddd0f$var$useIsomorphicLayoutEffect(()=>control._subjects.array.subscribe({
            next: ({ values: values, name: fieldArrayName })=>{
                if (fieldArrayName === name || !fieldArrayName) {
                    const fieldValues = $89d38d99107ddd0f$export$3988ae62b71be9a3(values, name);
                    if (Array.isArray(fieldValues)) {
                        setFields(fieldValues);
                        ids.current = fieldValues.map($89d38d99107ddd0f$var$generateId);
                    }
                }
            }
        }).unsubscribe, [
        control,
        name
    ]);
    const updateValues = (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useCallback((updatedFieldArrayValues)=>{
        _actioned.current = true;
        control._setFieldArray(name, updatedFieldArrayValues);
    }, [
        control,
        name
    ]);
    const append = (value1, options)=>{
        const appendValue = $89d38d99107ddd0f$var$convertToArrayPayload($89d38d99107ddd0f$var$cloneObject(value1));
        const updatedFieldArrayValues = $89d38d99107ddd0f$var$appendAt(control._getFieldArray(name), appendValue);
        control._names.focus = $89d38d99107ddd0f$var$getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = $89d38d99107ddd0f$var$appendAt(ids.current, appendValue.map($89d38d99107ddd0f$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $89d38d99107ddd0f$var$appendAt, {
            argA: $89d38d99107ddd0f$var$fillEmptyArray(value1)
        });
    };
    const prepend = (value1, options)=>{
        const prependValue = $89d38d99107ddd0f$var$convertToArrayPayload($89d38d99107ddd0f$var$cloneObject(value1));
        const updatedFieldArrayValues = $89d38d99107ddd0f$var$prependAt(control._getFieldArray(name), prependValue);
        control._names.focus = $89d38d99107ddd0f$var$getFocusFieldName(name, 0, options);
        ids.current = $89d38d99107ddd0f$var$prependAt(ids.current, prependValue.map($89d38d99107ddd0f$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $89d38d99107ddd0f$var$prependAt, {
            argA: $89d38d99107ddd0f$var$fillEmptyArray(value1)
        });
    };
    const remove = (index)=>{
        const updatedFieldArrayValues = $89d38d99107ddd0f$var$removeArrayAt(control._getFieldArray(name), index);
        ids.current = $89d38d99107ddd0f$var$removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        !Array.isArray($89d38d99107ddd0f$export$3988ae62b71be9a3(control._fields, name)) && $89d38d99107ddd0f$export$adaa4cf7ef1b65be(control._fields, name, undefined);
        control._setFieldArray(name, updatedFieldArrayValues, $89d38d99107ddd0f$var$removeArrayAt, {
            argA: index
        });
    };
    const insert$1 = (index, value1, options)=>{
        const insertValue = $89d38d99107ddd0f$var$convertToArrayPayload($89d38d99107ddd0f$var$cloneObject(value1));
        const updatedFieldArrayValues = $89d38d99107ddd0f$var$insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = $89d38d99107ddd0f$var$getFocusFieldName(name, index, options);
        ids.current = $89d38d99107ddd0f$var$insert(ids.current, index, insertValue.map($89d38d99107ddd0f$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $89d38d99107ddd0f$var$insert, {
            argA: index,
            argB: $89d38d99107ddd0f$var$fillEmptyArray(value1)
        });
    };
    const swap = (indexA, indexB)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $89d38d99107ddd0f$var$swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        $89d38d99107ddd0f$var$swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $89d38d99107ddd0f$var$swapArrayAt, {
            argA: indexA,
            argB: indexB
        }, false);
    };
    const move = (from, to)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $89d38d99107ddd0f$var$moveArrayAt(updatedFieldArrayValues, from, to);
        $89d38d99107ddd0f$var$moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $89d38d99107ddd0f$var$moveArrayAt, {
            argA: from,
            argB: to
        }, false);
    };
    const update = (index, value1)=>{
        const updateValue = $89d38d99107ddd0f$var$cloneObject(value1);
        const updatedFieldArrayValues = $89d38d99107ddd0f$var$updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [
            ...updatedFieldArrayValues
        ].map((item, i)=>!item || i === index ? $89d38d99107ddd0f$var$generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._setFieldArray(name, updatedFieldArrayValues, $89d38d99107ddd0f$var$updateAt, {
            argA: index,
            argB: updateValue
        }, true, false);
    };
    const replace = (value1)=>{
        const updatedFieldArrayValues = $89d38d99107ddd0f$var$convertToArrayPayload($89d38d99107ddd0f$var$cloneObject(value1));
        ids.current = updatedFieldArrayValues.map($89d38d99107ddd0f$var$generateId);
        updateValues([
            ...updatedFieldArrayValues
        ]);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._setFieldArray(name, [
            ...updatedFieldArrayValues
        ], (data)=>data, {}, true, false);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useEffect(()=>{
        control._state.action = false;
        $89d38d99107ddd0f$var$isWatched(name, control._names) && control._subjects.state.next({
            ...control._formState
        });
        const validationModes = $89d38d99107ddd0f$var$getValidationModes(control._options.mode);
        if (_actioned.current && (!validationModes.isOnSubmit || control._formState.isSubmitted) && !$89d38d99107ddd0f$var$getValidationModes(control._options.reValidateMode).isOnSubmit && !validationModes.isOnBlur) {
            if (control._options.resolver) control._runSchema([
                name
            ]).then((result)=>{
                control._updateIsValidating([
                    name
                ]);
                const error = $89d38d99107ddd0f$export$3988ae62b71be9a3(result.errors, name);
                const existingError = $89d38d99107ddd0f$export$3988ae62b71be9a3(control._formState.errors, name);
                if (existingError ? !error && existingError.type || error && (existingError.type !== error.type || existingError.message !== error.message) : error && error.type) {
                    error ? $89d38d99107ddd0f$export$adaa4cf7ef1b65be(control._formState.errors, name, error) : $89d38d99107ddd0f$var$unset(control._formState.errors, name);
                    control._subjects.state.next({
                        errors: control._formState.errors
                    });
                }
            });
            else {
                const field = $89d38d99107ddd0f$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f && !($89d38d99107ddd0f$var$getValidationModes(control._options.reValidateMode).isOnSubmit && $89d38d99107ddd0f$var$getValidationModes(control._options.mode).isOnSubmit)) $89d38d99107ddd0f$var$validateField(field, control._names.disabled, control._formValues, control._options.criteriaMode === $89d38d99107ddd0f$var$VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error)=>!$89d38d99107ddd0f$var$isEmptyObject(error) && control._subjects.state.next({
                        errors: $89d38d99107ddd0f$var$updateFieldArrayRootError(control._formState.errors, error, name)
                    }));
            }
        }
        control._subjects.state.next({
            name: name,
            values: $89d38d99107ddd0f$var$cloneObject(control._formValues)
        });
        control._names.focus && $89d38d99107ddd0f$var$iterateFieldsByAction(control._fields, (ref, key)=>{
            if (control._names.focus && key.startsWith(control._names.focus) && ref.focus) {
                ref.focus();
                return 1;
            }
            return;
        });
        control._names.focus = '';
        control._setValid();
        _actioned.current = false;
    }, [
        fields,
        name,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useEffect(()=>{
        !$89d38d99107ddd0f$export$3988ae62b71be9a3(control._formValues, name) && control._setFieldArray(name);
        return ()=>{
            const shouldKeepFieldArrayValues = !(control._options.shouldUnregister || shouldUnregister);
            const updateMounted = (name, value1)=>{
                const field = $89d38d99107ddd0f$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f) field._f.mount = value1;
            };
            if (_actioned.current && shouldKeepFieldArrayValues) control._subjects.state.next({
                name: name,
                values: $89d38d99107ddd0f$var$cloneObject(control._formValues)
            });
            shouldKeepFieldArrayValues ? updateMounted(name, false) : control.unregister(name);
        };
    }, [
        name,
        control,
        keyName,
        shouldUnregister
    ]);
    return {
        swap: (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useCallback(swap, [
            updateValues,
            name,
            control
        ]),
        move: (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useCallback(move, [
            updateValues,
            name,
            control
        ]),
        prepend: (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useCallback(prepend, [
            updateValues,
            name,
            control
        ]),
        append: (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useCallback(append, [
            updateValues,
            name,
            control
        ]),
        remove: (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useCallback(remove, [
            updateValues,
            name,
            control
        ]),
        insert: (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useCallback(insert$1, [
            updateValues,
            name,
            control
        ]),
        update: (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useCallback(update, [
            updateValues,
            name,
            control
        ]),
        replace: (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useCallback(replace, [
            updateValues,
            name,
            control
        ]),
        fields: (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useMemo(()=>fields.map((field, index)=>({
                    ...field,
                    [keyName]: ids.current[index] || $89d38d99107ddd0f$var$generateId()
                })), [
            fields,
            keyName
        ])
    };
}
/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <button>Submit</button>
 *     </form>
 *   );
 * }
 * ```
 */ function $89d38d99107ddd0f$export$87c0cf8eb5a167e0(props = {}) {
    const _formControl = (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useRef(undefined);
    const _values = (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useRef(undefined);
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useState(()=>({
            ...$89d38d99107ddd0f$var$cloneObject($89d38d99107ddd0f$var$DEFAULT_FORM_STATE),
            isLoading: $89d38d99107ddd0f$var$isFunction(props.defaultValues),
            errors: props.errors || {},
            disabled: props.disabled || false,
            defaultValues: $89d38d99107ddd0f$var$isFunction(props.defaultValues) ? undefined : props.defaultValues
        }));
    if (!_formControl.current) {
        if (props.formControl) {
            _formControl.current = {
                ...props.formControl,
                formState: formState
            };
            if (props.defaultValues && !$89d38d99107ddd0f$var$isFunction(props.defaultValues)) props.formControl.reset(props.defaultValues, props.resetOptions);
        } else {
            const { formControl: formControl, ...rest } = $89d38d99107ddd0f$export$1361f5e0e4cca3c3(props);
            _formControl.current = {
                ...rest,
                formState: formState
            };
        }
    }
    const control = _formControl.current.control;
    control._options = props;
    $89d38d99107ddd0f$var$useIsomorphicLayoutEffect(()=>{
        const sub = control._subscribe({
            formState: control._proxyFormState,
            callback: ()=>updateFormState({
                    ...control._formState,
                    defaultValues: control._defaultValues
                }),
            reRenderRoot: true
        });
        updateFormState((data)=>({
                ...data,
                isReady: true
            }));
        control._formState.isReady = true;
        return sub;
    }, [
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useEffect(()=>control._disableForm(props.disabled), [
        control,
        props.disabled
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useEffect(()=>{
        if (props.mode) control._options.mode = props.mode;
        if (props.reValidateMode) control._options.reValidateMode = props.reValidateMode;
    }, [
        control,
        props.mode,
        props.reValidateMode
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useEffect(()=>{
        if (props.errors) {
            control._setErrors(props.errors);
            control._focusError();
        }
    }, [
        control,
        props.errors
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useEffect(()=>{
        props.shouldUnregister && control._subjects.state.next({
            values: control._getWatch()
        });
    }, [
        control,
        props.shouldUnregister
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useEffect(()=>{
        if (control._proxyFormState.isDirty) {
            const isDirty = control._getDirty();
            if (isDirty !== formState.isDirty) control._subjects.state.next({
                isDirty: isDirty
            });
        }
    }, [
        control,
        formState.isDirty
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useEffect(()=>{
        var _a;
        if (props.values && !$89d38d99107ddd0f$var$deepEqual(props.values, _values.current)) {
            control._reset(props.values, {
                keepFieldsRef: true,
                ...control._options.resetOptions
            });
            if (!((_a = control._options.resetOptions) === null || _a === void 0 ? void 0 : _a.keepIsValid)) control._setValid();
            _values.current = props.values;
            updateFormState((state)=>({
                    ...state
                }));
        } else control._resetDefaultValues();
    }, [
        control,
        props.values
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useEffect(()=>{
        if (!control._state.mount) {
            control._setValid();
            control._state.mount = true;
        }
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next({
                ...control._formState
            });
        }
        control._removeUnmounted();
    });
    _formControl.current.formState = (0, (/*@__PURE__*/$parcel$interopDefault($5iwRF))).useMemo(()=>$89d38d99107ddd0f$var$getProxyFormState(formState, control), [
        control,
        formState
    ]);
    return _formControl.current;
}
/**
 * Watch component that subscribes to form field changes and re-renders when watched fields update.
 *
 * @param control - The form control object from useForm
 * @param name - Can be field name, array of field names, or undefined to watch the entire form
 * @param disabled - Disable subscription
 * @param exact - Whether to watch exact field names or not
 * @param defaultValue - The default value to use if the field is not yet set
 * @param compute - Function to compute derived values from watched fields
 * @param render - The function that receives watched values and returns ReactNode
 * @returns The result of calling render function with watched values
 *
 * @example
 * The `Watch` component only re-render when the values of `foo`, `bar`, and `baz.qux` change.
 * The types of `foo`, `bar`, and `baz.qux` are precisely inferred.
 *
 * ```tsx
 * const { control } = useForm();
 *
 * <Watch
 *   control={control}
 *   names={['foo', 'bar', 'baz.qux']}
 *   render={([foo, bar, baz_qux]) => <div>{foo}{bar}{baz_qux}</div>}
 * />
 * ```
 */ const $89d38d99107ddd0f$export$4c68f1a79f88778c = (props)=>props.render($89d38d99107ddd0f$export$3c773aa2b84f29e0({
        name: props.names,
        ...props
    }));




const $460ca0c5a53e2223$export$42a852a2b6b56249 = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('div', {
    display: "flex",
    alignItems: "center",
    alignContent: "center",
    flexDirection: "column"
});
const $460ca0c5a53e2223$export$4bbbaaf23c63aace = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('section', {
    display: "grid",
    rowGap: "1.5rem",
    "@media only screen and (min-width : 992px)": {
        gridTemplateColumns: "repeat(2, 1fr)",
        columnGap: "1.5rem"
    }
});
const $460ca0c5a53e2223$export$71655785c758526a = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('form', {
    display: 'flex',
    flexDirection: "column"
});
const $460ca0c5a53e2223$export$b04be29aa201d4f5 = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('p', {
    margin: "1em 0 0.2em 0",
    fontSize: "0.8em",
    color: "rgba(25,25,25,0.8)"
});
const $460ca0c5a53e2223$export$c86715117507e8e5 = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('input', {
    display: "block",
    padding: "0.2em 2em 0.2em 0",
    backgroundRepeat: "no-repeat",
    backgroundSize: "20px 20px",
    backgroundPosition: "99% 50%",
    border: "solid 1px rgba(25,25,25,0.5)",
    transition: "border-color ease 300ms",
    width: "100%",
    "&:focus": {
        border: "solid 1px $theme"
    }
});
const $460ca0c5a53e2223$export$f5c9f3c2c4054eec = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('textarea', {
    display: "block",
    padding: "0.2em 2em 0.2em 0",
    backgroundRepeat: "no-repeat",
    backgroundSize: "20px 20px",
    backgroundPosition: "99% 50%",
    border: "solid 1px rgba(25,25,25,0.5)",
    transition: "border-color ease 300ms",
    width: "100%",
    "&:focus": {
        border: "solid 1px $theme"
    }
});
const $460ca0c5a53e2223$export$353f5b6fc5456de1 = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('input', {
    display: "inline-block",
    width: "auto",
    fontFamily: "'Montserrat',Helvetica,Arial,sans-serif",
    fontWeight: 500,
    backgroundColor: "rgb(16, 201, 195)",
    padding: "0.8rem 1.6rem",
    marginTop: '1rem',
    color: "white",
    border: 0,
    cursor: "pointer",
    transition: "ease 400ms",
    textDecoration: "none",
    "&:hover": {
        backgroundColor: "rgb(37, 37, 37)"
    }
});
const $460ca0c5a53e2223$export$edf27be85e5f6da0 = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('span', {
    fontSize: '0.8rem',
    color: "#EF5350",
    paddingTop: "0.3rem"
});


function $d4dbd9c85928dd2f$export$836a6ea60fb78f25() {
    const { register: register, handleSubmit: handleSubmit, formState: { errors: errors, isSubmitting: isSubmitting } } = (0, $89d38d99107ddd0f$export$87c0cf8eb5a167e0)();
    const [showThankyou, setShowThankYou] = (0, $5iwRF.useState)(false);
    const onSubmit = async (data)=>{
        if (!data) throw (0, $460ca0c5a53e2223$export$edf27be85e5f6da0)('Submit Error');
        const res = await fetch('https://formspree.io/mzbkpjdj', {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        if (res.status === 200) setShowThankYou(true);
    };
    return /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $460ca0c5a53e2223$export$42a852a2b6b56249), {
        children: /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsxs)((0, $460ca0c5a53e2223$export$4bbbaaf23c63aace), {
            children: [
                /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)("h1", {
                            children: (0, $28a3ebeb835906c3$export$2e2bcd8739ae039).contactHeader
                        }),
                        /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)("p", {
                            children: (0, $28a3ebeb835906c3$export$2e2bcd8739ae039).contactText
                        })
                    ]
                }),
                !showThankyou && /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsxs)((0, $460ca0c5a53e2223$export$71655785c758526a), {
                    id: "form",
                    method: "POST",
                    onSubmit: handleSubmit(onSubmit),
                    children: [
                        /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsxs)("label", {
                            htmlFor: "email",
                            children: [
                                /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $460ca0c5a53e2223$export$b04be29aa201d4f5), {
                                    children: "Email"
                                }),
                                /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $460ca0c5a53e2223$export$c86715117507e8e5), {
                                    id: "email",
                                    ...register('email', {
                                        required: true
                                    })
                                }),
                                errors?.email && /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $460ca0c5a53e2223$export$edf27be85e5f6da0), {
                                    id: "form-email-error",
                                    children: "Please enter a valid email format"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsxs)("label", {
                            htmlFor: "name",
                            children: [
                                /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $460ca0c5a53e2223$export$b04be29aa201d4f5), {
                                    children: "Name"
                                }),
                                /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $460ca0c5a53e2223$export$c86715117507e8e5), {
                                    id: "name",
                                    ...register('name', {
                                        required: true,
                                        maxLength: 20
                                    })
                                }),
                                errors?.name && /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $460ca0c5a53e2223$export$edf27be85e5f6da0), {
                                    id: "form-name-error",
                                    children: "Please enter a valid name with alphabets only"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsxs)("label", {
                            htmlFor: "message",
                            children: [
                                /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $460ca0c5a53e2223$export$b04be29aa201d4f5), {
                                    children: "Message"
                                }),
                                /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $460ca0c5a53e2223$export$f5c9f3c2c4054eec), {
                                    id: "message",
                                    rows: 4,
                                    ...register('message', {
                                        required: true,
                                        maxLength: 400,
                                        minLength: 10
                                    })
                                }),
                                errors?.message && /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $460ca0c5a53e2223$export$edf27be85e5f6da0), {
                                    id: "form-message-error",
                                    children: "Please enter at least 10 characters and less than 400 characters."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $460ca0c5a53e2223$export$353f5b6fc5456de1), {
                            type: "submit",
                            value: isSubmitting ? 'Submitting...' : 'Submit',
                            name: "submit",
                            disabled: isSubmitting
                        })
                    ]
                }),
                showThankyou && /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)("div", {
                    "aria-hidden": showThankyou ? 'false' : 'true',
                    "data-testid": "contact-thank-you",
                    children: /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)("p", {
                        children: "Thank you for your message. I will reply soon after I receive it."
                    })
                })
            ]
        })
    });
}





function $bdec2d61cededb33$var$Home() {
    return /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $d7b37fea0f6203ad$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)("title", {
                    children: "Portfolio | Yuki Cheung"
                })
            }),
            /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $de2430378eeafd03$export$8b251419efc915eb), {}),
            /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $4803f1b3b0b75f38$export$b6032183171af19f), {}),
            /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $2fdc1cc89313d290$export$e6ff31bff12b7ff4), {}),
            /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $50d25fef0551d6f2$export$b68be92453dfc5b6), {}),
            /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $3d74bff2846008b2$export$c84671f46d6a1ca), {
                layout: "default",
                children: /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $d4dbd9c85928dd2f$export$836a6ea60fb78f25), {})
            })
        ]
    });
}
var $bdec2d61cededb33$export$2e2bcd8739ae039 = $bdec2d61cededb33$var$Home;



parcelRequire("5iwRF");



const $f512c3d0bdc899fc$export$e8d47fc67a89f8fe = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('div', {
    display: "grid",
    paddingBottom: "1rem",
    rowGap: "1.5rem",
    "@media only screen and (min-width : 992px)": {
        gridTemplateColumns: "60% 1fr",
        columnGap: "1.5rem"
    }
});
const $f512c3d0bdc899fc$export$8f314e512d92575f = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('div', {
    paddingBottom: "1.2rem"
});
const $f512c3d0bdc899fc$export$be58b4326e23250f = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('span', {
    color: "rgb(95, 95, 95)",
    display: "inline-flex",
    transition: "ease 400ms",
    marginRight: '0.8rem',
    "&:hover": {
        color: "rgb(23, 23, 23)"
    },
    svg: {
        width: "1.2rem",
        height: "1.2rem"
    }
});
const $f512c3d0bdc899fc$export$75f07c36086c2c81 = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('div', {
    display: 'inline-block'
});
const $f512c3d0bdc899fc$export$b78be80a52048ad7 = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('img', {
    display: 'inline-block',
    width: '100%'
});
const $f512c3d0bdc899fc$export$5f1af8db9871e1d6 = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('p', {
    paddingBottom: '1rem'
});
const $f512c3d0bdc899fc$export$118171a82d109c04 = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('span', {
    textTransform: 'capitalize',
    fontWeight: 'bold'
});




parcelRequire("5iwRF");


const $7cafbed7f073e3e0$var$iconComponents = {
    codepen: (0, $e908cfa9f077af86$export$54a08461bc4e9944),
    'dev-dot-to': (0, $e908cfa9f077af86$export$2c71112b202a47c),
    github: (0, $e908cfa9f077af86$export$e8e65f186ccd8749)
};
const $7cafbed7f073e3e0$var$isProfileIconId = (id)=>id in $7cafbed7f073e3e0$var$iconComponents;
const $7cafbed7f073e3e0$export$bd9c0be85c7db34 = ({ links: links })=>/*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $f512c3d0bdc899fc$export$8f314e512d92575f), {
        children: links.map((item)=>{
            if (!$7cafbed7f073e3e0$var$isProfileIconId(item.id)) return null;
            const SocialIcon = $7cafbed7f073e3e0$var$iconComponents[item.id];
            return /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)("a", {
                "aria-label": item.id,
                href: item.url,
                target: "_blank",
                rel: "noopener noreferrer",
                children: /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $f512c3d0bdc899fc$export$be58b4326e23250f), {
                    children: /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)(SocialIcon, {
                        title: item.id
                    })
                })
            }, item.id);
        })
    });


var $0ba90aa978e37518$exports = {};
$0ba90aa978e37518$exports = import.meta.resolve("7iewR");


const $786396f6f346590b$var$image = new URL($0ba90aa978e37518$exports).toString();
function $786396f6f346590b$var$About() {
    const category = Object.keys((0, $28a3ebeb835906c3$export$2e2bcd8739ae039).skills);
    const createList = (list)=>{
        let html = '';
        (0, $28a3ebeb835906c3$export$2e2bcd8739ae039).skills[list].map((item, idx)=>{
            const lastItem = idx === (0, $28a3ebeb835906c3$export$2e2bcd8739ae039).skills[list].length - 1 ? '' : ', ';
            html += `${item + lastItem}`;
        });
        return html;
    };
    return /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsxs)((0, $f0ae0fbdb7754737$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $d7b37fea0f6203ad$export$dcef8f9bb9a41431), {
                children: /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)("title", {
                    children: "About | Yuki Cheung"
                })
            }),
            /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsxs)((0, $f512c3d0bdc899fc$export$e8d47fc67a89f8fe), {
                children: [
                    /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)("h1", {
                                children: (0, $28a3ebeb835906c3$export$2e2bcd8739ae039).headerButton
                            }),
                            /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $f512c3d0bdc899fc$export$5f1af8db9871e1d6), {
                                children: (0, $28a3ebeb835906c3$export$2e2bcd8739ae039).aboutDesc
                            }),
                            /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $f512c3d0bdc899fc$export$5f1af8db9871e1d6), {
                                children: (0, $28a3ebeb835906c3$export$2e2bcd8739ae039).aboutDesc1
                            }),
                            /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $7cafbed7f073e3e0$export$bd9c0be85c7db34), {
                                links: (0, $28a3ebeb835906c3$export$2e2bcd8739ae039).footer
                            }),
                            /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)("h2", {
                                        children: "Skills"
                                    }),
                                    category.map((item)=>/*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsxs)((0, $f512c3d0bdc899fc$export$5f1af8db9871e1d6), {
                                            children: [
                                                /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $f512c3d0bdc899fc$export$118171a82d109c04), {
                                                    children: item
                                                }),
                                                ":",
                                                ' ',
                                                createList(item)
                                            ]
                                        }, item))
                                ]
                            }),
                            /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $ebfa7bd3c0bd7228$export$d5992c1fec905475), {
                                to: "/contact",
                                children: (0, $28a3ebeb835906c3$export$2e2bcd8739ae039).aboutButton
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $f512c3d0bdc899fc$export$75f07c36086c2c81), {
                        children: /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $f512c3d0bdc899fc$export$b78be80a52048ad7), {
                            loading: "lazy",
                            src: $786396f6f346590b$var$image,
                            alt: ""
                        })
                    })
                ]
            })
        ]
    });
}
var $786396f6f346590b$export$2e2bcd8739ae039 = $786396f6f346590b$var$About;



parcelRequire("5iwRF");


function $3a84e6e5bd2b5af0$var$ProjectPage() {
    return /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsxs)((0, $f0ae0fbdb7754737$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $d7b37fea0f6203ad$export$dcef8f9bb9a41431), {
                children: /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)("title", {
                    children: "Projects | Yuki Cheung"
                })
            }),
            /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $4803f1b3b0b75f38$export$b6032183171af19f), {})
        ]
    });
}
var $3a84e6e5bd2b5af0$export$2e2bcd8739ae039 = $3a84e6e5bd2b5af0$var$ProjectPage;



parcelRequire("5iwRF");


function $5726f6c238f9c09f$var$ContactPage() {
    return /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsxs)((0, $f0ae0fbdb7754737$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $d7b37fea0f6203ad$export$dcef8f9bb9a41431), {
                children: /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)("title", {
                    children: "Contact | Yuki Cheung"
                })
            }),
            /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $d4dbd9c85928dd2f$export$836a6ea60fb78f25), {})
        ]
    });
}
var $5726f6c238f9c09f$export$2e2bcd8739ae039 = $5726f6c238f9c09f$var$ContactPage;



parcelRequire("5iwRF");




const $97a14407dddc7c3c$export$6e76f8357f41ff9b = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('div', {
    height: 500,
    backgroundPosition: "60%",
    backgroundSize: "cover",
    "@media only screen and (min-width : 992px)": {
        height: 600
    }
});
const $97a14407dddc7c3c$export$4ee32776d0814bc1 = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('div', {
    padding: "1rem",
    backgroundColor: "#f6f6f6",
    "@media only screen and (min-width : 992px)": {
        padding: "2.5rem 4rem"
    }
});
const $97a14407dddc7c3c$export$55a2b0f315878a81 = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('div', {
    display: "grid",
    rowGap: "1rem",
    "@media only screen and (min-width : 992px)": {
        gridTemplateColumns: "repeat(3, 1fr)",
        columnGap: "1rem"
    }
});
const $97a14407dddc7c3c$export$e71c4d32a2263218 = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('div', {
    paddingBottom: "1rem"
});
const $97a14407dddc7c3c$export$d5992c1fec905475 = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('a', {
    display: "inline-block",
    width: "auto",
    fontFamily: "'Montserrat',Helvetica,Arial,sans-serif",
    fontWeight: 500,
    backgroundColor: "rgb(16, 201, 195)",
    padding: "0.8em 1.6em",
    color: "white",
    border: 0,
    cursor: "pointer",
    margin: "0.5em 0",
    transition: "ease 400ms",
    textDecoration: "none",
    "&:hover": {
        backgroundColor: "rgb(37, 37, 37)",
        color: "white"
    }
});
const $97a14407dddc7c3c$export$5a58f8265797e4b3 = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('section', {
    padding: "1rem"
});
const $97a14407dddc7c3c$export$67efe7a6dccb9914 = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('a', {
    textDecoration: "none",
    display: "inline",
    color: "rgb(95, 95, 95)",
    transition: "ease 400ms",
    "&:hover, &:focus": {
        color: "rgb(23, 23, 23)"
    }
});
const $97a14407dddc7c3c$export$ce4b6a469c26f53f = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('div', {
    paddingBottom: "4rem"
});
const $97a14407dddc7c3c$export$5f1af8db9871e1d6 = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('p', {
    paddingBottom: "1rem"
});
const $97a14407dddc7c3c$export$775c760e42beccb7 = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('img', {
    display: 'inline-block',
    width: '100%'
});


function $715e1afc1ace7d93$export$53ddc7574f854cfb() {
    const { url: url } = (0, $6fd199a57804d61d$export$99eaa27ddbbb95ef)();
    const project = (0, $28a3ebeb835906c3$export$2e2bcd8739ae039).projects.filter((item)=>item.urlKey === url);
    if (project.length !== 1) return /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $97a14407dddc7c3c$export$4ee32776d0814bc1), {
        children: "No project"
    });
    const projectItem = project.map((ele)=>/*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsxs)("section", {
            children: [
                /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $d7b37fea0f6203ad$export$dcef8f9bb9a41431), {
                    children: /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsxs)("title", {
                        children: [
                            ele.name,
                            ' ',
                            "- Projects | Yuki Cheung"
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)("h1", {
                            children: ele.name
                        }),
                        /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $97a14407dddc7c3c$export$5f1af8db9871e1d6), {
                            children: ele.desc
                        }),
                        /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $97a14407dddc7c3c$export$5f1af8db9871e1d6), {
                            children: ele.techDesc
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsxs)((0, $97a14407dddc7c3c$export$e71c4d32a2263218), {
                    children: [
                        /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsxs)("strong", {
                                    children: [
                                        "Client:",
                                        " "
                                    ]
                                }),
                                ele.client
                            ]
                        }),
                        /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsxs)("strong", {
                                    children: [
                                        "Date:",
                                        " "
                                    ]
                                }),
                                ele.date
                            ]
                        }),
                        /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsxs)("strong", {
                                    children: [
                                        "Category:",
                                        " "
                                    ]
                                }),
                                ele.category
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $97a14407dddc7c3c$export$ce4b6a469c26f53f), {
                    children: /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $97a14407dddc7c3c$export$d5992c1fec905475), {
                        href: ele.link,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: "Live site"
                    })
                }),
                /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $97a14407dddc7c3c$export$55a2b0f315878a81), {
                    children: ele.gallery ? ele.gallery.map((item, idx)=>/*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)("a", {
                            target: "_blank",
                            rel: "noopener noreferrer",
                            href: item,
                            children: /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $97a14407dddc7c3c$export$775c760e42beccb7), {
                                loading: "lazy",
                                src: item,
                                alt: ""
                            })
                        }, idx)) : ''
                })
            ]
        }, ele.urlKey));
    return /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsxs)((0, $f0ae0fbdb7754737$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $97a14407dddc7c3c$export$6e76f8357f41ff9b), {
                style: {
                    backgroundImage: `url(${project[0].bg})`
                }
            }),
            /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $97a14407dddc7c3c$export$4ee32776d0814bc1), {
                children: project && project.length === 1 ? projectItem : 'No project'
            }),
            /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $97a14407dddc7c3c$export$5a58f8265797e4b3), {
                children: /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $97a14407dddc7c3c$export$67efe7a6dccb9914), {
                    href: "/",
                    children: /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)("p", {
                        children: "Back to Home"
                    })
                })
            })
        ]
    });
}





parcelRequire("5iwRF");

const $a29f489b500e6da5$export$61905ae62c7860fb = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('footer', {
    background: "#f6f6f6",
    padding: "3rem 1rem",
    marginTop: "auto"
});
const $a29f489b500e6da5$export$b0bbe4a9730db175 = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('div', {
    display: "flex",
    justifyContent: "center",
    marginBottom: "0.5rem"
});
const $a29f489b500e6da5$export$5f1af8db9871e1d6 = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('p', {
    display: "block",
    textAlign: "center",
    fontSize: "0.9rem",
    margin: 0
});
const $a29f489b500e6da5$export$a6c7ac8248d6e38a = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('a', {
    marginRight: "1rem"
});
const $a29f489b500e6da5$export$f04a61298a47a40f = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('span', {
    color: "rgb(95, 95, 95)",
    display: "inline-flex",
    transition: "ease 400ms",
    "&:hover": {
        color: "rgb(23, 23, 23)"
    },
    svg: {
        width: "1.2em",
        height: "1.2em"
    }
});
const $a29f489b500e6da5$export$67efe7a6dccb9914 = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('a', {
    textDecoration: "none",
    display: "inline",
    color: "rgb(95, 95, 95)",
    transition: "ease 400ms",
    "&:hover, &:focus": {
        color: "rgb(23, 23, 23)"
    }
});




const $1d0e3e41addc6117$var$iconComponents = {
    codepen: (0, $e908cfa9f077af86$export$54a08461bc4e9944),
    'dev-dot-to': (0, $e908cfa9f077af86$export$2c71112b202a47c),
    github: (0, $e908cfa9f077af86$export$e8e65f186ccd8749)
};
function $1d0e3e41addc6117$export$a06f1c675e846f6f() {
    return /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsxs)((0, $a29f489b500e6da5$export$61905ae62c7860fb), {
        children: [
            /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $a29f489b500e6da5$export$b0bbe4a9730db175), {
                children: (0, $28a3ebeb835906c3$export$2e2bcd8739ae039).footer.map((item)=>{
                    const SocialIcon = $1d0e3e41addc6117$var$iconComponents[item.id];
                    return /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $a29f489b500e6da5$export$a6c7ac8248d6e38a), {
                        "aria-label": item.id,
                        href: item.url,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $a29f489b500e6da5$export$f04a61298a47a40f), {
                            children: /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)(SocialIcon, {
                                title: item.id
                            })
                        })
                    }, item.id);
                })
            }),
            /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsxs)((0, $a29f489b500e6da5$export$5f1af8db9871e1d6), {
                children: [
                    "2018 - ",
                    new Date().getFullYear(),
                    ' ',
                    "\xa9 All contents owned by Yuki Cheung. Design by",
                    ' ',
                    /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $a29f489b500e6da5$export$67efe7a6dccb9914), {
                        href: "https://dribbble.com/shots/3782221-Free-PSD-Portfolio-Template",
                        target: "_blank",
                        rel: "noreferrer noopener",
                        children: "Svetlana"
                    })
                ]
            })
        ]
    });
}




const $3d74bff2846008b2$var$AppContainer = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('div', {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh'
});
const $3d74bff2846008b2$export$c84671f46d6a1ca = (0, $d27e433b52638c64$export$3817b7a54a07cec7)('div', {
    variants: {
        layout: {
            default: {
                padding: '1rem',
                '@media only screen and (min-width : 992px)': {
                    maxWidth: 1140,
                    margin: '0 auto',
                    padding: '4em 1em'
                }
            }
        },
        homepage: {}
    }
});
const $3d74bff2846008b2$var$globalStyles = (0, $d27e433b52638c64$export$db53682eef82cc11)({
    '*': {
        margin: 0,
        padding: 0,
        boxSizing: 'border-box'
    },
    body: {
        fontFamily: "'Nunito Sans', sans-serif",
        width: '100%',
        height: '100%',
        margin: 0,
        padding: 0,
        fontSize: '1rem',
        lineHeight: 1.48,
        color: 'rgb(95, 95, 95)'
    },
    a: {
        textDecoration: 'none'
    },
    'h1,h2,h3,h4,h5,h6': {
        fontFamily: "'Montserrat', sans-serif",
        fontWeight: 500,
        color: 'rgb(23, 23, 23)'
    },
    h1: {
        fontSize: '2em',
        margin: '0 0 0.7em 0'
    },
    h2: {
        fontSize: '1.5em',
        margin: '0 0 0.8em 0'
    },
    h3: {
        fontSize: '1.17em',
        margin: '0 0 0.83em 0'
    },
    "@media (prefers-reduced-motion: reduce)": {
        "*": {
            animation: "none !important",
            transition: "none !important"
        }
    }
});
function $3d74bff2846008b2$var$App() {
    const location = (0, $6fd199a57804d61d$export$45d76561a5302f2b)();
    const isHomepage = (0, $6fd199a57804d61d$export$6c330e8992e8a295)('/');
    const isProjectDetailsPage = (0, $6fd199a57804d61d$export$6c330e8992e8a295)('/project/:url');
    const isFullWidth = isHomepage || isProjectDetailsPage;
    (0, $5iwRF.useLayoutEffect)(()=>{
        window.scrollTo(0, 0);
    }, [
        location.pathname
    ]);
    $3d74bff2846008b2$var$globalStyles();
    return /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsxs)($3d74bff2846008b2$var$AppContainer, {
        children: [
            !isHomepage && /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $6606e5f4ea82c065$export$d9b273488cd8ce6f), {}),
            /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)($3d74bff2846008b2$export$c84671f46d6a1ca, {
                layout: isFullWidth ? undefined : 'default',
                children: /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsxs)((0, $6fd199a57804d61d$export$3565eb3d00ca5a74), {
                    children: [
                        /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $6fd199a57804d61d$export$e7b0ac011bb776c6), {
                            path: "/",
                            element: /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $bdec2d61cededb33$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $6fd199a57804d61d$export$e7b0ac011bb776c6), {
                            path: "/about",
                            element: /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $786396f6f346590b$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $6fd199a57804d61d$export$e7b0ac011bb776c6), {
                            path: "/project",
                            element: /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $3a84e6e5bd2b5af0$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $6fd199a57804d61d$export$e7b0ac011bb776c6), {
                            path: "/contact",
                            element: /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $5726f6c238f9c09f$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $6fd199a57804d61d$export$e7b0ac011bb776c6), {
                            path: "/project/:url",
                            element: /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $715e1afc1ace7d93$export$53ddc7574f854cfb), {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $1d0e3e41addc6117$export$a06f1c675e846f6f), {})
        ]
    });
}
var $3d74bff2846008b2$export$2e2bcd8739ae039 = $3d74bff2846008b2$var$App;


const $35da740d59af89ba$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($3b466bc134990405$exports))).createRoot(document.getElementById("app"));
$35da740d59af89ba$var$root.render(/*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $6fd199a57804d61d$export$9ba4e89fdfa1fc54), {
    children: /*#__PURE__*/ (0, $f0ae0fbdb7754737$exports.jsx)((0, $3d74bff2846008b2$export$2e2bcd8739ae039), {})
}));


//# sourceMappingURL=repo.ee2bbcd3.js.map
